import * as Types from '../../../model/Sitecore.graphql.d';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type PressReleaseSearchLatestQuery_search_ItemSearchResults_pageInfo_PageInfo = (
  { __typename?: 'PageInfo' }
  & Pick<Types.PageInfo, 'endCursor' | 'hasNext'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BasePressRelease_template_ItemTemplate = (
  { __typename?: 'ItemTemplate' }
  & Pick<Types.ItemTemplate, 'id'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BasePressRelease_pressReleaseTitle_TextField = (
  { __typename?: 'TextField' }
  & Pick<Types.TextField, 'value'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BasePressRelease_pressReleaseDescription_TextField = (
  { __typename?: 'TextField' }
  & Pick<Types.TextField, 'value'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BasePressRelease_pressReleasePublicationDate_DateField = (
  { __typename?: 'DateField' }
  & Pick<Types.DateField, 'value' | 'formattedDateValue'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___PodcastPressRelease_duration_IntegerField = (
  { __typename?: 'IntegerField' }
  & Pick<Types.IntegerField, 'value'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___PressRelease_duration_IntegerField = (
  { __typename?: 'IntegerField' }
  & Pick<Types.IntegerField, 'value'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___VideoPressRelease_duration_IntegerField = (
  { __typename?: 'IntegerField' }
  & Pick<Types.IntegerField, 'value'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Accordion = (
  { __typename?: 'Accordion' }
  & Pick<Types.Accordion, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_AccordionFolder = (
  { __typename?: 'AccordionFolder' }
  & Pick<Types.AccordionFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_AccordionFolder_03f88fb497884025b46f2cb249f4fcd6 = (
  { __typename?: 'AccordionFolder_03f88fb497884025b46f2cb249f4fcd6' }
  & Pick<Types.AccordionFolder_03f88fb497884025b46f2cb249f4fcd6, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_AccordionItem = (
  { __typename?: 'AccordionItem' }
  & Pick<Types.AccordionItem, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_AccordionItem_8cf671721b2d489e809f4c23db5ab2da = (
  { __typename?: 'AccordionItem_8cf671721b2d489e809f4c23db5ab2da' }
  & Pick<Types.AccordionItem_8cf671721b2d489e809f4c23db5ab2da, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_AccordionParametersTemplate = (
  { __typename?: 'AccordionParametersTemplate' }
  & Pick<Types.AccordionParametersTemplate, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_AccordionPresentation = (
  { __typename?: 'AccordionPresentation' }
  & Pick<Types.AccordionPresentation, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_AccordionPresentationFolder = (
  { __typename?: 'AccordionPresentationFolder' }
  & Pick<Types.AccordionPresentationFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Accordion_02d060598cc14423a9ac9ff2365176b7 = (
  { __typename?: 'Accordion_02d060598cc14423a9ac9ff2365176b7' }
  & Pick<Types.Accordion_02d060598cc14423a9ac9ff2365176b7, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Accordion_705cc8b3bde54cb3bf1ce455a2a36ef1 = (
  { __typename?: 'Accordion_705cc8b3bde54cb3bf1ce455a2a36ef1' }
  & Pick<Types.Accordion_705cc8b3bde54cb3bf1ce455a2a36ef1, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_AddItem = (
  { __typename?: 'AddItem' }
  & Pick<Types.AddItem, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_AddItem_1e1b739ec3784909941d171aca7362e5 = (
  { __typename?: 'AddItem_1e1b739ec3784909941d171aca7362e5' }
  & Pick<Types.AddItem_1e1b739ec3784909941d171aca7362e5, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_AddItem_3aea335cd06d45b1841acbc8d2d1ce40 = (
  { __typename?: 'AddItem_3aea335cd06d45b1841acbc8d2d1ce40' }
  & Pick<Types.AddItem_3aea335cd06d45b1841acbc8d2d1ce40, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_AddItem_de8c75222f3241288f20342f479894eb = (
  { __typename?: 'AddItem_de8c75222f3241288f20342f479894eb' }
  & Pick<Types.AddItem_De8c75222f3241288f20342f479894eb, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_AddItem_ea8a3f269ccd443a95f571b868a94bd0 = (
  { __typename?: 'AddItem_ea8a3f269ccd443a95f571b868a94bd0' }
  & Pick<Types.AddItem_Ea8a3f269ccd443a95f571b868a94bd0, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_AddThisParameters = (
  { __typename?: 'AddThisParameters' }
  & Pick<Types.AddThisParameters, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_AggregatedFacetFilter = (
  { __typename?: 'AggregatedFacetFilter' }
  & Pick<Types.AggregatedFacetFilter, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_AlertMessage = (
  { __typename?: 'AlertMessage' }
  & Pick<Types.AlertMessage, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_AlertMessageFolder = (
  { __typename?: 'AlertMessageFolder' }
  & Pick<Types.AlertMessageFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_AlertMessageParametersTemplate = (
  { __typename?: 'AlertMessageParametersTemplate' }
  & Pick<Types.AlertMessageParametersTemplate, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_AlertMessageType = (
  { __typename?: 'AlertMessageType' }
  & Pick<Types.AlertMessageType, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_AllertMessageTypeFolder = (
  { __typename?: 'AllertMessageTypeFolder' }
  & Pick<Types.AllertMessageTypeFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Archive = (
  { __typename?: 'Archive' }
  & Pick<Types.Archive, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleAuthor = (
  { __typename?: 'ArticleAuthor' }
  & Pick<Types.ArticleAuthor, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleAuthorsFolder = (
  { __typename?: 'ArticleAuthorsFolder' }
  & Pick<Types.ArticleAuthorsFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleCategoriesFolder = (
  { __typename?: 'ArticleCategoriesFolder' }
  & Pick<Types.ArticleCategoriesFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleCategory = (
  { __typename?: 'ArticleCategory' }
  & Pick<Types.ArticleCategory, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleChapter = (
  { __typename?: 'ArticleChapter' }
  & Pick<Types.ArticleChapter, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleChapters = (
  { __typename?: 'ArticleChapters' }
  & Pick<Types.ArticleChapters, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleContentType = (
  { __typename?: 'ArticleContentType' }
  & Pick<Types.ArticleContentType, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleContentTypesFolder = (
  { __typename?: 'ArticleContentTypesFolder' }
  & Pick<Types.ArticleContentTypesFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleFilter = (
  { __typename?: 'ArticleFilter' }
  & Pick<Types.ArticleFilter, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleFilterOption = (
  { __typename?: 'ArticleFilterOption' }
  & Pick<Types.ArticleFilterOption, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleFootnote = (
  { __typename?: 'ArticleFootnote' }
  & Pick<Types.ArticleFootnote, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleFootnoteLink = (
  { __typename?: 'ArticleFootnoteLink' }
  & Pick<Types.ArticleFootnoteLink, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleFootnoteText = (
  { __typename?: 'ArticleFootnoteText' }
  & Pick<Types.ArticleFootnoteText, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleInfogramTile = (
  { __typename?: 'ArticleInfogramTile' }
  & Pick<Types.ArticleInfogramTile, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleInfogramTileParametersTemplate = (
  { __typename?: 'ArticleInfogramTileParametersTemplate' }
  & Pick<Types.ArticleInfogramTileParametersTemplate, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticlePage = (
  { __typename?: 'ArticlePage' }
  & Pick<Types.ArticlePage, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleRegion = (
  { __typename?: 'ArticleRegion' }
  & Pick<Types.ArticleRegion, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleRegionsFolder = (
  { __typename?: 'ArticleRegionsFolder' }
  & Pick<Types.ArticleRegionsFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleSearchPage = (
  { __typename?: 'ArticleSearchPage' }
  & Pick<Types.ArticleSearchPage, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleSearchPage_4d8bd0d1a07841dc96405ca1ed71d81c = (
  { __typename?: 'ArticleSearchPage_4d8bd0d1a07841dc96405ca1ed71d81c' }
  & Pick<Types.ArticleSearchPage_4d8bd0d1a07841dc96405ca1ed71d81c, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleSearchPage_22b7f7c7c37f4644a8eed9c32258b4a2 = (
  { __typename?: 'ArticleSearchPage_22b7f7c7c37f4644a8eed9c32258b4a2' }
  & Pick<Types.ArticleSearchPage_22b7f7c7c37f4644a8eed9c32258b4a2, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleSearchPage_be414ff574ac4203abb2694811443e25 = (
  { __typename?: 'ArticleSearchPage_be414ff574ac4203abb2694811443e25' }
  & Pick<Types.ArticleSearchPage_Be414ff574ac4203abb2694811443e25, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleSearchPage_c7ad44ac3cab45158b619465a552a82c = (
  { __typename?: 'ArticleSearchPage_c7ad44ac3cab45158b619465a552a82c' }
  & Pick<Types.ArticleSearchPage_C7ad44ac3cab45158b619465a552a82c, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleSearchPage_cf31bd740a4b4363b03d1f7a88e39907 = (
  { __typename?: 'ArticleSearchPage_cf31bd740a4b4363b03d1f7a88e39907' }
  & Pick<Types.ArticleSearchPage_Cf31bd740a4b4363b03d1f7a88e39907, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleSeriesCollection = (
  { __typename?: 'ArticleSeriesCollection' }
  & Pick<Types.ArticleSeriesCollection, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleSeriesFolder = (
  { __typename?: 'ArticleSeriesFolder' }
  & Pick<Types.ArticleSeriesFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleSettings = (
  { __typename?: 'ArticleSettings' }
  & Pick<Types.ArticleSettings, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleSubscriptionBanner = (
  { __typename?: 'ArticleSubscriptionBanner' }
  & Pick<Types.ArticleSubscriptionBanner, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleSubscriptionBannerFolder = (
  { __typename?: 'ArticleSubscriptionBannerFolder' }
  & Pick<Types.ArticleSubscriptionBannerFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleTag = (
  { __typename?: 'ArticleTag' }
  & Pick<Types.ArticleTag, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleTagsFolder = (
  { __typename?: 'ArticleTagsFolder' }
  & Pick<Types.ArticleTagsFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleTeamAuthor = (
  { __typename?: 'ArticleTeamAuthor' }
  & Pick<Types.ArticleTeamAuthor, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleTileParametersTemplate = (
  { __typename?: 'ArticleTileParametersTemplate' }
  & Pick<Types.ArticleTileParametersTemplate, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleTilesParametersTemplate = (
  { __typename?: 'ArticleTilesParametersTemplate' }
  & Pick<Types.ArticleTilesParametersTemplate, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleWildcardPage_4bf0be7a0c5c41d5973bb82f1ec73f8f = (
  { __typename?: 'ArticleWildcardPage_4bf0be7a0c5c41d5973bb82f1ec73f8f' }
  & Pick<Types.ArticleWildcardPage_4bf0be7a0c5c41d5973bb82f1ec73f8f, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleWildcardPage_8f17c5d3ea39491494916dbfe2410ad8 = (
  { __typename?: 'ArticleWildcardPage_8f17c5d3ea39491494916dbfe2410ad8' }
  & Pick<Types.ArticleWildcardPage_8f17c5d3ea39491494916dbfe2410ad8, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleWildcardPage_84a63b4789ee4a3f82684b750a6a23ca = (
  { __typename?: 'ArticleWildcardPage_84a63b4789ee4a3f82684b750a6a23ca' }
  & Pick<Types.ArticleWildcardPage_84a63b4789ee4a3f82684b750a6a23ca, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleWildcardPage_95e7966e0da1412bafbf0e8a69392c8c = (
  { __typename?: 'ArticleWildcardPage_95e7966e0da1412bafbf0e8a69392c8c' }
  & Pick<Types.ArticleWildcardPage_95e7966e0da1412bafbf0e8a69392c8c, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleWildcardPage_405b20252077400383d3b47f09f88b47 = (
  { __typename?: 'ArticleWildcardPage_405b20252077400383d3b47f09f88b47' }
  & Pick<Types.ArticleWildcardPage_405b20252077400383d3b47f09f88b47, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleWildcardPage_b037a577f5cb4ad3b79f07720a96985b = (
  { __typename?: 'ArticleWildcardPage_b037a577f5cb4ad3b79f07720a96985b' }
  & Pick<Types.ArticleWildcardPage_B037a577f5cb4ad3b79f07720a96985b, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticlesGroupFolder = (
  { __typename?: 'ArticlesGroupFolder' }
  & Pick<Types.ArticlesGroupFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_AttachThemeExtension = (
  { __typename?: 'AttachThemeExtension' }
  & Pick<Types.AttachThemeExtension, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_AutomaticDocumentListings = (
  { __typename?: 'AutomaticDocumentListings' }
  & Pick<Types.AutomaticDocumentListings, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_AutomaticDocumentListingsFolder = (
  { __typename?: 'AutomaticDocumentListingsFolder' }
  & Pick<Types.AutomaticDocumentListingsFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_AvailableJSONRenderings = (
  { __typename?: 'AvailableJSONRenderings' }
  & Pick<Types.AvailableJsonRenderings, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_AvailableMetaRenderings = (
  { __typename?: 'AvailableMetaRenderings' }
  & Pick<Types.AvailableMetaRenderings, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_AvailableRenderings = (
  { __typename?: 'AvailableRenderings' }
  & Pick<Types.AvailableRenderings, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_AvailableRenderingsFolder_26ec1d1811b24dd98326f6115f4fd7eb = (
  { __typename?: 'AvailableRenderingsFolder_26ec1d1811b24dd98326f6115f4fd7eb' }
  & Pick<Types.AvailableRenderingsFolder_26ec1d1811b24dd98326f6115f4fd7eb, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_AwardsBanner = (
  { __typename?: 'AwardsBanner' }
  & Pick<Types.AwardsBanner, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_AwardsBannerFolder = (
  { __typename?: 'AwardsBannerFolder' }
  & Pick<Types.AwardsBannerFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_AwardsBannerImage = (
  { __typename?: 'AwardsBannerImage' }
  & Pick<Types.AwardsBannerImage, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_AwardsBannerParametersTemplate = (
  { __typename?: 'AwardsBannerParametersTemplate' }
  & Pick<Types.AwardsBannerParametersTemplate, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_BYOCWrapperRenderingParameters = (
  { __typename?: 'BYOCWrapperRenderingParameters' }
  & Pick<Types.ByocWrapperRenderingParameters, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_BackgroundColorOption = (
  { __typename?: 'BackgroundColorOption' }
  & Pick<Types.BackgroundColorOption, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_BackgroundColorOptionFolder = (
  { __typename?: 'BackgroundColorOptionFolder' }
  & Pick<Types.BackgroundColorOptionFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_BannerFolder = (
  { __typename?: 'BannerFolder' }
  & Pick<Types.BannerFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_BannerType = (
  { __typename?: 'BannerType' }
  & Pick<Types.BannerType, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_BannerTypeFolder = (
  { __typename?: 'BannerTypeFolder' }
  & Pick<Types.BannerTypeFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_BaseHeading = (
  { __typename?: 'BaseHeading' }
  & Pick<Types.BaseHeading, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_BaseHeadingFolder = (
  { __typename?: 'BaseHeadingFolder' }
  & Pick<Types.BaseHeadingFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_BoolFacet = (
  { __typename?: 'BoolFacet' }
  & Pick<Types.BoolFacet, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_BranchesFolder = (
  { __typename?: 'BranchesFolder' }
  & Pick<Types.BranchesFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Breadcrumb = (
  { __typename?: 'Breadcrumb' }
  & Pick<Types.Breadcrumb, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_BrowserTitleDefinition = (
  { __typename?: 'BrowserTitleDefinition' }
  & Pick<Types.BrowserTitleDefinition, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_CORSEntry = (
  { __typename?: 'CORSEntry' }
  & Pick<Types.CorsEntry, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_CORSGrouping = (
  { __typename?: 'CORSGrouping' }
  & Pick<Types.CorsGrouping, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_CTAPresentationType = (
  { __typename?: 'CTAPresentationType' }
  & Pick<Types.CtaPresentationType, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_CTAPresentationTypeFolder = (
  { __typename?: 'CTAPresentationTypeFolder' }
  & Pick<Types.CtaPresentationTypeFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__AbrdnPage = (
  { __typename?: 'C__AbrdnPage' }
  & Pick<Types.C__AbrdnPage, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__ActionBase = (
  { __typename?: 'C__ActionBase' }
  & Pick<Types.C__ActionBase, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__AdvancedParameter = (
  { __typename?: 'C__AdvancedParameter' }
  & Pick<Types.C__AdvancedParameter, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__App = (
  { __typename?: 'C__App' }
  & Pick<Types.C__App, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180c = (
  { __typename?: 'C__ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180c' }
  & Pick<Types.C__ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180c, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__ArticleWildcardPage = (
  { __typename?: 'C__ArticleWildcardPage' }
  & Pick<Types.C__ArticleWildcardPage, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__AvailableRenderingsFolder = (
  { __typename?: 'C__AvailableRenderingsFolder' }
  & Pick<Types.C__AvailableRenderingsFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__BYOCRenderingParameters = (
  { __typename?: 'C__BYOCRenderingParameters' }
  & Pick<Types.C__ByocRenderingParameters, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__BackgroundParametersTemplate = (
  { __typename?: 'C__BackgroundParametersTemplate' }
  & Pick<Types.C__BackgroundParametersTemplate, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__BaseCTA = (
  { __typename?: 'C__BaseCTA' }
  & Pick<Types.C__BaseCta, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__BasePage = (
  { __typename?: 'C__BasePage' }
  & Pick<Types.C__BasePage, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__BasePage_037da552a5524fe4aeee331f57ac1378 = (
  { __typename?: 'C__BasePage_037da552a5524fe4aeee331f57ac1378' }
  & Pick<Types.C__BasePage_037da552a5524fe4aeee331f57ac1378, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f = (
  { __typename?: 'C__BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f' }
  & Pick<Types.C__BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__BasePage_315fd21bebf04c9d9f00bae191442f1d = (
  { __typename?: 'C__BasePage_315fd21bebf04c9d9f00bae191442f1d' }
  & Pick<Types.C__BasePage_315fd21bebf04c9d9f00bae191442f1d, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__BasePage_458c6cc442da4327b4d4d7d4ecd48cbd = (
  { __typename?: 'C__BasePage_458c6cc442da4327b4d4d7d4ecd48cbd' }
  & Pick<Types.C__BasePage_458c6cc442da4327b4d4d7d4ecd48cbd, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__BasePage_728c97b5c56146d9807e21018a972bb5 = (
  { __typename?: 'C__BasePage_728c97b5c56146d9807e21018a972bb5' }
  & Pick<Types.C__BasePage_728c97b5c56146d9807e21018a972bb5, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__BasePage_6105875085f346729dfc8d133b481f26 = (
  { __typename?: 'C__BasePage_6105875085f346729dfc8d133b481f26' }
  & Pick<Types.C__BasePage_6105875085f346729dfc8d133b481f26, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__BasePage_b08130ebd3314a3b9c0f2b5e9b66387b = (
  { __typename?: 'C__BasePage_b08130ebd3314a3b9c0f2b5e9b66387b' }
  & Pick<Types.C__BasePage_B08130ebd3314a3b9c0f2b5e9b66387b, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__BaseRenderingParameters = (
  { __typename?: 'C__BaseRenderingParameters' }
  & Pick<Types.C__BaseRenderingParameters, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__BaseTheme = (
  { __typename?: 'C__BaseTheme' }
  & Pick<Types.C__BaseTheme, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__BaseVariantField = (
  { __typename?: 'C__BaseVariantField' }
  & Pick<Types.C__BaseVariantField, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__Class = (
  { __typename?: 'C__Class' }
  & Pick<Types.C__Class, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__CompositeGroup = (
  { __typename?: 'C__CompositeGroup' }
  & Pick<Types.C__CompositeGroup, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__CompositeSection = (
  { __typename?: 'C__CompositeSection' }
  & Pick<Types.C__CompositeSection, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__EloquaForm = (
  { __typename?: 'C__EloquaForm' }
  & Pick<Types.C__EloquaForm, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__ErrorPage_d40dd5cadbf1461191b8f9e1071e557d = (
  { __typename?: 'C__ErrorPage_d40dd5cadbf1461191b8f9e1071e557d' }
  & Pick<Types.C__ErrorPage_D40dd5cadbf1461191b8f9e1071e557d, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__ExtendedOptions = (
  { __typename?: 'C__ExtendedOptions' }
  & Pick<Types.C__ExtendedOptions, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__ExtendedOptions_2964fb4257a6440fb192218443904c90 = (
  { __typename?: 'C__ExtendedOptions_2964fb4257a6440fb192218443904c90' }
  & Pick<Types.C__ExtendedOptions_2964fb4257a6440fb192218443904c90, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__ExtendedOptions_f1850030f97848b4bdb5884b7e863160 = (
  { __typename?: 'C__ExtendedOptions_f1850030f97848b4bdb5884b7e863160' }
  & Pick<Types.C__ExtendedOptions_F1850030f97848b4bdb5884b7e863160, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__FEaaSRenderingParameters = (
  { __typename?: 'C__FEaaSRenderingParameters' }
  & Pick<Types.C__FEaaSRenderingParameters, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__FacetSelectorConfigBase = (
  { __typename?: 'C__FacetSelectorConfigBase' }
  & Pick<Types.C__FacetSelectorConfigBase, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__FilteredArticlesParentPage_8196d9b5309f49f882f7918089b77845 = (
  { __typename?: 'C__FilteredArticlesParentPage_8196d9b5309f49f882f7918089b77845' }
  & Pick<Types.C__FilteredArticlesParentPage_8196d9b5309f49f882f7918089b77845, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2b = (
  { __typename?: 'C__FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2b' }
  & Pick<Types.C__FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2b, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__FundDetailsWildcardPage_fb127f7aeeba46458c5fbe9f7c589303 = (
  { __typename?: 'C__FundDetailsWildcardPage_fb127f7aeeba46458c5fbe9f7c589303' }
  & Pick<Types.C__FundDetailsWildcardPage_Fb127f7aeeba46458c5fbe9f7c589303, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__FundSearchPage_d83da2a5ce9042b6bd557aa8820c62c5 = (
  { __typename?: 'C__FundSearchPage_d83da2a5ce9042b6bd557aa8820c62c5' }
  & Pick<Types.C__FundSearchPage_D83da2a5ce9042b6bd557aa8820c62c5, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__FundShareclassDetailsWildcardPage_e3590ad764a84980a419c4f1f926f9fc = (
  { __typename?: 'C__FundShareclassDetailsWildcardPage_e3590ad764a84980a419c4f1f926f9fc' }
  & Pick<Types.C__FundShareclassDetailsWildcardPage_E3590ad764a84980a419c4f1f926f9fc, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__GlobalDatasourceBehavior = (
  { __typename?: 'C__GlobalDatasourceBehavior' }
  & Pick<Types.C__GlobalDatasourceBehavior, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__GridDefinition = (
  { __typename?: 'C__GridDefinition' }
  & Pick<Types.C__GridDefinition, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__GridItemBase = (
  { __typename?: 'C__GridItemBase' }
  & Pick<Types.C__GridItemBase, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__GridParameters = (
  { __typename?: 'C__GridParameters' }
  & Pick<Types.C__GridParameters, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__HeadlessSite = (
  { __typename?: 'C__HeadlessSite' }
  & Pick<Types.C__HeadlessSite, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__HeadlessTenant = (
  { __typename?: 'C__HeadlessTenant' }
  & Pick<Types.C__HeadlessTenant, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__HelpArticleSearchPage_d1c4d91365c8401389dcde7b5fb2f28b = (
  { __typename?: 'C__HelpArticleSearchPage_d1c4d91365c8401389dcde7b5fb2f28b' }
  & Pick<Types.C__HelpArticleSearchPage_D1c4d91365c8401389dcde7b5fb2f28b, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__HelpArticleWildcardPage_c0a939305f6e47a38739f2a8f300e65d = (
  { __typename?: 'C__HelpArticleWildcardPage_c0a939305f6e47a38739f2a8f300e65d' }
  & Pick<Types.C__HelpArticleWildcardPage_C0a939305f6e47a38739f2a8f300e65d, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__HomePage_2899b95da7f346b7a1da7ef14d7ef84d = (
  { __typename?: 'C__HomePage_2899b95da7f346b7a1da7ef14d7ef84d' }
  & Pick<Types.C__HomePage_2899b95da7f346b7a1da7ef14d7ef84d, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__IAllowEmpty = (
  { __typename?: 'C__IAllowEmpty' }
  & Pick<Types.C__IAllowEmpty, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__IBaseVariantDefinition = (
  { __typename?: 'C__IBaseVariantDefinition' }
  & Pick<Types.C__IBaseVariantDefinition, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__IBoosting = (
  { __typename?: 'C__IBoosting' }
  & Pick<Types.C__IBoosting, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__ICacheable = (
  { __typename?: 'C__ICacheable' }
  & Pick<Types.C__ICacheable, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__ICompatibleRenderings = (
  { __typename?: 'C__ICompatibleRenderings' }
  & Pick<Types.C__ICompatibleRenderings, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__IComponentVariant = (
  { __typename?: 'C__IComponentVariant' }
  & Pick<Types.C__IComponentVariant, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__IControlType = (
  { __typename?: 'C__IControlType' }
  & Pick<Types.C__IControlType, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__IDynamicPlaceholder = (
  { __typename?: 'C__IDynamicPlaceholder' }
  & Pick<Types.C__IDynamicPlaceholder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__IFEaaSComponentsDataSourceTemplates = (
  { __typename?: 'C__IFEaaSComponentsDataSourceTemplates' }
  & Pick<Types.C__IfEaaSComponentsDataSourceTemplates, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__IFEaaSComponentsEditorScriptURL = (
  { __typename?: 'C__IFEaaSComponentsEditorScriptURL' }
  & Pick<Types.C__IfEaaSComponentsEditorScriptUrl, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__IIcon = (
  { __typename?: 'C__IIcon' }
  & Pick<Types.C__IIcon, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__ILocation = (
  { __typename?: 'C__ILocation' }
  & Pick<Types.C__ILocation, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__IPaginable = (
  { __typename?: 'C__IPaginable' }
  & Pick<Types.C__IPaginable, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__IPagination = (
  { __typename?: 'C__IPagination' }
  & Pick<Types.C__IPagination, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__IPoi = (
  { __typename?: 'C__IPoi' }
  & Pick<Types.C__IPoi, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__IRenderingId = (
  { __typename?: 'C__IRenderingId' }
  & Pick<Types.C__IRenderingId, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__ISplitter = (
  { __typename?: 'C__ISplitter' }
  & Pick<Types.C__ISplitter, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__IStyling = (
  { __typename?: 'C__IStyling' }
  & Pick<Types.C__IStyling, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__IVariantDefinition = (
  { __typename?: 'C__IVariantDefinition' }
  & Pick<Types.C__IVariantDefinition, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__InvestmentTrustPage = (
  { __typename?: 'C__InvestmentTrustPage' }
  & Pick<Types.C__InvestmentTrustPage, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__JSONField = (
  { __typename?: 'C__JSONField' }
  & Pick<Types.C__JsonField, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__JSONReference = (
  { __typename?: 'C__JSONReference' }
  & Pick<Types.C__JsonReference, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__JSSData = (
  { __typename?: 'C__JSSData' }
  & Pick<Types.C__JssData, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__JSSSettings = (
  { __typename?: 'C__JSSSettings' }
  & Pick<Types.C__JssSettings, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__JSSSiteFolder = (
  { __typename?: 'C__JSSSiteFolder' }
  & Pick<Types.C__JssSiteFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__JssRootFolder = (
  { __typename?: 'C__JssRootFolder' }
  & Pick<Types.C__JssRootFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__LiteratureHubSearchPage_5378ef42e2c4488497ac7cc017b10086 = (
  { __typename?: 'C__LiteratureHubSearchPage_5378ef42e2c4488497ac7cc017b10086' }
  & Pick<Types.C__LiteratureHubSearchPage_5378ef42e2c4488497ac7cc017b10086, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__Navigation_e6d98f24d01c419e871a4617125a49ed = (
  { __typename?: 'C__Navigation_e6d98f24d01c419e871a4617125a49ed' }
  & Pick<Types.C__Navigation_E6d98f24d01c419e871a4617125a49ed, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__Page = (
  { __typename?: 'C__Page' }
  & Pick<Types.C__Page, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__PageData = (
  { __typename?: 'C__PageData' }
  & Pick<Types.C__PageData, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__PageDesignFolder = (
  { __typename?: 'C__PageDesignFolder' }
  & Pick<Types.C__PageDesignFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__PageDesignFolder_023f5d48979d4381bc5e149e36abd3bd = (
  { __typename?: 'C__PageDesignFolder_023f5d48979d4381bc5e149e36abd3bd' }
  & Pick<Types.C__PageDesignFolder_023f5d48979d4381bc5e149e36abd3bd, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__PageDesigns_daaf41fd96db4892be99f62f16d036c4 = (
  { __typename?: 'C__PageDesigns_daaf41fd96db4892be99f62f16d036c4' }
  & Pick<Types.C__PageDesigns_Daaf41fd96db4892be99f62f16d036c4, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__PartialDesign = (
  { __typename?: 'C__PartialDesign' }
  & Pick<Types.C__PartialDesign, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__PartialDesignFolder = (
  { __typename?: 'C__PartialDesignFolder' }
  & Pick<Types.C__PartialDesignFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__PartialDesignFolder_25f01f50553444f9b1babcbb60b2d13d = (
  { __typename?: 'C__PartialDesignFolder_25f01f50553444f9b1babcbb60b2d13d' }
  & Pick<Types.C__PartialDesignFolder_25f01f50553444f9b1babcbb60b2d13d, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__PartialDesigns_79c9fa015f6a48b2b45905bbaa826a9d = (
  { __typename?: 'C__PartialDesigns_79c9fa015f6a48b2b45905bbaa826a9d' }
  & Pick<Types.C__PartialDesigns_79c9fa015f6a48b2b45905bbaa826a9d, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__PlaceholderWrapper = (
  { __typename?: 'C__PlaceholderWrapper' }
  & Pick<Types.C__PlaceholderWrapper, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__PressReleaseSearchPage_4197f4d95d5f4fb3be77e0be695df7ac = (
  { __typename?: 'C__PressReleaseSearchPage_4197f4d95d5f4fb3be77e0be695df7ac' }
  & Pick<Types.C__PressReleaseSearchPage_4197f4d95d5f4fb3be77e0be695df7ac, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__PressReleaseWildcardPage_6a8c237f261d4a9891ef3e27afee2b9b = (
  { __typename?: 'C__PressReleaseWildcardPage_6a8c237f261d4a9891ef3e27afee2b9b' }
  & Pick<Types.C__PressReleaseWildcardPage_6a8c237f261d4a9891ef3e27afee2b9b, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__RedirectMapGrouping = (
  { __typename?: 'C__RedirectMapGrouping' }
  & Pick<Types.C__RedirectMapGrouping, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__ResizableIFramePage_6ff27d6556ff453393bbb3f7f568d973 = (
  { __typename?: 'C__ResizableIFramePage_6ff27d6556ff453393bbb3f7f568d973' }
  & Pick<Types.C__ResizableIFramePage_6ff27d6556ff453393bbb3f7f568d973, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__Route = (
  { __typename?: 'C__Route' }
  & Pick<Types.C__Route, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__SimpleVideo = (
  { __typename?: 'C__SimpleVideo' }
  & Pick<Types.C__SimpleVideo, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__SiteSettingsFolder = (
  { __typename?: 'C__SiteSettingsFolder' }
  & Pick<Types.C__SiteSettingsFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__SitemapSettings = (
  { __typename?: 'C__SitemapSettings' }
  & Pick<Types.C__SitemapSettings, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__StandardTemplate = (
  { __typename?: 'C__StandardTemplate' }
  & Pick<Types.C__StandardTemplate, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__TeamMembersParentPage_11fbd080aa844abca056f5caac316e4c = (
  { __typename?: 'C__TeamMembersParentPage_11fbd080aa844abca056f5caac316e4c' }
  & Pick<Types.C__TeamMembersParentPage_11fbd080aa844abca056f5caac316e4c, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__TeamMembersWildcardPage_8b12628190064b2980f0a054ead02a65 = (
  { __typename?: 'C__TeamMembersWildcardPage_8b12628190064b2980f0a054ead02a65' }
  & Pick<Types.C__TeamMembersWildcardPage_8b12628190064b2980f0a054ead02a65, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__TrustFolder = (
  { __typename?: 'C__TrustFolder' }
  & Pick<Types.C__TrustFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__VariantDefinition = (
  { __typename?: 'C__VariantDefinition' }
  & Pick<Types.C__VariantDefinition, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__VariantField = (
  { __typename?: 'C__VariantField' }
  & Pick<Types.C__VariantField, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__VariantsGrouping = (
  { __typename?: 'C__VariantsGrouping' }
  & Pick<Types.C__VariantsGrouping, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___AdvancedItem = (
  { __typename?: 'C___AdvancedItem' }
  & Pick<Types.C___AdvancedItem, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___Arguments = (
  { __typename?: 'C___Arguments' }
  & Pick<Types.C___Arguments, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___Arguments_33fab87cd52f44319a1f589ba7c1e287 = (
  { __typename?: 'C___Arguments_33fab87cd52f44319a1f589ba7c1e287' }
  & Pick<Types.C___Arguments_33fab87cd52f44319a1f589ba7c1e287, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___Article = (
  { __typename?: 'C___Article' }
  & Pick<Types.C___Article, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___ArticlePageWorkflow = (
  { __typename?: 'C___ArticlePageWorkflow' }
  & Pick<Types.C___ArticlePageWorkflow, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___ArticleSearchPage = (
  { __typename?: 'C___ArticleSearchPage' }
  & Pick<Types.C___ArticleSearchPage, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___ArticleWildcard = (
  { __typename?: 'C___ArticleWildcard' }
  & Pick<Types.C___ArticleWildcard, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___AssetServiceThemeMode = (
  { __typename?: 'C___AssetServiceThemeMode' }
  & Pick<Types.C___AssetServiceThemeMode, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BaseArticle = (
  { __typename?: 'C___BaseArticle' }
  & Pick<Types.C___BaseArticle, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BaseDataFolder = (
  { __typename?: 'C___BaseDataFolder' }
  & Pick<Types.C___BaseDataFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BaseHelpArticle = (
  { __typename?: 'C___BaseHelpArticle' }
  & Pick<Types.C___BaseHelpArticle, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BaseInvestmentTrust = (
  { __typename?: 'C___BaseInvestmentTrust' }
  & Pick<Types.C___BaseInvestmentTrust, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BaseJSSTenant = (
  { __typename?: 'C___BaseJSSTenant' }
  & Pick<Types.C___BaseJssTenant, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BasePage = (
  { __typename?: 'C___BasePage' }
  & Pick<Types.C___BasePage, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BasePageDesign = (
  { __typename?: 'C___BasePageDesign' }
  & Pick<Types.C___BasePageDesign, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BasePageDesignFolder = (
  { __typename?: 'C___BasePageDesignFolder' }
  & Pick<Types.C___BasePageDesignFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BasePartialDesign = (
  { __typename?: 'C___BasePartialDesign' }
  & Pick<Types.C___BasePartialDesign, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BasePartialDesignFolder = (
  { __typename?: 'C___BasePartialDesignFolder' }
  & Pick<Types.C___BasePartialDesignFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BasePlaceholder = (
  { __typename?: 'C___BasePlaceholder' }
  & Pick<Types.C___BasePlaceholder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BasePlaceholderSettingsFolder = (
  { __typename?: 'C___BasePlaceholderSettingsFolder' }
  & Pick<Types.C___BasePlaceholderSettingsFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BasePresentation = (
  { __typename?: 'C___BasePresentation' }
  & Pick<Types.C___BasePresentation, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BasePressRelease = (
  { __typename?: 'C___BasePressRelease' }
  & Pick<Types.C___BasePressRelease, 'id' | 'name'>
  & { template: PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BasePressRelease_template_ItemTemplate, pressReleaseTitle: Types.Maybe<PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BasePressRelease_pressReleaseTitle_TextField>, pressReleaseDescription: Types.Maybe<PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BasePressRelease_pressReleaseDescription_TextField>, pressReleasePublicationDate: Types.Maybe<PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BasePressRelease_pressReleasePublicationDate_DateField> }
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BaseRenderingParameters = (
  { __typename?: 'C___BaseRenderingParameters' }
  & Pick<Types.C___BaseRenderingParameters, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BaseSXAStandardValuesFolder = (
  { __typename?: 'C___BaseSXAStandardValuesFolder' }
  & Pick<Types.C___BaseSxaStandardValuesFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BaseSettings = (
  { __typename?: 'C___BaseSettings' }
  & Pick<Types.C___BaseSettings, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BaseSharedSitesSettings = (
  { __typename?: 'C___BaseSharedSitesSettings' }
  & Pick<Types.C___BaseSharedSitesSettings, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BaseSiteDefinition = (
  { __typename?: 'C___BaseSiteDefinition' }
  & Pick<Types.C___BaseSiteDefinition, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BaseSiteFolder = (
  { __typename?: 'C___BaseSiteFolder' }
  & Pick<Types.C___BaseSiteFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BaseSiteGrouping = (
  { __typename?: 'C___BaseSiteGrouping' }
  & Pick<Types.C___BaseSiteGrouping, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BaseSiteRoot = (
  { __typename?: 'C___BaseSiteRoot' }
  & Pick<Types.C___BaseSiteRoot, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BaseTenant = (
  { __typename?: 'C___BaseTenant' }
  & Pick<Types.C___BaseTenant, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BaseTenantFolder = (
  { __typename?: 'C___BaseTenantFolder' }
  & Pick<Types.C___BaseTenantFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BucketRules = (
  { __typename?: 'C___BucketRules' }
  & Pick<Types.C___BucketRules, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___CORS = (
  { __typename?: 'C___CORS' }
  & Pick<Types.C___Cors, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___Content = (
  { __typename?: 'C___Content' }
  & Pick<Types.C___Content, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___ContentType = (
  { __typename?: 'C___ContentType' }
  & Pick<Types.C___ContentType, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___DataAttributes = (
  { __typename?: 'C___DataAttributes' }
  & Pick<Types.C___DataAttributes, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___DatasourceWorkflow = (
  { __typename?: 'C___DatasourceWorkflow' }
  & Pick<Types.C___DatasourceWorkflow, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___Dependencies = (
  { __typename?: 'C___Dependencies' }
  & Pick<Types.C___Dependencies, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___Description = (
  { __typename?: 'C___Description' }
  & Pick<Types.C___Description, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___DesignTemplateMapping = (
  { __typename?: 'C___DesignTemplateMapping' }
  & Pick<Types.C___DesignTemplateMapping, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___Designable = (
  { __typename?: 'C___Designable' }
  & Pick<Types.C___Designable, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___EditType = (
  { __typename?: 'C___EditType' }
  & Pick<Types.C___EditType, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___EditType_8a9f84baaa124c5d9096935714809da4 = (
  { __typename?: 'C___EditType_8a9f84baaa124c5d9096935714809da4' }
  & Pick<Types.C___EditType_8a9f84baaa124c5d9096935714809da4, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___EditingTheme = (
  { __typename?: 'C___EditingTheme' }
  & Pick<Types.C___EditingTheme, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___Enabled = (
  { __typename?: 'C___Enabled' }
  & Pick<Types.C___Enabled, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___ErrorHandling = (
  { __typename?: 'C___ErrorHandling' }
  & Pick<Types.C___ErrorHandling, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___ExternalArticle = (
  { __typename?: 'C___ExternalArticle' }
  & Pick<Types.C___ExternalArticle, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___Fields = (
  { __typename?: 'C___Fields' }
  & Pick<Types.C___Fields, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___FilteredArticlesParent = (
  { __typename?: 'C___FilteredArticlesParent' }
  & Pick<Types.C___FilteredArticlesParent, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___FilteredArticlesWildcard = (
  { __typename?: 'C___FilteredArticlesWildcard' }
  & Pick<Types.C___FilteredArticlesWildcard, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___Footnotes = (
  { __typename?: 'C___Footnotes' }
  & Pick<Types.C___Footnotes, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___FundDetailsWildcard = (
  { __typename?: 'C___FundDetailsWildcard' }
  & Pick<Types.C___FundDetailsWildcard, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___FundFormAvailability = (
  { __typename?: 'C___FundFormAvailability' }
  & Pick<Types.C___FundFormAvailability, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___FundMetadataPage = (
  { __typename?: 'C___FundMetadataPage' }
  & Pick<Types.C___FundMetadataPage, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___FundSearchPage = (
  { __typename?: 'C___FundSearchPage' }
  & Pick<Types.C___FundSearchPage, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___FundsFolder = (
  { __typename?: 'C___FundsFolder' }
  & Pick<Types.C___FundsFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___FundsFormsFolder = (
  { __typename?: 'C___FundsFormsFolder' }
  & Pick<Types.C___FundsFormsFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___FundsLiteratureFolder = (
  { __typename?: 'C___FundsLiteratureFolder' }
  & Pick<Types.C___FundsLiteratureFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___FundsShareclassesDetailsWildcard = (
  { __typename?: 'C___FundsShareclassesDetailsWildcard' }
  & Pick<Types.C___FundsShareclassesDetailsWildcard, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___GridMapping = (
  { __typename?: 'C___GridMapping' }
  & Pick<Types.C___GridMapping, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___HelpArticle = (
  { __typename?: 'C___HelpArticle' }
  & Pick<Types.C___HelpArticle, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___HelpArticleSearchPage = (
  { __typename?: 'C___HelpArticleSearchPage' }
  & Pick<Types.C___HelpArticleSearchPage, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___HelpArticleWildcard = (
  { __typename?: 'C___HelpArticleWildcard' }
  & Pick<Types.C___HelpArticleWildcard, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___HorizonDatasourceGrouping = (
  { __typename?: 'C___HorizonDatasourceGrouping' }
  & Pick<Types.C___HorizonDatasourceGrouping, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___Icon = (
  { __typename?: 'C___Icon' }
  & Pick<Types.C___Icon, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___IncludeByDefault = (
  { __typename?: 'C___IncludeByDefault' }
  & Pick<Types.C___IncludeByDefault, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___IncludeIfInstalled = (
  { __typename?: 'C___IncludeIfInstalled' }
  & Pick<Types.C___IncludeIfInstalled, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___InternalArticle = (
  { __typename?: 'C___InternalArticle' }
  & Pick<Types.C___InternalArticle, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___InternetExplorerCompatibilityMode = (
  { __typename?: 'C___InternetExplorerCompatibilityMode' }
  & Pick<Types.C___InternetExplorerCompatibilityMode, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___IsSystemModule = (
  { __typename?: 'C___IsSystemModule' }
  & Pick<Types.C___IsSystemModule, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___JSONVariantPaging = (
  { __typename?: 'C___JSONVariantPaging' }
  & Pick<Types.C___JsonVariantPaging, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___JSONVariantsBase = (
  { __typename?: 'C___JSONVariantsBase' }
  & Pick<Types.C___JsonVariantsBase, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___LimitedDisplay = (
  { __typename?: 'C___LimitedDisplay' }
  & Pick<Types.C___LimitedDisplay, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___LinkAttributes = (
  { __typename?: 'C___LinkAttributes' }
  & Pick<Types.C___LinkAttributes, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___LinkSettings = (
  { __typename?: 'C___LinkSettings' }
  & Pick<Types.C___LinkSettings, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___LiteratureHubSearchPage = (
  { __typename?: 'C___LiteratureHubSearchPage' }
  & Pick<Types.C___LiteratureHubSearchPage, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___ManualKeyInformation = (
  { __typename?: 'C___ManualKeyInformation' }
  & Pick<Types.C___ManualKeyInformation, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___MemberOf = (
  { __typename?: 'C___MemberOf' }
  & Pick<Types.C___MemberOf, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___MetadataPage = (
  { __typename?: 'C___MetadataPage' }
  & Pick<Types.C___MetadataPage, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___Modules = (
  { __typename?: 'C___Modules' }
  & Pick<Types.C___Modules, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___Name = (
  { __typename?: 'C___Name' }
  & Pick<Types.C___Name, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___Name_0345fd2f95094dc7b0f56c73a9b6cd8d = (
  { __typename?: 'C___Name_0345fd2f95094dc7b0f56c73a9b6cd8d' }
  & Pick<Types.C___Name_0345fd2f95094dc7b0f56c73a9b6cd8d, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___Name_299cdb154745448a807868d401248eaa = (
  { __typename?: 'C___Name_299cdb154745448a807868d401248eaa' }
  & Pick<Types.C___Name_299cdb154745448a807868d401248eaa, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___Name_b88cf88159a54a19991e71038751cb60 = (
  { __typename?: 'C___Name_b88cf88159a54a19991e71038751cb60' }
  & Pick<Types.C___Name_B88cf88159a54a19991e71038751cb60, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___Navigable = (
  { __typename?: 'C___Navigable' }
  & Pick<Types.C___Navigable, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___NavigablePage = (
  { __typename?: 'C___NavigablePage' }
  & Pick<Types.C___NavigablePage, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___PageContent = (
  { __typename?: 'C___PageContent' }
  & Pick<Types.C___PageContent, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___PageWorkflow = (
  { __typename?: 'C___PageWorkflow' }
  & Pick<Types.C___PageWorkflow, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___PerSiteStandardValues = (
  { __typename?: 'C___PerSiteStandardValues' }
  & Pick<Types.C___PerSiteStandardValues, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___Podcast = (
  { __typename?: 'C___Podcast' }
  & Pick<Types.C___Podcast, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___PodcastPressRelease = (
  { __typename?: 'C___PodcastPressRelease' }
  & Pick<Types.C___PodcastPressRelease, 'id' | 'name'>
  & { template: PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BasePressRelease_template_ItemTemplate, pressReleaseTitle: Types.Maybe<PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BasePressRelease_pressReleaseTitle_TextField>, pressReleaseDescription: Types.Maybe<PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BasePressRelease_pressReleaseDescription_TextField>, pressReleasePublicationDate: Types.Maybe<PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BasePressRelease_pressReleasePublicationDate_DateField>, duration: Types.Maybe<PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___PodcastPressRelease_duration_IntegerField> }
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___PremiumContentPage = (
  { __typename?: 'C___PremiumContentPage' }
  & Pick<Types.C___PremiumContentPage, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___PressRelease = (
  { __typename?: 'C___PressRelease' }
  & Pick<Types.C___PressRelease, 'id' | 'name'>
  & { template: PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BasePressRelease_template_ItemTemplate, pressReleaseTitle: Types.Maybe<PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BasePressRelease_pressReleaseTitle_TextField>, pressReleaseDescription: Types.Maybe<PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BasePressRelease_pressReleaseDescription_TextField>, pressReleasePublicationDate: Types.Maybe<PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BasePressRelease_pressReleasePublicationDate_DateField>, duration: Types.Maybe<PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___PressRelease_duration_IntegerField> }
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___PressReleaseContentType = (
  { __typename?: 'C___PressReleaseContentType' }
  & Pick<Types.C___PressReleaseContentType, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___PressReleaseSearchPage = (
  { __typename?: 'C___PressReleaseSearchPage' }
  & Pick<Types.C___PressReleaseSearchPage, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___PressReleaseWildcard = (
  { __typename?: 'C___PressReleaseWildcard' }
  & Pick<Types.C___PressReleaseWildcard, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___ProtectedTheme = (
  { __typename?: 'C___ProtectedTheme' }
  & Pick<Types.C___ProtectedTheme, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___PublishingGroupingTemplate = (
  { __typename?: 'C___PublishingGroupingTemplate' }
  & Pick<Types.C___PublishingGroupingTemplate, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___RenderingRelatedParameters = (
  { __typename?: 'C___RenderingRelatedParameters' }
  & Pick<Types.C___RenderingRelatedParameters, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___RenderingVariantsBase = (
  { __typename?: 'C___RenderingVariantsBase' }
  & Pick<Types.C___RenderingVariantsBase, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___RenderingsList = (
  { __typename?: 'C___RenderingsList' }
  & Pick<Types.C___RenderingsList, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___RobotsContent = (
  { __typename?: 'C___RobotsContent' }
  & Pick<Types.C___RobotsContent, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___RoleDomain = (
  { __typename?: 'C___RoleDomain' }
  & Pick<Types.C___RoleDomain, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___RoleName = (
  { __typename?: 'C___RoleName' }
  & Pick<Types.C___RoleName, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___RoleType = (
  { __typename?: 'C___RoleType' }
  & Pick<Types.C___RoleType, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___SalesforceCommonValidations = (
  { __typename?: 'C___SalesforceCommonValidations' }
  & Pick<Types.C___SalesforceCommonValidations, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___SalesforceFieldId = (
  { __typename?: 'C___SalesforceFieldId' }
  & Pick<Types.C___SalesforceFieldId, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___SalesforceFieldTitle = (
  { __typename?: 'C___SalesforceFieldTitle' }
  & Pick<Types.C___SalesforceFieldTitle, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___SalesforceFieldValue = (
  { __typename?: 'C___SalesforceFieldValue' }
  & Pick<Types.C___SalesforceFieldValue, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___Script = (
  { __typename?: 'C___Script' }
  & Pick<Types.C___Script, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___SearchSignature = (
  { __typename?: 'C___SearchSignature' }
  & Pick<Types.C___SearchSignature, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___Searchable = (
  { __typename?: 'C___Searchable' }
  & Pick<Types.C___Searchable, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___SecurityItemPointer = (
  { __typename?: 'C___SecurityItemPointer' }
  & Pick<Types.C___SecurityItemPointer, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___SharedArticles = (
  { __typename?: 'C___SharedArticles' }
  & Pick<Types.C___SharedArticles, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___SharedContent = (
  { __typename?: 'C___SharedContent' }
  & Pick<Types.C___SharedContent, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___SharedHelpArticles = (
  { __typename?: 'C___SharedHelpArticles' }
  & Pick<Types.C___SharedHelpArticles, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___SharedPage = (
  { __typename?: 'C___SharedPage' }
  & Pick<Types.C___SharedPage, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___SharedPressReleases = (
  { __typename?: 'C___SharedPressReleases' }
  & Pick<Types.C___SharedPressReleases, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___SharedRoot = (
  { __typename?: 'C___SharedRoot' }
  & Pick<Types.C___SharedRoot, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___SharedSettings = (
  { __typename?: 'C___SharedSettings' }
  & Pick<Types.C___SharedSettings, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___SiteContent = (
  { __typename?: 'C___SiteContent' }
  & Pick<Types.C___SiteContent, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___SiteFolder = (
  { __typename?: 'C___SiteFolder' }
  & Pick<Types.C___SiteFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___SiteMediaLibrary = (
  { __typename?: 'C___SiteMediaLibrary' }
  & Pick<Types.C___SiteMediaLibrary, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___SiteSettings = (
  { __typename?: 'C___SiteSettings' }
  & Pick<Types.C___SiteSettings, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___SiteTemplate = (
  { __typename?: 'C___SiteTemplate' }
  & Pick<Types.C___SiteTemplate, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___SitecoreClientSiteManaging = (
  { __typename?: 'C___SitecoreClientSiteManaging' }
  & Pick<Types.C___SitecoreClientSiteManaging, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___Sitemap = (
  { __typename?: 'C___Sitemap' }
  & Pick<Types.C___Sitemap, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___SitemapMediaItems = (
  { __typename?: 'C___SitemapMediaItems' }
  & Pick<Types.C___SitemapMediaItems, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___SlidersRangeSettings = (
  { __typename?: 'C___SlidersRangeSettings' }
  & Pick<Types.C___SlidersRangeSettings, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___SolutionTemplateContent = (
  { __typename?: 'C___SolutionTemplateContent' }
  & Pick<Types.C___SolutionTemplateContent, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___SolutionTemplateDescription = (
  { __typename?: 'C___SolutionTemplateDescription' }
  & Pick<Types.C___SolutionTemplateDescription, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___SolutionTemplateName = (
  { __typename?: 'C___SolutionTemplateName' }
  & Pick<Types.C___SolutionTemplateName, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___SortOrder = (
  { __typename?: 'C___SortOrder' }
  & Pick<Types.C___SortOrder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___StackBreakpoint = (
  { __typename?: 'C___StackBreakpoint' }
  & Pick<Types.C___StackBreakpoint, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___Statistics = (
  { __typename?: 'C___Statistics' }
  & Pick<Types.C___Statistics, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___SupportedLanguages = (
  { __typename?: 'C___SupportedLanguages' }
  & Pick<Types.C___SupportedLanguages, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___Taggable = (
  { __typename?: 'C___Taggable' }
  & Pick<Types.C___Taggable, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___TeamMembersParentPage = (
  { __typename?: 'C___TeamMembersParentPage' }
  & Pick<Types.C___TeamMembersParentPage, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___TeamMembersWildcard = (
  { __typename?: 'C___TeamMembersWildcard' }
  & Pick<Types.C___TeamMembersWildcard, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___TechzoneArticle = (
  { __typename?: 'C___TechzoneArticle' }
  & Pick<Types.C___TechzoneArticle, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___Template = (
  { __typename?: 'C___Template' }
  & Pick<Types.C___Template, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___Title = (
  { __typename?: 'C___Title' }
  & Pick<Types.C___Title, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___Type = (
  { __typename?: 'C___Type' }
  & Pick<Types.C___Type, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___Validation = (
  { __typename?: 'C___Validation' }
  & Pick<Types.C___Validation, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___VariantPaging = (
  { __typename?: 'C___VariantPaging' }
  & Pick<Types.C___VariantPaging, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___VectorTile = (
  { __typename?: 'C___VectorTile' }
  & Pick<Types.C___VectorTile, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___VectorTileLink = (
  { __typename?: 'C___VectorTileLink' }
  & Pick<Types.C___VectorTileLink, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___Video = (
  { __typename?: 'C___Video' }
  & Pick<Types.C___Video, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___VideoPressRelease = (
  { __typename?: 'C___VideoPressRelease' }
  & Pick<Types.C___VideoPressRelease, 'id' | 'name'>
  & { template: PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BasePressRelease_template_ItemTemplate, pressReleaseTitle: Types.Maybe<PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BasePressRelease_pressReleaseTitle_TextField>, pressReleaseDescription: Types.Maybe<PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BasePressRelease_pressReleaseDescription_TextField>, pressReleasePublicationDate: Types.Maybe<PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BasePressRelease_pressReleasePublicationDate_DateField>, duration: Types.Maybe<PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___VideoPressRelease_duration_IntegerField> }
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___Width = (
  { __typename?: 'C___Width' }
  & Pick<Types.C___Width, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___WildcardPage = (
  { __typename?: 'C___WildcardPage' }
  & Pick<Types.C___WildcardPage, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_CacheSetting = (
  { __typename?: 'CacheSetting' }
  & Pick<Types.CacheSetting, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Caching_26fce9bf0256458d8281a713a5bf5520 = (
  { __typename?: 'Caching_26fce9bf0256458d8281a713a5bf5520' }
  & Pick<Types.Caching_26fce9bf0256458d8281a713a5bf5520, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_CalendarEvent = (
  { __typename?: 'CalendarEvent' }
  & Pick<Types.CalendarEvent, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_CallOutSection = (
  { __typename?: 'CallOutSection' }
  & Pick<Types.CallOutSection, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_CallOutSectionDropdownOption = (
  { __typename?: 'CallOutSectionDropdownOption' }
  & Pick<Types.CallOutSectionDropdownOption, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_CallOutSectionFolder = (
  { __typename?: 'CallOutSectionFolder' }
  & Pick<Types.CallOutSectionFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_CallOutSectionParametersTemplate = (
  { __typename?: 'CallOutSectionParametersTemplate' }
  & Pick<Types.CallOutSectionParametersTemplate, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_CallToAction = (
  { __typename?: 'CallToAction' }
  & Pick<Types.CallToAction, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_CallToActionFolder = (
  { __typename?: 'CallToActionFolder' }
  & Pick<Types.CallToActionFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_CapabilitiesFolder = (
  { __typename?: 'CapabilitiesFolder' }
  & Pick<Types.CapabilitiesFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Capability = (
  { __typename?: 'Capability' }
  & Pick<Types.Capability, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_CapabilityMap = (
  { __typename?: 'CapabilityMap' }
  & Pick<Types.CapabilityMap, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_CapabilityMappings = (
  { __typename?: 'CapabilityMappings' }
  & Pick<Types.CapabilityMappings, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Carousel = (
  { __typename?: 'Carousel' }
  & Pick<Types.Carousel, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_CarouselFolder = (
  { __typename?: 'CarouselFolder' }
  & Pick<Types.CarouselFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_CarouselSlide = (
  { __typename?: 'CarouselSlide' }
  & Pick<Types.CarouselSlide, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Carousel_2b65f0d87ec54834b4aa1753c0f7036b = (
  { __typename?: 'Carousel_2b65f0d87ec54834b4aa1753c0f7036b' }
  & Pick<Types.Carousel_2b65f0d87ec54834b4aa1753c0f7036b, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Checkbox = (
  { __typename?: 'Checkbox' }
  & Pick<Types.Checkbox, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ChecklistFilter = (
  { __typename?: 'ChecklistFilter' }
  & Pick<Types.ChecklistFilter, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ChecklistFilterFolder = (
  { __typename?: 'ChecklistFilterFolder' }
  & Pick<Types.ChecklistFilterFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ChecklistFilter_3cb40bd669c94976a9742120a5eba1ee = (
  { __typename?: 'ChecklistFilter_3cb40bd669c94976a9742120a5eba1ee' }
  & Pick<Types.ChecklistFilter_3cb40bd669c94976a9742120a5eba1ee, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ColumnSplitter = (
  { __typename?: 'ColumnSplitter' }
  & Pick<Types.ColumnSplitter, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ColumnSplitter_3e1016e56ecb4c19aa0117c18b42deb0 = (
  { __typename?: 'ColumnSplitter_3e1016e56ecb4c19aa0117c18b42deb0' }
  & Pick<Types.ColumnSplitter_3e1016e56ecb4c19aa0117c18b42deb0, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_CompatibilityMode = (
  { __typename?: 'CompatibilityMode' }
  & Pick<Types.CompatibilityMode, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ComponentConfiguration = (
  { __typename?: 'ComponentConfiguration' }
  & Pick<Types.ComponentConfiguration, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ComponentThemeConfiguration = (
  { __typename?: 'ComponentThemeConfiguration' }
  & Pick<Types.ComponentThemeConfiguration, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ComponentThemesConfiguration = (
  { __typename?: 'ComponentThemesConfiguration' }
  & Pick<Types.ComponentThemesConfiguration, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ComponentsConfigurations = (
  { __typename?: 'ComponentsConfigurations' }
  & Pick<Types.ComponentsConfigurations, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ConfigurationFolder = (
  { __typename?: 'ConfigurationFolder' }
  & Pick<Types.ConfigurationFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Container = (
  { __typename?: 'Container' }
  & Pick<Types.Container, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ContainerOption = (
  { __typename?: 'ContainerOption' }
  & Pick<Types.ContainerOption, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ContainerOptionsFolder = (
  { __typename?: 'ContainerOptionsFolder' }
  & Pick<Types.ContainerOptionsFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ContainerParametersTemplate = (
  { __typename?: 'ContainerParametersTemplate' }
  & Pick<Types.ContainerParametersTemplate, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Container_45130bdbbae34edcaea87b68b9d94c7f = (
  { __typename?: 'Container_45130bdbbae34edcaea87b68b9d94c7f' }
  & Pick<Types.Container_45130bdbbae34edcaea87b68b9d94c7f, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ContentBlock = (
  { __typename?: 'ContentBlock' }
  & Pick<Types.ContentBlock, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ContentBlockFolder = (
  { __typename?: 'ContentBlockFolder' }
  & Pick<Types.ContentBlockFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ContentToken = (
  { __typename?: 'ContentToken' }
  & Pick<Types.ContentToken, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ContentTokenFolder = (
  { __typename?: 'ContentTokenFolder' }
  & Pick<Types.ContentTokenFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ContentType = (
  { __typename?: 'ContentType' }
  & Pick<Types.ContentType, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_CorporateTheme = (
  { __typename?: 'CorporateTheme' }
  & Pick<Types.CorporateTheme, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_CorporateThemesFolder = (
  { __typename?: 'CorporateThemesFolder' }
  & Pick<Types.CorporateThemesFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Country = (
  { __typename?: 'Country' }
  & Pick<Types.Country, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_CountryISOCode = (
  { __typename?: 'CountryISOCode' }
  & Pick<Types.CountryIsoCode, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_CountryISOCodesFolder = (
  { __typename?: 'CountryISOCodesFolder' }
  & Pick<Types.CountryIsoCodesFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_CustomerReviewFolder = (
  { __typename?: 'CustomerReviewFolder' }
  & Pick<Types.CustomerReviewFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_CustomerReviewTile = (
  { __typename?: 'CustomerReviewTile' }
  & Pick<Types.CustomerReviewTile, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_CustomerReviewTileParametersTemplate = (
  { __typename?: 'CustomerReviewTileParametersTemplate' }
  & Pick<Types.CustomerReviewTileParametersTemplate, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_DataBridgeDocumentCategoryMap = (
  { __typename?: 'DataBridgeDocumentCategoryMap' }
  & Pick<Types.DataBridgeDocumentCategoryMap, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_DataBridgeFund = (
  { __typename?: 'DataBridgeFund' }
  & Pick<Types.DataBridgeFund, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_DataBridgeFundRangeName = (
  { __typename?: 'DataBridgeFundRangeName' }
  & Pick<Types.DataBridgeFundRangeName, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_DataBridgeSettingsFolder = (
  { __typename?: 'DataBridgeSettingsFolder' }
  & Pick<Types.DataBridgeSettingsFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_DataBridgeShareClass = (
  { __typename?: 'DataBridgeShareClass' }
  & Pick<Types.DataBridgeShareClass, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_DataFolder = (
  { __typename?: 'DataFolder' }
  & Pick<Types.DataFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_DatasourceConfiguration = (
  { __typename?: 'DatasourceConfiguration' }
  & Pick<Types.DatasourceConfiguration, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_DatasourceConfigurations = (
  { __typename?: 'DatasourceConfigurations' }
  & Pick<Types.DatasourceConfigurations, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_DatasourceWorkflowAction = (
  { __typename?: 'DatasourceWorkflowAction' }
  & Pick<Types.DatasourceWorkflowAction, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_DateFacet = (
  { __typename?: 'DateFacet' }
  & Pick<Types.DateFacet, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_DateFilter = (
  { __typename?: 'DateFilter' }
  & Pick<Types.DateFilter, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_DateFilterFolder = (
  { __typename?: 'DateFilterFolder' }
  & Pick<Types.DateFilterFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_DateFilter_ad89c1f1e99148ef865938ab13aa28f1 = (
  { __typename?: 'DateFilter_ad89c1f1e99148ef865938ab13aa28f1' }
  & Pick<Types.DateFilter_Ad89c1f1e99148ef865938ab13aa28f1, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_DefaultColumnLayout = (
  { __typename?: 'DefaultColumnLayout' }
  & Pick<Types.DefaultColumnLayout, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_DefaultShareclassMapping = (
  { __typename?: 'DefaultShareclassMapping' }
  & Pick<Types.DefaultShareclassMapping, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_DefaultShareclassMappings = (
  { __typename?: 'DefaultShareclassMappings' }
  & Pick<Types.DefaultShareclassMappings, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_DescriptiveHighlight = (
  { __typename?: 'DescriptiveHighlight' }
  & Pick<Types.DescriptiveHighlight, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_DescriptiveHighlightFolder = (
  { __typename?: 'DescriptiveHighlightFolder' }
  & Pick<Types.DescriptiveHighlightFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_DescriptiveHighlightItem = (
  { __typename?: 'DescriptiveHighlightItem' }
  & Pick<Types.DescriptiveHighlightItem, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_DescriptiveHighlightParametersTemplate = (
  { __typename?: 'DescriptiveHighlightParametersTemplate' }
  & Pick<Types.DescriptiveHighlightParametersTemplate, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Device = (
  { __typename?: 'Device' }
  & Pick<Types.Device, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Device_7c27ec70f42e40428a0fabaa2f8eda18 = (
  { __typename?: 'Device_7c27ec70f42e40428a0fabaa2f8eda18' }
  & Pick<Types.Device_7c27ec70f42e40428a0fabaa2f8eda18, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Devices = (
  { __typename?: 'Devices' }
  & Pick<Types.Devices, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_DictionaryFolder = (
  { __typename?: 'DictionaryFolder' }
  & Pick<Types.DictionaryFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_DisqusParameters = (
  { __typename?: 'DisqusParameters' }
  & Pick<Types.DisqusParameters, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_DistanceFacet = (
  { __typename?: 'DistanceFacet' }
  & Pick<Types.DistanceFacet, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Divider = (
  { __typename?: 'Divider' }
  & Pick<Types.Divider, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_DocumentItem = (
  { __typename?: 'DocumentItem' }
  & Pick<Types.DocumentItem, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_DocumentListings = (
  { __typename?: 'DocumentListings' }
  & Pick<Types.DocumentListings, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_DocumentListingsFolder = (
  { __typename?: 'DocumentListingsFolder' }
  & Pick<Types.DocumentListingsFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_DocumentTypeFolder = (
  { __typename?: 'DocumentTypeFolder' }
  & Pick<Types.DocumentTypeFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_DominantLanguageMapping = (
  { __typename?: 'DominantLanguageMapping' }
  & Pick<Types.DominantLanguageMapping, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Dropdown = (
  { __typename?: 'Dropdown' }
  & Pick<Types.Dropdown, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_DropdownFilter = (
  { __typename?: 'DropdownFilter' }
  & Pick<Types.DropdownFilter, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_DropdownFilterFolder = (
  { __typename?: 'DropdownFilterFolder' }
  & Pick<Types.DropdownFilterFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_DropdownFilter_790c0f2c16214604a6c672b9f8ae830d = (
  { __typename?: 'DropdownFilter_790c0f2c16214604a6c672b9f8ae830d' }
  & Pick<Types.DropdownFilter_790c0f2c16214604a6c672b9f8ae830d, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_EditEditingTheme = (
  { __typename?: 'EditEditingTheme' }
  & Pick<Types.EditEditingTheme, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_EditFrame = (
  { __typename?: 'EditFrame' }
  & Pick<Types.EditFrame, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_EditModePanel = (
  { __typename?: 'EditModePanel' }
  & Pick<Types.EditModePanel, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_EditSiteItem = (
  { __typename?: 'EditSiteItem' }
  & Pick<Types.EditSiteItem, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_EditSiteItem_f040db0387fe4e10ae4053c63175e31b = (
  { __typename?: 'EditSiteItem_f040db0387fe4e10ae4053c63175e31b' }
  & Pick<Types.EditSiteItem_F040db0387fe4e10ae4053c63175e31b, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_EditSiteTheme = (
  { __typename?: 'EditSiteTheme' }
  & Pick<Types.EditSiteTheme, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_EditTenantTemplate = (
  { __typename?: 'EditTenantTemplate' }
  & Pick<Types.EditTenantTemplate, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_EditTenantTemplate_a7d9fcbcc8944274935f9b9659c000d3 = (
  { __typename?: 'EditTenantTemplate_a7d9fcbcc8944274935f9b9659c000d3' }
  & Pick<Types.EditTenantTemplate_A7d9fcbcc8944274935f9b9659c000d3, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_EditType = (
  { __typename?: 'EditType' }
  & Pick<Types.EditType, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_EloquaFormFolder = (
  { __typename?: 'EloquaFormFolder' }
  & Pick<Types.EloquaFormFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_EloquaFundForm = (
  { __typename?: 'EloquaFundForm' }
  & Pick<Types.EloquaFundForm, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Enum = (
  { __typename?: 'Enum' }
  & Pick<Types.Enum, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Enums = (
  { __typename?: 'Enums' }
  & Pick<Types.Enums, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ErrorPage = (
  { __typename?: 'ErrorPage' }
  & Pick<Types.ErrorPage, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ErrorPage_4b405ec4ef9f4c91a3ffb98c1ac81171 = (
  { __typename?: 'ErrorPage_4b405ec4ef9f4c91a3ffb98c1ac81171' }
  & Pick<Types.ErrorPage_4b405ec4ef9f4c91a3ffb98c1ac81171, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ErrorPage_4dbccce416d1491f94198496e3f77c6d = (
  { __typename?: 'ErrorPage_4dbccce416d1491f94198496e3f77c6d' }
  & Pick<Types.ErrorPage_4dbccce416d1491f94198496e3f77c6d, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ErrorPage_45d797cc048740ffb693214883ff35c2 = (
  { __typename?: 'ErrorPage_45d797cc048740ffb693214883ff35c2' }
  & Pick<Types.ErrorPage_45d797cc048740ffb693214883ff35c2, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ErrorPage_76eb47b3f3a248bdbbdbb5bf7d8f9bf9 = (
  { __typename?: 'ErrorPage_76eb47b3f3a248bdbbdbb5bf7d8f9bf9' }
  & Pick<Types.ErrorPage_76eb47b3f3a248bdbbdbb5bf7d8f9bf9, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ErrorPage_a7dfa49761224679bf9949fffacd5fa1 = (
  { __typename?: 'ErrorPage_a7dfa49761224679bf9949fffacd5fa1' }
  & Pick<Types.ErrorPage_A7dfa49761224679bf9949fffacd5fa1, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_EventCalendarParameters = (
  { __typename?: 'EventCalendarParameters' }
  & Pick<Types.EventCalendarParameters, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_EventList = (
  { __typename?: 'EventList' }
  & Pick<Types.EventList, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_EventListParameters = (
  { __typename?: 'EventListParameters' }
  & Pick<Types.EventListParameters, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_EventTypes = (
  { __typename?: 'EventTypes' }
  & Pick<Types.EventTypes, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_EventsFolder = (
  { __typename?: 'EventsFolder' }
  & Pick<Types.EventsFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ExecuteScript = (
  { __typename?: 'ExecuteScript' }
  & Pick<Types.ExecuteScript, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ExecuteScript_3d4e4577ab334ca6ae43b98d1ec6472f = (
  { __typename?: 'ExecuteScript_3d4e4577ab334ca6ae43b98d1ec6472f' }
  & Pick<Types.ExecuteScript_3d4e4577ab334ca6ae43b98d1ec6472f, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ExecuteScript_6545c81fc30f4b5897d9ef85b890f70a = (
  { __typename?: 'ExecuteScript_6545c81fc30f4b5897d9ef85b890f70a' }
  & Pick<Types.ExecuteScript_6545c81fc30f4b5897d9ef85b890f70a, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ExecuteScript_b06460c28b7b47a59e2cf966f689b6ca = (
  { __typename?: 'ExecuteScript_b06460c28b7b47a59e2cf966f689b6ca' }
  & Pick<Types.ExecuteScript_B06460c28b7b47a59e2cf966f689b6ca, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ExecuteScript_bc9bb68436df4285888bd8b4d87b10de = (
  { __typename?: 'ExecuteScript_bc9bb68436df4285888bd8b4d87b10de' }
  & Pick<Types.ExecuteScript_Bc9bb68436df4285888bd8b4d87b10de, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ExecuteScript_e14c08721a97459eafef0acaaaf1ffbb = (
  { __typename?: 'ExecuteScript_e14c08721a97459eafef0acaaaf1ffbb' }
  & Pick<Types.ExecuteScript_E14c08721a97459eafef0acaaaf1ffbb, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ExtendSiteTheme = (
  { __typename?: 'ExtendSiteTheme' }
  & Pick<Types.ExtendSiteTheme, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ExternalLiterature = (
  { __typename?: 'ExternalLiterature' }
  & Pick<Types.ExternalLiterature, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FEaaSWrapperRenderingParameters = (
  { __typename?: 'FEaaSWrapperRenderingParameters' }
  & Pick<Types.FEaaSWrapperRenderingParameters, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FacebookCommentsParametersTemplate = (
  { __typename?: 'FacebookCommentsParametersTemplate' }
  & Pick<Types.FacebookCommentsParametersTemplate, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FacetSlider = (
  { __typename?: 'FacetSlider' }
  & Pick<Types.FacetSlider, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FacetSliderFolder = (
  { __typename?: 'FacetSliderFolder' }
  & Pick<Types.FacetSliderFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FacetSlider_995ce2c7319f478b84fe22053ac85bb7 = (
  { __typename?: 'FacetSlider_995ce2c7319f478b84fe22053ac85bb7' }
  & Pick<Types.FacetSlider_995ce2c7319f478b84fe22053ac85bb7, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FacetSummary = (
  { __typename?: 'FacetSummary' }
  & Pick<Types.FacetSummary, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FacetSummaryFolder = (
  { __typename?: 'FacetSummaryFolder' }
  & Pick<Types.FacetSummaryFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FacetSummary_cd5c935c1f604d899a6b88ce28305cf2 = (
  { __typename?: 'FacetSummary_cd5c935c1f604d899a6b88ce28305cf2' }
  & Pick<Types.FacetSummary_Cd5c935c1f604d899a6b88ce28305cf2, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FacetsGrouping = (
  { __typename?: 'FacetsGrouping' }
  & Pick<Types.FacetsGrouping, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FakeNavigationItem = (
  { __typename?: 'FakeNavigationItem' }
  & Pick<Types.FakeNavigationItem, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FeatureBanner = (
  { __typename?: 'FeatureBanner' }
  & Pick<Types.FeatureBanner, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FeatureBannerParametersTemplate = (
  { __typename?: 'FeatureBannerParametersTemplate' }
  & Pick<Types.FeatureBannerParametersTemplate, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FeaturedArticles = (
  { __typename?: 'FeaturedArticles' }
  & Pick<Types.FeaturedArticles, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FeaturedArticlesFolder = (
  { __typename?: 'FeaturedArticlesFolder' }
  & Pick<Types.FeaturedArticlesFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FeaturedTheme = (
  { __typename?: 'FeaturedTheme' }
  & Pick<Types.FeaturedTheme, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FeaturedThemesFolder = (
  { __typename?: 'FeaturedThemesFolder' }
  & Pick<Types.FeaturedThemesFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Feed = (
  { __typename?: 'Feed' }
  & Pick<Types.Feed, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FeedFolder = (
  { __typename?: 'FeedFolder' }
  & Pick<Types.FeedFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FeedParameters = (
  { __typename?: 'FeedParameters' }
  & Pick<Types.FeedParameters, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FieldEditor = (
  { __typename?: 'FieldEditor' }
  & Pick<Types.FieldEditor, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FieldRenderer = (
  { __typename?: 'FieldRenderer' }
  & Pick<Types.FieldRenderer, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FileList = (
  { __typename?: 'FileList' }
  & Pick<Types.FileList, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FileListFolder = (
  { __typename?: 'FileListFolder' }
  & Pick<Types.FileListFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FileListParametersTemplate = (
  { __typename?: 'FileListParametersTemplate' }
  & Pick<Types.FileListParametersTemplate, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_File_04129321770849c1801baee196e1c0a8 = (
  { __typename?: 'File_04129321770849c1801baee196e1c0a8' }
  & Pick<Types.File_04129321770849c1801baee196e1c0a8, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FilterCriteria = (
  { __typename?: 'FilterCriteria' }
  & Pick<Types.FilterCriteria, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FilterCriteriaFolder = (
  { __typename?: 'FilterCriteriaFolder' }
  & Pick<Types.FilterCriteriaFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FilterTaxonomyOption = (
  { __typename?: 'FilterTaxonomyOption' }
  & Pick<Types.FilterTaxonomyOption, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FilterTaxonomyOptions = (
  { __typename?: 'FilterTaxonomyOptions' }
  & Pick<Types.FilterTaxonomyOptions, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FilteredArticlesParentPage = (
  { __typename?: 'FilteredArticlesParentPage' }
  & Pick<Types.FilteredArticlesParentPage, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FilteredArticlesParentPage_6adc5be146ab4c7d97f64e5c3512177d = (
  { __typename?: 'FilteredArticlesParentPage_6adc5be146ab4c7d97f64e5c3512177d' }
  & Pick<Types.FilteredArticlesParentPage_6adc5be146ab4c7d97f64e5c3512177d, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FilteredArticlesParentPage_7f5d344247eb446a8f147890b998e941 = (
  { __typename?: 'FilteredArticlesParentPage_7f5d344247eb446a8f147890b998e941' }
  & Pick<Types.FilteredArticlesParentPage_7f5d344247eb446a8f147890b998e941, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FilteredArticlesParentPage_a34845039cf1441f8c967a5bbbdd7616 = (
  { __typename?: 'FilteredArticlesParentPage_a34845039cf1441f8c967a5bbbdd7616' }
  & Pick<Types.FilteredArticlesParentPage_A34845039cf1441f8c967a5bbbdd7616, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FilteredArticlesParentPage_e4f65f074322485787460a4058d378f9 = (
  { __typename?: 'FilteredArticlesParentPage_e4f65f074322485787460a4058d378f9' }
  & Pick<Types.FilteredArticlesParentPage_E4f65f074322485787460a4058d378f9, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FilteredArticlesParentPage_f099104e87204d52a6ab75aa44d159ce = (
  { __typename?: 'FilteredArticlesParentPage_f099104e87204d52a6ab75aa44d159ce' }
  & Pick<Types.FilteredArticlesParentPage_F099104e87204d52a6ab75aa44d159ce, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage = (
  { __typename?: 'FilteredArticlesWildcardPage' }
  & Pick<Types.FilteredArticlesWildcardPage, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage_5d527e4033c048c6a474af1068db082e = (
  { __typename?: 'FilteredArticlesWildcardPage_5d527e4033c048c6a474af1068db082e' }
  & Pick<Types.FilteredArticlesWildcardPage_5d527e4033c048c6a474af1068db082e, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage_98c82b05868444df9fe806b5fb955835 = (
  { __typename?: 'FilteredArticlesWildcardPage_98c82b05868444df9fe806b5fb955835' }
  & Pick<Types.FilteredArticlesWildcardPage_98c82b05868444df9fe806b5fb955835, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage_705b3bb7cecc447f910fa76bdc57ada2 = (
  { __typename?: 'FilteredArticlesWildcardPage_705b3bb7cecc447f910fa76bdc57ada2' }
  & Pick<Types.FilteredArticlesWildcardPage_705b3bb7cecc447f910fa76bdc57ada2, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage_ceac9aa72d344797adf00f73f9a55f96 = (
  { __typename?: 'FilteredArticlesWildcardPage_ceac9aa72d344797adf00f73f9a55f96' }
  & Pick<Types.FilteredArticlesWildcardPage_Ceac9aa72d344797adf00f73f9a55f96, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage_da761c9a4e8f4a91b99040d8f5baa260 = (
  { __typename?: 'FilteredArticlesWildcardPage_da761c9a4e8f4a91b99040d8f5baa260' }
  & Pick<Types.FilteredArticlesWildcardPage_Da761c9a4e8f4a91b99040d8f5baa260, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Flip = (
  { __typename?: 'Flip' }
  & Pick<Types.Flip, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FlipFolder = (
  { __typename?: 'FlipFolder' }
  & Pick<Types.FlipFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Flip_5ef078504c044b839dafefd752cfaba8 = (
  { __typename?: 'Flip_5ef078504c044b839dafefd752cfaba8' }
  & Pick<Types.Flip_5ef078504c044b839dafefd752cfaba8, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Flipside = (
  { __typename?: 'Flipside' }
  & Pick<Types.Flipside, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FloatFacet = (
  { __typename?: 'FloatFacet' }
  & Pick<Types.FloatFacet, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Footer = (
  { __typename?: 'Footer' }
  & Pick<Types.Footer, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FooterFolder = (
  { __typename?: 'FooterFolder' }
  & Pick<Types.FooterFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FooterLink = (
  { __typename?: 'FooterLink' }
  & Pick<Types.FooterLink, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FormRenderingParameters = (
  { __typename?: 'FormRenderingParameters' }
  & Pick<Types.FormRenderingParameters, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FundAssetClass = (
  { __typename?: 'FundAssetClass' }
  & Pick<Types.FundAssetClass, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FundAssetClassesFolder = (
  { __typename?: 'FundAssetClassesFolder' }
  & Pick<Types.FundAssetClassesFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FundDetailsWildcardPage = (
  { __typename?: 'FundDetailsWildcardPage' }
  & Pick<Types.FundDetailsWildcardPage, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FundDetailsWildcardPage_97df45d1e5294f6dbc2279895ee83734 = (
  { __typename?: 'FundDetailsWildcardPage_97df45d1e5294f6dbc2279895ee83734' }
  & Pick<Types.FundDetailsWildcardPage_97df45d1e5294f6dbc2279895ee83734, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FundDetailsWildcardPage_590b12426ab64f49990b2dd2c5fffd0f = (
  { __typename?: 'FundDetailsWildcardPage_590b12426ab64f49990b2dd2c5fffd0f' }
  & Pick<Types.FundDetailsWildcardPage_590b12426ab64f49990b2dd2c5fffd0f, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FundDetailsWildcardPage_60069dbb81dc496b888fe2e38073a74b = (
  { __typename?: 'FundDetailsWildcardPage_60069dbb81dc496b888fe2e38073a74b' }
  & Pick<Types.FundDetailsWildcardPage_60069dbb81dc496b888fe2e38073a74b, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FundFormsFolder = (
  { __typename?: 'FundFormsFolder' }
  & Pick<Types.FundFormsFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FundInFocus = (
  { __typename?: 'FundInFocus' }
  & Pick<Types.FundInFocus, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FundInFocusShareClass = (
  { __typename?: 'FundInFocusShareClass' }
  & Pick<Types.FundInFocusShareClass, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FundSearchPage = (
  { __typename?: 'FundSearchPage' }
  & Pick<Types.FundSearchPage, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FundSearchPage_5505b84dba1f47c7b8054749d802d926 = (
  { __typename?: 'FundSearchPage_5505b84dba1f47c7b8054749d802d926' }
  & Pick<Types.FundSearchPage_5505b84dba1f47c7b8054749d802d926, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FundSearchPage_5806f83c03bc443380678ff955f4310f = (
  { __typename?: 'FundSearchPage_5806f83c03bc443380678ff955f4310f' }
  & Pick<Types.FundSearchPage_5806f83c03bc443380678ff955f4310f, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FundSearchPage_7432205c04214a419ca064c4cb37501c = (
  { __typename?: 'FundSearchPage_7432205c04214a419ca064c4cb37501c' }
  & Pick<Types.FundSearchPage_7432205c04214a419ca064c4cb37501c, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FundSearchPage_edc9df02132e4c0a8435dd60057cbb0a = (
  { __typename?: 'FundSearchPage_edc9df02132e4c0a8435dd60057cbb0a' }
  & Pick<Types.FundSearchPage_Edc9df02132e4c0a8435dd60057cbb0a, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FundSettings = (
  { __typename?: 'FundSettings' }
  & Pick<Types.FundSettings, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FundShareclassDetailsWildcardPage = (
  { __typename?: 'FundShareclassDetailsWildcardPage' }
  & Pick<Types.FundShareclassDetailsWildcardPage, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FundShareclassDetailsWildcardPage_543d5f778ad443269e2384804031cb3c = (
  { __typename?: 'FundShareclassDetailsWildcardPage_543d5f778ad443269e2384804031cb3c' }
  & Pick<Types.FundShareclassDetailsWildcardPage_543d5f778ad443269e2384804031cb3c, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FundShareclassDetailsWildcardPage_5827425c1b4246d19f1311387a5bd4b3 = (
  { __typename?: 'FundShareclassDetailsWildcardPage_5827425c1b4246d19f1311387a5bd4b3' }
  & Pick<Types.FundShareclassDetailsWildcardPage_5827425c1b4246d19f1311387a5bd4b3, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FundShareclassDetailsWildcardPage_cf3f2635270b49779bb3822ab90f1dcc = (
  { __typename?: 'FundShareclassDetailsWildcardPage_cf3f2635270b49779bb3822ab90f1dcc' }
  & Pick<Types.FundShareclassDetailsWildcardPage_Cf3f2635270b49779bb3822ab90f1dcc, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FundShareclassDetailsWildcardPage_d7e686d9c3bc4ef9974e201972b59eee = (
  { __typename?: 'FundShareclassDetailsWildcardPage_d7e686d9c3bc4ef9974e201972b59eee' }
  & Pick<Types.FundShareclassDetailsWildcardPage_D7e686d9c3bc4ef9974e201972b59eee, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FundSubAssetClass = (
  { __typename?: 'FundSubAssetClass' }
  & Pick<Types.FundSubAssetClass, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FundSubAssetClassesFolder = (
  { __typename?: 'FundSubAssetClassesFolder' }
  & Pick<Types.FundSubAssetClassesFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FundsExternalLiteratureFolder = (
  { __typename?: 'FundsExternalLiteratureFolder' }
  & Pick<Types.FundsExternalLiteratureFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FundsFolder = (
  { __typename?: 'FundsFolder' }
  & Pick<Types.FundsFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FundsInFocusFolder = (
  { __typename?: 'FundsInFocusFolder' }
  & Pick<Types.FundsInFocusFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FundsInFocusParametersTemplate = (
  { __typename?: 'FundsInFocusParametersTemplate' }
  & Pick<Types.FundsInFocusParametersTemplate, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FundsLiteratureFolder = (
  { __typename?: 'FundsLiteratureFolder' }
  & Pick<Types.FundsLiteratureFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FundsLiteratureMappingsFolder = (
  { __typename?: 'FundsLiteratureMappingsFolder' }
  & Pick<Types.FundsLiteratureMappingsFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Gallery = (
  { __typename?: 'Gallery' }
  & Pick<Types.Gallery, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_GalleryFolder = (
  { __typename?: 'GalleryFolder' }
  & Pick<Types.GalleryFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_GalleryImage = (
  { __typename?: 'GalleryImage' }
  & Pick<Types.GalleryImage, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_GalleryParametersTemplate = (
  { __typename?: 'GalleryParametersTemplate' }
  & Pick<Types.GalleryParametersTemplate, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_GalleryVideo = (
  { __typename?: 'GalleryVideo' }
  & Pick<Types.GalleryVideo, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_GatedAccordionContainer = (
  { __typename?: 'GatedAccordionContainer' }
  & Pick<Types.GatedAccordionContainer, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_GlobalLanguageSelector = (
  { __typename?: 'GlobalLanguageSelector' }
  & Pick<Types.GlobalLanguageSelector, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_GlobalNavigationBar = (
  { __typename?: 'GlobalNavigationBar' }
  & Pick<Types.GlobalNavigationBar, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_GoogleAnalytics = (
  { __typename?: 'GoogleAnalytics' }
  & Pick<Types.GoogleAnalytics, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_GoogleTagManager = (
  { __typename?: 'GoogleTagManager' }
  & Pick<Types.GoogleTagManager, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_GoogleTagManagerFolder = (
  { __typename?: 'GoogleTagManagerFolder' }
  & Pick<Types.GoogleTagManagerFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_GridSetup = (
  { __typename?: 'GridSetup' }
  & Pick<Types.GridSetup, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_GridTheme = (
  { __typename?: 'GridTheme' }
  & Pick<Types.GridTheme, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HTMLCode = (
  { __typename?: 'HTMLCode' }
  & Pick<Types.HtmlCode, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HTMLCodeFolder = (
  { __typename?: 'HTMLCodeFolder' }
  & Pick<Types.HtmlCodeFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HTMLInclude = (
  { __typename?: 'HTMLInclude' }
  & Pick<Types.HtmlInclude, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HTMLIncludesFolder = (
  { __typename?: 'HTMLIncludesFolder' }
  & Pick<Types.HtmlIncludesFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HTMLSnippet = (
  { __typename?: 'HTMLSnippet' }
  & Pick<Types.HtmlSnippet, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HTMLSnippetFolder = (
  { __typename?: 'HTMLSnippetFolder' }
  & Pick<Types.HtmlSnippetFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HTMLTag = (
  { __typename?: 'HTMLTag' }
  & Pick<Types.HtmlTag, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Header = (
  { __typename?: 'Header' }
  & Pick<Types.Header, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HeaderFolder = (
  { __typename?: 'HeaderFolder' }
  & Pick<Types.HeaderFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Heading = (
  { __typename?: 'Heading' }
  & Pick<Types.Heading, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HeadlessSiteSetupRoot = (
  { __typename?: 'HeadlessSiteSetupRoot' }
  & Pick<Types.HeadlessSiteSetupRoot, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HeadlessSite_00d050988bad49e5b65db1e08b03ca1b = (
  { __typename?: 'HeadlessSite_00d050988bad49e5b65db1e08b03ca1b' }
  & Pick<Types.HeadlessSite_00d050988bad49e5b65db1e08b03ca1b, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HeadlessSite_0bb67daed5d04933a5ce1c0baa6c4df1 = (
  { __typename?: 'HeadlessSite_0bb67daed5d04933a5ce1c0baa6c4df1' }
  & Pick<Types.HeadlessSite_0bb67daed5d04933a5ce1c0baa6c4df1, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HeadlessSite_8ca001453c4b4715959d8a05292ecbc5 = (
  { __typename?: 'HeadlessSite_8ca001453c4b4715959d8a05292ecbc5' }
  & Pick<Types.HeadlessSite_8ca001453c4b4715959d8a05292ecbc5, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HeadlessSite_68ffa40c5aab45548f774742b163f318 = (
  { __typename?: 'HeadlessSite_68ffa40c5aab45548f774742b163f318' }
  & Pick<Types.HeadlessSite_68ffa40c5aab45548f774742b163f318, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HeadlessSite_89d464c8c03e4b0287e9a878d95d7149 = (
  { __typename?: 'HeadlessSite_89d464c8c03e4b0287e9a878d95d7149' }
  & Pick<Types.HeadlessSite_89d464c8c03e4b0287e9a878d95d7149, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HeadlessSite_229484893ca144958b9937167dfb5064 = (
  { __typename?: 'HeadlessSite_229484893ca144958b9937167dfb5064' }
  & Pick<Types.HeadlessSite_229484893ca144958b9937167dfb5064, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HeadlessSite_b28055626acc45a2913a9617398c9730 = (
  { __typename?: 'HeadlessSite_b28055626acc45a2913a9617398c9730' }
  & Pick<Types.HeadlessSite_B28055626acc45a2913a9617398c9730, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HeadlessSite_f1cab1661abb450d84d55d938e7699cb = (
  { __typename?: 'HeadlessSite_f1cab1661abb450d84d55d938e7699cb' }
  & Pick<Types.HeadlessSite_F1cab1661abb450d84d55d938e7699cb, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HeadlessSite_f3884baa0e1548f59a6d7154a4559604 = (
  { __typename?: 'HeadlessSite_f3884baa0e1548f59a6d7154a4559604' }
  & Pick<Types.HeadlessSite_F3884baa0e1548f59a6d7154a4559604, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HeadlessSolutionTemplateFolder = (
  { __typename?: 'HeadlessSolutionTemplateFolder' }
  & Pick<Types.HeadlessSolutionTemplateFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HeadlessTenantSetupRoot = (
  { __typename?: 'HeadlessTenantSetupRoot' }
  & Pick<Types.HeadlessTenantSetupRoot, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HeadlessTenant_07248c4700af499eb2a9cb7789f72372 = (
  { __typename?: 'HeadlessTenant_07248c4700af499eb2a9cb7789f72372' }
  & Pick<Types.HeadlessTenant_07248c4700af499eb2a9cb7789f72372, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HeadlessTenant_5b3d7ac5419343c697c722309a2ad4c8 = (
  { __typename?: 'HeadlessTenant_5b3d7ac5419343c697c722309a2ad4c8' }
  & Pick<Types.HeadlessTenant_5b3d7ac5419343c697c722309a2ad4c8, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HeadlessTenant_5d72df6049c74324969205b55767ad7b = (
  { __typename?: 'HeadlessTenant_5d72df6049c74324969205b55767ad7b' }
  & Pick<Types.HeadlessTenant_5d72df6049c74324969205b55767ad7b, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HeadlessTenant_6abd3bf16bcb4f25ac5b2399ff7a92e3 = (
  { __typename?: 'HeadlessTenant_6abd3bf16bcb4f25ac5b2399ff7a92e3' }
  & Pick<Types.HeadlessTenant_6abd3bf16bcb4f25ac5b2399ff7a92e3, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HeadlessTenant_77a403a2094e48afafa60943d349d23d = (
  { __typename?: 'HeadlessTenant_77a403a2094e48afafa60943d349d23d' }
  & Pick<Types.HeadlessTenant_77a403a2094e48afafa60943d349d23d, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HeadlessTenant_115c42029c0d4fbcb542a4a539c33ee2 = (
  { __typename?: 'HeadlessTenant_115c42029c0d4fbcb542a4a539c33ee2' }
  & Pick<Types.HeadlessTenant_115c42029c0d4fbcb542a4a539c33ee2, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HeadlessTenant_94824ac390d748499e5af0275d10811f = (
  { __typename?: 'HeadlessTenant_94824ac390d748499e5af0275d10811f' }
  & Pick<Types.HeadlessTenant_94824ac390d748499e5af0275d10811f, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HeadlessTenant_4797571864fd40929cf2412c39757ec3 = (
  { __typename?: 'HeadlessTenant_4797571864fd40929cf2412c39757ec3' }
  & Pick<Types.HeadlessTenant_4797571864fd40929cf2412c39757ec3, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HeadlessTenant_c102fb48f40f49fb9c21f8e3e1b0c107 = (
  { __typename?: 'HeadlessTenant_c102fb48f40f49fb9c21f8e3e1b0c107' }
  & Pick<Types.HeadlessTenant_C102fb48f40f49fb9c21f8e3e1b0c107, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HeadlessTrustSite = (
  { __typename?: 'HeadlessTrustSite' }
  & Pick<Types.HeadlessTrustSite, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HeadlessVariants = (
  { __typename?: 'HeadlessVariants' }
  & Pick<Types.HeadlessVariants, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HeadlessVariantsGrouping = (
  { __typename?: 'HeadlessVariantsGrouping' }
  & Pick<Types.HeadlessVariantsGrouping, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HelpArticlePage = (
  { __typename?: 'HelpArticlePage' }
  & Pick<Types.HelpArticlePage, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HelpArticlePlatform = (
  { __typename?: 'HelpArticlePlatform' }
  & Pick<Types.HelpArticlePlatform, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HelpArticlePlatformMap = (
  { __typename?: 'HelpArticlePlatformMap' }
  & Pick<Types.HelpArticlePlatformMap, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HelpArticlePlatformMappings = (
  { __typename?: 'HelpArticlePlatformMappings' }
  & Pick<Types.HelpArticlePlatformMappings, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HelpArticlePlatformsFolder = (
  { __typename?: 'HelpArticlePlatformsFolder' }
  & Pick<Types.HelpArticlePlatformsFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HelpArticleSearchPage = (
  { __typename?: 'HelpArticleSearchPage' }
  & Pick<Types.HelpArticleSearchPage, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HelpArticleSearchPage_486d4c7432c64f9a929b595943c6fe77 = (
  { __typename?: 'HelpArticleSearchPage_486d4c7432c64f9a929b595943c6fe77' }
  & Pick<Types.HelpArticleSearchPage_486d4c7432c64f9a929b595943c6fe77, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HelpArticleTag = (
  { __typename?: 'HelpArticleTag' }
  & Pick<Types.HelpArticleTag, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HelpArticleTagsFolder = (
  { __typename?: 'HelpArticleTagsFolder' }
  & Pick<Types.HelpArticleTagsFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HelpArticleWildcardPage = (
  { __typename?: 'HelpArticleWildcardPage' }
  & Pick<Types.HelpArticleWildcardPage, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HelpArticleWildcardPage_e4e2d58c853341deaa6b2a2a136421c4 = (
  { __typename?: 'HelpArticleWildcardPage_e4e2d58c853341deaa6b2a2a136421c4' }
  & Pick<Types.HelpArticleWildcardPage_E4e2d58c853341deaa6b2a2a136421c4, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HelpArticlesGroupFolder = (
  { __typename?: 'HelpArticlesGroupFolder' }
  & Pick<Types.HelpArticlesGroupFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HelpTagMap = (
  { __typename?: 'HelpTagMap' }
  & Pick<Types.HelpTagMap, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HelpTagMappings = (
  { __typename?: 'HelpTagMappings' }
  & Pick<Types.HelpTagMappings, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HeroBanner = (
  { __typename?: 'HeroBanner' }
  & Pick<Types.HeroBanner, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Highlight = (
  { __typename?: 'Highlight' }
  & Pick<Types.Highlight, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HighlightBlock = (
  { __typename?: 'HighlightBlock' }
  & Pick<Types.HighlightBlock, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HighlightBlockFolder = (
  { __typename?: 'HighlightBlockFolder' }
  & Pick<Types.HighlightBlockFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HighlightBlockParametersTemplate = (
  { __typename?: 'HighlightBlockParametersTemplate' }
  & Pick<Types.HighlightBlockParametersTemplate, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HighlightFolder = (
  { __typename?: 'HighlightFolder' }
  & Pick<Types.HighlightFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HighlightItem = (
  { __typename?: 'HighlightItem' }
  & Pick<Types.HighlightItem, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HighlightParametersTemplate = (
  { __typename?: 'HighlightParametersTemplate' }
  & Pick<Types.HighlightParametersTemplate, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Home = (
  { __typename?: 'Home' }
  & Pick<Types.Home, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HomePage = (
  { __typename?: 'HomePage' }
  & Pick<Types.HomePage, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HomePage_0d3963a8171d4080b5f808618578b631 = (
  { __typename?: 'HomePage_0d3963a8171d4080b5f808618578b631' }
  & Pick<Types.HomePage_0d3963a8171d4080b5f808618578b631, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HomePage_6d95c7d946c74a70be07304cc73a2010 = (
  { __typename?: 'HomePage_6d95c7d946c74a70be07304cc73a2010' }
  & Pick<Types.HomePage_6d95c7d946c74a70be07304cc73a2010, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HomePage_b407f259b4e34c7db9a06e8907a56b17 = (
  { __typename?: 'HomePage_b407f259b4e34c7db9a06e8907a56b17' }
  & Pick<Types.HomePage_B407f259b4e34c7db9a06e8907a56b17, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HomePage_cde13c51062d426b95569e8202edc963 = (
  { __typename?: 'HomePage_cde13c51062d426b95569e8202edc963' }
  & Pick<Types.HomePage_Cde13c51062d426b95569e8202edc963, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HomePage_de9353283a3e41c495ba386aed0540c6 = (
  { __typename?: 'HomePage_de9353283a3e41c495ba386aed0540c6' }
  & Pick<Types.HomePage_De9353283a3e41c495ba386aed0540c6, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_IFrame = (
  { __typename?: 'IFrame' }
  & Pick<Types.IFrame, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_IFrameFolder = (
  { __typename?: 'IFrameFolder' }
  & Pick<Types.IFrameFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_IFrameFolder_21366ebf5fda4ff4a4dac7b1f4d7ada2 = (
  { __typename?: 'IFrameFolder_21366ebf5fda4ff4a4dac7b1f4d7ada2' }
  & Pick<Types.IFrameFolder_21366ebf5fda4ff4a4dac7b1f4d7ada2, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_IFrameParametersTemplate = (
  { __typename?: 'IFrameParametersTemplate' }
  & Pick<Types.IFrameParametersTemplate, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_IFrame_0da12d476de24dfeb4d0f513489bfea1 = (
  { __typename?: 'IFrame_0da12d476de24dfeb4d0f513489bfea1' }
  & Pick<Types.IFrame_0da12d476de24dfeb4d0f513489bfea1, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_IFrame_88a6f65f2b78491bb3770b06e48883e1 = (
  { __typename?: 'IFrame_88a6f65f2b78491bb3770b06e48883e1' }
  & Pick<Types.IFrame_88a6f65f2b78491bb3770b06e48883e1, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Icon = (
  { __typename?: 'Icon' }
  & Pick<Types.Icon, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_IconFolder = (
  { __typename?: 'IconFolder' }
  & Pick<Types.IconFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Image = (
  { __typename?: 'Image' }
  & Pick<Types.Image, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ImageFolder = (
  { __typename?: 'ImageFolder' }
  & Pick<Types.ImageFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ImageFolder_edc00e86cef24d0cbfa264460becc323 = (
  { __typename?: 'ImageFolder_edc00e86cef24d0cbfa264460becc323' }
  & Pick<Types.ImageFolder_Edc00e86cef24d0cbfa264460becc323, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ImageFolder_f7a4527687f14ea5bf25e3c7cb7aa993 = (
  { __typename?: 'ImageFolder_f7a4527687f14ea5bf25e3c7cb7aa993' }
  & Pick<Types.ImageFolder_F7a4527687f14ea5bf25e3c7cb7aa993, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ImageParametersTemplate = (
  { __typename?: 'ImageParametersTemplate' }
  & Pick<Types.ImageParametersTemplate, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Image_83bc563c6320490092f8204bff81586a = (
  { __typename?: 'Image_83bc563c6320490092f8204bff81586a' }
  & Pick<Types.Image_83bc563c6320490092f8204bff81586a, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Image_15185b0e641844499f934ff03b7ee032 = (
  { __typename?: 'Image_15185b0e641844499f934ff03b7ee032' }
  & Pick<Types.Image_15185b0e641844499f934ff03b7ee032, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Image_d885df8cb2d64007b34b2bbafb527304 = (
  { __typename?: 'Image_d885df8cb2d64007b34b2bbafb527304' }
  & Pick<Types.Image_D885df8cb2d64007b34b2bbafb527304, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Infographics = (
  { __typename?: 'Infographics' }
  & Pick<Types.Infographics, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_InfographicsFolder = (
  { __typename?: 'InfographicsFolder' }
  & Pick<Types.InfographicsFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_InputValidationStep = (
  { __typename?: 'InputValidationStep' }
  & Pick<Types.InputValidationStep, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_InputValidationStep_088928cf558e40ec87f3342aa9e66757 = (
  { __typename?: 'InputValidationStep_088928cf558e40ec87f3342aa9e66757' }
  & Pick<Types.InputValidationStep_088928cf558e40ec87f3342aa9e66757, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_InputValidationStep_9eded2f7f84748938a0bf69e7fcf3593 = (
  { __typename?: 'InputValidationStep_9eded2f7f84748938a0bf69e7fcf3593' }
  & Pick<Types.InputValidationStep_9eded2f7f84748938a0bf69e7fcf3593, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_InputValidationStep_d028fef2babf4ad1bbe74d62a977992f = (
  { __typename?: 'InputValidationStep_d028fef2babf4ad1bbe74d62a977992f' }
  & Pick<Types.InputValidationStep_D028fef2babf4ad1bbe74d62a977992f, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_IntegerFacet = (
  { __typename?: 'IntegerFacet' }
  & Pick<Types.IntegerFacet, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_IntroCopy = (
  { __typename?: 'IntroCopy' }
  & Pick<Types.IntroCopy, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_IntroCopyFolder = (
  { __typename?: 'IntroCopyFolder' }
  & Pick<Types.IntroCopyFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_InvestmentTrustAssetClass = (
  { __typename?: 'InvestmentTrustAssetClass' }
  & Pick<Types.InvestmentTrustAssetClass, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_InvestmentTrustAssetClassFolder = (
  { __typename?: 'InvestmentTrustAssetClassFolder' }
  & Pick<Types.InvestmentTrustAssetClassFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_InvestmentTrustPage_8f108193367d41dcb4dc3a71722c2b73 = (
  { __typename?: 'InvestmentTrustPage_8f108193367d41dcb4dc3a71722c2b73' }
  & Pick<Types.InvestmentTrustPage_8f108193367d41dcb4dc3a71722c2b73, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_InvestmentTrustPage_79a99ec28fe841f0a929356fe3a6aaeb = (
  { __typename?: 'InvestmentTrustPage_79a99ec28fe841f0a929356fe3a6aaeb' }
  & Pick<Types.InvestmentTrustPage_79a99ec28fe841f0a929356fe3a6aaeb, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_InvestmentTrustRegion = (
  { __typename?: 'InvestmentTrustRegion' }
  & Pick<Types.InvestmentTrustRegion, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_InvestmentTrustRegionFolder = (
  { __typename?: 'InvestmentTrustRegionFolder' }
  & Pick<Types.InvestmentTrustRegionFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_InvestmentTrustStyle = (
  { __typename?: 'InvestmentTrustStyle' }
  & Pick<Types.InvestmentTrustStyle, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_InvestmentTrustStyleFolder = (
  { __typename?: 'InvestmentTrustStyleFolder' }
  & Pick<Types.InvestmentTrustStyleFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_InvestorType = (
  { __typename?: 'InvestorType' }
  & Pick<Types.InvestorType, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_InvestorTypesFolder = (
  { __typename?: 'InvestorTypesFolder' }
  & Pick<Types.InvestorTypesFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ItemQueriesFolder = (
  { __typename?: 'ItemQueriesFolder' }
  & Pick<Types.ItemQueriesFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ItemRights = (
  { __typename?: 'ItemRights' }
  & Pick<Types.ItemRights, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_JSBeaconSettings = (
  { __typename?: 'JSBeaconSettings' }
  & Pick<Types.JsBeaconSettings, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_JSONCheckbox = (
  { __typename?: 'JSONCheckbox' }
  & Pick<Types.JsonCheckbox, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_JSONContent = (
  { __typename?: 'JSONContent' }
  & Pick<Types.JsonContent, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_JSONDate = (
  { __typename?: 'JSONDate' }
  & Pick<Types.JsonDate, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_JSONFile = (
  { __typename?: 'JSONFile' }
  & Pick<Types.JsonFile, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_JSONImage = (
  { __typename?: 'JSONImage' }
  & Pick<Types.JsonImage, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_JSONLayout = (
  { __typename?: 'JSONLayout' }
  & Pick<Types.JsonLayout, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_JSONList = (
  { __typename?: 'JSONList' }
  & Pick<Types.JsonList, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_JSONMultilistReference = (
  { __typename?: 'JSONMultilistReference' }
  & Pick<Types.JsonMultilistReference, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_JSONPlaceholder = (
  { __typename?: 'JSONPlaceholder' }
  & Pick<Types.JsonPlaceholder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_JSONQuery = (
  { __typename?: 'JSONQuery' }
  & Pick<Types.JsonQuery, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_JSONResults = (
  { __typename?: 'JSONResults' }
  & Pick<Types.JsonResults, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_JSONRichText = (
  { __typename?: 'JSONRichText' }
  & Pick<Types.JsonRichText, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_JSONScriban = (
  { __typename?: 'JSONScriban' }
  & Pick<Types.JsonScriban, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_JSONSection = (
  { __typename?: 'JSONSection' }
  & Pick<Types.JsonSection, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_JSONTemplate = (
  { __typename?: 'JSONTemplate' }
  & Pick<Types.JsonTemplate, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_JSONText = (
  { __typename?: 'JSONText' }
  & Pick<Types.JsonText, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_JSONToken = (
  { __typename?: 'JSONToken' }
  & Pick<Types.JsonToken, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_JSONVariantDefinition = (
  { __typename?: 'JSONVariantDefinition' }
  & Pick<Types.JsonVariantDefinition, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_JSONVariants = (
  { __typename?: 'JSONVariants' }
  & Pick<Types.JsonVariants, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_JSSLayout = (
  { __typename?: 'JSSLayout' }
  & Pick<Types.JssLayout, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_JSSSettings_1a6fb678eca242c09ae77a9e7f72a6d0 = (
  { __typename?: 'JSSSettings_1a6fb678eca242c09ae77a9e7f72a6d0' }
  & Pick<Types.JssSettings_1a6fb678eca242c09ae77a9e7f72a6d0, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_JSSSettings_6b328292f8314ab79885d89a054ca10a = (
  { __typename?: 'JSSSettings_6b328292f8314ab79885d89a054ca10a' }
  & Pick<Types.JssSettings_6b328292f8314ab79885d89a054ca10a, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_JSSSettings_457c9d0b61b84adfaf7f82561ed275ff = (
  { __typename?: 'JSSSettings_457c9d0b61b84adfaf7f82561ed275ff' }
  & Pick<Types.JssSettings_457c9d0b61b84adfaf7f82561ed275ff, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_JSSSettings_5045bf85d2ea430b9f41c2e348436e5d = (
  { __typename?: 'JSSSettings_5045bf85d2ea430b9f41c2e348436e5d' }
  & Pick<Types.JssSettings_5045bf85d2ea430b9f41c2e348436e5d, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_JSSSettings_a767f80d5ad44bfbb8b750a8da144cb5 = (
  { __typename?: 'JSSSettings_a767f80d5ad44bfbb8b750a8da144cb5' }
  & Pick<Types.JssSettings_A767f80d5ad44bfbb8b750a8da144cb5, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_JSSSettings_b001fd725bb1476496825a8cb9e995cd = (
  { __typename?: 'JSSSettings_b001fd725bb1476496825a8cb9e995cd' }
  & Pick<Types.JssSettings_B001fd725bb1476496825a8cb9e995cd, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_JSSSettings_c643bc8630d14d61a173c7870f5dbbad = (
  { __typename?: 'JSSSettings_c643bc8630d14d61a173c7870f5dbbad' }
  & Pick<Types.JssSettings_C643bc8630d14d61a173c7870f5dbbad, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_JSSSettings_ce3dfd340df34b2d8715e54f85dfcce2 = (
  { __typename?: 'JSSSettings_ce3dfd340df34b2d8715e54f85dfcce2' }
  & Pick<Types.JssSettings_Ce3dfd340df34b2d8715e54f85dfcce2, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_JSSSettings_ef855d0ba8b04a8e87851d1298266d90 = (
  { __typename?: 'JSSSettings_ef855d0ba8b04a8e87851d1298266d90' }
  & Pick<Types.JssSettings_Ef855d0ba8b04a8e87851d1298266d90, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_JSSSiteGrouping = (
  { __typename?: 'JSSSiteGrouping' }
  & Pick<Types.JssSiteGrouping, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_JSSTenantFolder = (
  { __typename?: 'JSSTenantFolder' }
  & Pick<Types.JssTenantFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_JavaScriptRendering = (
  { __typename?: 'JavaScriptRendering' }
  & Pick<Types.JavaScriptRendering, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_JsonRendering = (
  { __typename?: 'JsonRendering' }
  & Pick<Types.JsonRendering, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_JurisdictionStatus = (
  { __typename?: 'JurisdictionStatus' }
  & Pick<Types.JurisdictionStatus, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_JurisdictionsFolder = (
  { __typename?: 'JurisdictionsFolder' }
  & Pick<Types.JurisdictionsFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_KeyHighlightItem = (
  { __typename?: 'KeyHighlightItem' }
  & Pick<Types.KeyHighlightItem, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_KeyHighlights = (
  { __typename?: 'KeyHighlights' }
  & Pick<Types.KeyHighlights, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_KeyHighlightsFolder = (
  { __typename?: 'KeyHighlightsFolder' }
  & Pick<Types.KeyHighlightsFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_KeyHighlightsParametersTemplate = (
  { __typename?: 'KeyHighlightsParametersTemplate' }
  & Pick<Types.KeyHighlightsParametersTemplate, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Language = (
  { __typename?: 'Language' }
  & Pick<Types.Language, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_LanguageSelector = (
  { __typename?: 'LanguageSelector' }
  & Pick<Types.LanguageSelector, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_LanguagesFolder = (
  { __typename?: 'LanguagesFolder' }
  & Pick<Types.LanguagesFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_LatestPressReleasesParametersTemplate = (
  { __typename?: 'LatestPressReleasesParametersTemplate' }
  & Pick<Types.LatestPressReleasesParametersTemplate, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_LayoutServiceVariants = (
  { __typename?: 'LayoutServiceVariants' }
  & Pick<Types.LayoutServiceVariants, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_LimitedDisplayFolder = (
  { __typename?: 'LimitedDisplayFolder' }
  & Pick<Types.LimitedDisplayFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_LimitedDisplayOption = (
  { __typename?: 'LimitedDisplayOption' }
  & Pick<Types.LimitedDisplayOption, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Link = (
  { __typename?: 'Link' }
  & Pick<Types.Link, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_LinkList = (
  { __typename?: 'LinkList' }
  & Pick<Types.LinkList, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_LinkListFolder = (
  { __typename?: 'LinkListFolder' }
  & Pick<Types.LinkListFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_LinkListFolder_c237d144647a4afeaa7b1570f3e3f139 = (
  { __typename?: 'LinkListFolder_c237d144647a4afeaa7b1570f3e3f139' }
  & Pick<Types.LinkListFolder_C237d144647a4afeaa7b1570f3e3f139, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_LinkList_33c9207e3b0446068ef54ca99a97c776 = (
  { __typename?: 'LinkList_33c9207e3b0446068ef54ca99a97c776' }
  & Pick<Types.LinkList_33c9207e3b0446068ef54ca99a97c776, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_LinkList_97a593ad273141dc80bfceb5ef6a33b7 = (
  { __typename?: 'LinkList_97a593ad273141dc80bfceb5ef6a33b7' }
  & Pick<Types.LinkList_97a593ad273141dc80bfceb5ef6a33b7, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_LinkList_f7561ffcc0d8477fb53d2703a4060be1 = (
  { __typename?: 'LinkList_f7561ffcc0d8477fb53d2703a4060be1' }
  & Pick<Types.LinkList_F7561ffcc0d8477fb53d2703a4060be1, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Link_68bd1cb5a7624a969ac6cb16ab5882a3 = (
  { __typename?: 'Link_68bd1cb5a7624a969ac6cb16ab5882a3' }
  & Pick<Types.Link_68bd1cb5a7624a969ac6cb16ab5882a3, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Link_930f134d56784b35bfd1b77f9d0115f1 = (
  { __typename?: 'Link_930f134d56784b35bfd1b77f9d0115f1' }
  & Pick<Types.Link_930f134d56784b35bfd1b77f9d0115f1, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Link_e24e0789a05848bfabb6c69c0e60b6b7 = (
  { __typename?: 'Link_e24e0789a05848bfabb6c69c0e60b6b7' }
  & Pick<Types.Link_E24e0789a05848bfabb6c69c0e60b6b7, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_LinksFolder = (
  { __typename?: 'LinksFolder' }
  & Pick<Types.LinksFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_List = (
  { __typename?: 'List' }
  & Pick<Types.List, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ListFacet = (
  { __typename?: 'ListFacet' }
  & Pick<Types.ListFacet, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ListFolder = (
  { __typename?: 'ListFolder' }
  & Pick<Types.ListFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ListItem = (
  { __typename?: 'ListItem' }
  & Pick<Types.ListItem, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ListParametersTemplate = (
  { __typename?: 'ListParametersTemplate' }
  & Pick<Types.ListParametersTemplate, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ListStyle = (
  { __typename?: 'ListStyle' }
  & Pick<Types.ListStyle, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ListStyleItem = (
  { __typename?: 'ListStyleItem' }
  & Pick<Types.ListStyleItem, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ListingHeroBanner = (
  { __typename?: 'ListingHeroBanner' }
  & Pick<Types.ListingHeroBanner, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ListingHeroParametersTemplate = (
  { __typename?: 'ListingHeroParametersTemplate' }
  & Pick<Types.ListingHeroParametersTemplate, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_LiteratureAuthorization = (
  { __typename?: 'LiteratureAuthorization' }
  & Pick<Types.LiteratureAuthorization, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_LiteratureAuthorizationsFolder = (
  { __typename?: 'LiteratureAuthorizationsFolder' }
  & Pick<Types.LiteratureAuthorizationsFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_LiteratureHubSearchPage = (
  { __typename?: 'LiteratureHubSearchPage' }
  & Pick<Types.LiteratureHubSearchPage, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_LiteratureHubSearchPage_62f4748b81db49ee9be8b674a7f42d9d = (
  { __typename?: 'LiteratureHubSearchPage_62f4748b81db49ee9be8b674a7f42d9d' }
  & Pick<Types.LiteratureHubSearchPage_62f4748b81db49ee9be8b674a7f42d9d, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_LiteratureHubSearchPage_94278fe5377a4665bccbd1d4cef5e30e = (
  { __typename?: 'LiteratureHubSearchPage_94278fe5377a4665bccbd1d4cef5e30e' }
  & Pick<Types.LiteratureHubSearchPage_94278fe5377a4665bccbd1d4cef5e30e, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_LiteratureHubSearchPage_d2b2958263564ba8bba5922add46a0ea = (
  { __typename?: 'LiteratureHubSearchPage_d2b2958263564ba8bba5922add46a0ea' }
  & Pick<Types.LiteratureHubSearchPage_D2b2958263564ba8bba5922add46a0ea, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_LoadMore = (
  { __typename?: 'LoadMore' }
  & Pick<Types.LoadMore, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_LoadMoreFolder = (
  { __typename?: 'LoadMoreFolder' }
  & Pick<Types.LoadMoreFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_LoadMore_7a3a53e06a0144ff8ba52be46e201fe6 = (
  { __typename?: 'LoadMore_7a3a53e06a0144ff8ba52be46e201fe6' }
  & Pick<Types.LoadMore_7a3a53e06a0144ff8ba52be46e201fe6, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_LocationFilter = (
  { __typename?: 'LocationFilter' }
  & Pick<Types.LocationFilter, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_LocationFilterFolder = (
  { __typename?: 'LocationFilterFolder' }
  & Pick<Types.LocationFilterFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_LocationFilter_aaad4aad290744dc90b69e4e83a661ec = (
  { __typename?: 'LocationFilter_aaad4aad290744dc90b69e4e83a661ec' }
  & Pick<Types.LocationFilter_Aaad4aad290744dc90b69e4e83a661ec, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Log = (
  { __typename?: 'Log' }
  & Pick<Types.Log, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Login = (
  { __typename?: 'Login' }
  & Pick<Types.Login, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Login_abed54dc4f7840ddac562289c9c849d8 = (
  { __typename?: 'Login_abed54dc4f7840ddac562289c9c849d8' }
  & Pick<Types.Login_Abed54dc4f7840ddac562289c9c849d8, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_LogoTextBlockItem = (
  { __typename?: 'LogoTextBlockItem' }
  & Pick<Types.LogoTextBlockItem, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_LogoTextBlocks = (
  { __typename?: 'LogoTextBlocks' }
  & Pick<Types.LogoTextBlocks, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_LogoTextBlocksFolder = (
  { __typename?: 'LogoTextBlocksFolder' }
  & Pick<Types.LogoTextBlocksFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Logout = (
  { __typename?: 'Logout' }
  & Pick<Types.Logout, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Logout_c2294d8235a6452a94b15eb5e543b602 = (
  { __typename?: 'Logout_c2294d8235a6452a94b15eb5e543b602' }
  & Pick<Types.Logout_C2294d8235a6452a94b15eb5e543b602, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ManagedRangeFilter = (
  { __typename?: 'ManagedRangeFilter' }
  & Pick<Types.ManagedRangeFilter, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ManagedRangeFilterFolder = (
  { __typename?: 'ManagedRangeFilterFolder' }
  & Pick<Types.ManagedRangeFilterFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ManagedRangeFilter_14c6033e186b49088bb925aba0da4d91 = (
  { __typename?: 'ManagedRangeFilter_14c6033e186b49088bb925aba0da4d91' }
  & Pick<Types.ManagedRangeFilter_14c6033e186b49088bb925aba0da4d91, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ManagedRangeItem = (
  { __typename?: 'ManagedRangeItem' }
  & Pick<Types.ManagedRangeItem, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Map = (
  { __typename?: 'Map' }
  & Pick<Types.Map, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_MapParameters = (
  { __typename?: 'MapParameters' }
  & Pick<Types.MapParameters, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_MapsFolder = (
  { __typename?: 'MapsFolder' }
  & Pick<Types.MapsFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_MapsProvider = (
  { __typename?: 'MapsProvider' }
  & Pick<Types.MapsProvider, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_MediaBlock = (
  { __typename?: 'MediaBlock' }
  & Pick<Types.MediaBlock, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_MediaBlockFolder = (
  { __typename?: 'MediaBlockFolder' }
  & Pick<Types.MediaBlockFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_MediaBlockParametersTemplate = (
  { __typename?: 'MediaBlockParametersTemplate' }
  & Pick<Types.MediaBlockParametersTemplate, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_MediaFolder_81150e5837f5443fa3c075e14a9321e7 = (
  { __typename?: 'MediaFolder_81150e5837f5443fa3c075e14a9321e7' }
  & Pick<Types.MediaFolder_81150e5837f5443fa3c075e14a9321e7, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_MediaLinkParameters = (
  { __typename?: 'MediaLinkParameters' }
  & Pick<Types.MediaLinkParameters, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_MediaVirtualFolder = (
  { __typename?: 'MediaVirtualFolder' }
  & Pick<Types.MediaVirtualFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_MegaNavigation = (
  { __typename?: 'MegaNavigation' }
  & Pick<Types.MegaNavigation, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_MegaNavigationFolder = (
  { __typename?: 'MegaNavigationFolder' }
  & Pick<Types.MegaNavigationFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_MetaBranding = (
  { __typename?: 'MetaBranding' }
  & Pick<Types.MetaBranding, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_MetaRenderingParameters = (
  { __typename?: 'MetaRenderingParameters' }
  & Pick<Types.MetaRenderingParameters, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_MetadataPartialDesign = (
  { __typename?: 'MetadataPartialDesign' }
  & Pick<Types.MetadataPartialDesign, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Model = (
  { __typename?: 'Model' }
  & Pick<Types.Model, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ModelIterator = (
  { __typename?: 'ModelIterator' }
  & Pick<Types.ModelIterator, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_MyLocationPOI = (
  { __typename?: 'MyLocationPOI' }
  & Pick<Types.MyLocationPoi, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Navigation = (
  { __typename?: 'Navigation' }
  & Pick<Types.Navigation, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_NavigationCategory = (
  { __typename?: 'NavigationCategory' }
  & Pick<Types.NavigationCategory, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_NavigationFilter = (
  { __typename?: 'NavigationFilter' }
  & Pick<Types.NavigationFilter, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_NavigationFilterFolder = (
  { __typename?: 'NavigationFilterFolder' }
  & Pick<Types.NavigationFilterFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_NavigationLink = (
  { __typename?: 'NavigationLink' }
  & Pick<Types.NavigationLink, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_NavigationSubcategory = (
  { __typename?: 'NavigationSubcategory' }
  & Pick<Types.NavigationSubcategory, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Navigation_9ce34bf95c934dff841d8f649c2bd6c8 = (
  { __typename?: 'Navigation_9ce34bf95c934dff841d8f649c2bd6c8' }
  & Pick<Types.Navigation_9ce34bf95c934dff841d8f649c2bd6c8, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_OneTrustSettings = (
  { __typename?: 'OneTrustSettings' }
  & Pick<Types.OneTrustSettings, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_OptimiserConfiguration = (
  { __typename?: 'OptimiserConfiguration' }
  & Pick<Types.OptimiserConfiguration, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_OptimiserConfigurationSection = (
  { __typename?: 'OptimiserConfigurationSection' }
  & Pick<Types.OptimiserConfigurationSection, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_OptimizedFile = (
  { __typename?: 'OptimizedFile' }
  & Pick<Types.OptimizedFile, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_OracleCDPSettings = (
  { __typename?: 'OracleCDPSettings' }
  & Pick<Types.OracleCdpSettings, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_OverlayContent = (
  { __typename?: 'OverlayContent' }
  & Pick<Types.OverlayContent, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_OverlayFolderTemplate = (
  { __typename?: 'OverlayFolderTemplate' }
  & Pick<Types.OverlayFolderTemplate, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Ownership = (
  { __typename?: 'Ownership' }
  & Pick<Types.Ownership, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_OwnershipFolder = (
  { __typename?: 'OwnershipFolder' }
  & Pick<Types.OwnershipFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_POI = (
  { __typename?: 'POI' }
  & Pick<Types.Poi, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_POIFolder = (
  { __typename?: 'POIFolder' }
  & Pick<Types.PoiFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_POIType = (
  { __typename?: 'POIType' }
  & Pick<Types.PoiType, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_POIs = (
  { __typename?: 'POIs' }
  & Pick<Types.PoIs, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PageBranchesFolder = (
  { __typename?: 'PageBranchesFolder' }
  & Pick<Types.PageBranchesFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PageContent = (
  { __typename?: 'PageContent' }
  & Pick<Types.PageContent, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PageContentFolder = (
  { __typename?: 'PageContentFolder' }
  & Pick<Types.PageContentFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PageContent_ef87e73bc7ff49a2ac599b0be83755c3 = (
  { __typename?: 'PageContent_ef87e73bc7ff49a2ac599b0be83755c3' }
  & Pick<Types.PageContent_Ef87e73bc7ff49a2ac599b0be83755c3, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PageDesign = (
  { __typename?: 'PageDesign' }
  & Pick<Types.PageDesign, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PageDesignFolder_1aa9bc8250a94e4eb15003b55b4dfed0 = (
  { __typename?: 'PageDesignFolder_1aa9bc8250a94e4eb15003b55b4dfed0' }
  & Pick<Types.PageDesignFolder_1aa9bc8250a94e4eb15003b55b4dfed0, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PageDesignFolder_27d4f8be63b045769a4ef3163c935b47 = (
  { __typename?: 'PageDesignFolder_27d4f8be63b045769a4ef3163c935b47' }
  & Pick<Types.PageDesignFolder_27d4f8be63b045769a4ef3163c935b47, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PageDesignFolder_352ce40ee6e1457a8bf225d8771894e8 = (
  { __typename?: 'PageDesignFolder_352ce40ee6e1457a8bf225d8771894e8' }
  & Pick<Types.PageDesignFolder_352ce40ee6e1457a8bf225d8771894e8, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PageDesignFolder_446a7eadeb894ed6b48c7f1862f29d7b = (
  { __typename?: 'PageDesignFolder_446a7eadeb894ed6b48c7f1862f29d7b' }
  & Pick<Types.PageDesignFolder_446a7eadeb894ed6b48c7f1862f29d7b, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PageDesignFolder_720d01f11e5046fa9c4a697f9321f662 = (
  { __typename?: 'PageDesignFolder_720d01f11e5046fa9c4a697f9321f662' }
  & Pick<Types.PageDesignFolder_720d01f11e5046fa9c4a697f9321f662, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PageDesignFolder_771a0de7e83f44338c5d78727ead93bc = (
  { __typename?: 'PageDesignFolder_771a0de7e83f44338c5d78727ead93bc' }
  & Pick<Types.PageDesignFolder_771a0de7e83f44338c5d78727ead93bc, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PageDesignFolder_14161ec204984aa7a2a46decadf669f5 = (
  { __typename?: 'PageDesignFolder_14161ec204984aa7a2a46decadf669f5' }
  & Pick<Types.PageDesignFolder_14161ec204984aa7a2a46decadf669f5, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PageDesignFolder_c691c2c4e0dd4fedb84a3c29de7002cb = (
  { __typename?: 'PageDesignFolder_c691c2c4e0dd4fedb84a3c29de7002cb' }
  & Pick<Types.PageDesignFolder_C691c2c4e0dd4fedb84a3c29de7002cb, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PageDesignFolder_d84605f786ea482da6ff683f6572821c = (
  { __typename?: 'PageDesignFolder_d84605f786ea482da6ff683f6572821c' }
  & Pick<Types.PageDesignFolder_D84605f786ea482da6ff683f6572821c, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PageDesign_1105b8f81e00426bbf1fc840742d827b = (
  { __typename?: 'PageDesign_1105b8f81e00426bbf1fc840742d827b' }
  & Pick<Types.PageDesign_1105b8f81e00426bbf1fc840742d827b, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PageDesigns = (
  { __typename?: 'PageDesigns' }
  & Pick<Types.PageDesigns, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PageDesigns_3af52e70e982424b9c85e355542500c9 = (
  { __typename?: 'PageDesigns_3af52e70e982424b9c85e355542500c9' }
  & Pick<Types.PageDesigns_3af52e70e982424b9c85e355542500c9, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PageDesigns_9b34083e890b467d8e76b8c3dbbb712d = (
  { __typename?: 'PageDesigns_9b34083e890b467d8e76b8c3dbbb712d' }
  & Pick<Types.PageDesigns_9b34083e890b467d8e76b8c3dbbb712d, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PageDesigns_48d2d50a150c4f6283603a4fed5646e0 = (
  { __typename?: 'PageDesigns_48d2d50a150c4f6283603a4fed5646e0' }
  & Pick<Types.PageDesigns_48d2d50a150c4f6283603a4fed5646e0, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PageDesigns_99a71bba507746729c3fb29b04abee23 = (
  { __typename?: 'PageDesigns_99a71bba507746729c3fb29b04abee23' }
  & Pick<Types.PageDesigns_99a71bba507746729c3fb29b04abee23, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PageDesigns_a0f265b42d6241968b65d3ede7cb59c3 = (
  { __typename?: 'PageDesigns_a0f265b42d6241968b65d3ede7cb59c3' }
  & Pick<Types.PageDesigns_A0f265b42d6241968b65d3ede7cb59c3, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PageDesigns_abe5ce6a82ff4433b4973bc50f192e11 = (
  { __typename?: 'PageDesigns_abe5ce6a82ff4433b4973bc50f192e11' }
  & Pick<Types.PageDesigns_Abe5ce6a82ff4433b4973bc50f192e11, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PageDesigns_b8d9b352c1694b31bd506848b47ca884 = (
  { __typename?: 'PageDesigns_b8d9b352c1694b31bd506848b47ca884' }
  & Pick<Types.PageDesigns_B8d9b352c1694b31bd506848b47ca884, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PageDesigns_d3b2e1466f744df0900bec314f699ef3 = (
  { __typename?: 'PageDesigns_d3b2e1466f744df0900bec314f699ef3' }
  & Pick<Types.PageDesigns_D3b2e1466f744df0900bec314f699ef3, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PageDesigns_fd4b9b54f7474f01abdeba569d4b5bbe = (
  { __typename?: 'PageDesigns_fd4b9b54f7474f01abdeba569d4b5bbe' }
  & Pick<Types.PageDesigns_Fd4b9b54f7474f01abdeba569d4b5bbe, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PageLevelTabs = (
  { __typename?: 'PageLevelTabs' }
  & Pick<Types.PageLevelTabs, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PageLevelTabsFolder = (
  { __typename?: 'PageLevelTabsFolder' }
  & Pick<Types.PageLevelTabsFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PageList = (
  { __typename?: 'PageList' }
  & Pick<Types.PageList, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PageSelector = (
  { __typename?: 'PageSelector' }
  & Pick<Types.PageSelector, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PageSelectorConfiguration = (
  { __typename?: 'PageSelectorConfiguration' }
  & Pick<Types.PageSelectorConfiguration, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PageSelectorFolder = (
  { __typename?: 'PageSelectorFolder' }
  & Pick<Types.PageSelectorFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PageSelector_59a7bb775f8c435ab810291abde80e63 = (
  { __typename?: 'PageSelector_59a7bb775f8c435ab810291abde80e63' }
  & Pick<Types.PageSelector_59a7bb775f8c435ab810291abde80e63, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PageSize = (
  { __typename?: 'PageSize' }
  & Pick<Types.PageSize, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PageSizeFolder = (
  { __typename?: 'PageSizeFolder' }
  & Pick<Types.PageSizeFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PageSize_b682562e0af64b3e9e3b45273bbe152d = (
  { __typename?: 'PageSize_b682562e0af64b3e9e3b45273bbe152d' }
  & Pick<Types.PageSize_B682562e0af64b3e9e3b45273bbe152d, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PageTheme = (
  { __typename?: 'PageTheme' }
  & Pick<Types.PageTheme, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PageThemesFolder = (
  { __typename?: 'PageThemesFolder' }
  & Pick<Types.PageThemesFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Page_4f49a81db3664f198b89cab92f377d7a = (
  { __typename?: 'Page_4f49a81db3664f198b89cab92f377d7a' }
  & Pick<Types.Page_4f49a81db3664f198b89cab92f377d7a, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Page_5e66d86353544fe6a27d3b894984d50f = (
  { __typename?: 'Page_5e66d86353544fe6a27d3b894984d50f' }
  & Pick<Types.Page_5e66d86353544fe6a27d3b894984d50f, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Page_84f342ad2d0646b9aa9a818201145ca2 = (
  { __typename?: 'Page_84f342ad2d0646b9aa9a818201145ca2' }
  & Pick<Types.Page_84f342ad2d0646b9aa9a818201145ca2, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Page_718df200be51463d93edf4d77ab7a49e = (
  { __typename?: 'Page_718df200be51463d93edf4d77ab7a49e' }
  & Pick<Types.Page_718df200be51463d93edf4d77ab7a49e, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Page_b61d5babe46f4ef39f27b57c4ccefdf7 = (
  { __typename?: 'Page_b61d5babe46f4ef39f27b57c4ccefdf7' }
  & Pick<Types.Page_B61d5babe46f4ef39f27b57c4ccefdf7, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Page_cfd6e04697e24f3cb9eb41b79afc35dc = (
  { __typename?: 'Page_cfd6e04697e24f3cb9eb41b79afc35dc' }
  & Pick<Types.Page_Cfd6e04697e24f3cb9eb41b79afc35dc, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Page_dae7821153e14dbabb0ddf0b53a90aaf = (
  { __typename?: 'Page_dae7821153e14dbabb0ddf0b53a90aaf' }
  & Pick<Types.Page_Dae7821153e14dbabb0ddf0b53a90aaf, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Page_fa608b3e6aeb426388a059d89caabada = (
  { __typename?: 'Page_fa608b3e6aeb426388a059d89caabada' }
  & Pick<Types.Page_Fa608b3e6aeb426388a059d89caabada, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Pagging = (
  { __typename?: 'Pagging' }
  & Pick<Types.Pagging, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Pagination = (
  { __typename?: 'Pagination' }
  & Pick<Types.Pagination, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PaginationFolder = (
  { __typename?: 'PaginationFolder' }
  & Pick<Types.PaginationFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Paragraph = (
  { __typename?: 'Paragraph' }
  & Pick<Types.Paragraph, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PartialDesignFolder_8cf20a4412b746ee801218122c955b2d = (
  { __typename?: 'PartialDesignFolder_8cf20a4412b746ee801218122c955b2d' }
  & Pick<Types.PartialDesignFolder_8cf20a4412b746ee801218122c955b2d, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PartialDesignFolder_42eb57ecaa474923b3ddbfb72818f00b = (
  { __typename?: 'PartialDesignFolder_42eb57ecaa474923b3ddbfb72818f00b' }
  & Pick<Types.PartialDesignFolder_42eb57ecaa474923b3ddbfb72818f00b, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PartialDesignFolder_766d4de859a0419292de1898fe0ac4e8 = (
  { __typename?: 'PartialDesignFolder_766d4de859a0419292de1898fe0ac4e8' }
  & Pick<Types.PartialDesignFolder_766d4de859a0419292de1898fe0ac4e8, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PartialDesignFolder_827d4d2f2a84408e8f0ff1d6869a441b = (
  { __typename?: 'PartialDesignFolder_827d4d2f2a84408e8f0ff1d6869a441b' }
  & Pick<Types.PartialDesignFolder_827d4d2f2a84408e8f0ff1d6869a441b, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PartialDesignFolder_828b5ff144cd4150bcdfe54084165112 = (
  { __typename?: 'PartialDesignFolder_828b5ff144cd4150bcdfe54084165112' }
  & Pick<Types.PartialDesignFolder_828b5ff144cd4150bcdfe54084165112, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PartialDesignFolder_89098e3089aa4062a77346d608caac90 = (
  { __typename?: 'PartialDesignFolder_89098e3089aa4062a77346d608caac90' }
  & Pick<Types.PartialDesignFolder_89098e3089aa4062a77346d608caac90, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PartialDesignFolder_1695576fb93647d7842ed17730278c32 = (
  { __typename?: 'PartialDesignFolder_1695576fb93647d7842ed17730278c32' }
  & Pick<Types.PartialDesignFolder_1695576fb93647d7842ed17730278c32, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PartialDesignFolder_f16ae56fb78845639407c88edaffcbcc = (
  { __typename?: 'PartialDesignFolder_f16ae56fb78845639407c88edaffcbcc' }
  & Pick<Types.PartialDesignFolder_F16ae56fb78845639407c88edaffcbcc, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PartialDesignFolder_fb58558a3ec946d18524cd30805ab21a = (
  { __typename?: 'PartialDesignFolder_fb58558a3ec946d18524cd30805ab21a' }
  & Pick<Types.PartialDesignFolder_Fb58558a3ec946d18524cd30805ab21a, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PartialDesign_fd2059fd60434dfe8c04e2437ce87634 = (
  { __typename?: 'PartialDesign_fd2059fd60434dfe8c04e2437ce87634' }
  & Pick<Types.PartialDesign_Fd2059fd60434dfe8c04e2437ce87634, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PartialDesigns = (
  { __typename?: 'PartialDesigns' }
  & Pick<Types.PartialDesigns, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PartialDesigns_043d3ad0ac4445dba03afc3550d088ec = (
  { __typename?: 'PartialDesigns_043d3ad0ac4445dba03afc3550d088ec' }
  & Pick<Types.PartialDesigns_043d3ad0ac4445dba03afc3550d088ec, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PartialDesigns_0310a4bf20d1441c886a0418c53e30f4 = (
  { __typename?: 'PartialDesigns_0310a4bf20d1441c886a0418c53e30f4' }
  & Pick<Types.PartialDesigns_0310a4bf20d1441c886a0418c53e30f4, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PartialDesigns_36c869ded22040929ce829f6ed643c66 = (
  { __typename?: 'PartialDesigns_36c869ded22040929ce829f6ed643c66' }
  & Pick<Types.PartialDesigns_36c869ded22040929ce829f6ed643c66, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PartialDesigns_1943dc73710a430895515a342c84b037 = (
  { __typename?: 'PartialDesigns_1943dc73710a430895515a342c84b037' }
  & Pick<Types.PartialDesigns_1943dc73710a430895515a342c84b037, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PartialDesigns_b1e2a6790a1442d8bafa66317b8be117 = (
  { __typename?: 'PartialDesigns_b1e2a6790a1442d8bafa66317b8be117' }
  & Pick<Types.PartialDesigns_B1e2a6790a1442d8bafa66317b8be117, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PartialDesigns_cc6d8635f3e2440ab8ebb93dc1030e9e = (
  { __typename?: 'PartialDesigns_cc6d8635f3e2440ab8ebb93dc1030e9e' }
  & Pick<Types.PartialDesigns_Cc6d8635f3e2440ab8ebb93dc1030e9e, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PartialDesigns_d52704ed3b704a53abb4292105f687ad = (
  { __typename?: 'PartialDesigns_d52704ed3b704a53abb4292105f687ad' }
  & Pick<Types.PartialDesigns_D52704ed3b704a53abb4292105f687ad, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PartialDesigns_d216303f58d8425688da8cd30d00afab = (
  { __typename?: 'PartialDesigns_d216303f58d8425688da8cd30d00afab' }
  & Pick<Types.PartialDesigns_D216303f58d8425688da8cd30d00afab, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PartialDesigns_facda26791204fa9a0363344348f2c42 = (
  { __typename?: 'PartialDesigns_facda26791204fa9a0363344348f2c42' }
  & Pick<Types.PartialDesigns_Facda26791204fa9a0363344348f2c42, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PerformanceChartSettings = (
  { __typename?: 'PerformanceChartSettings' }
  & Pick<Types.PerformanceChartSettings, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PerformanceChartTimePeriod = (
  { __typename?: 'PerformanceChartTimePeriod' }
  & Pick<Types.PerformanceChartTimePeriod, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PerformanceChartTimePeriodFolder = (
  { __typename?: 'PerformanceChartTimePeriodFolder' }
  & Pick<Types.PerformanceChartTimePeriodFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PlaceholderSettingsFolder_0339bac078c143c1b930f8c26a5fdf80 = (
  { __typename?: 'PlaceholderSettingsFolder_0339bac078c143c1b930f8c26a5fdf80' }
  & Pick<Types.PlaceholderSettingsFolder_0339bac078c143c1b930f8c26a5fdf80, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PlaceholderSettingsFolder_3d281bf8533646869dd6ab4ab5b3fd5d = (
  { __typename?: 'PlaceholderSettingsFolder_3d281bf8533646869dd6ab4ab5b3fd5d' }
  & Pick<Types.PlaceholderSettingsFolder_3d281bf8533646869dd6ab4ab5b3fd5d, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PlaceholderSettingsFolder_52288e3978304694b62d32a54c6ef7ba = (
  { __typename?: 'PlaceholderSettingsFolder_52288e3978304694b62d32a54c6ef7ba' }
  & Pick<Types.PlaceholderSettingsFolder_52288e3978304694b62d32a54c6ef7ba, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Placeholder_1ca0304be5b64810821154426f1752c2 = (
  { __typename?: 'Placeholder_1ca0304be5b64810821154426f1752c2' }
  & Pick<Types.Placeholder_1ca0304be5b64810821154426f1752c2, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Placeholder_d2a6884c04d54089a64ed27ca9d68d4c = (
  { __typename?: 'Placeholder_d2a6884c04d54089a64ed27ca9d68d4c' }
  & Pick<Types.Placeholder_D2a6884c04d54089a64ed27ca9d68d4c, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PlainHtmlParametersTemplate = (
  { __typename?: 'PlainHtmlParametersTemplate' }
  & Pick<Types.PlainHtmlParametersTemplate, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Playlist = (
  { __typename?: 'Playlist' }
  & Pick<Types.Playlist, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PlaylistFolder = (
  { __typename?: 'PlaylistFolder' }
  & Pick<Types.PlaylistFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PlaylistParametersTemplate = (
  { __typename?: 'PlaylistParametersTemplate' }
  & Pick<Types.PlaylistParametersTemplate, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Podcast = (
  { __typename?: 'Podcast' }
  & Pick<Types.Podcast, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PodcastFolder = (
  { __typename?: 'PodcastFolder' }
  & Pick<Types.PodcastFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PodcastPage = (
  { __typename?: 'PodcastPage' }
  & Pick<Types.PodcastPage, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PodcastPressReleasePage = (
  { __typename?: 'PodcastPressReleasePage' }
  & Pick<Types.PodcastPressReleasePage, 'id' | 'name'>
  & { template: PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BasePressRelease_template_ItemTemplate, pressReleaseTitle: Types.Maybe<PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BasePressRelease_pressReleaseTitle_TextField>, pressReleaseDescription: Types.Maybe<PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BasePressRelease_pressReleaseDescription_TextField>, pressReleasePublicationDate: Types.Maybe<PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BasePressRelease_pressReleasePublicationDate_DateField>, duration: Types.Maybe<PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___PodcastPressRelease_duration_IntegerField> }
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PoiTypes = (
  { __typename?: 'PoiTypes' }
  & Pick<Types.PoiTypes, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PostDeleteStep = (
  { __typename?: 'PostDeleteStep' }
  & Pick<Types.PostDeleteStep, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PostDeleteStep_7a7e57b99c6d4a22b5fdf7b214dde574 = (
  { __typename?: 'PostDeleteStep_7a7e57b99c6d4a22b5fdf7b214dde574' }
  & Pick<Types.PostDeleteStep_7a7e57b99c6d4a22b5fdf7b214dde574, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PostDeleteStep_78d6ec9b66e34763987003cf314ee37a = (
  { __typename?: 'PostDeleteStep_78d6ec9b66e34763987003cf314ee37a' }
  & Pick<Types.PostDeleteStep_78d6ec9b66e34763987003cf314ee37a, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PostDeleteStep_b20857895385413883f096f3767cb156 = (
  { __typename?: 'PostDeleteStep_b20857895385413883f096f3767cb156' }
  & Pick<Types.PostDeleteStep_B20857895385413883f096f3767cb156, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PostSetupStep = (
  { __typename?: 'PostSetupStep' }
  & Pick<Types.PostSetupStep, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PostSetupStep_6fac654e22154a419a1d59197bebc0fe = (
  { __typename?: 'PostSetupStep_6fac654e22154a419a1d59197bebc0fe' }
  & Pick<Types.PostSetupStep_6fac654e22154a419a1d59197bebc0fe, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PostSetupStep_8ff2febff6d2461d9ed38b0cb5d9d86f = (
  { __typename?: 'PostSetupStep_8ff2febff6d2461d9ed38b0cb5d9d86f' }
  & Pick<Types.PostSetupStep_8ff2febff6d2461d9ed38b0cb5d9d86f, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PostSetupStep_341738aa44fe490e90ff7010a3c2463b = (
  { __typename?: 'PostSetupStep_341738aa44fe490e90ff7010a3c2463b' }
  & Pick<Types.PostSetupStep_341738aa44fe490e90ff7010a3c2463b, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PreDeleteStep = (
  { __typename?: 'PreDeleteStep' }
  & Pick<Types.PreDeleteStep, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PreDeleteStep_51437c06212c4c0fb3b2fa5b0486ab49 = (
  { __typename?: 'PreDeleteStep_51437c06212c4c0fb3b2fa5b0486ab49' }
  & Pick<Types.PreDeleteStep_51437c06212c4c0fb3b2fa5b0486ab49, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PreDeleteStep_52510f549ec5464cb075ef44b5c2f96b = (
  { __typename?: 'PreDeleteStep_52510f549ec5464cb075ef44b5c2f96b' }
  & Pick<Types.PreDeleteStep_52510f549ec5464cb075ef44b5c2f96b, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PreDeleteStep_f0daf401190f45468bda8568d08e161d = (
  { __typename?: 'PreDeleteStep_f0daf401190f45468bda8568d08e161d' }
  & Pick<Types.PreDeleteStep_F0daf401190f45468bda8568d08e161d, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PreDeleteValidationStep = (
  { __typename?: 'PreDeleteValidationStep' }
  & Pick<Types.PreDeleteValidationStep, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PreDeleteValidationStep_408fd8ab1667440ba6051370ddf0a51f = (
  { __typename?: 'PreDeleteValidationStep_408fd8ab1667440ba6051370ddf0a51f' }
  & Pick<Types.PreDeleteValidationStep_408fd8ab1667440ba6051370ddf0a51f, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PreDeleteValidationStep_edf1fa4206c44703ab1af23495bc6d8f = (
  { __typename?: 'PreDeleteValidationStep_edf1fa4206c44703ab1af23495bc6d8f' }
  & Pick<Types.PreDeleteValidationStep_Edf1fa4206c44703ab1af23495bc6d8f, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PreDeleteValidationStep_f8c52120d0ea4d009de3b49fe12a3f1e = (
  { __typename?: 'PreDeleteValidationStep_f8c52120d0ea4d009de3b49fe12a3f1e' }
  & Pick<Types.PreDeleteValidationStep_F8c52120d0ea4d009de3b49fe12a3f1e, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Presentation = (
  { __typename?: 'Presentation' }
  & Pick<Types.Presentation, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Presentation_0a70fa7389234a6eabf34134f25f3221 = (
  { __typename?: 'Presentation_0a70fa7389234a6eabf34134f25f3221' }
  & Pick<Types.Presentation_0a70fa7389234a6eabf34134f25f3221, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PressReleaseContentType = (
  { __typename?: 'PressReleaseContentType' }
  & Pick<Types.PressReleaseContentType, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PressReleaseContentTypesFolder = (
  { __typename?: 'PressReleaseContentTypesFolder' }
  & Pick<Types.PressReleaseContentTypesFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PressReleaseFilter = (
  { __typename?: 'PressReleaseFilter' }
  & Pick<Types.PressReleaseFilter, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PressReleasePage = (
  { __typename?: 'PressReleasePage' }
  & Pick<Types.PressReleasePage, 'id' | 'name'>
  & { template: PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BasePressRelease_template_ItemTemplate, pressReleaseTitle: Types.Maybe<PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BasePressRelease_pressReleaseTitle_TextField>, pressReleaseDescription: Types.Maybe<PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BasePressRelease_pressReleaseDescription_TextField>, pressReleasePublicationDate: Types.Maybe<PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BasePressRelease_pressReleasePublicationDate_DateField>, duration: Types.Maybe<PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___PressRelease_duration_IntegerField> }
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PressReleasePlatform = (
  { __typename?: 'PressReleasePlatform' }
  & Pick<Types.PressReleasePlatform, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PressReleasePlatformsFolder = (
  { __typename?: 'PressReleasePlatformsFolder' }
  & Pick<Types.PressReleasePlatformsFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PressReleaseSearchPage = (
  { __typename?: 'PressReleaseSearchPage' }
  & Pick<Types.PressReleaseSearchPage, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PressReleaseSearchPage_1b2f7a53709a4c62b381dae5f1280b7f = (
  { __typename?: 'PressReleaseSearchPage_1b2f7a53709a4c62b381dae5f1280b7f' }
  & Pick<Types.PressReleaseSearchPage_1b2f7a53709a4c62b381dae5f1280b7f, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PressReleaseSearchPage_a6c344ca7c6946009de2ca92e27d7b72 = (
  { __typename?: 'PressReleaseSearchPage_a6c344ca7c6946009de2ca92e27d7b72' }
  & Pick<Types.PressReleaseSearchPage_A6c344ca7c6946009de2ca92e27d7b72, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PressReleaseSearchPage_b9cd16f585ea4405a1ceda10cb20f64d = (
  { __typename?: 'PressReleaseSearchPage_b9cd16f585ea4405a1ceda10cb20f64d' }
  & Pick<Types.PressReleaseSearchPage_B9cd16f585ea4405a1ceda10cb20f64d, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PressReleaseSearchPage_c97027442df647cf9c36eedfc6787f58 = (
  { __typename?: 'PressReleaseSearchPage_c97027442df647cf9c36eedfc6787f58' }
  & Pick<Types.PressReleaseSearchPage_C97027442df647cf9c36eedfc6787f58, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PressReleaseWildcardPage = (
  { __typename?: 'PressReleaseWildcardPage' }
  & Pick<Types.PressReleaseWildcardPage, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PressReleaseWildcardPage_2c028bdb02874051b629a7b7d422cc1e = (
  { __typename?: 'PressReleaseWildcardPage_2c028bdb02874051b629a7b7d422cc1e' }
  & Pick<Types.PressReleaseWildcardPage_2c028bdb02874051b629a7b7d422cc1e, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PressReleaseWildcardPage_5a72be834c654d70a591cef7e9ce9d79 = (
  { __typename?: 'PressReleaseWildcardPage_5a72be834c654d70a591cef7e9ce9d79' }
  & Pick<Types.PressReleaseWildcardPage_5a72be834c654d70a591cef7e9ce9d79, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PressReleaseWildcardPage_b337d30403c642d2b9757e23d08223a1 = (
  { __typename?: 'PressReleaseWildcardPage_b337d30403c642d2b9757e23d08223a1' }
  & Pick<Types.PressReleaseWildcardPage_B337d30403c642d2b9757e23d08223a1, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PressReleaseWildcardPage_e55e9d5bf9614e30b0a2a90327428258 = (
  { __typename?: 'PressReleaseWildcardPage_e55e9d5bf9614e30b0a2a90327428258' }
  & Pick<Types.PressReleaseWildcardPage_E55e9d5bf9614e30b0a2a90327428258, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PressReleasesGroupFolder = (
  { __typename?: 'PressReleasesGroupFolder' }
  & Pick<Types.PressReleasesGroupFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PrivacyWarning = (
  { __typename?: 'PrivacyWarning' }
  & Pick<Types.PrivacyWarning, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ProjectFolder = (
  { __typename?: 'ProjectFolder' }
  & Pick<Types.ProjectFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Promo = (
  { __typename?: 'Promo' }
  & Pick<Types.Promo, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PromoFolder = (
  { __typename?: 'PromoFolder' }
  & Pick<Types.PromoFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PromoFolder_f07cbe8973ae4de692172570260cac6e = (
  { __typename?: 'PromoFolder_f07cbe8973ae4de692172570260cac6e' }
  & Pick<Types.PromoFolder_F07cbe8973ae4de692172570260cac6e, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Promo_7f21f14d096b4f27bbccf115c6e6f6f1 = (
  { __typename?: 'Promo_7f21f14d096b4f27bbccf115c6e6f6f1' }
  & Pick<Types.Promo_7f21f14d096b4f27bbccf115c6e6f6f1, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Promo_881869ca7f5845ea8b34ad1bfd3551a8 = (
  { __typename?: 'Promo_881869ca7f5845ea8b34ad1bfd3551a8' }
  & Pick<Types.Promo_881869ca7f5845ea8b34ad1bfd3551a8, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Promo_dfed4457d760457abec1c0dccdc44381 = (
  { __typename?: 'Promo_dfed4457d760457abec1c0dccdc44381' }
  & Pick<Types.Promo_Dfed4457d760457abec1c0dccdc44381, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PromotedContent = (
  { __typename?: 'PromotedContent' }
  & Pick<Types.PromotedContent, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PromotedContentFolder = (
  { __typename?: 'PromotedContentFolder' }
  & Pick<Types.PromotedContentFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PropertyListingCard = (
  { __typename?: 'PropertyListingCard' }
  & Pick<Types.PropertyListingCard, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PropertyListingCards = (
  { __typename?: 'PropertyListingCards' }
  & Pick<Types.PropertyListingCards, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PropertyListingCategory = (
  { __typename?: 'PropertyListingCategory' }
  & Pick<Types.PropertyListingCategory, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PropertyListingFolder = (
  { __typename?: 'PropertyListingFolder' }
  & Pick<Types.PropertyListingFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Query_98b413525a4b4067b92418a4b50f0a53 = (
  { __typename?: 'Query_98b413525a4b4067b92418a4b50f0a53' }
  & Pick<Types.Query_98b413525a4b4067b92418a4b50f0a53, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_QuickLinks = (
  { __typename?: 'QuickLinks' }
  & Pick<Types.QuickLinks, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_QuickLinksFolder = (
  { __typename?: 'QuickLinksFolder' }
  & Pick<Types.QuickLinksFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_QuickLinksParametersTemplate = (
  { __typename?: 'QuickLinksParametersTemplate' }
  & Pick<Types.QuickLinksParametersTemplate, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_QuotationBlockItem = (
  { __typename?: 'QuotationBlockItem' }
  & Pick<Types.QuotationBlockItem, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_QuotationBlocks = (
  { __typename?: 'QuotationBlocks' }
  & Pick<Types.QuotationBlocks, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_QuotationBlocksFolder = (
  { __typename?: 'QuotationBlocksFolder' }
  & Pick<Types.QuotationBlocksFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_QuotationBlocksParametersTemplate = (
  { __typename?: 'QuotationBlocksParametersTemplate' }
  & Pick<Types.QuotationBlocksParametersTemplate, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Quote = (
  { __typename?: 'Quote' }
  & Pick<Types.Quote, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_QuoteFolder = (
  { __typename?: 'QuoteFolder' }
  & Pick<Types.QuoteFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_QuoteParametersTemplate = (
  { __typename?: 'QuoteParametersTemplate' }
  & Pick<Types.QuoteParametersTemplate, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_RadiusFilter = (
  { __typename?: 'RadiusFilter' }
  & Pick<Types.RadiusFilter, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_RadiusFilterFolder = (
  { __typename?: 'RadiusFilterFolder' }
  & Pick<Types.RadiusFilterFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_RadiusFilter_de3fa58eef9d45449f77dcd1dbb05b64 = (
  { __typename?: 'RadiusFilter_de3fa58eef9d45449f77dcd1dbb05b64' }
  & Pick<Types.RadiusFilter_De3fa58eef9d45449f77dcd1dbb05b64, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_RadiusScheme = (
  { __typename?: 'RadiusScheme' }
  & Pick<Types.RadiusScheme, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_RadiusSchemeValue = (
  { __typename?: 'RadiusSchemeValue' }
  & Pick<Types.RadiusSchemeValue, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_RangeSliderFilter = (
  { __typename?: 'RangeSliderFilter' }
  & Pick<Types.RangeSliderFilter, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_RangeSliderFilterFolder = (
  { __typename?: 'RangeSliderFilterFolder' }
  & Pick<Types.RangeSliderFilterFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_RangeSliderFilter_0a1787c296b54d40828522564a5d8e03 = (
  { __typename?: 'RangeSliderFilter_0a1787c296b54d40828522564a5d8e03' }
  & Pick<Types.RangeSliderFilter_0a1787c296b54d40828522564a5d8e03, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_RecentArticles = (
  { __typename?: 'RecentArticles' }
  & Pick<Types.RecentArticles, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Redirect = (
  { __typename?: 'Redirect' }
  & Pick<Types.Redirect, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_RedirectMap = (
  { __typename?: 'RedirectMap' }
  & Pick<Types.RedirectMap, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_RedirectMaps = (
  { __typename?: 'RedirectMaps' }
  & Pick<Types.RedirectMaps, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Region = (
  { __typename?: 'Region' }
  & Pick<Types.Region, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_RegionLanguages = (
  { __typename?: 'RegionLanguages' }
  & Pick<Types.RegionLanguages, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_RegionLanguagesFolder = (
  { __typename?: 'RegionLanguagesFolder' }
  & Pick<Types.RegionLanguagesFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_RelatedArticles = (
  { __typename?: 'RelatedArticles' }
  & Pick<Types.RelatedArticles, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_RelatedArticlesParametersTemplate = (
  { __typename?: 'RelatedArticlesParametersTemplate' }
  & Pick<Types.RelatedArticlesParametersTemplate, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_RenderEngineType = (
  { __typename?: 'RenderEngineType' }
  & Pick<Types.RenderEngineType, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_RenderingFolder_840d4a46550349ecbf9dbd090946c63d = (
  { __typename?: 'RenderingFolder_840d4a46550349ecbf9dbd090946c63d' }
  & Pick<Types.RenderingFolder_840d4a46550349ecbf9dbd090946c63d, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_RenderingHost = (
  { __typename?: 'RenderingHost' }
  & Pick<Types.RenderingHost, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ResizableIFramePage = (
  { __typename?: 'ResizableIFramePage' }
  & Pick<Types.ResizableIFramePage, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ResizableIFramePage_8ab2ae106350452ca0e7b06d6d859067 = (
  { __typename?: 'ResizableIFramePage_8ab2ae106350452ca0e7b06d6d859067' }
  & Pick<Types.ResizableIFramePage_8ab2ae106350452ca0e7b06d6d859067, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ResizableIFramePage_92674815f3f74a879c0874bcb72c9b68 = (
  { __typename?: 'ResizableIFramePage_92674815f3f74a879c0874bcb72c9b68' }
  & Pick<Types.ResizableIFramePage_92674815f3f74a879c0874bcb72c9b68, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ResizableIFramePage_b58eacfb27f5417bb536141f94b92521 = (
  { __typename?: 'ResizableIFramePage_b58eacfb27f5417bb536141f94b92521' }
  & Pick<Types.ResizableIFramePage_B58eacfb27f5417bb536141f94b92521, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ResizableIFramePage_d8d76a2407084147bf3900cd5e12e401 = (
  { __typename?: 'ResizableIFramePage_d8d76a2407084147bf3900cd5e12e401' }
  & Pick<Types.ResizableIFramePage_D8d76a2407084147bf3900cd5e12e401, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ResizableIFramePage_f460ab055585441892023750e7cef6b7 = (
  { __typename?: 'ResizableIFramePage_f460ab055585441892023750e7cef6b7' }
  & Pick<Types.ResizableIFramePage_F460ab055585441892023750e7cef6b7, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ResponsiveImage = (
  { __typename?: 'ResponsiveImage' }
  & Pick<Types.ResponsiveImage, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ResultsCount = (
  { __typename?: 'ResultsCount' }
  & Pick<Types.ResultsCount, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ResultsCountFolder = (
  { __typename?: 'ResultsCountFolder' }
  & Pick<Types.ResultsCountFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ResultsCount_f3c0661ef9a9444ca26d44bf2a68a186 = (
  { __typename?: 'ResultsCount_f3c0661ef9a9444ca26d44bf2a68a186' }
  & Pick<Types.ResultsCount_F3c0661ef9a9444ca26d44bf2a68a186, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ResultsVariantSelector = (
  { __typename?: 'ResultsVariantSelector' }
  & Pick<Types.ResultsVariantSelector, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_RichText = (
  { __typename?: 'RichText' }
  & Pick<Types.RichText, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_RichTextFolder = (
  { __typename?: 'RichTextFolder' }
  & Pick<Types.RichTextFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_RichText_0f3b73366112418c8bbab0526f3887ce = (
  { __typename?: 'RichText_0f3b73366112418c8bbab0526f3887ce' }
  & Pick<Types.RichText_0f3b73366112418c8bbab0526f3887ce, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_RichText_efcfd8f6596745f48f85b5421928205d = (
  { __typename?: 'RichText_efcfd8f6596745f48f85b5421928205d' }
  & Pick<Types.RichText_Efcfd8f6596745f48f85b5421928205d, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_RiskImageMapping = (
  { __typename?: 'RiskImageMapping' }
  & Pick<Types.RiskImageMapping, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_RiskImageMappings = (
  { __typename?: 'RiskImageMappings' }
  & Pick<Types.RiskImageMappings, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_RiskLevelOption = (
  { __typename?: 'RiskLevelOption' }
  & Pick<Types.RiskLevelOption, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_RiskLevelOptionFolder = (
  { __typename?: 'RiskLevelOptionFolder' }
  & Pick<Types.RiskLevelOptionFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_RiskWarning = (
  { __typename?: 'RiskWarning' }
  & Pick<Types.RiskWarning, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_RiskWarningFolder = (
  { __typename?: 'RiskWarningFolder' }
  & Pick<Types.RiskWarningFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_RiskWarningParametersTemplate = (
  { __typename?: 'RiskWarningParametersTemplate' }
  & Pick<Types.RiskWarningParametersTemplate, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_RolePlaceholder = (
  { __typename?: 'RolePlaceholder' }
  & Pick<Types.RolePlaceholder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_RowSplitter = (
  { __typename?: 'RowSplitter' }
  & Pick<Types.RowSplitter, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_RowSplitter_340c887da1d1415b9678c763af74ea97 = (
  { __typename?: 'RowSplitter_340c887da1d1415b9678c763af74ea97' }
  & Pick<Types.RowSplitter_340c887da1d1415b9678c763af74ea97, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Rule = (
  { __typename?: 'Rule' }
  & Pick<Types.Rule, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SDRLogoMapping = (
  { __typename?: 'SDRLogoMapping' }
  & Pick<Types.SdrLogoMapping, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SDRLogoMappings = (
  { __typename?: 'SDRLogoMappings' }
  & Pick<Types.SdrLogoMappings, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SDRTypeOption = (
  { __typename?: 'SDRTypeOption' }
  & Pick<Types.SdrTypeOption, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SDRTypeOptionFolder = (
  { __typename?: 'SDRTypeOptionFolder' }
  & Pick<Types.SdrTypeOptionFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SXAJSSLayout = (
  { __typename?: 'SXAJSSLayout' }
  & Pick<Types.SxajssLayout, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SXARole = (
  { __typename?: 'SXARole' }
  & Pick<Types.SxaRole, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SXAStandardValuesFolder = (
  { __typename?: 'SXAStandardValuesFolder' }
  & Pick<Types.SxaStandardValuesFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SalesforceAlertMessage = (
  { __typename?: 'SalesforceAlertMessage' }
  & Pick<Types.SalesforceAlertMessage, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SalesforceCheckBox = (
  { __typename?: 'SalesforceCheckBox' }
  & Pick<Types.SalesforceCheckBox, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SalesforceCheckBoxType = (
  { __typename?: 'SalesforceCheckBoxType' }
  & Pick<Types.SalesforceCheckBoxType, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SalesforceConditionalRadioButton = (
  { __typename?: 'SalesforceConditionalRadioButton' }
  & Pick<Types.SalesforceConditionalRadioButton, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SalesforceConditionalRadioButtons = (
  { __typename?: 'SalesforceConditionalRadioButtons' }
  & Pick<Types.SalesforceConditionalRadioButtons, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SalesforceDateInput = (
  { __typename?: 'SalesforceDateInput' }
  & Pick<Types.SalesforceDateInput, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SalesforceDropdown = (
  { __typename?: 'SalesforceDropdown' }
  & Pick<Types.SalesforceDropdown, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SalesforceDropdownOption = (
  { __typename?: 'SalesforceDropdownOption' }
  & Pick<Types.SalesforceDropdownOption, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SalesforceHiddenField = (
  { __typename?: 'SalesforceHiddenField' }
  & Pick<Types.SalesforceHiddenField, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SalesforceInput = (
  { __typename?: 'SalesforceInput' }
  & Pick<Types.SalesforceInput, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SalesforceInputType = (
  { __typename?: 'SalesforceInputType' }
  & Pick<Types.SalesforceInputType, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SalesforceIntegratedForm = (
  { __typename?: 'SalesforceIntegratedForm' }
  & Pick<Types.SalesforceIntegratedForm, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SalesforceIntegratedFormTypesFolder = (
  { __typename?: 'SalesforceIntegratedFormTypesFolder' }
  & Pick<Types.SalesforceIntegratedFormTypesFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SalesforceRepeatableSubSection = (
  { __typename?: 'SalesforceRepeatableSubSection' }
  & Pick<Types.SalesforceRepeatableSubSection, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SalesforceRichTextArea = (
  { __typename?: 'SalesforceRichTextArea' }
  & Pick<Types.SalesforceRichTextArea, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SalesforceSection = (
  { __typename?: 'SalesforceSection' }
  & Pick<Types.SalesforceSection, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SalesforceSortCodeInput = (
  { __typename?: 'SalesforceSortCodeInput' }
  & Pick<Types.SalesforceSortCodeInput, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SalesforceSubmissionType = (
  { __typename?: 'SalesforceSubmissionType' }
  & Pick<Types.SalesforceSubmissionType, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Scope = (
  { __typename?: 'Scope' }
  & Pick<Types.Scope, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ScopesFolder = (
  { __typename?: 'ScopesFolder' }
  & Pick<Types.ScopesFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Scriban = (
  { __typename?: 'Scriban' }
  & Pick<Types.Scriban, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Scripts = (
  { __typename?: 'Scripts' }
  & Pick<Types.Scripts, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SearchBox = (
  { __typename?: 'SearchBox' }
  & Pick<Types.SearchBox, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SearchBoxFolder = (
  { __typename?: 'SearchBoxFolder' }
  & Pick<Types.SearchBoxFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SearchBox_1c04fd611d874590acfe9cc186865ab3 = (
  { __typename?: 'SearchBox_1c04fd611d874590acfe9cc186865ab3' }
  & Pick<Types.SearchBox_1c04fd611d874590acfe9cc186865ab3, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SearchFolder = (
  { __typename?: 'SearchFolder' }
  & Pick<Types.SearchFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SearchResults = (
  { __typename?: 'SearchResults' }
  & Pick<Types.SearchResults, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SearchResultsFolder = (
  { __typename?: 'SearchResultsFolder' }
  & Pick<Types.SearchResultsFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SearchResults_a06f7130041d46bb8c2995a2dc00c26a = (
  { __typename?: 'SearchResults_a06f7130041d46bb8c2995a2dc00c26a' }
  & Pick<Types.SearchResults_A06f7130041d46bb8c2995a2dc00c26a, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SecondaryHeroBannerParametersTemplate = (
  { __typename?: 'SecondaryHeroBannerParametersTemplate' }
  & Pick<Types.SecondaryHeroBannerParametersTemplate, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SectionHeading = (
  { __typename?: 'SectionHeading' }
  & Pick<Types.SectionHeading, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SectionHeadingFolder = (
  { __typename?: 'SectionHeadingFolder' }
  & Pick<Types.SectionHeadingFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SectionHeadingParametersTemplate = (
  { __typename?: 'SectionHeadingParametersTemplate' }
  & Pick<Types.SectionHeadingParametersTemplate, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SectionHeadingType = (
  { __typename?: 'SectionHeadingType' }
  & Pick<Types.SectionHeadingType, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SectionHeadingTypeFolder = (
  { __typename?: 'SectionHeadingTypeFolder' }
  & Pick<Types.SectionHeadingTypeFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SectionSelector = (
  { __typename?: 'SectionSelector' }
  & Pick<Types.SectionSelector, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SectionSelectorFolder = (
  { __typename?: 'SectionSelectorFolder' }
  & Pick<Types.SectionSelectorFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SectionSelectorTab = (
  { __typename?: 'SectionSelectorTab' }
  & Pick<Types.SectionSelectorTab, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Security_33077d51ebad4d1cb4a83b79f51dba13 = (
  { __typename?: 'Security_33077d51ebad4d1cb4a83b79f51dba13' }
  & Pick<Types.Security_33077d51ebad4d1cb4a83b79f51dba13, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Series = (
  { __typename?: 'Series' }
  & Pick<Types.Series, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SeriesFolder = (
  { __typename?: 'SeriesFolder' }
  & Pick<Types.SeriesFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Settings = (
  { __typename?: 'Settings' }
  & Pick<Types.Settings, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SettingsFolder = (
  { __typename?: 'SettingsFolder' }
  & Pick<Types.SettingsFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Settings_6c82caca67dc464195698faad083230e = (
  { __typename?: 'Settings_6c82caca67dc464195698faad083230e' }
  & Pick<Types.Settings_6c82caca67dc464195698faad083230e, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SharePriceSettings = (
  { __typename?: 'SharePriceSettings' }
  & Pick<Types.SharePriceSettings, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SharedArticlesFolder = (
  { __typename?: 'SharedArticlesFolder' }
  & Pick<Types.SharedArticlesFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SharedContentFolder = (
  { __typename?: 'SharedContentFolder' }
  & Pick<Types.SharedContentFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SharedFolder = (
  { __typename?: 'SharedFolder' }
  & Pick<Types.SharedFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SharedHelpArticlesFolder = (
  { __typename?: 'SharedHelpArticlesFolder' }
  & Pick<Types.SharedHelpArticlesFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SharedPressReleasesFolder = (
  { __typename?: 'SharedPressReleasesFolder' }
  & Pick<Types.SharedPressReleasesFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SharedSettingsFolder = (
  { __typename?: 'SharedSettingsFolder' }
  & Pick<Types.SharedSettingsFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SharedSitesSettings = (
  { __typename?: 'SharedSitesSettings' }
  & Pick<Types.SharedSitesSettings, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SharedSitesSettings_c14bf746030f4e598594395f6d299e61 = (
  { __typename?: 'SharedSitesSettings_c14bf746030f4e598594395f6d299e61' }
  & Pick<Types.SharedSitesSettings_C14bf746030f4e598594395f6d299e61, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Showcase = (
  { __typename?: 'Showcase' }
  & Pick<Types.Showcase, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ShowcaseFolder = (
  { __typename?: 'ShowcaseFolder' }
  & Pick<Types.ShowcaseFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ShowcaseItem = (
  { __typename?: 'ShowcaseItem' }
  & Pick<Types.ShowcaseItem, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ShowcaseParametersTemplate = (
  { __typename?: 'ShowcaseParametersTemplate' }
  & Pick<Types.ShowcaseParametersTemplate, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Site = (
  { __typename?: 'Site' }
  & Pick<Types.Site, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SiteContentFolder = (
  { __typename?: 'SiteContentFolder' }
  & Pick<Types.SiteContentFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SiteDefinition = (
  { __typename?: 'SiteDefinition' }
  & Pick<Types.SiteDefinition, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SiteEntryDisclaimer = (
  { __typename?: 'SiteEntryDisclaimer' }
  & Pick<Types.SiteEntryDisclaimer, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SiteFolder = (
  { __typename?: 'SiteFolder' }
  & Pick<Types.SiteFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SiteGrouping = (
  { __typename?: 'SiteGrouping' }
  & Pick<Types.SiteGrouping, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SiteManagement = (
  { __typename?: 'SiteManagement' }
  & Pick<Types.SiteManagement, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SiteSecurityItemPointer = (
  { __typename?: 'SiteSecurityItemPointer' }
  & Pick<Types.SiteSecurityItemPointer, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SiteSelector = (
  { __typename?: 'SiteSelector' }
  & Pick<Types.SiteSelector, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SiteSelector_a44632f56dcd4d10b4892f4e35e193c3 = (
  { __typename?: 'SiteSelector_a44632f56dcd4d10b4892f4e35e193c3' }
  & Pick<Types.SiteSelector_A44632f56dcd4d10b4892f4e35e193c3, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SiteSetupRoot = (
  { __typename?: 'SiteSetupRoot' }
  & Pick<Types.SiteSetupRoot, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SiteTheme = (
  { __typename?: 'SiteTheme' }
  & Pick<Types.SiteTheme, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Site_e46f3af239fa4866a1577017c4b2a40c = (
  { __typename?: 'Site_e46f3af239fa4866a1577017c4b2a40c' }
  & Pick<Types.Site_E46f3af239fa4866a1577017c4b2a40c, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SitecoreFormWrapperParametersTemplate = (
  { __typename?: 'SitecoreFormWrapperParametersTemplate' }
  & Pick<Types.SitecoreFormWrapperParametersTemplate, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SitecoreRole = (
  { __typename?: 'SitecoreRole' }
  & Pick<Types.SitecoreRole, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SitemapSettings_c71d856635c849b7a84d9d176e9cbd05 = (
  { __typename?: 'SitemapSettings_c71d856635c849b7a84d9d176e9cbd05' }
  & Pick<Types.SitemapSettings_C71d856635c849b7a84d9d176e9cbd05, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SkipLink = (
  { __typename?: 'SkipLink' }
  & Pick<Types.SkipLink, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SkipLinkParameters = (
  { __typename?: 'SkipLinkParameters' }
  & Pick<Types.SkipLinkParameters, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SkipLinksFolder = (
  { __typename?: 'SkipLinksFolder' }
  & Pick<Types.SkipLinksFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Snippet = (
  { __typename?: 'Snippet' }
  & Pick<Types.Snippet, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SnippetItem = (
  { __typename?: 'SnippetItem' }
  & Pick<Types.SnippetItem, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SnippetsFolder = (
  { __typename?: 'SnippetsFolder' }
  & Pick<Types.SnippetsFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SocialLoginWrapper = (
  { __typename?: 'SocialLoginWrapper' }
  & Pick<Types.SocialLoginWrapper, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SocialMediaButtons = (
  { __typename?: 'SocialMediaButtons' }
  & Pick<Types.SocialMediaButtons, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SocialMediaFolder = (
  { __typename?: 'SocialMediaFolder' }
  & Pick<Types.SocialMediaFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SocialMediaShare = (
  { __typename?: 'SocialMediaShare' }
  & Pick<Types.SocialMediaShare, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SocialMediaTemplate = (
  { __typename?: 'SocialMediaTemplate' }
  & Pick<Types.SocialMediaTemplate, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SocialNetwork = (
  { __typename?: 'SocialNetwork' }
  & Pick<Types.SocialNetwork, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SocialNetworkFolder = (
  { __typename?: 'SocialNetworkFolder' }
  & Pick<Types.SocialNetworkFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SocialNetworkLink = (
  { __typename?: 'SocialNetworkLink' }
  & Pick<Types.SocialNetworkLink, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SolutionTemplate = (
  { __typename?: 'SolutionTemplate' }
  & Pick<Types.SolutionTemplate, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SortResults = (
  { __typename?: 'SortResults' }
  & Pick<Types.SortResults, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SortResultsFolder = (
  { __typename?: 'SortResultsFolder' }
  & Pick<Types.SortResultsFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Sorting = (
  { __typename?: 'Sorting' }
  & Pick<Types.Sorting, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SortingGroups = (
  { __typename?: 'SortingGroups' }
  & Pick<Types.SortingGroups, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SpotifyPodcast = (
  { __typename?: 'SpotifyPodcast' }
  & Pick<Types.SpotifyPodcast, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SpotifyPodcastFolder = (
  { __typename?: 'SpotifyPodcastFolder' }
  & Pick<Types.SpotifyPodcastFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_StickyCTA = (
  { __typename?: 'StickyCTA' }
  & Pick<Types.StickyCta, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_StickyCTAFolder = (
  { __typename?: 'StickyCTAFolder' }
  & Pick<Types.StickyCtaFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_StickyCTAParametersTemplate = (
  { __typename?: 'StickyCTAParametersTemplate' }
  & Pick<Types.StickyCtaParametersTemplate, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_StrategiesInFocusFolder = (
  { __typename?: 'StrategiesInFocusFolder' }
  & Pick<Types.StrategiesInFocusFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_StrategyInFocus = (
  { __typename?: 'StrategyInFocus' }
  & Pick<Types.StrategyInFocus, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Style = (
  { __typename?: 'Style' }
  & Pick<Types.Style, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Styles = (
  { __typename?: 'Styles' }
  & Pick<Types.Styles, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Styles_9c0dac2808aa4b44bc2153363206f6a5 = (
  { __typename?: 'Styles_9c0dac2808aa4b44bc2153363206f6a5' }
  & Pick<Types.Styles_9c0dac2808aa4b44bc2153363206f6a5, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SubscriptionBannerParametersTemplate = (
  { __typename?: 'SubscriptionBannerParametersTemplate' }
  & Pick<Types.SubscriptionBannerParametersTemplate, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Tab = (
  { __typename?: 'Tab' }
  & Pick<Types.Tab, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TabItem = (
  { __typename?: 'TabItem' }
  & Pick<Types.TabItem, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TableOfContents = (
  { __typename?: 'TableOfContents' }
  & Pick<Types.TableOfContents, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TableOfContentsFolder = (
  { __typename?: 'TableOfContentsFolder' }
  & Pick<Types.TableOfContentsFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TableOfContentsSection = (
  { __typename?: 'TableOfContentsSection' }
  & Pick<Types.TableOfContentsSection, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TableOfContentsSubsection = (
  { __typename?: 'TableOfContentsSubsection' }
  & Pick<Types.TableOfContentsSubsection, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Tabs = (
  { __typename?: 'Tabs' }
  & Pick<Types.Tabs, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TabsFolder = (
  { __typename?: 'TabsFolder' }
  & Pick<Types.TabsFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Tabs_f26a9560ccf148c59542800e837caf7a = (
  { __typename?: 'Tabs_f26a9560ccf148c59542800e837caf7a' }
  & Pick<Types.Tabs_F26a9560ccf148c59542800e837caf7a, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Tag = (
  { __typename?: 'Tag' }
  & Pick<Types.Tag, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TagCloud = (
  { __typename?: 'TagCloud' }
  & Pick<Types.TagCloud, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TagFolder = (
  { __typename?: 'TagFolder' }
  & Pick<Types.TagFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TagList = (
  { __typename?: 'TagList' }
  & Pick<Types.TagList, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TeamBiographySettings = (
  { __typename?: 'TeamBiographySettings' }
  & Pick<Types.TeamBiographySettings, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TeamListingCards = (
  { __typename?: 'TeamListingCards' }
  & Pick<Types.TeamListingCards, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TeamListingCardsFolder = (
  { __typename?: 'TeamListingCardsFolder' }
  & Pick<Types.TeamListingCardsFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TeamMember = (
  { __typename?: 'TeamMember' }
  & Pick<Types.TeamMember, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TeamMemberCard = (
  { __typename?: 'TeamMemberCard' }
  & Pick<Types.TeamMemberCard, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TeamMembers = (
  { __typename?: 'TeamMembers' }
  & Pick<Types.TeamMembers, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TeamMembersParentPage = (
  { __typename?: 'TeamMembersParentPage' }
  & Pick<Types.TeamMembersParentPage, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TeamMembersParentPage_0dfb40140ba44abe8a480904ff1eff1e = (
  { __typename?: 'TeamMembersParentPage_0dfb40140ba44abe8a480904ff1eff1e' }
  & Pick<Types.TeamMembersParentPage_0dfb40140ba44abe8a480904ff1eff1e, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TeamMembersParentPage_2e9df92fe936461987fd0ea8ad08bd9e = (
  { __typename?: 'TeamMembersParentPage_2e9df92fe936461987fd0ea8ad08bd9e' }
  & Pick<Types.TeamMembersParentPage_2e9df92fe936461987fd0ea8ad08bd9e, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TeamMembersParentPage_47f304d629a84648a0e2b942513133ff = (
  { __typename?: 'TeamMembersParentPage_47f304d629a84648a0e2b942513133ff' }
  & Pick<Types.TeamMembersParentPage_47f304d629a84648a0e2b942513133ff, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TeamMembersParentPage_75c911bd18704434ad7adcca64dfb089 = (
  { __typename?: 'TeamMembersParentPage_75c911bd18704434ad7adcca64dfb089' }
  & Pick<Types.TeamMembersParentPage_75c911bd18704434ad7adcca64dfb089, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TeamMembersParentPage_b4311697c06c4d58b88dca047c0a72b0 = (
  { __typename?: 'TeamMembersParentPage_b4311697c06c4d58b88dca047c0a72b0' }
  & Pick<Types.TeamMembersParentPage_B4311697c06c4d58b88dca047c0a72b0, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TeamMembersWildcardPage = (
  { __typename?: 'TeamMembersWildcardPage' }
  & Pick<Types.TeamMembersWildcardPage, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TeamMembersWildcardPage_6c0a7b262ac64e1ba92ab20013a5a00e = (
  { __typename?: 'TeamMembersWildcardPage_6c0a7b262ac64e1ba92ab20013a5a00e' }
  & Pick<Types.TeamMembersWildcardPage_6c0a7b262ac64e1ba92ab20013a5a00e, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TeamMembersWildcardPage_9c436bbf177d481da8bdfdc12a53d450 = (
  { __typename?: 'TeamMembersWildcardPage_9c436bbf177d481da8bdfdc12a53d450' }
  & Pick<Types.TeamMembersWildcardPage_9c436bbf177d481da8bdfdc12a53d450, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TeamMembersWildcardPage_52ba0118982f400fb80e1fee787f1d3a = (
  { __typename?: 'TeamMembersWildcardPage_52ba0118982f400fb80e1fee787f1d3a' }
  & Pick<Types.TeamMembersWildcardPage_52ba0118982f400fb80e1fee787f1d3a, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TeamMembersWildcardPage_54e4118770954f8abdfb908c88ce2f29 = (
  { __typename?: 'TeamMembersWildcardPage_54e4118770954f8abdfb908c88ce2f29' }
  & Pick<Types.TeamMembersWildcardPage_54e4118770954f8abdfb908c88ce2f29, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TeamMembersWildcardPage_ea27a3d835fd49a3a4c797d2a6d52745 = (
  { __typename?: 'TeamMembersWildcardPage_ea27a3d835fd49a3a4c797d2a6d52745' }
  & Pick<Types.TeamMembersWildcardPage_Ea27a3d835fd49a3a4c797d2a6d52745, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TeamProfileCards = (
  { __typename?: 'TeamProfileCards' }
  & Pick<Types.TeamProfileCards, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TeamProfileCardsFolder = (
  { __typename?: 'TeamProfileCardsFolder' }
  & Pick<Types.TeamProfileCardsFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TechzoneArticlePage = (
  { __typename?: 'TechzoneArticlePage' }
  & Pick<Types.TechzoneArticlePage, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Tenant = (
  { __typename?: 'Tenant' }
  & Pick<Types.Tenant, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TenantFolder = (
  { __typename?: 'TenantFolder' }
  & Pick<Types.TenantFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TenantSecurityItemPointer = (
  { __typename?: 'TenantSecurityItemPointer' }
  & Pick<Types.TenantSecurityItemPointer, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TenantSetupRoot = (
  { __typename?: 'TenantSetupRoot' }
  & Pick<Types.TenantSetupRoot, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TertieryHeroBanner = (
  { __typename?: 'TertieryHeroBanner' }
  & Pick<Types.TertieryHeroBanner, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TertieryHeroBannerParametersTemplate = (
  { __typename?: 'TertieryHeroBannerParametersTemplate' }
  & Pick<Types.TertieryHeroBannerParametersTemplate, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Text = (
  { __typename?: 'Text' }
  & Pick<Types.Text, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TextBlock = (
  { __typename?: 'TextBlock' }
  & Pick<Types.TextBlock, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TextBlockHeadingParametersTemplate = (
  { __typename?: 'TextBlockHeadingParametersTemplate' }
  & Pick<Types.TextBlockHeadingParametersTemplate, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TextBlockHeadingType = (
  { __typename?: 'TextBlockHeadingType' }
  & Pick<Types.TextBlockHeadingType, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TextBlockHeadingTypeFolder = (
  { __typename?: 'TextBlockHeadingTypeFolder' }
  & Pick<Types.TextBlockHeadingTypeFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TextBlockLinkType = (
  { __typename?: 'TextBlockLinkType' }
  & Pick<Types.TextBlockLinkType, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TextBlockLinkTypeFolder = (
  { __typename?: 'TextBlockLinkTypeFolder' }
  & Pick<Types.TextBlockLinkTypeFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TextBlocks = (
  { __typename?: 'TextBlocks' }
  & Pick<Types.TextBlocks, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TextBlocksFolder = (
  { __typename?: 'TextBlocksFolder' }
  & Pick<Types.TextBlocksFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TextBlocksParametersTemplate = (
  { __typename?: 'TextBlocksParametersTemplate' }
  & Pick<Types.TextBlocksParametersTemplate, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TextFolder = (
  { __typename?: 'TextFolder' }
  & Pick<Types.TextFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TextFolder_b762d56787f5493cbb480c455d834457 = (
  { __typename?: 'TextFolder_b762d56787f5493cbb480c455d834457' }
  & Pick<Types.TextFolder_B762d56787f5493cbb480c455d834457, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Text_b8f5894cb4934016bf784090b0a2fd16 = (
  { __typename?: 'Text_b8f5894cb4934016bf784090b0a2fd16' }
  & Pick<Types.Text_B8f5894cb4934016bf784090b0a2fd16, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Theme = (
  { __typename?: 'Theme' }
  & Pick<Types.Theme, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ThemeTag = (
  { __typename?: 'ThemeTag' }
  & Pick<Types.ThemeTag, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ThemeTagsFolder = (
  { __typename?: 'ThemeTagsFolder' }
  & Pick<Types.ThemeTagsFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ThemingMode = (
  { __typename?: 'ThemingMode' }
  & Pick<Types.ThemingMode, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ThemingModes = (
  { __typename?: 'ThemingModes' }
  & Pick<Types.ThemingModes, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Tile = (
  { __typename?: 'Tile' }
  & Pick<Types.Tile, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TileLink = (
  { __typename?: 'TileLink' }
  & Pick<Types.TileLink, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TileParametersTemplate = (
  { __typename?: 'TileParametersTemplate' }
  & Pick<Types.TileParametersTemplate, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TileSizeOption = (
  { __typename?: 'TileSizeOption' }
  & Pick<Types.TileSizeOption, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TileSizeOptionFolder = (
  { __typename?: 'TileSizeOptionFolder' }
  & Pick<Types.TileSizeOptionFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TilesFolder = (
  { __typename?: 'TilesFolder' }
  & Pick<Types.TilesFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TilesParametersTemplate = (
  { __typename?: 'TilesParametersTemplate' }
  & Pick<Types.TilesParametersTemplate, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Title = (
  { __typename?: 'Title' }
  & Pick<Types.Title, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Title_a82e893105754175917de904ef7e6dbe = (
  { __typename?: 'Title_a82e893105754175917de904ef7e6dbe' }
  & Pick<Types.Title_A82e893105754175917de904ef7e6dbe, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Toggle = (
  { __typename?: 'Toggle' }
  & Pick<Types.Toggle, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ToggleFolder = (
  { __typename?: 'ToggleFolder' }
  & Pick<Types.ToggleFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Toggle_8e4c968e9fa543a89ac4c0baf273ccde = (
  { __typename?: 'Toggle_8e4c968e9fa543a89ac4c0baf273ccde' }
  & Pick<Types.Toggle_8e4c968e9fa543a89ac4c0baf273ccde, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Transformation = (
  { __typename?: 'Transformation' }
  & Pick<Types.Transformation, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TrustArticleHeroParametersTemplate = (
  { __typename?: 'TrustArticleHeroParametersTemplate' }
  & Pick<Types.TrustArticleHeroParametersTemplate, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TrustFinder = (
  { __typename?: 'TrustFinder' }
  & Pick<Types.TrustFinder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TrustFinderFilterOption = (
  { __typename?: 'TrustFinderFilterOption' }
  & Pick<Types.TrustFinderFilterOption, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TrustRegion = (
  { __typename?: 'TrustRegion' }
  & Pick<Types.TrustRegion, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TrustType = (
  { __typename?: 'TrustType' }
  & Pick<Types.TrustType, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TrustTypesFolder = (
  { __typename?: 'TrustTypesFolder' }
  & Pick<Types.TrustTypesFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Twitter = (
  { __typename?: 'Twitter' }
  & Pick<Types.Twitter, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TwitterApp = (
  { __typename?: 'TwitterApp' }
  & Pick<Types.TwitterApp, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TwitterApps = (
  { __typename?: 'TwitterApps' }
  & Pick<Types.TwitterApps, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TwitterFolder = (
  { __typename?: 'TwitterFolder' }
  & Pick<Types.TwitterFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TwitterParametersTemplate = (
  { __typename?: 'TwitterParametersTemplate' }
  & Pick<Types.TwitterParametersTemplate, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TwitterSettings = (
  { __typename?: 'TwitterSettings' }
  & Pick<Types.TwitterSettings, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_UnknownItem = (
  { __typename?: 'UnknownItem' }
  & Pick<Types.UnknownItem, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_UnminifiedFile = (
  { __typename?: 'UnminifiedFile' }
  & Pick<Types.UnminifiedFile, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_UpgradeScript = (
  { __typename?: 'UpgradeScript' }
  & Pick<Types.UpgradeScript, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_UpgradeScriptLibrary = (
  { __typename?: 'UpgradeScriptLibrary' }
  & Pick<Types.UpgradeScriptLibrary, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_VariantComponentField = (
  { __typename?: 'VariantComponentField' }
  & Pick<Types.VariantComponentField, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_VariantDateField = (
  { __typename?: 'VariantDateField' }
  & Pick<Types.VariantDateField, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_VariantDefinition_4d50cdaec2d94de8b0808f992bfb1b55 = (
  { __typename?: 'VariantDefinition_4d50cdaec2d94de8b0808f992bfb1b55' }
  & Pick<Types.VariantDefinition_4d50cdaec2d94de8b0808f992bfb1b55, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_VariantPlaceholder = (
  { __typename?: 'VariantPlaceholder' }
  & Pick<Types.VariantPlaceholder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_VariantReference = (
  { __typename?: 'VariantReference' }
  & Pick<Types.VariantReference, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_VariantSection = (
  { __typename?: 'VariantSection' }
  & Pick<Types.VariantSection, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_VariantTemplate = (
  { __typename?: 'VariantTemplate' }
  & Pick<Types.VariantTemplate, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_VariantText = (
  { __typename?: 'VariantText' }
  & Pick<Types.VariantText, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_VariantToken = (
  { __typename?: 'VariantToken' }
  & Pick<Types.VariantToken, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Variants = (
  { __typename?: 'Variants' }
  & Pick<Types.Variants, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_VectorFolder = (
  { __typename?: 'VectorFolder' }
  & Pick<Types.VectorFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_VectorTile = (
  { __typename?: 'VectorTile' }
  & Pick<Types.VectorTile, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_VectorTileLink = (
  { __typename?: 'VectorTileLink' }
  & Pick<Types.VectorTileLink, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_VectorTilesFolder = (
  { __typename?: 'VectorTilesFolder' }
  & Pick<Types.VectorTilesFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_VectorTilesParametersTemplate = (
  { __typename?: 'VectorTilesParametersTemplate' }
  & Pick<Types.VectorTilesParametersTemplate, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Version_95ebc23204774dc38ad3465d5fe8da2f = (
  { __typename?: 'Version_95ebc23204774dc38ad3465d5fe8da2f' }
  & Pick<Types.Version_95ebc23204774dc38ad3465d5fe8da2f, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Video = (
  { __typename?: 'Video' }
  & Pick<Types.Video, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_VideoCountOption = (
  { __typename?: 'VideoCountOption' }
  & Pick<Types.VideoCountOption, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_VideoCountOptions = (
  { __typename?: 'VideoCountOptions' }
  & Pick<Types.VideoCountOptions, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_VideoFolder = (
  { __typename?: 'VideoFolder' }
  & Pick<Types.VideoFolder, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_VideoFolder_bba49474673e468186ba8b1a20e067a9 = (
  { __typename?: 'VideoFolder_bba49474673e468186ba8b1a20e067a9' }
  & Pick<Types.VideoFolder_Bba49474673e468186ba8b1a20e067a9, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_VideoPage = (
  { __typename?: 'VideoPage' }
  & Pick<Types.VideoPage, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_VideoParameters = (
  { __typename?: 'VideoParameters' }
  & Pick<Types.VideoParameters, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_VideoParametersTemplate = (
  { __typename?: 'VideoParametersTemplate' }
  & Pick<Types.VideoParametersTemplate, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_VideoPressReleasePage = (
  { __typename?: 'VideoPressReleasePage' }
  & Pick<Types.VideoPressReleasePage, 'id' | 'name'>
  & { template: PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BasePressRelease_template_ItemTemplate, pressReleaseTitle: Types.Maybe<PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BasePressRelease_pressReleaseTitle_TextField>, pressReleaseDescription: Types.Maybe<PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BasePressRelease_pressReleaseDescription_TextField>, pressReleasePublicationDate: Types.Maybe<PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BasePressRelease_pressReleasePublicationDate_DateField>, duration: Types.Maybe<PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___VideoPressRelease_duration_IntegerField> }
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Video_4bc649610a894242be2dc5026090cf49 = (
  { __typename?: 'Video_4bc649610a894242be2dc5026090cf49' }
  & Pick<Types.Video_4bc649610a894242be2dc5026090cf49, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results__AssetsOptimization = (
  { __typename?: '_AssetsOptimization' }
  & Pick<Types._AssetsOptimization, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results__BackgroundImage = (
  { __typename?: '_BackgroundImage' }
  & Pick<Types._BackgroundImage, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results__CompatibleThemes = (
  { __typename?: '_CompatibleThemes' }
  & Pick<Types._CompatibleThemes, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results__CompositeTheme = (
  { __typename?: '_CompositeTheme' }
  & Pick<Types._CompositeTheme, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results__CustomMetadata = (
  { __typename?: '_CustomMetadata' }
  & Pick<Types._CustomMetadata, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results__CustomRenderingViewPath = (
  { __typename?: '_CustomRenderingViewPath' }
  & Pick<Types._CustomRenderingViewPath, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results__DatasourceBehaviour = (
  { __typename?: '_DatasourceBehaviour' }
  & Pick<Types._DatasourceBehaviour, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results__Favicon = (
  { __typename?: '_Favicon' }
  & Pick<Types._Favicon, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results__FormsFolderLocation = (
  { __typename?: '_FormsFolderLocation' }
  & Pick<Types._FormsFolderLocation, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results__FundSettings = (
  { __typename?: '_FundSettings' }
  & Pick<Types._FundSettings, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results__HasValidUrlName = (
  { __typename?: '_HasValidUrlName' }
  & Pick<Types._HasValidUrlName, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results__LocalDataLink = (
  { __typename?: '_LocalDataLink' }
  & Pick<Types._LocalDataLink, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results__Login = (
  { __typename?: '_Login' }
  & Pick<Types._Login, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results__OpenGraphMetadata = (
  { __typename?: '_OpenGraphMetadata' }
  & Pick<Types._OpenGraphMetadata, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results__PageDesignTheme = (
  { __typename?: '_PageDesignTheme' }
  & Pick<Types._PageDesignTheme, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results__PageSearchScope = (
  { __typename?: '_PageSearchScope' }
  & Pick<Types._PageSearchScope, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results__SearchCriteria = (
  { __typename?: '_SearchCriteria' }
  & Pick<Types._SearchCriteria, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results__SearchableWithoutRelatedItems = (
  { __typename?: '_SearchableWithoutRelatedItems' }
  & Pick<Types._SearchableWithoutRelatedItems, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results__SeoMetadata = (
  { __typename?: '_SeoMetadata' }
  & Pick<Types._SeoMetadata, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results__SiteTheme = (
  { __typename?: '_SiteTheme' }
  & Pick<Types._SiteTheme, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results__SitemapSettings = (
  { __typename?: '_SitemapSettings' }
  & Pick<Types._SitemapSettings, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results__StickyNote = (
  { __typename?: '_StickyNote' }
  & Pick<Types._StickyNote, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results__Styleable = (
  { __typename?: '_Styleable' }
  & Pick<Types._Styleable, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results__TwitterMetadata = (
  { __typename?: '_TwitterMetadata' }
  & Pick<Types._TwitterMetadata, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results__Webinar = (
  { __typename?: '_Webinar' }
  & Pick<Types._Webinar, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results__WildcardSource = (
  { __typename?: '_WildcardSource' }
  & Pick<Types._WildcardSource, 'id' | 'name'>
);

export type PressReleaseSearchLatestQuery_search_ItemSearchResults_results = PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Accordion | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_AccordionFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_AccordionFolder_03f88fb497884025b46f2cb249f4fcd6 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_AccordionItem | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_AccordionItem_8cf671721b2d489e809f4c23db5ab2da | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_AccordionParametersTemplate | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_AccordionPresentation | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_AccordionPresentationFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Accordion_02d060598cc14423a9ac9ff2365176b7 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Accordion_705cc8b3bde54cb3bf1ce455a2a36ef1 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_AddItem | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_AddItem_1e1b739ec3784909941d171aca7362e5 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_AddItem_3aea335cd06d45b1841acbc8d2d1ce40 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_AddItem_de8c75222f3241288f20342f479894eb | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_AddItem_ea8a3f269ccd443a95f571b868a94bd0 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_AddThisParameters | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_AggregatedFacetFilter | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_AlertMessage | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_AlertMessageFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_AlertMessageParametersTemplate | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_AlertMessageType | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_AllertMessageTypeFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Archive | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleAuthor | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleAuthorsFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleCategoriesFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleCategory | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleChapter | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleChapters | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleContentType | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleContentTypesFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleFilter | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleFilterOption | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleFootnote | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleFootnoteLink | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleFootnoteText | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleInfogramTile | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleInfogramTileParametersTemplate | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticlePage | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleRegion | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleRegionsFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleSearchPage | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleSearchPage_4d8bd0d1a07841dc96405ca1ed71d81c | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleSearchPage_22b7f7c7c37f4644a8eed9c32258b4a2 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleSearchPage_be414ff574ac4203abb2694811443e25 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleSearchPage_c7ad44ac3cab45158b619465a552a82c | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleSearchPage_cf31bd740a4b4363b03d1f7a88e39907 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleSeriesCollection | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleSeriesFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleSettings | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleSubscriptionBanner | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleSubscriptionBannerFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleTag | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleTagsFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleTeamAuthor | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleTileParametersTemplate | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleTilesParametersTemplate | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleWildcardPage_4bf0be7a0c5c41d5973bb82f1ec73f8f | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleWildcardPage_8f17c5d3ea39491494916dbfe2410ad8 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleWildcardPage_84a63b4789ee4a3f82684b750a6a23ca | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleWildcardPage_95e7966e0da1412bafbf0e8a69392c8c | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleWildcardPage_405b20252077400383d3b47f09f88b47 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticleWildcardPage_b037a577f5cb4ad3b79f07720a96985b | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ArticlesGroupFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_AttachThemeExtension | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_AutomaticDocumentListings | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_AutomaticDocumentListingsFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_AvailableJSONRenderings | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_AvailableMetaRenderings | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_AvailableRenderings | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_AvailableRenderingsFolder_26ec1d1811b24dd98326f6115f4fd7eb | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_AwardsBanner | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_AwardsBannerFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_AwardsBannerImage | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_AwardsBannerParametersTemplate | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_BYOCWrapperRenderingParameters | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_BackgroundColorOption | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_BackgroundColorOptionFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_BannerFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_BannerType | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_BannerTypeFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_BaseHeading | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_BaseHeadingFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_BoolFacet | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_BranchesFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Breadcrumb | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_BrowserTitleDefinition | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_CORSEntry | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_CORSGrouping | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_CTAPresentationType | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_CTAPresentationTypeFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__AbrdnPage | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__ActionBase | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__AdvancedParameter | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__App | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180c | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__ArticleWildcardPage | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__AvailableRenderingsFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__BYOCRenderingParameters | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__BackgroundParametersTemplate | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__BaseCTA | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__BasePage | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__BasePage_037da552a5524fe4aeee331f57ac1378 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__BasePage_315fd21bebf04c9d9f00bae191442f1d | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__BasePage_458c6cc442da4327b4d4d7d4ecd48cbd | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__BasePage_728c97b5c56146d9807e21018a972bb5 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__BasePage_6105875085f346729dfc8d133b481f26 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__BasePage_b08130ebd3314a3b9c0f2b5e9b66387b | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__BaseRenderingParameters | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__BaseTheme | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__BaseVariantField | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__Class | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__CompositeGroup | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__CompositeSection | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__EloquaForm | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__ErrorPage_d40dd5cadbf1461191b8f9e1071e557d | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__ExtendedOptions | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__ExtendedOptions_2964fb4257a6440fb192218443904c90 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__ExtendedOptions_f1850030f97848b4bdb5884b7e863160 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__FEaaSRenderingParameters | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__FacetSelectorConfigBase | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__FilteredArticlesParentPage_8196d9b5309f49f882f7918089b77845 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2b | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__FundDetailsWildcardPage_fb127f7aeeba46458c5fbe9f7c589303 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__FundSearchPage_d83da2a5ce9042b6bd557aa8820c62c5 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__FundShareclassDetailsWildcardPage_e3590ad764a84980a419c4f1f926f9fc | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__GlobalDatasourceBehavior | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__GridDefinition | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__GridItemBase | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__GridParameters | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__HeadlessSite | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__HeadlessTenant | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__HelpArticleSearchPage_d1c4d91365c8401389dcde7b5fb2f28b | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__HelpArticleWildcardPage_c0a939305f6e47a38739f2a8f300e65d | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__HomePage_2899b95da7f346b7a1da7ef14d7ef84d | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__IAllowEmpty | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__IBaseVariantDefinition | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__IBoosting | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__ICacheable | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__ICompatibleRenderings | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__IComponentVariant | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__IControlType | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__IDynamicPlaceholder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__IFEaaSComponentsDataSourceTemplates | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__IFEaaSComponentsEditorScriptURL | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__IIcon | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__ILocation | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__IPaginable | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__IPagination | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__IPoi | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__IRenderingId | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__ISplitter | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__IStyling | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__IVariantDefinition | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__InvestmentTrustPage | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__JSONField | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__JSONReference | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__JSSData | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__JSSSettings | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__JSSSiteFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__JssRootFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__LiteratureHubSearchPage_5378ef42e2c4488497ac7cc017b10086 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__Navigation_e6d98f24d01c419e871a4617125a49ed | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__Page | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__PageData | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__PageDesignFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__PageDesignFolder_023f5d48979d4381bc5e149e36abd3bd | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__PageDesigns_daaf41fd96db4892be99f62f16d036c4 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__PartialDesign | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__PartialDesignFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__PartialDesignFolder_25f01f50553444f9b1babcbb60b2d13d | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__PartialDesigns_79c9fa015f6a48b2b45905bbaa826a9d | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__PlaceholderWrapper | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__PressReleaseSearchPage_4197f4d95d5f4fb3be77e0be695df7ac | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__PressReleaseWildcardPage_6a8c237f261d4a9891ef3e27afee2b9b | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__RedirectMapGrouping | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__ResizableIFramePage_6ff27d6556ff453393bbb3f7f568d973 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__Route | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__SimpleVideo | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__SiteSettingsFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__SitemapSettings | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__StandardTemplate | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__TeamMembersParentPage_11fbd080aa844abca056f5caac316e4c | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__TeamMembersWildcardPage_8b12628190064b2980f0a054ead02a65 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__TrustFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__VariantDefinition | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__VariantField | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C__VariantsGrouping | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___AdvancedItem | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___Arguments | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___Arguments_33fab87cd52f44319a1f589ba7c1e287 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___Article | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___ArticlePageWorkflow | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___ArticleSearchPage | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___ArticleWildcard | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___AssetServiceThemeMode | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BaseArticle | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BaseDataFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BaseHelpArticle | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BaseInvestmentTrust | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BaseJSSTenant | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BasePage | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BasePageDesign | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BasePageDesignFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BasePartialDesign | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BasePartialDesignFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BasePlaceholder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BasePlaceholderSettingsFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BasePresentation | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BasePressRelease | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BaseRenderingParameters | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BaseSXAStandardValuesFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BaseSettings | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BaseSharedSitesSettings | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BaseSiteDefinition | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BaseSiteFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BaseSiteGrouping | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BaseSiteRoot | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BaseTenant | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BaseTenantFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BucketRules | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___CORS | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___Content | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___ContentType | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___DataAttributes | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___DatasourceWorkflow | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___Dependencies | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___Description | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___DesignTemplateMapping | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___Designable | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___EditType | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___EditType_8a9f84baaa124c5d9096935714809da4 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___EditingTheme | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___Enabled | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___ErrorHandling | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___ExternalArticle | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___Fields | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___FilteredArticlesParent | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___FilteredArticlesWildcard | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___Footnotes | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___FundDetailsWildcard | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___FundFormAvailability | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___FundMetadataPage | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___FundSearchPage | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___FundsFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___FundsFormsFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___FundsLiteratureFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___FundsShareclassesDetailsWildcard | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___GridMapping | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___HelpArticle | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___HelpArticleSearchPage | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___HelpArticleWildcard | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___HorizonDatasourceGrouping | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___Icon | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___IncludeByDefault | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___IncludeIfInstalled | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___InternalArticle | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___InternetExplorerCompatibilityMode | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___IsSystemModule | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___JSONVariantPaging | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___JSONVariantsBase | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___LimitedDisplay | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___LinkAttributes | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___LinkSettings | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___LiteratureHubSearchPage | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___ManualKeyInformation | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___MemberOf | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___MetadataPage | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___Modules | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___Name | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___Name_0345fd2f95094dc7b0f56c73a9b6cd8d | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___Name_299cdb154745448a807868d401248eaa | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___Name_b88cf88159a54a19991e71038751cb60 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___Navigable | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___NavigablePage | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___PageContent | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___PageWorkflow | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___PerSiteStandardValues | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___Podcast | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___PodcastPressRelease | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___PremiumContentPage | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___PressRelease | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___PressReleaseContentType | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___PressReleaseSearchPage | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___PressReleaseWildcard | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___ProtectedTheme | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___PublishingGroupingTemplate | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___RenderingRelatedParameters | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___RenderingVariantsBase | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___RenderingsList | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___RobotsContent | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___RoleDomain | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___RoleName | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___RoleType | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___SalesforceCommonValidations | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___SalesforceFieldId | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___SalesforceFieldTitle | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___SalesforceFieldValue | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___Script | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___SearchSignature | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___Searchable | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___SecurityItemPointer | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___SharedArticles | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___SharedContent | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___SharedHelpArticles | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___SharedPage | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___SharedPressReleases | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___SharedRoot | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___SharedSettings | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___SiteContent | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___SiteFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___SiteMediaLibrary | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___SiteSettings | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___SiteTemplate | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___SitecoreClientSiteManaging | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___Sitemap | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___SitemapMediaItems | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___SlidersRangeSettings | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___SolutionTemplateContent | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___SolutionTemplateDescription | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___SolutionTemplateName | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___SortOrder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___StackBreakpoint | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___Statistics | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___SupportedLanguages | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___Taggable | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___TeamMembersParentPage | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___TeamMembersWildcard | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___TechzoneArticle | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___Template | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___Title | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___Type | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___Validation | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___VariantPaging | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___VectorTile | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___VectorTileLink | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___Video | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___VideoPressRelease | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___Width | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___WildcardPage | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_CacheSetting | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Caching_26fce9bf0256458d8281a713a5bf5520 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_CalendarEvent | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_CallOutSection | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_CallOutSectionDropdownOption | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_CallOutSectionFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_CallOutSectionParametersTemplate | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_CallToAction | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_CallToActionFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_CapabilitiesFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Capability | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_CapabilityMap | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_CapabilityMappings | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Carousel | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_CarouselFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_CarouselSlide | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Carousel_2b65f0d87ec54834b4aa1753c0f7036b | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Checkbox | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ChecklistFilter | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ChecklistFilterFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ChecklistFilter_3cb40bd669c94976a9742120a5eba1ee | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ColumnSplitter | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ColumnSplitter_3e1016e56ecb4c19aa0117c18b42deb0 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_CompatibilityMode | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ComponentConfiguration | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ComponentThemeConfiguration | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ComponentThemesConfiguration | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ComponentsConfigurations | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ConfigurationFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Container | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ContainerOption | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ContainerOptionsFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ContainerParametersTemplate | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Container_45130bdbbae34edcaea87b68b9d94c7f | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ContentBlock | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ContentBlockFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ContentToken | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ContentTokenFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ContentType | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_CorporateTheme | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_CorporateThemesFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Country | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_CountryISOCode | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_CountryISOCodesFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_CustomerReviewFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_CustomerReviewTile | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_CustomerReviewTileParametersTemplate | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_DataBridgeDocumentCategoryMap | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_DataBridgeFund | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_DataBridgeFundRangeName | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_DataBridgeSettingsFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_DataBridgeShareClass | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_DataFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_DatasourceConfiguration | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_DatasourceConfigurations | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_DatasourceWorkflowAction | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_DateFacet | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_DateFilter | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_DateFilterFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_DateFilter_ad89c1f1e99148ef865938ab13aa28f1 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_DefaultColumnLayout | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_DefaultShareclassMapping | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_DefaultShareclassMappings | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_DescriptiveHighlight | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_DescriptiveHighlightFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_DescriptiveHighlightItem | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_DescriptiveHighlightParametersTemplate | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Device | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Device_7c27ec70f42e40428a0fabaa2f8eda18 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Devices | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_DictionaryFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_DisqusParameters | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_DistanceFacet | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Divider | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_DocumentItem | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_DocumentListings | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_DocumentListingsFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_DocumentTypeFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_DominantLanguageMapping | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Dropdown | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_DropdownFilter | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_DropdownFilterFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_DropdownFilter_790c0f2c16214604a6c672b9f8ae830d | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_EditEditingTheme | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_EditFrame | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_EditModePanel | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_EditSiteItem | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_EditSiteItem_f040db0387fe4e10ae4053c63175e31b | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_EditSiteTheme | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_EditTenantTemplate | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_EditTenantTemplate_a7d9fcbcc8944274935f9b9659c000d3 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_EditType | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_EloquaFormFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_EloquaFundForm | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Enum | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Enums | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ErrorPage | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ErrorPage_4b405ec4ef9f4c91a3ffb98c1ac81171 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ErrorPage_4dbccce416d1491f94198496e3f77c6d | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ErrorPage_45d797cc048740ffb693214883ff35c2 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ErrorPage_76eb47b3f3a248bdbbdbb5bf7d8f9bf9 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ErrorPage_a7dfa49761224679bf9949fffacd5fa1 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_EventCalendarParameters | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_EventList | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_EventListParameters | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_EventTypes | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_EventsFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ExecuteScript | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ExecuteScript_3d4e4577ab334ca6ae43b98d1ec6472f | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ExecuteScript_6545c81fc30f4b5897d9ef85b890f70a | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ExecuteScript_b06460c28b7b47a59e2cf966f689b6ca | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ExecuteScript_bc9bb68436df4285888bd8b4d87b10de | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ExecuteScript_e14c08721a97459eafef0acaaaf1ffbb | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ExtendSiteTheme | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ExternalLiterature | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FEaaSWrapperRenderingParameters | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FacebookCommentsParametersTemplate | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FacetSlider | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FacetSliderFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FacetSlider_995ce2c7319f478b84fe22053ac85bb7 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FacetSummary | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FacetSummaryFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FacetSummary_cd5c935c1f604d899a6b88ce28305cf2 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FacetsGrouping | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FakeNavigationItem | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FeatureBanner | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FeatureBannerParametersTemplate | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FeaturedArticles | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FeaturedArticlesFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FeaturedTheme | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FeaturedThemesFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Feed | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FeedFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FeedParameters | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FieldEditor | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FieldRenderer | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FileList | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FileListFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FileListParametersTemplate | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_File_04129321770849c1801baee196e1c0a8 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FilterCriteria | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FilterCriteriaFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FilterTaxonomyOption | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FilterTaxonomyOptions | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FilteredArticlesParentPage | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FilteredArticlesParentPage_6adc5be146ab4c7d97f64e5c3512177d | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FilteredArticlesParentPage_7f5d344247eb446a8f147890b998e941 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FilteredArticlesParentPage_a34845039cf1441f8c967a5bbbdd7616 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FilteredArticlesParentPage_e4f65f074322485787460a4058d378f9 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FilteredArticlesParentPage_f099104e87204d52a6ab75aa44d159ce | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage_5d527e4033c048c6a474af1068db082e | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage_98c82b05868444df9fe806b5fb955835 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage_705b3bb7cecc447f910fa76bdc57ada2 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage_ceac9aa72d344797adf00f73f9a55f96 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage_da761c9a4e8f4a91b99040d8f5baa260 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Flip | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FlipFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Flip_5ef078504c044b839dafefd752cfaba8 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Flipside | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FloatFacet | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Footer | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FooterFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FooterLink | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FormRenderingParameters | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FundAssetClass | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FundAssetClassesFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FundDetailsWildcardPage | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FundDetailsWildcardPage_97df45d1e5294f6dbc2279895ee83734 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FundDetailsWildcardPage_590b12426ab64f49990b2dd2c5fffd0f | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FundDetailsWildcardPage_60069dbb81dc496b888fe2e38073a74b | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FundFormsFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FundInFocus | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FundInFocusShareClass | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FundSearchPage | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FundSearchPage_5505b84dba1f47c7b8054749d802d926 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FundSearchPage_5806f83c03bc443380678ff955f4310f | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FundSearchPage_7432205c04214a419ca064c4cb37501c | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FundSearchPage_edc9df02132e4c0a8435dd60057cbb0a | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FundSettings | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FundShareclassDetailsWildcardPage | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FundShareclassDetailsWildcardPage_543d5f778ad443269e2384804031cb3c | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FundShareclassDetailsWildcardPage_5827425c1b4246d19f1311387a5bd4b3 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FundShareclassDetailsWildcardPage_cf3f2635270b49779bb3822ab90f1dcc | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FundShareclassDetailsWildcardPage_d7e686d9c3bc4ef9974e201972b59eee | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FundSubAssetClass | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FundSubAssetClassesFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FundsExternalLiteratureFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FundsFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FundsInFocusFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FundsInFocusParametersTemplate | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FundsLiteratureFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_FundsLiteratureMappingsFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Gallery | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_GalleryFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_GalleryImage | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_GalleryParametersTemplate | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_GalleryVideo | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_GatedAccordionContainer | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_GlobalLanguageSelector | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_GlobalNavigationBar | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_GoogleAnalytics | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_GoogleTagManager | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_GoogleTagManagerFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_GridSetup | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_GridTheme | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HTMLCode | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HTMLCodeFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HTMLInclude | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HTMLIncludesFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HTMLSnippet | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HTMLSnippetFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HTMLTag | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Header | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HeaderFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Heading | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HeadlessSiteSetupRoot | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HeadlessSite_00d050988bad49e5b65db1e08b03ca1b | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HeadlessSite_0bb67daed5d04933a5ce1c0baa6c4df1 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HeadlessSite_8ca001453c4b4715959d8a05292ecbc5 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HeadlessSite_68ffa40c5aab45548f774742b163f318 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HeadlessSite_89d464c8c03e4b0287e9a878d95d7149 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HeadlessSite_229484893ca144958b9937167dfb5064 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HeadlessSite_b28055626acc45a2913a9617398c9730 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HeadlessSite_f1cab1661abb450d84d55d938e7699cb | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HeadlessSite_f3884baa0e1548f59a6d7154a4559604 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HeadlessSolutionTemplateFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HeadlessTenantSetupRoot | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HeadlessTenant_07248c4700af499eb2a9cb7789f72372 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HeadlessTenant_5b3d7ac5419343c697c722309a2ad4c8 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HeadlessTenant_5d72df6049c74324969205b55767ad7b | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HeadlessTenant_6abd3bf16bcb4f25ac5b2399ff7a92e3 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HeadlessTenant_77a403a2094e48afafa60943d349d23d | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HeadlessTenant_115c42029c0d4fbcb542a4a539c33ee2 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HeadlessTenant_94824ac390d748499e5af0275d10811f | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HeadlessTenant_4797571864fd40929cf2412c39757ec3 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HeadlessTenant_c102fb48f40f49fb9c21f8e3e1b0c107 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HeadlessTrustSite | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HeadlessVariants | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HeadlessVariantsGrouping | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HelpArticlePage | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HelpArticlePlatform | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HelpArticlePlatformMap | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HelpArticlePlatformMappings | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HelpArticlePlatformsFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HelpArticleSearchPage | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HelpArticleSearchPage_486d4c7432c64f9a929b595943c6fe77 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HelpArticleTag | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HelpArticleTagsFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HelpArticleWildcardPage | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HelpArticleWildcardPage_e4e2d58c853341deaa6b2a2a136421c4 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HelpArticlesGroupFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HelpTagMap | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HelpTagMappings | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HeroBanner | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Highlight | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HighlightBlock | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HighlightBlockFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HighlightBlockParametersTemplate | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HighlightFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HighlightItem | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HighlightParametersTemplate | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Home | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HomePage | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HomePage_0d3963a8171d4080b5f808618578b631 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HomePage_6d95c7d946c74a70be07304cc73a2010 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HomePage_b407f259b4e34c7db9a06e8907a56b17 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HomePage_cde13c51062d426b95569e8202edc963 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_HomePage_de9353283a3e41c495ba386aed0540c6 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_IFrame | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_IFrameFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_IFrameFolder_21366ebf5fda4ff4a4dac7b1f4d7ada2 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_IFrameParametersTemplate | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_IFrame_0da12d476de24dfeb4d0f513489bfea1 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_IFrame_88a6f65f2b78491bb3770b06e48883e1 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Icon | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_IconFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Image | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ImageFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ImageFolder_edc00e86cef24d0cbfa264460becc323 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ImageFolder_f7a4527687f14ea5bf25e3c7cb7aa993 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ImageParametersTemplate | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Image_83bc563c6320490092f8204bff81586a | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Image_15185b0e641844499f934ff03b7ee032 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Image_d885df8cb2d64007b34b2bbafb527304 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Infographics | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_InfographicsFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_InputValidationStep | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_InputValidationStep_088928cf558e40ec87f3342aa9e66757 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_InputValidationStep_9eded2f7f84748938a0bf69e7fcf3593 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_InputValidationStep_d028fef2babf4ad1bbe74d62a977992f | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_IntegerFacet | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_IntroCopy | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_IntroCopyFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_InvestmentTrustAssetClass | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_InvestmentTrustAssetClassFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_InvestmentTrustPage_8f108193367d41dcb4dc3a71722c2b73 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_InvestmentTrustPage_79a99ec28fe841f0a929356fe3a6aaeb | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_InvestmentTrustRegion | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_InvestmentTrustRegionFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_InvestmentTrustStyle | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_InvestmentTrustStyleFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_InvestorType | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_InvestorTypesFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ItemQueriesFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ItemRights | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_JSBeaconSettings | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_JSONCheckbox | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_JSONContent | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_JSONDate | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_JSONFile | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_JSONImage | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_JSONLayout | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_JSONList | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_JSONMultilistReference | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_JSONPlaceholder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_JSONQuery | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_JSONResults | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_JSONRichText | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_JSONScriban | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_JSONSection | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_JSONTemplate | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_JSONText | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_JSONToken | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_JSONVariantDefinition | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_JSONVariants | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_JSSLayout | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_JSSSettings_1a6fb678eca242c09ae77a9e7f72a6d0 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_JSSSettings_6b328292f8314ab79885d89a054ca10a | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_JSSSettings_457c9d0b61b84adfaf7f82561ed275ff | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_JSSSettings_5045bf85d2ea430b9f41c2e348436e5d | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_JSSSettings_a767f80d5ad44bfbb8b750a8da144cb5 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_JSSSettings_b001fd725bb1476496825a8cb9e995cd | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_JSSSettings_c643bc8630d14d61a173c7870f5dbbad | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_JSSSettings_ce3dfd340df34b2d8715e54f85dfcce2 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_JSSSettings_ef855d0ba8b04a8e87851d1298266d90 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_JSSSiteGrouping | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_JSSTenantFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_JavaScriptRendering | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_JsonRendering | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_JurisdictionStatus | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_JurisdictionsFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_KeyHighlightItem | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_KeyHighlights | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_KeyHighlightsFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_KeyHighlightsParametersTemplate | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Language | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_LanguageSelector | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_LanguagesFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_LatestPressReleasesParametersTemplate | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_LayoutServiceVariants | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_LimitedDisplayFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_LimitedDisplayOption | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Link | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_LinkList | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_LinkListFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_LinkListFolder_c237d144647a4afeaa7b1570f3e3f139 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_LinkList_33c9207e3b0446068ef54ca99a97c776 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_LinkList_97a593ad273141dc80bfceb5ef6a33b7 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_LinkList_f7561ffcc0d8477fb53d2703a4060be1 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Link_68bd1cb5a7624a969ac6cb16ab5882a3 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Link_930f134d56784b35bfd1b77f9d0115f1 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Link_e24e0789a05848bfabb6c69c0e60b6b7 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_LinksFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_List | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ListFacet | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ListFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ListItem | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ListParametersTemplate | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ListStyle | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ListStyleItem | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ListingHeroBanner | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ListingHeroParametersTemplate | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_LiteratureAuthorization | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_LiteratureAuthorizationsFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_LiteratureHubSearchPage | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_LiteratureHubSearchPage_62f4748b81db49ee9be8b674a7f42d9d | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_LiteratureHubSearchPage_94278fe5377a4665bccbd1d4cef5e30e | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_LiteratureHubSearchPage_d2b2958263564ba8bba5922add46a0ea | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_LoadMore | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_LoadMoreFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_LoadMore_7a3a53e06a0144ff8ba52be46e201fe6 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_LocationFilter | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_LocationFilterFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_LocationFilter_aaad4aad290744dc90b69e4e83a661ec | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Log | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Login | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Login_abed54dc4f7840ddac562289c9c849d8 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_LogoTextBlockItem | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_LogoTextBlocks | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_LogoTextBlocksFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Logout | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Logout_c2294d8235a6452a94b15eb5e543b602 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ManagedRangeFilter | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ManagedRangeFilterFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ManagedRangeFilter_14c6033e186b49088bb925aba0da4d91 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ManagedRangeItem | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Map | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_MapParameters | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_MapsFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_MapsProvider | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_MediaBlock | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_MediaBlockFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_MediaBlockParametersTemplate | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_MediaFolder_81150e5837f5443fa3c075e14a9321e7 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_MediaLinkParameters | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_MediaVirtualFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_MegaNavigation | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_MegaNavigationFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_MetaBranding | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_MetaRenderingParameters | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_MetadataPartialDesign | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Model | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ModelIterator | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_MyLocationPOI | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Navigation | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_NavigationCategory | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_NavigationFilter | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_NavigationFilterFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_NavigationLink | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_NavigationSubcategory | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Navigation_9ce34bf95c934dff841d8f649c2bd6c8 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_OneTrustSettings | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_OptimiserConfiguration | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_OptimiserConfigurationSection | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_OptimizedFile | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_OracleCDPSettings | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_OverlayContent | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_OverlayFolderTemplate | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Ownership | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_OwnershipFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_POI | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_POIFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_POIType | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_POIs | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PageBranchesFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PageContent | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PageContentFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PageContent_ef87e73bc7ff49a2ac599b0be83755c3 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PageDesign | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PageDesignFolder_1aa9bc8250a94e4eb15003b55b4dfed0 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PageDesignFolder_27d4f8be63b045769a4ef3163c935b47 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PageDesignFolder_352ce40ee6e1457a8bf225d8771894e8 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PageDesignFolder_446a7eadeb894ed6b48c7f1862f29d7b | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PageDesignFolder_720d01f11e5046fa9c4a697f9321f662 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PageDesignFolder_771a0de7e83f44338c5d78727ead93bc | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PageDesignFolder_14161ec204984aa7a2a46decadf669f5 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PageDesignFolder_c691c2c4e0dd4fedb84a3c29de7002cb | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PageDesignFolder_d84605f786ea482da6ff683f6572821c | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PageDesign_1105b8f81e00426bbf1fc840742d827b | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PageDesigns | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PageDesigns_3af52e70e982424b9c85e355542500c9 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PageDesigns_9b34083e890b467d8e76b8c3dbbb712d | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PageDesigns_48d2d50a150c4f6283603a4fed5646e0 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PageDesigns_99a71bba507746729c3fb29b04abee23 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PageDesigns_a0f265b42d6241968b65d3ede7cb59c3 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PageDesigns_abe5ce6a82ff4433b4973bc50f192e11 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PageDesigns_b8d9b352c1694b31bd506848b47ca884 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PageDesigns_d3b2e1466f744df0900bec314f699ef3 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PageDesigns_fd4b9b54f7474f01abdeba569d4b5bbe | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PageLevelTabs | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PageLevelTabsFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PageList | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PageSelector | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PageSelectorConfiguration | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PageSelectorFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PageSelector_59a7bb775f8c435ab810291abde80e63 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PageSize | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PageSizeFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PageSize_b682562e0af64b3e9e3b45273bbe152d | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PageTheme | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PageThemesFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Page_4f49a81db3664f198b89cab92f377d7a | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Page_5e66d86353544fe6a27d3b894984d50f | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Page_84f342ad2d0646b9aa9a818201145ca2 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Page_718df200be51463d93edf4d77ab7a49e | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Page_b61d5babe46f4ef39f27b57c4ccefdf7 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Page_cfd6e04697e24f3cb9eb41b79afc35dc | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Page_dae7821153e14dbabb0ddf0b53a90aaf | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Page_fa608b3e6aeb426388a059d89caabada | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Pagging | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Pagination | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PaginationFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Paragraph | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PartialDesignFolder_8cf20a4412b746ee801218122c955b2d | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PartialDesignFolder_42eb57ecaa474923b3ddbfb72818f00b | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PartialDesignFolder_766d4de859a0419292de1898fe0ac4e8 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PartialDesignFolder_827d4d2f2a84408e8f0ff1d6869a441b | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PartialDesignFolder_828b5ff144cd4150bcdfe54084165112 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PartialDesignFolder_89098e3089aa4062a77346d608caac90 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PartialDesignFolder_1695576fb93647d7842ed17730278c32 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PartialDesignFolder_f16ae56fb78845639407c88edaffcbcc | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PartialDesignFolder_fb58558a3ec946d18524cd30805ab21a | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PartialDesign_fd2059fd60434dfe8c04e2437ce87634 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PartialDesigns | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PartialDesigns_043d3ad0ac4445dba03afc3550d088ec | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PartialDesigns_0310a4bf20d1441c886a0418c53e30f4 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PartialDesigns_36c869ded22040929ce829f6ed643c66 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PartialDesigns_1943dc73710a430895515a342c84b037 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PartialDesigns_b1e2a6790a1442d8bafa66317b8be117 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PartialDesigns_cc6d8635f3e2440ab8ebb93dc1030e9e | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PartialDesigns_d52704ed3b704a53abb4292105f687ad | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PartialDesigns_d216303f58d8425688da8cd30d00afab | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PartialDesigns_facda26791204fa9a0363344348f2c42 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PerformanceChartSettings | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PerformanceChartTimePeriod | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PerformanceChartTimePeriodFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PlaceholderSettingsFolder_0339bac078c143c1b930f8c26a5fdf80 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PlaceholderSettingsFolder_3d281bf8533646869dd6ab4ab5b3fd5d | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PlaceholderSettingsFolder_52288e3978304694b62d32a54c6ef7ba | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Placeholder_1ca0304be5b64810821154426f1752c2 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Placeholder_d2a6884c04d54089a64ed27ca9d68d4c | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PlainHtmlParametersTemplate | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Playlist | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PlaylistFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PlaylistParametersTemplate | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Podcast | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PodcastFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PodcastPage | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PodcastPressReleasePage | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PoiTypes | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PostDeleteStep | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PostDeleteStep_7a7e57b99c6d4a22b5fdf7b214dde574 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PostDeleteStep_78d6ec9b66e34763987003cf314ee37a | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PostDeleteStep_b20857895385413883f096f3767cb156 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PostSetupStep | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PostSetupStep_6fac654e22154a419a1d59197bebc0fe | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PostSetupStep_8ff2febff6d2461d9ed38b0cb5d9d86f | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PostSetupStep_341738aa44fe490e90ff7010a3c2463b | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PreDeleteStep | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PreDeleteStep_51437c06212c4c0fb3b2fa5b0486ab49 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PreDeleteStep_52510f549ec5464cb075ef44b5c2f96b | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PreDeleteStep_f0daf401190f45468bda8568d08e161d | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PreDeleteValidationStep | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PreDeleteValidationStep_408fd8ab1667440ba6051370ddf0a51f | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PreDeleteValidationStep_edf1fa4206c44703ab1af23495bc6d8f | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PreDeleteValidationStep_f8c52120d0ea4d009de3b49fe12a3f1e | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Presentation | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Presentation_0a70fa7389234a6eabf34134f25f3221 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PressReleaseContentType | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PressReleaseContentTypesFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PressReleaseFilter | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PressReleasePage | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PressReleasePlatform | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PressReleasePlatformsFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PressReleaseSearchPage | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PressReleaseSearchPage_1b2f7a53709a4c62b381dae5f1280b7f | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PressReleaseSearchPage_a6c344ca7c6946009de2ca92e27d7b72 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PressReleaseSearchPage_b9cd16f585ea4405a1ceda10cb20f64d | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PressReleaseSearchPage_c97027442df647cf9c36eedfc6787f58 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PressReleaseWildcardPage | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PressReleaseWildcardPage_2c028bdb02874051b629a7b7d422cc1e | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PressReleaseWildcardPage_5a72be834c654d70a591cef7e9ce9d79 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PressReleaseWildcardPage_b337d30403c642d2b9757e23d08223a1 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PressReleaseWildcardPage_e55e9d5bf9614e30b0a2a90327428258 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PressReleasesGroupFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PrivacyWarning | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ProjectFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Promo | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PromoFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PromoFolder_f07cbe8973ae4de692172570260cac6e | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Promo_7f21f14d096b4f27bbccf115c6e6f6f1 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Promo_881869ca7f5845ea8b34ad1bfd3551a8 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Promo_dfed4457d760457abec1c0dccdc44381 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PromotedContent | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PromotedContentFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PropertyListingCard | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PropertyListingCards | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PropertyListingCategory | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_PropertyListingFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Query_98b413525a4b4067b92418a4b50f0a53 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_QuickLinks | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_QuickLinksFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_QuickLinksParametersTemplate | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_QuotationBlockItem | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_QuotationBlocks | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_QuotationBlocksFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_QuotationBlocksParametersTemplate | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Quote | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_QuoteFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_QuoteParametersTemplate | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_RadiusFilter | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_RadiusFilterFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_RadiusFilter_de3fa58eef9d45449f77dcd1dbb05b64 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_RadiusScheme | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_RadiusSchemeValue | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_RangeSliderFilter | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_RangeSliderFilterFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_RangeSliderFilter_0a1787c296b54d40828522564a5d8e03 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_RecentArticles | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Redirect | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_RedirectMap | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_RedirectMaps | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Region | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_RegionLanguages | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_RegionLanguagesFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_RelatedArticles | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_RelatedArticlesParametersTemplate | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_RenderEngineType | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_RenderingFolder_840d4a46550349ecbf9dbd090946c63d | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_RenderingHost | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ResizableIFramePage | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ResizableIFramePage_8ab2ae106350452ca0e7b06d6d859067 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ResizableIFramePage_92674815f3f74a879c0874bcb72c9b68 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ResizableIFramePage_b58eacfb27f5417bb536141f94b92521 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ResizableIFramePage_d8d76a2407084147bf3900cd5e12e401 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ResizableIFramePage_f460ab055585441892023750e7cef6b7 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ResponsiveImage | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ResultsCount | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ResultsCountFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ResultsCount_f3c0661ef9a9444ca26d44bf2a68a186 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ResultsVariantSelector | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_RichText | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_RichTextFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_RichText_0f3b73366112418c8bbab0526f3887ce | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_RichText_efcfd8f6596745f48f85b5421928205d | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_RiskImageMapping | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_RiskImageMappings | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_RiskLevelOption | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_RiskLevelOptionFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_RiskWarning | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_RiskWarningFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_RiskWarningParametersTemplate | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_RolePlaceholder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_RowSplitter | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_RowSplitter_340c887da1d1415b9678c763af74ea97 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Rule | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SDRLogoMapping | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SDRLogoMappings | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SDRTypeOption | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SDRTypeOptionFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SXAJSSLayout | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SXARole | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SXAStandardValuesFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SalesforceAlertMessage | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SalesforceCheckBox | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SalesforceCheckBoxType | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SalesforceConditionalRadioButton | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SalesforceConditionalRadioButtons | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SalesforceDateInput | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SalesforceDropdown | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SalesforceDropdownOption | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SalesforceHiddenField | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SalesforceInput | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SalesforceInputType | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SalesforceIntegratedForm | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SalesforceIntegratedFormTypesFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SalesforceRepeatableSubSection | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SalesforceRichTextArea | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SalesforceSection | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SalesforceSortCodeInput | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SalesforceSubmissionType | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Scope | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ScopesFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Scriban | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Scripts | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SearchBox | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SearchBoxFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SearchBox_1c04fd611d874590acfe9cc186865ab3 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SearchFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SearchResults | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SearchResultsFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SearchResults_a06f7130041d46bb8c2995a2dc00c26a | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SecondaryHeroBannerParametersTemplate | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SectionHeading | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SectionHeadingFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SectionHeadingParametersTemplate | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SectionHeadingType | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SectionHeadingTypeFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SectionSelector | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SectionSelectorFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SectionSelectorTab | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Security_33077d51ebad4d1cb4a83b79f51dba13 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Series | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SeriesFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Settings | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SettingsFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Settings_6c82caca67dc464195698faad083230e | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SharePriceSettings | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SharedArticlesFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SharedContentFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SharedFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SharedHelpArticlesFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SharedPressReleasesFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SharedSettingsFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SharedSitesSettings | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SharedSitesSettings_c14bf746030f4e598594395f6d299e61 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Showcase | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ShowcaseFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ShowcaseItem | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ShowcaseParametersTemplate | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Site | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SiteContentFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SiteDefinition | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SiteEntryDisclaimer | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SiteFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SiteGrouping | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SiteManagement | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SiteSecurityItemPointer | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SiteSelector | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SiteSelector_a44632f56dcd4d10b4892f4e35e193c3 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SiteSetupRoot | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SiteTheme | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Site_e46f3af239fa4866a1577017c4b2a40c | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SitecoreFormWrapperParametersTemplate | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SitecoreRole | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SitemapSettings_c71d856635c849b7a84d9d176e9cbd05 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SkipLink | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SkipLinkParameters | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SkipLinksFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Snippet | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SnippetItem | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SnippetsFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SocialLoginWrapper | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SocialMediaButtons | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SocialMediaFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SocialMediaShare | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SocialMediaTemplate | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SocialNetwork | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SocialNetworkFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SocialNetworkLink | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SolutionTemplate | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SortResults | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SortResultsFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Sorting | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SortingGroups | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SpotifyPodcast | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SpotifyPodcastFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_StickyCTA | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_StickyCTAFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_StickyCTAParametersTemplate | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_StrategiesInFocusFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_StrategyInFocus | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Style | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Styles | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Styles_9c0dac2808aa4b44bc2153363206f6a5 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_SubscriptionBannerParametersTemplate | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Tab | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TabItem | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TableOfContents | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TableOfContentsFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TableOfContentsSection | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TableOfContentsSubsection | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Tabs | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TabsFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Tabs_f26a9560ccf148c59542800e837caf7a | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Tag | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TagCloud | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TagFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TagList | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TeamBiographySettings | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TeamListingCards | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TeamListingCardsFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TeamMember | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TeamMemberCard | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TeamMembers | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TeamMembersParentPage | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TeamMembersParentPage_0dfb40140ba44abe8a480904ff1eff1e | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TeamMembersParentPage_2e9df92fe936461987fd0ea8ad08bd9e | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TeamMembersParentPage_47f304d629a84648a0e2b942513133ff | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TeamMembersParentPage_75c911bd18704434ad7adcca64dfb089 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TeamMembersParentPage_b4311697c06c4d58b88dca047c0a72b0 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TeamMembersWildcardPage | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TeamMembersWildcardPage_6c0a7b262ac64e1ba92ab20013a5a00e | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TeamMembersWildcardPage_9c436bbf177d481da8bdfdc12a53d450 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TeamMembersWildcardPage_52ba0118982f400fb80e1fee787f1d3a | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TeamMembersWildcardPage_54e4118770954f8abdfb908c88ce2f29 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TeamMembersWildcardPage_ea27a3d835fd49a3a4c797d2a6d52745 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TeamProfileCards | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TeamProfileCardsFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TechzoneArticlePage | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Tenant | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TenantFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TenantSecurityItemPointer | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TenantSetupRoot | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TertieryHeroBanner | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TertieryHeroBannerParametersTemplate | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Text | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TextBlock | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TextBlockHeadingParametersTemplate | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TextBlockHeadingType | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TextBlockHeadingTypeFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TextBlockLinkType | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TextBlockLinkTypeFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TextBlocks | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TextBlocksFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TextBlocksParametersTemplate | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TextFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TextFolder_b762d56787f5493cbb480c455d834457 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Text_b8f5894cb4934016bf784090b0a2fd16 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Theme | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ThemeTag | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ThemeTagsFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ThemingMode | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ThemingModes | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Tile | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TileLink | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TileParametersTemplate | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TileSizeOption | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TileSizeOptionFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TilesFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TilesParametersTemplate | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Title | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Title_a82e893105754175917de904ef7e6dbe | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Toggle | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_ToggleFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Toggle_8e4c968e9fa543a89ac4c0baf273ccde | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Transformation | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TrustArticleHeroParametersTemplate | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TrustFinder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TrustFinderFilterOption | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TrustRegion | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TrustType | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TrustTypesFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Twitter | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TwitterApp | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TwitterApps | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TwitterFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TwitterParametersTemplate | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_TwitterSettings | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_UnknownItem | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_UnminifiedFile | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_UpgradeScript | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_UpgradeScriptLibrary | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_VariantComponentField | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_VariantDateField | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_VariantDefinition_4d50cdaec2d94de8b0808f992bfb1b55 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_VariantPlaceholder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_VariantReference | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_VariantSection | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_VariantTemplate | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_VariantText | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_VariantToken | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Variants | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_VectorFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_VectorTile | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_VectorTileLink | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_VectorTilesFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_VectorTilesParametersTemplate | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Version_95ebc23204774dc38ad3465d5fe8da2f | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Video | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_VideoCountOption | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_VideoCountOptions | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_VideoFolder | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_VideoFolder_bba49474673e468186ba8b1a20e067a9 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_VideoPage | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_VideoParameters | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_VideoParametersTemplate | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_VideoPressReleasePage | PressReleaseSearchLatestQuery_search_ItemSearchResults_results_Video_4bc649610a894242be2dc5026090cf49 | PressReleaseSearchLatestQuery_search_ItemSearchResults_results__AssetsOptimization | PressReleaseSearchLatestQuery_search_ItemSearchResults_results__BackgroundImage | PressReleaseSearchLatestQuery_search_ItemSearchResults_results__CompatibleThemes | PressReleaseSearchLatestQuery_search_ItemSearchResults_results__CompositeTheme | PressReleaseSearchLatestQuery_search_ItemSearchResults_results__CustomMetadata | PressReleaseSearchLatestQuery_search_ItemSearchResults_results__CustomRenderingViewPath | PressReleaseSearchLatestQuery_search_ItemSearchResults_results__DatasourceBehaviour | PressReleaseSearchLatestQuery_search_ItemSearchResults_results__Favicon | PressReleaseSearchLatestQuery_search_ItemSearchResults_results__FormsFolderLocation | PressReleaseSearchLatestQuery_search_ItemSearchResults_results__FundSettings | PressReleaseSearchLatestQuery_search_ItemSearchResults_results__HasValidUrlName | PressReleaseSearchLatestQuery_search_ItemSearchResults_results__LocalDataLink | PressReleaseSearchLatestQuery_search_ItemSearchResults_results__Login | PressReleaseSearchLatestQuery_search_ItemSearchResults_results__OpenGraphMetadata | PressReleaseSearchLatestQuery_search_ItemSearchResults_results__PageDesignTheme | PressReleaseSearchLatestQuery_search_ItemSearchResults_results__PageSearchScope | PressReleaseSearchLatestQuery_search_ItemSearchResults_results__SearchCriteria | PressReleaseSearchLatestQuery_search_ItemSearchResults_results__SearchableWithoutRelatedItems | PressReleaseSearchLatestQuery_search_ItemSearchResults_results__SeoMetadata | PressReleaseSearchLatestQuery_search_ItemSearchResults_results__SiteTheme | PressReleaseSearchLatestQuery_search_ItemSearchResults_results__SitemapSettings | PressReleaseSearchLatestQuery_search_ItemSearchResults_results__StickyNote | PressReleaseSearchLatestQuery_search_ItemSearchResults_results__Styleable | PressReleaseSearchLatestQuery_search_ItemSearchResults_results__TwitterMetadata | PressReleaseSearchLatestQuery_search_ItemSearchResults_results__Webinar | PressReleaseSearchLatestQuery_search_ItemSearchResults_results__WildcardSource;

export type PressReleaseSearchLatestQuery_search_ItemSearchResults = (
  { __typename?: 'ItemSearchResults' }
  & Pick<Types.ItemSearchResults, 'total'>
  & { pageInfo: PressReleaseSearchLatestQuery_search_ItemSearchResults_pageInfo_PageInfo, results: Array<Types.Maybe<PressReleaseSearchLatestQuery_search_ItemSearchResults_results>> }
);

export type PressReleaseSearchLatestQuery_Query = (
  { __typename?: 'Query' }
  & { search: Types.Maybe<PressReleaseSearchLatestQuery_search_ItemSearchResults> }
);


export type PressReleaseSearchLatestQueryVariables = Types.Exact<{
  pageSize: Types.Scalars['Int']['input'];
  language: Types.Scalars['String']['input'];
  siteId: Types.Scalars['String']['input'];
}>;


export type PressReleaseSearchLatestQuery = PressReleaseSearchLatestQuery_Query;

export type PressReleaseBase_Accordion_Fragment = (
  { __typename?: 'Accordion' }
  & Pick<Types.Accordion, 'id' | 'name'>
);

export type PressReleaseBase_AccordionFolder_Fragment = (
  { __typename?: 'AccordionFolder' }
  & Pick<Types.AccordionFolder, 'id' | 'name'>
);

export type PressReleaseBase_AccordionFolder_03f88fb497884025b46f2cb249f4fcd6_Fragment = (
  { __typename?: 'AccordionFolder_03f88fb497884025b46f2cb249f4fcd6' }
  & Pick<Types.AccordionFolder_03f88fb497884025b46f2cb249f4fcd6, 'id' | 'name'>
);

export type PressReleaseBase_AccordionItem_Fragment = (
  { __typename?: 'AccordionItem' }
  & Pick<Types.AccordionItem, 'id' | 'name'>
);

export type PressReleaseBase_AccordionItem_8cf671721b2d489e809f4c23db5ab2da_Fragment = (
  { __typename?: 'AccordionItem_8cf671721b2d489e809f4c23db5ab2da' }
  & Pick<Types.AccordionItem_8cf671721b2d489e809f4c23db5ab2da, 'id' | 'name'>
);

export type PressReleaseBase_AccordionParametersTemplate_Fragment = (
  { __typename?: 'AccordionParametersTemplate' }
  & Pick<Types.AccordionParametersTemplate, 'id' | 'name'>
);

export type PressReleaseBase_AccordionPresentation_Fragment = (
  { __typename?: 'AccordionPresentation' }
  & Pick<Types.AccordionPresentation, 'id' | 'name'>
);

export type PressReleaseBase_AccordionPresentationFolder_Fragment = (
  { __typename?: 'AccordionPresentationFolder' }
  & Pick<Types.AccordionPresentationFolder, 'id' | 'name'>
);

export type PressReleaseBase_Accordion_02d060598cc14423a9ac9ff2365176b7_Fragment = (
  { __typename?: 'Accordion_02d060598cc14423a9ac9ff2365176b7' }
  & Pick<Types.Accordion_02d060598cc14423a9ac9ff2365176b7, 'id' | 'name'>
);

export type PressReleaseBase_Accordion_705cc8b3bde54cb3bf1ce455a2a36ef1_Fragment = (
  { __typename?: 'Accordion_705cc8b3bde54cb3bf1ce455a2a36ef1' }
  & Pick<Types.Accordion_705cc8b3bde54cb3bf1ce455a2a36ef1, 'id' | 'name'>
);

export type PressReleaseBase_AddItem_Fragment = (
  { __typename?: 'AddItem' }
  & Pick<Types.AddItem, 'id' | 'name'>
);

export type PressReleaseBase_AddItem_1e1b739ec3784909941d171aca7362e5_Fragment = (
  { __typename?: 'AddItem_1e1b739ec3784909941d171aca7362e5' }
  & Pick<Types.AddItem_1e1b739ec3784909941d171aca7362e5, 'id' | 'name'>
);

export type PressReleaseBase_AddItem_3aea335cd06d45b1841acbc8d2d1ce40_Fragment = (
  { __typename?: 'AddItem_3aea335cd06d45b1841acbc8d2d1ce40' }
  & Pick<Types.AddItem_3aea335cd06d45b1841acbc8d2d1ce40, 'id' | 'name'>
);

export type PressReleaseBase_AddItem_De8c75222f3241288f20342f479894eb_Fragment = (
  { __typename?: 'AddItem_de8c75222f3241288f20342f479894eb' }
  & Pick<Types.AddItem_De8c75222f3241288f20342f479894eb, 'id' | 'name'>
);

export type PressReleaseBase_AddItem_Ea8a3f269ccd443a95f571b868a94bd0_Fragment = (
  { __typename?: 'AddItem_ea8a3f269ccd443a95f571b868a94bd0' }
  & Pick<Types.AddItem_Ea8a3f269ccd443a95f571b868a94bd0, 'id' | 'name'>
);

export type PressReleaseBase_AddThisParameters_Fragment = (
  { __typename?: 'AddThisParameters' }
  & Pick<Types.AddThisParameters, 'id' | 'name'>
);

export type PressReleaseBase_AggregatedFacetFilter_Fragment = (
  { __typename?: 'AggregatedFacetFilter' }
  & Pick<Types.AggregatedFacetFilter, 'id' | 'name'>
);

export type PressReleaseBase_AlertMessage_Fragment = (
  { __typename?: 'AlertMessage' }
  & Pick<Types.AlertMessage, 'id' | 'name'>
);

export type PressReleaseBase_AlertMessageFolder_Fragment = (
  { __typename?: 'AlertMessageFolder' }
  & Pick<Types.AlertMessageFolder, 'id' | 'name'>
);

export type PressReleaseBase_AlertMessageParametersTemplate_Fragment = (
  { __typename?: 'AlertMessageParametersTemplate' }
  & Pick<Types.AlertMessageParametersTemplate, 'id' | 'name'>
);

export type PressReleaseBase_AlertMessageType_Fragment = (
  { __typename?: 'AlertMessageType' }
  & Pick<Types.AlertMessageType, 'id' | 'name'>
);

export type PressReleaseBase_AllertMessageTypeFolder_Fragment = (
  { __typename?: 'AllertMessageTypeFolder' }
  & Pick<Types.AllertMessageTypeFolder, 'id' | 'name'>
);

export type PressReleaseBase_Archive_Fragment = (
  { __typename?: 'Archive' }
  & Pick<Types.Archive, 'id' | 'name'>
);

export type PressReleaseBase_ArticleAuthor_Fragment = (
  { __typename?: 'ArticleAuthor' }
  & Pick<Types.ArticleAuthor, 'id' | 'name'>
);

export type PressReleaseBase_ArticleAuthorsFolder_Fragment = (
  { __typename?: 'ArticleAuthorsFolder' }
  & Pick<Types.ArticleAuthorsFolder, 'id' | 'name'>
);

export type PressReleaseBase_ArticleCategoriesFolder_Fragment = (
  { __typename?: 'ArticleCategoriesFolder' }
  & Pick<Types.ArticleCategoriesFolder, 'id' | 'name'>
);

export type PressReleaseBase_ArticleCategory_Fragment = (
  { __typename?: 'ArticleCategory' }
  & Pick<Types.ArticleCategory, 'id' | 'name'>
);

export type PressReleaseBase_ArticleChapter_Fragment = (
  { __typename?: 'ArticleChapter' }
  & Pick<Types.ArticleChapter, 'id' | 'name'>
);

export type PressReleaseBase_ArticleChapters_Fragment = (
  { __typename?: 'ArticleChapters' }
  & Pick<Types.ArticleChapters, 'id' | 'name'>
);

export type PressReleaseBase_ArticleContentType_Fragment = (
  { __typename?: 'ArticleContentType' }
  & Pick<Types.ArticleContentType, 'id' | 'name'>
);

export type PressReleaseBase_ArticleContentTypesFolder_Fragment = (
  { __typename?: 'ArticleContentTypesFolder' }
  & Pick<Types.ArticleContentTypesFolder, 'id' | 'name'>
);

export type PressReleaseBase_ArticleFilter_Fragment = (
  { __typename?: 'ArticleFilter' }
  & Pick<Types.ArticleFilter, 'id' | 'name'>
);

export type PressReleaseBase_ArticleFilterOption_Fragment = (
  { __typename?: 'ArticleFilterOption' }
  & Pick<Types.ArticleFilterOption, 'id' | 'name'>
);

export type PressReleaseBase_ArticleFootnote_Fragment = (
  { __typename?: 'ArticleFootnote' }
  & Pick<Types.ArticleFootnote, 'id' | 'name'>
);

export type PressReleaseBase_ArticleFootnoteLink_Fragment = (
  { __typename?: 'ArticleFootnoteLink' }
  & Pick<Types.ArticleFootnoteLink, 'id' | 'name'>
);

export type PressReleaseBase_ArticleFootnoteText_Fragment = (
  { __typename?: 'ArticleFootnoteText' }
  & Pick<Types.ArticleFootnoteText, 'id' | 'name'>
);

export type PressReleaseBase_ArticleInfogramTile_Fragment = (
  { __typename?: 'ArticleInfogramTile' }
  & Pick<Types.ArticleInfogramTile, 'id' | 'name'>
);

export type PressReleaseBase_ArticleInfogramTileParametersTemplate_Fragment = (
  { __typename?: 'ArticleInfogramTileParametersTemplate' }
  & Pick<Types.ArticleInfogramTileParametersTemplate, 'id' | 'name'>
);

export type PressReleaseBase_ArticlePage_Fragment = (
  { __typename?: 'ArticlePage' }
  & Pick<Types.ArticlePage, 'id' | 'name'>
);

export type PressReleaseBase_ArticleRegion_Fragment = (
  { __typename?: 'ArticleRegion' }
  & Pick<Types.ArticleRegion, 'id' | 'name'>
);

export type PressReleaseBase_ArticleRegionsFolder_Fragment = (
  { __typename?: 'ArticleRegionsFolder' }
  & Pick<Types.ArticleRegionsFolder, 'id' | 'name'>
);

export type PressReleaseBase_ArticleSearchPage_Fragment = (
  { __typename?: 'ArticleSearchPage' }
  & Pick<Types.ArticleSearchPage, 'id' | 'name'>
);

export type PressReleaseBase_ArticleSearchPage_4d8bd0d1a07841dc96405ca1ed71d81c_Fragment = (
  { __typename?: 'ArticleSearchPage_4d8bd0d1a07841dc96405ca1ed71d81c' }
  & Pick<Types.ArticleSearchPage_4d8bd0d1a07841dc96405ca1ed71d81c, 'id' | 'name'>
);

export type PressReleaseBase_ArticleSearchPage_22b7f7c7c37f4644a8eed9c32258b4a2_Fragment = (
  { __typename?: 'ArticleSearchPage_22b7f7c7c37f4644a8eed9c32258b4a2' }
  & Pick<Types.ArticleSearchPage_22b7f7c7c37f4644a8eed9c32258b4a2, 'id' | 'name'>
);

export type PressReleaseBase_ArticleSearchPage_Be414ff574ac4203abb2694811443e25_Fragment = (
  { __typename?: 'ArticleSearchPage_be414ff574ac4203abb2694811443e25' }
  & Pick<Types.ArticleSearchPage_Be414ff574ac4203abb2694811443e25, 'id' | 'name'>
);

export type PressReleaseBase_ArticleSearchPage_C7ad44ac3cab45158b619465a552a82c_Fragment = (
  { __typename?: 'ArticleSearchPage_c7ad44ac3cab45158b619465a552a82c' }
  & Pick<Types.ArticleSearchPage_C7ad44ac3cab45158b619465a552a82c, 'id' | 'name'>
);

export type PressReleaseBase_ArticleSearchPage_Cf31bd740a4b4363b03d1f7a88e39907_Fragment = (
  { __typename?: 'ArticleSearchPage_cf31bd740a4b4363b03d1f7a88e39907' }
  & Pick<Types.ArticleSearchPage_Cf31bd740a4b4363b03d1f7a88e39907, 'id' | 'name'>
);

export type PressReleaseBase_ArticleSeriesCollection_Fragment = (
  { __typename?: 'ArticleSeriesCollection' }
  & Pick<Types.ArticleSeriesCollection, 'id' | 'name'>
);

export type PressReleaseBase_ArticleSeriesFolder_Fragment = (
  { __typename?: 'ArticleSeriesFolder' }
  & Pick<Types.ArticleSeriesFolder, 'id' | 'name'>
);

export type PressReleaseBase_ArticleSettings_Fragment = (
  { __typename?: 'ArticleSettings' }
  & Pick<Types.ArticleSettings, 'id' | 'name'>
);

export type PressReleaseBase_ArticleSubscriptionBanner_Fragment = (
  { __typename?: 'ArticleSubscriptionBanner' }
  & Pick<Types.ArticleSubscriptionBanner, 'id' | 'name'>
);

export type PressReleaseBase_ArticleSubscriptionBannerFolder_Fragment = (
  { __typename?: 'ArticleSubscriptionBannerFolder' }
  & Pick<Types.ArticleSubscriptionBannerFolder, 'id' | 'name'>
);

export type PressReleaseBase_ArticleTag_Fragment = (
  { __typename?: 'ArticleTag' }
  & Pick<Types.ArticleTag, 'id' | 'name'>
);

export type PressReleaseBase_ArticleTagsFolder_Fragment = (
  { __typename?: 'ArticleTagsFolder' }
  & Pick<Types.ArticleTagsFolder, 'id' | 'name'>
);

export type PressReleaseBase_ArticleTeamAuthor_Fragment = (
  { __typename?: 'ArticleTeamAuthor' }
  & Pick<Types.ArticleTeamAuthor, 'id' | 'name'>
);

export type PressReleaseBase_ArticleTileParametersTemplate_Fragment = (
  { __typename?: 'ArticleTileParametersTemplate' }
  & Pick<Types.ArticleTileParametersTemplate, 'id' | 'name'>
);

export type PressReleaseBase_ArticleTilesParametersTemplate_Fragment = (
  { __typename?: 'ArticleTilesParametersTemplate' }
  & Pick<Types.ArticleTilesParametersTemplate, 'id' | 'name'>
);

export type PressReleaseBase_ArticleWildcardPage_4bf0be7a0c5c41d5973bb82f1ec73f8f_Fragment = (
  { __typename?: 'ArticleWildcardPage_4bf0be7a0c5c41d5973bb82f1ec73f8f' }
  & Pick<Types.ArticleWildcardPage_4bf0be7a0c5c41d5973bb82f1ec73f8f, 'id' | 'name'>
);

export type PressReleaseBase_ArticleWildcardPage_8f17c5d3ea39491494916dbfe2410ad8_Fragment = (
  { __typename?: 'ArticleWildcardPage_8f17c5d3ea39491494916dbfe2410ad8' }
  & Pick<Types.ArticleWildcardPage_8f17c5d3ea39491494916dbfe2410ad8, 'id' | 'name'>
);

export type PressReleaseBase_ArticleWildcardPage_84a63b4789ee4a3f82684b750a6a23ca_Fragment = (
  { __typename?: 'ArticleWildcardPage_84a63b4789ee4a3f82684b750a6a23ca' }
  & Pick<Types.ArticleWildcardPage_84a63b4789ee4a3f82684b750a6a23ca, 'id' | 'name'>
);

export type PressReleaseBase_ArticleWildcardPage_95e7966e0da1412bafbf0e8a69392c8c_Fragment = (
  { __typename?: 'ArticleWildcardPage_95e7966e0da1412bafbf0e8a69392c8c' }
  & Pick<Types.ArticleWildcardPage_95e7966e0da1412bafbf0e8a69392c8c, 'id' | 'name'>
);

export type PressReleaseBase_ArticleWildcardPage_405b20252077400383d3b47f09f88b47_Fragment = (
  { __typename?: 'ArticleWildcardPage_405b20252077400383d3b47f09f88b47' }
  & Pick<Types.ArticleWildcardPage_405b20252077400383d3b47f09f88b47, 'id' | 'name'>
);

export type PressReleaseBase_ArticleWildcardPage_B037a577f5cb4ad3b79f07720a96985b_Fragment = (
  { __typename?: 'ArticleWildcardPage_b037a577f5cb4ad3b79f07720a96985b' }
  & Pick<Types.ArticleWildcardPage_B037a577f5cb4ad3b79f07720a96985b, 'id' | 'name'>
);

export type PressReleaseBase_ArticlesGroupFolder_Fragment = (
  { __typename?: 'ArticlesGroupFolder' }
  & Pick<Types.ArticlesGroupFolder, 'id' | 'name'>
);

export type PressReleaseBase_AttachThemeExtension_Fragment = (
  { __typename?: 'AttachThemeExtension' }
  & Pick<Types.AttachThemeExtension, 'id' | 'name'>
);

export type PressReleaseBase_AutomaticDocumentListings_Fragment = (
  { __typename?: 'AutomaticDocumentListings' }
  & Pick<Types.AutomaticDocumentListings, 'id' | 'name'>
);

export type PressReleaseBase_AutomaticDocumentListingsFolder_Fragment = (
  { __typename?: 'AutomaticDocumentListingsFolder' }
  & Pick<Types.AutomaticDocumentListingsFolder, 'id' | 'name'>
);

export type PressReleaseBase_AvailableJsonRenderings_Fragment = (
  { __typename?: 'AvailableJSONRenderings' }
  & Pick<Types.AvailableJsonRenderings, 'id' | 'name'>
);

export type PressReleaseBase_AvailableMetaRenderings_Fragment = (
  { __typename?: 'AvailableMetaRenderings' }
  & Pick<Types.AvailableMetaRenderings, 'id' | 'name'>
);

export type PressReleaseBase_AvailableRenderings_Fragment = (
  { __typename?: 'AvailableRenderings' }
  & Pick<Types.AvailableRenderings, 'id' | 'name'>
);

export type PressReleaseBase_AvailableRenderingsFolder_26ec1d1811b24dd98326f6115f4fd7eb_Fragment = (
  { __typename?: 'AvailableRenderingsFolder_26ec1d1811b24dd98326f6115f4fd7eb' }
  & Pick<Types.AvailableRenderingsFolder_26ec1d1811b24dd98326f6115f4fd7eb, 'id' | 'name'>
);

export type PressReleaseBase_AwardsBanner_Fragment = (
  { __typename?: 'AwardsBanner' }
  & Pick<Types.AwardsBanner, 'id' | 'name'>
);

export type PressReleaseBase_AwardsBannerFolder_Fragment = (
  { __typename?: 'AwardsBannerFolder' }
  & Pick<Types.AwardsBannerFolder, 'id' | 'name'>
);

export type PressReleaseBase_AwardsBannerImage_Fragment = (
  { __typename?: 'AwardsBannerImage' }
  & Pick<Types.AwardsBannerImage, 'id' | 'name'>
);

export type PressReleaseBase_AwardsBannerParametersTemplate_Fragment = (
  { __typename?: 'AwardsBannerParametersTemplate' }
  & Pick<Types.AwardsBannerParametersTemplate, 'id' | 'name'>
);

export type PressReleaseBase_ByocWrapperRenderingParameters_Fragment = (
  { __typename?: 'BYOCWrapperRenderingParameters' }
  & Pick<Types.ByocWrapperRenderingParameters, 'id' | 'name'>
);

export type PressReleaseBase_BackgroundColorOption_Fragment = (
  { __typename?: 'BackgroundColorOption' }
  & Pick<Types.BackgroundColorOption, 'id' | 'name'>
);

export type PressReleaseBase_BackgroundColorOptionFolder_Fragment = (
  { __typename?: 'BackgroundColorOptionFolder' }
  & Pick<Types.BackgroundColorOptionFolder, 'id' | 'name'>
);

export type PressReleaseBase_BannerFolder_Fragment = (
  { __typename?: 'BannerFolder' }
  & Pick<Types.BannerFolder, 'id' | 'name'>
);

export type PressReleaseBase_BannerType_Fragment = (
  { __typename?: 'BannerType' }
  & Pick<Types.BannerType, 'id' | 'name'>
);

export type PressReleaseBase_BannerTypeFolder_Fragment = (
  { __typename?: 'BannerTypeFolder' }
  & Pick<Types.BannerTypeFolder, 'id' | 'name'>
);

export type PressReleaseBase_BaseHeading_Fragment = (
  { __typename?: 'BaseHeading' }
  & Pick<Types.BaseHeading, 'id' | 'name'>
);

export type PressReleaseBase_BaseHeadingFolder_Fragment = (
  { __typename?: 'BaseHeadingFolder' }
  & Pick<Types.BaseHeadingFolder, 'id' | 'name'>
);

export type PressReleaseBase_BoolFacet_Fragment = (
  { __typename?: 'BoolFacet' }
  & Pick<Types.BoolFacet, 'id' | 'name'>
);

export type PressReleaseBase_BranchesFolder_Fragment = (
  { __typename?: 'BranchesFolder' }
  & Pick<Types.BranchesFolder, 'id' | 'name'>
);

export type PressReleaseBase_Breadcrumb_Fragment = (
  { __typename?: 'Breadcrumb' }
  & Pick<Types.Breadcrumb, 'id' | 'name'>
);

export type PressReleaseBase_BrowserTitleDefinition_Fragment = (
  { __typename?: 'BrowserTitleDefinition' }
  & Pick<Types.BrowserTitleDefinition, 'id' | 'name'>
);

export type PressReleaseBase_CorsEntry_Fragment = (
  { __typename?: 'CORSEntry' }
  & Pick<Types.CorsEntry, 'id' | 'name'>
);

export type PressReleaseBase_CorsGrouping_Fragment = (
  { __typename?: 'CORSGrouping' }
  & Pick<Types.CorsGrouping, 'id' | 'name'>
);

export type PressReleaseBase_CtaPresentationType_Fragment = (
  { __typename?: 'CTAPresentationType' }
  & Pick<Types.CtaPresentationType, 'id' | 'name'>
);

export type PressReleaseBase_CtaPresentationTypeFolder_Fragment = (
  { __typename?: 'CTAPresentationTypeFolder' }
  & Pick<Types.CtaPresentationTypeFolder, 'id' | 'name'>
);

export type PressReleaseBase_C__AbrdnPage_Fragment = (
  { __typename?: 'C__AbrdnPage' }
  & Pick<Types.C__AbrdnPage, 'id' | 'name'>
);

export type PressReleaseBase_C__ActionBase_Fragment = (
  { __typename?: 'C__ActionBase' }
  & Pick<Types.C__ActionBase, 'id' | 'name'>
);

export type PressReleaseBase_C__AdvancedParameter_Fragment = (
  { __typename?: 'C__AdvancedParameter' }
  & Pick<Types.C__AdvancedParameter, 'id' | 'name'>
);

export type PressReleaseBase_C__App_Fragment = (
  { __typename?: 'C__App' }
  & Pick<Types.C__App, 'id' | 'name'>
);

export type PressReleaseBase_C__ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180c_Fragment = (
  { __typename?: 'C__ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180c' }
  & Pick<Types.C__ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180c, 'id' | 'name'>
);

export type PressReleaseBase_C__ArticleWildcardPage_Fragment = (
  { __typename?: 'C__ArticleWildcardPage' }
  & Pick<Types.C__ArticleWildcardPage, 'id' | 'name'>
);

export type PressReleaseBase_C__AvailableRenderingsFolder_Fragment = (
  { __typename?: 'C__AvailableRenderingsFolder' }
  & Pick<Types.C__AvailableRenderingsFolder, 'id' | 'name'>
);

export type PressReleaseBase_C__ByocRenderingParameters_Fragment = (
  { __typename?: 'C__BYOCRenderingParameters' }
  & Pick<Types.C__ByocRenderingParameters, 'id' | 'name'>
);

export type PressReleaseBase_C__BackgroundParametersTemplate_Fragment = (
  { __typename?: 'C__BackgroundParametersTemplate' }
  & Pick<Types.C__BackgroundParametersTemplate, 'id' | 'name'>
);

export type PressReleaseBase_C__BaseCta_Fragment = (
  { __typename?: 'C__BaseCTA' }
  & Pick<Types.C__BaseCta, 'id' | 'name'>
);

export type PressReleaseBase_C__BasePage_Fragment = (
  { __typename?: 'C__BasePage' }
  & Pick<Types.C__BasePage, 'id' | 'name'>
);

export type PressReleaseBase_C__BasePage_037da552a5524fe4aeee331f57ac1378_Fragment = (
  { __typename?: 'C__BasePage_037da552a5524fe4aeee331f57ac1378' }
  & Pick<Types.C__BasePage_037da552a5524fe4aeee331f57ac1378, 'id' | 'name'>
);

export type PressReleaseBase_C__BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f_Fragment = (
  { __typename?: 'C__BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f' }
  & Pick<Types.C__BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f, 'id' | 'name'>
);

export type PressReleaseBase_C__BasePage_315fd21bebf04c9d9f00bae191442f1d_Fragment = (
  { __typename?: 'C__BasePage_315fd21bebf04c9d9f00bae191442f1d' }
  & Pick<Types.C__BasePage_315fd21bebf04c9d9f00bae191442f1d, 'id' | 'name'>
);

export type PressReleaseBase_C__BasePage_458c6cc442da4327b4d4d7d4ecd48cbd_Fragment = (
  { __typename?: 'C__BasePage_458c6cc442da4327b4d4d7d4ecd48cbd' }
  & Pick<Types.C__BasePage_458c6cc442da4327b4d4d7d4ecd48cbd, 'id' | 'name'>
);

export type PressReleaseBase_C__BasePage_728c97b5c56146d9807e21018a972bb5_Fragment = (
  { __typename?: 'C__BasePage_728c97b5c56146d9807e21018a972bb5' }
  & Pick<Types.C__BasePage_728c97b5c56146d9807e21018a972bb5, 'id' | 'name'>
);

export type PressReleaseBase_C__BasePage_6105875085f346729dfc8d133b481f26_Fragment = (
  { __typename?: 'C__BasePage_6105875085f346729dfc8d133b481f26' }
  & Pick<Types.C__BasePage_6105875085f346729dfc8d133b481f26, 'id' | 'name'>
);

export type PressReleaseBase_C__BasePage_B08130ebd3314a3b9c0f2b5e9b66387b_Fragment = (
  { __typename?: 'C__BasePage_b08130ebd3314a3b9c0f2b5e9b66387b' }
  & Pick<Types.C__BasePage_B08130ebd3314a3b9c0f2b5e9b66387b, 'id' | 'name'>
);

export type PressReleaseBase_C__BaseRenderingParameters_Fragment = (
  { __typename?: 'C__BaseRenderingParameters' }
  & Pick<Types.C__BaseRenderingParameters, 'id' | 'name'>
);

export type PressReleaseBase_C__BaseTheme_Fragment = (
  { __typename?: 'C__BaseTheme' }
  & Pick<Types.C__BaseTheme, 'id' | 'name'>
);

export type PressReleaseBase_C__BaseVariantField_Fragment = (
  { __typename?: 'C__BaseVariantField' }
  & Pick<Types.C__BaseVariantField, 'id' | 'name'>
);

export type PressReleaseBase_C__Class_Fragment = (
  { __typename?: 'C__Class' }
  & Pick<Types.C__Class, 'id' | 'name'>
);

export type PressReleaseBase_C__CompositeGroup_Fragment = (
  { __typename?: 'C__CompositeGroup' }
  & Pick<Types.C__CompositeGroup, 'id' | 'name'>
);

export type PressReleaseBase_C__CompositeSection_Fragment = (
  { __typename?: 'C__CompositeSection' }
  & Pick<Types.C__CompositeSection, 'id' | 'name'>
);

export type PressReleaseBase_C__EloquaForm_Fragment = (
  { __typename?: 'C__EloquaForm' }
  & Pick<Types.C__EloquaForm, 'id' | 'name'>
);

export type PressReleaseBase_C__ErrorPage_D40dd5cadbf1461191b8f9e1071e557d_Fragment = (
  { __typename?: 'C__ErrorPage_d40dd5cadbf1461191b8f9e1071e557d' }
  & Pick<Types.C__ErrorPage_D40dd5cadbf1461191b8f9e1071e557d, 'id' | 'name'>
);

export type PressReleaseBase_C__ExtendedOptions_Fragment = (
  { __typename?: 'C__ExtendedOptions' }
  & Pick<Types.C__ExtendedOptions, 'id' | 'name'>
);

export type PressReleaseBase_C__ExtendedOptions_2964fb4257a6440fb192218443904c90_Fragment = (
  { __typename?: 'C__ExtendedOptions_2964fb4257a6440fb192218443904c90' }
  & Pick<Types.C__ExtendedOptions_2964fb4257a6440fb192218443904c90, 'id' | 'name'>
);

export type PressReleaseBase_C__ExtendedOptions_F1850030f97848b4bdb5884b7e863160_Fragment = (
  { __typename?: 'C__ExtendedOptions_f1850030f97848b4bdb5884b7e863160' }
  & Pick<Types.C__ExtendedOptions_F1850030f97848b4bdb5884b7e863160, 'id' | 'name'>
);

export type PressReleaseBase_C__FEaaSRenderingParameters_Fragment = (
  { __typename?: 'C__FEaaSRenderingParameters' }
  & Pick<Types.C__FEaaSRenderingParameters, 'id' | 'name'>
);

export type PressReleaseBase_C__FacetSelectorConfigBase_Fragment = (
  { __typename?: 'C__FacetSelectorConfigBase' }
  & Pick<Types.C__FacetSelectorConfigBase, 'id' | 'name'>
);

export type PressReleaseBase_C__FilteredArticlesParentPage_8196d9b5309f49f882f7918089b77845_Fragment = (
  { __typename?: 'C__FilteredArticlesParentPage_8196d9b5309f49f882f7918089b77845' }
  & Pick<Types.C__FilteredArticlesParentPage_8196d9b5309f49f882f7918089b77845, 'id' | 'name'>
);

export type PressReleaseBase_C__FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2b_Fragment = (
  { __typename?: 'C__FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2b' }
  & Pick<Types.C__FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2b, 'id' | 'name'>
);

export type PressReleaseBase_C__FundDetailsWildcardPage_Fb127f7aeeba46458c5fbe9f7c589303_Fragment = (
  { __typename?: 'C__FundDetailsWildcardPage_fb127f7aeeba46458c5fbe9f7c589303' }
  & Pick<Types.C__FundDetailsWildcardPage_Fb127f7aeeba46458c5fbe9f7c589303, 'id' | 'name'>
);

export type PressReleaseBase_C__FundSearchPage_D83da2a5ce9042b6bd557aa8820c62c5_Fragment = (
  { __typename?: 'C__FundSearchPage_d83da2a5ce9042b6bd557aa8820c62c5' }
  & Pick<Types.C__FundSearchPage_D83da2a5ce9042b6bd557aa8820c62c5, 'id' | 'name'>
);

export type PressReleaseBase_C__FundShareclassDetailsWildcardPage_E3590ad764a84980a419c4f1f926f9fc_Fragment = (
  { __typename?: 'C__FundShareclassDetailsWildcardPage_e3590ad764a84980a419c4f1f926f9fc' }
  & Pick<Types.C__FundShareclassDetailsWildcardPage_E3590ad764a84980a419c4f1f926f9fc, 'id' | 'name'>
);

export type PressReleaseBase_C__GlobalDatasourceBehavior_Fragment = (
  { __typename?: 'C__GlobalDatasourceBehavior' }
  & Pick<Types.C__GlobalDatasourceBehavior, 'id' | 'name'>
);

export type PressReleaseBase_C__GridDefinition_Fragment = (
  { __typename?: 'C__GridDefinition' }
  & Pick<Types.C__GridDefinition, 'id' | 'name'>
);

export type PressReleaseBase_C__GridItemBase_Fragment = (
  { __typename?: 'C__GridItemBase' }
  & Pick<Types.C__GridItemBase, 'id' | 'name'>
);

export type PressReleaseBase_C__GridParameters_Fragment = (
  { __typename?: 'C__GridParameters' }
  & Pick<Types.C__GridParameters, 'id' | 'name'>
);

export type PressReleaseBase_C__HeadlessSite_Fragment = (
  { __typename?: 'C__HeadlessSite' }
  & Pick<Types.C__HeadlessSite, 'id' | 'name'>
);

export type PressReleaseBase_C__HeadlessTenant_Fragment = (
  { __typename?: 'C__HeadlessTenant' }
  & Pick<Types.C__HeadlessTenant, 'id' | 'name'>
);

export type PressReleaseBase_C__HelpArticleSearchPage_D1c4d91365c8401389dcde7b5fb2f28b_Fragment = (
  { __typename?: 'C__HelpArticleSearchPage_d1c4d91365c8401389dcde7b5fb2f28b' }
  & Pick<Types.C__HelpArticleSearchPage_D1c4d91365c8401389dcde7b5fb2f28b, 'id' | 'name'>
);

export type PressReleaseBase_C__HelpArticleWildcardPage_C0a939305f6e47a38739f2a8f300e65d_Fragment = (
  { __typename?: 'C__HelpArticleWildcardPage_c0a939305f6e47a38739f2a8f300e65d' }
  & Pick<Types.C__HelpArticleWildcardPage_C0a939305f6e47a38739f2a8f300e65d, 'id' | 'name'>
);

export type PressReleaseBase_C__HomePage_2899b95da7f346b7a1da7ef14d7ef84d_Fragment = (
  { __typename?: 'C__HomePage_2899b95da7f346b7a1da7ef14d7ef84d' }
  & Pick<Types.C__HomePage_2899b95da7f346b7a1da7ef14d7ef84d, 'id' | 'name'>
);

export type PressReleaseBase_C__IAllowEmpty_Fragment = (
  { __typename?: 'C__IAllowEmpty' }
  & Pick<Types.C__IAllowEmpty, 'id' | 'name'>
);

export type PressReleaseBase_C__IBaseVariantDefinition_Fragment = (
  { __typename?: 'C__IBaseVariantDefinition' }
  & Pick<Types.C__IBaseVariantDefinition, 'id' | 'name'>
);

export type PressReleaseBase_C__IBoosting_Fragment = (
  { __typename?: 'C__IBoosting' }
  & Pick<Types.C__IBoosting, 'id' | 'name'>
);

export type PressReleaseBase_C__ICacheable_Fragment = (
  { __typename?: 'C__ICacheable' }
  & Pick<Types.C__ICacheable, 'id' | 'name'>
);

export type PressReleaseBase_C__ICompatibleRenderings_Fragment = (
  { __typename?: 'C__ICompatibleRenderings' }
  & Pick<Types.C__ICompatibleRenderings, 'id' | 'name'>
);

export type PressReleaseBase_C__IComponentVariant_Fragment = (
  { __typename?: 'C__IComponentVariant' }
  & Pick<Types.C__IComponentVariant, 'id' | 'name'>
);

export type PressReleaseBase_C__IControlType_Fragment = (
  { __typename?: 'C__IControlType' }
  & Pick<Types.C__IControlType, 'id' | 'name'>
);

export type PressReleaseBase_C__IDynamicPlaceholder_Fragment = (
  { __typename?: 'C__IDynamicPlaceholder' }
  & Pick<Types.C__IDynamicPlaceholder, 'id' | 'name'>
);

export type PressReleaseBase_C__IfEaaSComponentsDataSourceTemplates_Fragment = (
  { __typename?: 'C__IFEaaSComponentsDataSourceTemplates' }
  & Pick<Types.C__IfEaaSComponentsDataSourceTemplates, 'id' | 'name'>
);

export type PressReleaseBase_C__IfEaaSComponentsEditorScriptUrl_Fragment = (
  { __typename?: 'C__IFEaaSComponentsEditorScriptURL' }
  & Pick<Types.C__IfEaaSComponentsEditorScriptUrl, 'id' | 'name'>
);

export type PressReleaseBase_C__IIcon_Fragment = (
  { __typename?: 'C__IIcon' }
  & Pick<Types.C__IIcon, 'id' | 'name'>
);

export type PressReleaseBase_C__ILocation_Fragment = (
  { __typename?: 'C__ILocation' }
  & Pick<Types.C__ILocation, 'id' | 'name'>
);

export type PressReleaseBase_C__IPaginable_Fragment = (
  { __typename?: 'C__IPaginable' }
  & Pick<Types.C__IPaginable, 'id' | 'name'>
);

export type PressReleaseBase_C__IPagination_Fragment = (
  { __typename?: 'C__IPagination' }
  & Pick<Types.C__IPagination, 'id' | 'name'>
);

export type PressReleaseBase_C__IPoi_Fragment = (
  { __typename?: 'C__IPoi' }
  & Pick<Types.C__IPoi, 'id' | 'name'>
);

export type PressReleaseBase_C__IRenderingId_Fragment = (
  { __typename?: 'C__IRenderingId' }
  & Pick<Types.C__IRenderingId, 'id' | 'name'>
);

export type PressReleaseBase_C__ISplitter_Fragment = (
  { __typename?: 'C__ISplitter' }
  & Pick<Types.C__ISplitter, 'id' | 'name'>
);

export type PressReleaseBase_C__IStyling_Fragment = (
  { __typename?: 'C__IStyling' }
  & Pick<Types.C__IStyling, 'id' | 'name'>
);

export type PressReleaseBase_C__IVariantDefinition_Fragment = (
  { __typename?: 'C__IVariantDefinition' }
  & Pick<Types.C__IVariantDefinition, 'id' | 'name'>
);

export type PressReleaseBase_C__InvestmentTrustPage_Fragment = (
  { __typename?: 'C__InvestmentTrustPage' }
  & Pick<Types.C__InvestmentTrustPage, 'id' | 'name'>
);

export type PressReleaseBase_C__JsonField_Fragment = (
  { __typename?: 'C__JSONField' }
  & Pick<Types.C__JsonField, 'id' | 'name'>
);

export type PressReleaseBase_C__JsonReference_Fragment = (
  { __typename?: 'C__JSONReference' }
  & Pick<Types.C__JsonReference, 'id' | 'name'>
);

export type PressReleaseBase_C__JssData_Fragment = (
  { __typename?: 'C__JSSData' }
  & Pick<Types.C__JssData, 'id' | 'name'>
);

export type PressReleaseBase_C__JssSettings_Fragment = (
  { __typename?: 'C__JSSSettings' }
  & Pick<Types.C__JssSettings, 'id' | 'name'>
);

export type PressReleaseBase_C__JssSiteFolder_Fragment = (
  { __typename?: 'C__JSSSiteFolder' }
  & Pick<Types.C__JssSiteFolder, 'id' | 'name'>
);

export type PressReleaseBase_C__JssRootFolder_Fragment = (
  { __typename?: 'C__JssRootFolder' }
  & Pick<Types.C__JssRootFolder, 'id' | 'name'>
);

export type PressReleaseBase_C__LiteratureHubSearchPage_5378ef42e2c4488497ac7cc017b10086_Fragment = (
  { __typename?: 'C__LiteratureHubSearchPage_5378ef42e2c4488497ac7cc017b10086' }
  & Pick<Types.C__LiteratureHubSearchPage_5378ef42e2c4488497ac7cc017b10086, 'id' | 'name'>
);

export type PressReleaseBase_C__Navigation_E6d98f24d01c419e871a4617125a49ed_Fragment = (
  { __typename?: 'C__Navigation_e6d98f24d01c419e871a4617125a49ed' }
  & Pick<Types.C__Navigation_E6d98f24d01c419e871a4617125a49ed, 'id' | 'name'>
);

export type PressReleaseBase_C__Page_Fragment = (
  { __typename?: 'C__Page' }
  & Pick<Types.C__Page, 'id' | 'name'>
);

export type PressReleaseBase_C__PageData_Fragment = (
  { __typename?: 'C__PageData' }
  & Pick<Types.C__PageData, 'id' | 'name'>
);

export type PressReleaseBase_C__PageDesignFolder_Fragment = (
  { __typename?: 'C__PageDesignFolder' }
  & Pick<Types.C__PageDesignFolder, 'id' | 'name'>
);

export type PressReleaseBase_C__PageDesignFolder_023f5d48979d4381bc5e149e36abd3bd_Fragment = (
  { __typename?: 'C__PageDesignFolder_023f5d48979d4381bc5e149e36abd3bd' }
  & Pick<Types.C__PageDesignFolder_023f5d48979d4381bc5e149e36abd3bd, 'id' | 'name'>
);

export type PressReleaseBase_C__PageDesigns_Daaf41fd96db4892be99f62f16d036c4_Fragment = (
  { __typename?: 'C__PageDesigns_daaf41fd96db4892be99f62f16d036c4' }
  & Pick<Types.C__PageDesigns_Daaf41fd96db4892be99f62f16d036c4, 'id' | 'name'>
);

export type PressReleaseBase_C__PartialDesign_Fragment = (
  { __typename?: 'C__PartialDesign' }
  & Pick<Types.C__PartialDesign, 'id' | 'name'>
);

export type PressReleaseBase_C__PartialDesignFolder_Fragment = (
  { __typename?: 'C__PartialDesignFolder' }
  & Pick<Types.C__PartialDesignFolder, 'id' | 'name'>
);

export type PressReleaseBase_C__PartialDesignFolder_25f01f50553444f9b1babcbb60b2d13d_Fragment = (
  { __typename?: 'C__PartialDesignFolder_25f01f50553444f9b1babcbb60b2d13d' }
  & Pick<Types.C__PartialDesignFolder_25f01f50553444f9b1babcbb60b2d13d, 'id' | 'name'>
);

export type PressReleaseBase_C__PartialDesigns_79c9fa015f6a48b2b45905bbaa826a9d_Fragment = (
  { __typename?: 'C__PartialDesigns_79c9fa015f6a48b2b45905bbaa826a9d' }
  & Pick<Types.C__PartialDesigns_79c9fa015f6a48b2b45905bbaa826a9d, 'id' | 'name'>
);

export type PressReleaseBase_C__PlaceholderWrapper_Fragment = (
  { __typename?: 'C__PlaceholderWrapper' }
  & Pick<Types.C__PlaceholderWrapper, 'id' | 'name'>
);

export type PressReleaseBase_C__PressReleaseSearchPage_4197f4d95d5f4fb3be77e0be695df7ac_Fragment = (
  { __typename?: 'C__PressReleaseSearchPage_4197f4d95d5f4fb3be77e0be695df7ac' }
  & Pick<Types.C__PressReleaseSearchPage_4197f4d95d5f4fb3be77e0be695df7ac, 'id' | 'name'>
);

export type PressReleaseBase_C__PressReleaseWildcardPage_6a8c237f261d4a9891ef3e27afee2b9b_Fragment = (
  { __typename?: 'C__PressReleaseWildcardPage_6a8c237f261d4a9891ef3e27afee2b9b' }
  & Pick<Types.C__PressReleaseWildcardPage_6a8c237f261d4a9891ef3e27afee2b9b, 'id' | 'name'>
);

export type PressReleaseBase_C__RedirectMapGrouping_Fragment = (
  { __typename?: 'C__RedirectMapGrouping' }
  & Pick<Types.C__RedirectMapGrouping, 'id' | 'name'>
);

export type PressReleaseBase_C__ResizableIFramePage_6ff27d6556ff453393bbb3f7f568d973_Fragment = (
  { __typename?: 'C__ResizableIFramePage_6ff27d6556ff453393bbb3f7f568d973' }
  & Pick<Types.C__ResizableIFramePage_6ff27d6556ff453393bbb3f7f568d973, 'id' | 'name'>
);

export type PressReleaseBase_C__Route_Fragment = (
  { __typename?: 'C__Route' }
  & Pick<Types.C__Route, 'id' | 'name'>
);

export type PressReleaseBase_C__SimpleVideo_Fragment = (
  { __typename?: 'C__SimpleVideo' }
  & Pick<Types.C__SimpleVideo, 'id' | 'name'>
);

export type PressReleaseBase_C__SiteSettingsFolder_Fragment = (
  { __typename?: 'C__SiteSettingsFolder' }
  & Pick<Types.C__SiteSettingsFolder, 'id' | 'name'>
);

export type PressReleaseBase_C__SitemapSettings_Fragment = (
  { __typename?: 'C__SitemapSettings' }
  & Pick<Types.C__SitemapSettings, 'id' | 'name'>
);

export type PressReleaseBase_C__StandardTemplate_Fragment = (
  { __typename?: 'C__StandardTemplate' }
  & Pick<Types.C__StandardTemplate, 'id' | 'name'>
);

export type PressReleaseBase_C__TeamMembersParentPage_11fbd080aa844abca056f5caac316e4c_Fragment = (
  { __typename?: 'C__TeamMembersParentPage_11fbd080aa844abca056f5caac316e4c' }
  & Pick<Types.C__TeamMembersParentPage_11fbd080aa844abca056f5caac316e4c, 'id' | 'name'>
);

export type PressReleaseBase_C__TeamMembersWildcardPage_8b12628190064b2980f0a054ead02a65_Fragment = (
  { __typename?: 'C__TeamMembersWildcardPage_8b12628190064b2980f0a054ead02a65' }
  & Pick<Types.C__TeamMembersWildcardPage_8b12628190064b2980f0a054ead02a65, 'id' | 'name'>
);

export type PressReleaseBase_C__TrustFolder_Fragment = (
  { __typename?: 'C__TrustFolder' }
  & Pick<Types.C__TrustFolder, 'id' | 'name'>
);

export type PressReleaseBase_C__VariantDefinition_Fragment = (
  { __typename?: 'C__VariantDefinition' }
  & Pick<Types.C__VariantDefinition, 'id' | 'name'>
);

export type PressReleaseBase_C__VariantField_Fragment = (
  { __typename?: 'C__VariantField' }
  & Pick<Types.C__VariantField, 'id' | 'name'>
);

export type PressReleaseBase_C__VariantsGrouping_Fragment = (
  { __typename?: 'C__VariantsGrouping' }
  & Pick<Types.C__VariantsGrouping, 'id' | 'name'>
);

export type PressReleaseBase_C___AdvancedItem_Fragment = (
  { __typename?: 'C___AdvancedItem' }
  & Pick<Types.C___AdvancedItem, 'id' | 'name'>
);

export type PressReleaseBase_C___Arguments_Fragment = (
  { __typename?: 'C___Arguments' }
  & Pick<Types.C___Arguments, 'id' | 'name'>
);

export type PressReleaseBase_C___Arguments_33fab87cd52f44319a1f589ba7c1e287_Fragment = (
  { __typename?: 'C___Arguments_33fab87cd52f44319a1f589ba7c1e287' }
  & Pick<Types.C___Arguments_33fab87cd52f44319a1f589ba7c1e287, 'id' | 'name'>
);

export type PressReleaseBase_C___Article_Fragment = (
  { __typename?: 'C___Article' }
  & Pick<Types.C___Article, 'id' | 'name'>
);

export type PressReleaseBase_C___ArticlePageWorkflow_Fragment = (
  { __typename?: 'C___ArticlePageWorkflow' }
  & Pick<Types.C___ArticlePageWorkflow, 'id' | 'name'>
);

export type PressReleaseBase_C___ArticleSearchPage_Fragment = (
  { __typename?: 'C___ArticleSearchPage' }
  & Pick<Types.C___ArticleSearchPage, 'id' | 'name'>
);

export type PressReleaseBase_C___ArticleWildcard_Fragment = (
  { __typename?: 'C___ArticleWildcard' }
  & Pick<Types.C___ArticleWildcard, 'id' | 'name'>
);

export type PressReleaseBase_C___AssetServiceThemeMode_Fragment = (
  { __typename?: 'C___AssetServiceThemeMode' }
  & Pick<Types.C___AssetServiceThemeMode, 'id' | 'name'>
);

export type PressReleaseBase_C___BaseArticle_Fragment = (
  { __typename?: 'C___BaseArticle' }
  & Pick<Types.C___BaseArticle, 'id' | 'name'>
);

export type PressReleaseBase_C___BaseDataFolder_Fragment = (
  { __typename?: 'C___BaseDataFolder' }
  & Pick<Types.C___BaseDataFolder, 'id' | 'name'>
);

export type PressReleaseBase_C___BaseHelpArticle_Fragment = (
  { __typename?: 'C___BaseHelpArticle' }
  & Pick<Types.C___BaseHelpArticle, 'id' | 'name'>
);

export type PressReleaseBase_C___BaseInvestmentTrust_Fragment = (
  { __typename?: 'C___BaseInvestmentTrust' }
  & Pick<Types.C___BaseInvestmentTrust, 'id' | 'name'>
);

export type PressReleaseBase_C___BaseJssTenant_Fragment = (
  { __typename?: 'C___BaseJSSTenant' }
  & Pick<Types.C___BaseJssTenant, 'id' | 'name'>
);

export type PressReleaseBase_C___BasePage_Fragment = (
  { __typename?: 'C___BasePage' }
  & Pick<Types.C___BasePage, 'id' | 'name'>
);

export type PressReleaseBase_C___BasePageDesign_Fragment = (
  { __typename?: 'C___BasePageDesign' }
  & Pick<Types.C___BasePageDesign, 'id' | 'name'>
);

export type PressReleaseBase_C___BasePageDesignFolder_Fragment = (
  { __typename?: 'C___BasePageDesignFolder' }
  & Pick<Types.C___BasePageDesignFolder, 'id' | 'name'>
);

export type PressReleaseBase_C___BasePartialDesign_Fragment = (
  { __typename?: 'C___BasePartialDesign' }
  & Pick<Types.C___BasePartialDesign, 'id' | 'name'>
);

export type PressReleaseBase_C___BasePartialDesignFolder_Fragment = (
  { __typename?: 'C___BasePartialDesignFolder' }
  & Pick<Types.C___BasePartialDesignFolder, 'id' | 'name'>
);

export type PressReleaseBase_C___BasePlaceholder_Fragment = (
  { __typename?: 'C___BasePlaceholder' }
  & Pick<Types.C___BasePlaceholder, 'id' | 'name'>
);

export type PressReleaseBase_C___BasePlaceholderSettingsFolder_Fragment = (
  { __typename?: 'C___BasePlaceholderSettingsFolder' }
  & Pick<Types.C___BasePlaceholderSettingsFolder, 'id' | 'name'>
);

export type PressReleaseBase_C___BasePresentation_Fragment = (
  { __typename?: 'C___BasePresentation' }
  & Pick<Types.C___BasePresentation, 'id' | 'name'>
);

export type PressReleaseBase_C___BasePressRelease_Fragment = (
  { __typename?: 'C___BasePressRelease' }
  & Pick<Types.C___BasePressRelease, 'id' | 'name'>
);

export type PressReleaseBase_C___BaseRenderingParameters_Fragment = (
  { __typename?: 'C___BaseRenderingParameters' }
  & Pick<Types.C___BaseRenderingParameters, 'id' | 'name'>
);

export type PressReleaseBase_C___BaseSxaStandardValuesFolder_Fragment = (
  { __typename?: 'C___BaseSXAStandardValuesFolder' }
  & Pick<Types.C___BaseSxaStandardValuesFolder, 'id' | 'name'>
);

export type PressReleaseBase_C___BaseSettings_Fragment = (
  { __typename?: 'C___BaseSettings' }
  & Pick<Types.C___BaseSettings, 'id' | 'name'>
);

export type PressReleaseBase_C___BaseSharedSitesSettings_Fragment = (
  { __typename?: 'C___BaseSharedSitesSettings' }
  & Pick<Types.C___BaseSharedSitesSettings, 'id' | 'name'>
);

export type PressReleaseBase_C___BaseSiteDefinition_Fragment = (
  { __typename?: 'C___BaseSiteDefinition' }
  & Pick<Types.C___BaseSiteDefinition, 'id' | 'name'>
);

export type PressReleaseBase_C___BaseSiteFolder_Fragment = (
  { __typename?: 'C___BaseSiteFolder' }
  & Pick<Types.C___BaseSiteFolder, 'id' | 'name'>
);

export type PressReleaseBase_C___BaseSiteGrouping_Fragment = (
  { __typename?: 'C___BaseSiteGrouping' }
  & Pick<Types.C___BaseSiteGrouping, 'id' | 'name'>
);

export type PressReleaseBase_C___BaseSiteRoot_Fragment = (
  { __typename?: 'C___BaseSiteRoot' }
  & Pick<Types.C___BaseSiteRoot, 'id' | 'name'>
);

export type PressReleaseBase_C___BaseTenant_Fragment = (
  { __typename?: 'C___BaseTenant' }
  & Pick<Types.C___BaseTenant, 'id' | 'name'>
);

export type PressReleaseBase_C___BaseTenantFolder_Fragment = (
  { __typename?: 'C___BaseTenantFolder' }
  & Pick<Types.C___BaseTenantFolder, 'id' | 'name'>
);

export type PressReleaseBase_C___BucketRules_Fragment = (
  { __typename?: 'C___BucketRules' }
  & Pick<Types.C___BucketRules, 'id' | 'name'>
);

export type PressReleaseBase_C___Cors_Fragment = (
  { __typename?: 'C___CORS' }
  & Pick<Types.C___Cors, 'id' | 'name'>
);

export type PressReleaseBase_C___Content_Fragment = (
  { __typename?: 'C___Content' }
  & Pick<Types.C___Content, 'id' | 'name'>
);

export type PressReleaseBase_C___ContentType_Fragment = (
  { __typename?: 'C___ContentType' }
  & Pick<Types.C___ContentType, 'id' | 'name'>
);

export type PressReleaseBase_C___DataAttributes_Fragment = (
  { __typename?: 'C___DataAttributes' }
  & Pick<Types.C___DataAttributes, 'id' | 'name'>
);

export type PressReleaseBase_C___DatasourceWorkflow_Fragment = (
  { __typename?: 'C___DatasourceWorkflow' }
  & Pick<Types.C___DatasourceWorkflow, 'id' | 'name'>
);

export type PressReleaseBase_C___Dependencies_Fragment = (
  { __typename?: 'C___Dependencies' }
  & Pick<Types.C___Dependencies, 'id' | 'name'>
);

export type PressReleaseBase_C___Description_Fragment = (
  { __typename?: 'C___Description' }
  & Pick<Types.C___Description, 'id' | 'name'>
);

export type PressReleaseBase_C___DesignTemplateMapping_Fragment = (
  { __typename?: 'C___DesignTemplateMapping' }
  & Pick<Types.C___DesignTemplateMapping, 'id' | 'name'>
);

export type PressReleaseBase_C___Designable_Fragment = (
  { __typename?: 'C___Designable' }
  & Pick<Types.C___Designable, 'id' | 'name'>
);

export type PressReleaseBase_C___EditType_Fragment = (
  { __typename?: 'C___EditType' }
  & Pick<Types.C___EditType, 'id' | 'name'>
);

export type PressReleaseBase_C___EditType_8a9f84baaa124c5d9096935714809da4_Fragment = (
  { __typename?: 'C___EditType_8a9f84baaa124c5d9096935714809da4' }
  & Pick<Types.C___EditType_8a9f84baaa124c5d9096935714809da4, 'id' | 'name'>
);

export type PressReleaseBase_C___EditingTheme_Fragment = (
  { __typename?: 'C___EditingTheme' }
  & Pick<Types.C___EditingTheme, 'id' | 'name'>
);

export type PressReleaseBase_C___Enabled_Fragment = (
  { __typename?: 'C___Enabled' }
  & Pick<Types.C___Enabled, 'id' | 'name'>
);

export type PressReleaseBase_C___ErrorHandling_Fragment = (
  { __typename?: 'C___ErrorHandling' }
  & Pick<Types.C___ErrorHandling, 'id' | 'name'>
);

export type PressReleaseBase_C___ExternalArticle_Fragment = (
  { __typename?: 'C___ExternalArticle' }
  & Pick<Types.C___ExternalArticle, 'id' | 'name'>
);

export type PressReleaseBase_C___Fields_Fragment = (
  { __typename?: 'C___Fields' }
  & Pick<Types.C___Fields, 'id' | 'name'>
);

export type PressReleaseBase_C___FilteredArticlesParent_Fragment = (
  { __typename?: 'C___FilteredArticlesParent' }
  & Pick<Types.C___FilteredArticlesParent, 'id' | 'name'>
);

export type PressReleaseBase_C___FilteredArticlesWildcard_Fragment = (
  { __typename?: 'C___FilteredArticlesWildcard' }
  & Pick<Types.C___FilteredArticlesWildcard, 'id' | 'name'>
);

export type PressReleaseBase_C___Footnotes_Fragment = (
  { __typename?: 'C___Footnotes' }
  & Pick<Types.C___Footnotes, 'id' | 'name'>
);

export type PressReleaseBase_C___FundDetailsWildcard_Fragment = (
  { __typename?: 'C___FundDetailsWildcard' }
  & Pick<Types.C___FundDetailsWildcard, 'id' | 'name'>
);

export type PressReleaseBase_C___FundFormAvailability_Fragment = (
  { __typename?: 'C___FundFormAvailability' }
  & Pick<Types.C___FundFormAvailability, 'id' | 'name'>
);

export type PressReleaseBase_C___FundMetadataPage_Fragment = (
  { __typename?: 'C___FundMetadataPage' }
  & Pick<Types.C___FundMetadataPage, 'id' | 'name'>
);

export type PressReleaseBase_C___FundSearchPage_Fragment = (
  { __typename?: 'C___FundSearchPage' }
  & Pick<Types.C___FundSearchPage, 'id' | 'name'>
);

export type PressReleaseBase_C___FundsFolder_Fragment = (
  { __typename?: 'C___FundsFolder' }
  & Pick<Types.C___FundsFolder, 'id' | 'name'>
);

export type PressReleaseBase_C___FundsFormsFolder_Fragment = (
  { __typename?: 'C___FundsFormsFolder' }
  & Pick<Types.C___FundsFormsFolder, 'id' | 'name'>
);

export type PressReleaseBase_C___FundsLiteratureFolder_Fragment = (
  { __typename?: 'C___FundsLiteratureFolder' }
  & Pick<Types.C___FundsLiteratureFolder, 'id' | 'name'>
);

export type PressReleaseBase_C___FundsShareclassesDetailsWildcard_Fragment = (
  { __typename?: 'C___FundsShareclassesDetailsWildcard' }
  & Pick<Types.C___FundsShareclassesDetailsWildcard, 'id' | 'name'>
);

export type PressReleaseBase_C___GridMapping_Fragment = (
  { __typename?: 'C___GridMapping' }
  & Pick<Types.C___GridMapping, 'id' | 'name'>
);

export type PressReleaseBase_C___HelpArticle_Fragment = (
  { __typename?: 'C___HelpArticle' }
  & Pick<Types.C___HelpArticle, 'id' | 'name'>
);

export type PressReleaseBase_C___HelpArticleSearchPage_Fragment = (
  { __typename?: 'C___HelpArticleSearchPage' }
  & Pick<Types.C___HelpArticleSearchPage, 'id' | 'name'>
);

export type PressReleaseBase_C___HelpArticleWildcard_Fragment = (
  { __typename?: 'C___HelpArticleWildcard' }
  & Pick<Types.C___HelpArticleWildcard, 'id' | 'name'>
);

export type PressReleaseBase_C___HorizonDatasourceGrouping_Fragment = (
  { __typename?: 'C___HorizonDatasourceGrouping' }
  & Pick<Types.C___HorizonDatasourceGrouping, 'id' | 'name'>
);

export type PressReleaseBase_C___Icon_Fragment = (
  { __typename?: 'C___Icon' }
  & Pick<Types.C___Icon, 'id' | 'name'>
);

export type PressReleaseBase_C___IncludeByDefault_Fragment = (
  { __typename?: 'C___IncludeByDefault' }
  & Pick<Types.C___IncludeByDefault, 'id' | 'name'>
);

export type PressReleaseBase_C___IncludeIfInstalled_Fragment = (
  { __typename?: 'C___IncludeIfInstalled' }
  & Pick<Types.C___IncludeIfInstalled, 'id' | 'name'>
);

export type PressReleaseBase_C___InternalArticle_Fragment = (
  { __typename?: 'C___InternalArticle' }
  & Pick<Types.C___InternalArticle, 'id' | 'name'>
);

export type PressReleaseBase_C___InternetExplorerCompatibilityMode_Fragment = (
  { __typename?: 'C___InternetExplorerCompatibilityMode' }
  & Pick<Types.C___InternetExplorerCompatibilityMode, 'id' | 'name'>
);

export type PressReleaseBase_C___IsSystemModule_Fragment = (
  { __typename?: 'C___IsSystemModule' }
  & Pick<Types.C___IsSystemModule, 'id' | 'name'>
);

export type PressReleaseBase_C___JsonVariantPaging_Fragment = (
  { __typename?: 'C___JSONVariantPaging' }
  & Pick<Types.C___JsonVariantPaging, 'id' | 'name'>
);

export type PressReleaseBase_C___JsonVariantsBase_Fragment = (
  { __typename?: 'C___JSONVariantsBase' }
  & Pick<Types.C___JsonVariantsBase, 'id' | 'name'>
);

export type PressReleaseBase_C___LimitedDisplay_Fragment = (
  { __typename?: 'C___LimitedDisplay' }
  & Pick<Types.C___LimitedDisplay, 'id' | 'name'>
);

export type PressReleaseBase_C___LinkAttributes_Fragment = (
  { __typename?: 'C___LinkAttributes' }
  & Pick<Types.C___LinkAttributes, 'id' | 'name'>
);

export type PressReleaseBase_C___LinkSettings_Fragment = (
  { __typename?: 'C___LinkSettings' }
  & Pick<Types.C___LinkSettings, 'id' | 'name'>
);

export type PressReleaseBase_C___LiteratureHubSearchPage_Fragment = (
  { __typename?: 'C___LiteratureHubSearchPage' }
  & Pick<Types.C___LiteratureHubSearchPage, 'id' | 'name'>
);

export type PressReleaseBase_C___ManualKeyInformation_Fragment = (
  { __typename?: 'C___ManualKeyInformation' }
  & Pick<Types.C___ManualKeyInformation, 'id' | 'name'>
);

export type PressReleaseBase_C___MemberOf_Fragment = (
  { __typename?: 'C___MemberOf' }
  & Pick<Types.C___MemberOf, 'id' | 'name'>
);

export type PressReleaseBase_C___MetadataPage_Fragment = (
  { __typename?: 'C___MetadataPage' }
  & Pick<Types.C___MetadataPage, 'id' | 'name'>
);

export type PressReleaseBase_C___Modules_Fragment = (
  { __typename?: 'C___Modules' }
  & Pick<Types.C___Modules, 'id' | 'name'>
);

export type PressReleaseBase_C___Name_Fragment = (
  { __typename?: 'C___Name' }
  & Pick<Types.C___Name, 'id' | 'name'>
);

export type PressReleaseBase_C___Name_0345fd2f95094dc7b0f56c73a9b6cd8d_Fragment = (
  { __typename?: 'C___Name_0345fd2f95094dc7b0f56c73a9b6cd8d' }
  & Pick<Types.C___Name_0345fd2f95094dc7b0f56c73a9b6cd8d, 'id' | 'name'>
);

export type PressReleaseBase_C___Name_299cdb154745448a807868d401248eaa_Fragment = (
  { __typename?: 'C___Name_299cdb154745448a807868d401248eaa' }
  & Pick<Types.C___Name_299cdb154745448a807868d401248eaa, 'id' | 'name'>
);

export type PressReleaseBase_C___Name_B88cf88159a54a19991e71038751cb60_Fragment = (
  { __typename?: 'C___Name_b88cf88159a54a19991e71038751cb60' }
  & Pick<Types.C___Name_B88cf88159a54a19991e71038751cb60, 'id' | 'name'>
);

export type PressReleaseBase_C___Navigable_Fragment = (
  { __typename?: 'C___Navigable' }
  & Pick<Types.C___Navigable, 'id' | 'name'>
);

export type PressReleaseBase_C___NavigablePage_Fragment = (
  { __typename?: 'C___NavigablePage' }
  & Pick<Types.C___NavigablePage, 'id' | 'name'>
);

export type PressReleaseBase_C___PageContent_Fragment = (
  { __typename?: 'C___PageContent' }
  & Pick<Types.C___PageContent, 'id' | 'name'>
);

export type PressReleaseBase_C___PageWorkflow_Fragment = (
  { __typename?: 'C___PageWorkflow' }
  & Pick<Types.C___PageWorkflow, 'id' | 'name'>
);

export type PressReleaseBase_C___PerSiteStandardValues_Fragment = (
  { __typename?: 'C___PerSiteStandardValues' }
  & Pick<Types.C___PerSiteStandardValues, 'id' | 'name'>
);

export type PressReleaseBase_C___Podcast_Fragment = (
  { __typename?: 'C___Podcast' }
  & Pick<Types.C___Podcast, 'id' | 'name'>
);

export type PressReleaseBase_C___PodcastPressRelease_Fragment = (
  { __typename?: 'C___PodcastPressRelease' }
  & Pick<Types.C___PodcastPressRelease, 'id' | 'name'>
);

export type PressReleaseBase_C___PremiumContentPage_Fragment = (
  { __typename?: 'C___PremiumContentPage' }
  & Pick<Types.C___PremiumContentPage, 'id' | 'name'>
);

export type PressReleaseBase_C___PressRelease_Fragment = (
  { __typename?: 'C___PressRelease' }
  & Pick<Types.C___PressRelease, 'id' | 'name'>
);

export type PressReleaseBase_C___PressReleaseContentType_Fragment = (
  { __typename?: 'C___PressReleaseContentType' }
  & Pick<Types.C___PressReleaseContentType, 'id' | 'name'>
);

export type PressReleaseBase_C___PressReleaseSearchPage_Fragment = (
  { __typename?: 'C___PressReleaseSearchPage' }
  & Pick<Types.C___PressReleaseSearchPage, 'id' | 'name'>
);

export type PressReleaseBase_C___PressReleaseWildcard_Fragment = (
  { __typename?: 'C___PressReleaseWildcard' }
  & Pick<Types.C___PressReleaseWildcard, 'id' | 'name'>
);

export type PressReleaseBase_C___ProtectedTheme_Fragment = (
  { __typename?: 'C___ProtectedTheme' }
  & Pick<Types.C___ProtectedTheme, 'id' | 'name'>
);

export type PressReleaseBase_C___PublishingGroupingTemplate_Fragment = (
  { __typename?: 'C___PublishingGroupingTemplate' }
  & Pick<Types.C___PublishingGroupingTemplate, 'id' | 'name'>
);

export type PressReleaseBase_C___RenderingRelatedParameters_Fragment = (
  { __typename?: 'C___RenderingRelatedParameters' }
  & Pick<Types.C___RenderingRelatedParameters, 'id' | 'name'>
);

export type PressReleaseBase_C___RenderingVariantsBase_Fragment = (
  { __typename?: 'C___RenderingVariantsBase' }
  & Pick<Types.C___RenderingVariantsBase, 'id' | 'name'>
);

export type PressReleaseBase_C___RenderingsList_Fragment = (
  { __typename?: 'C___RenderingsList' }
  & Pick<Types.C___RenderingsList, 'id' | 'name'>
);

export type PressReleaseBase_C___RobotsContent_Fragment = (
  { __typename?: 'C___RobotsContent' }
  & Pick<Types.C___RobotsContent, 'id' | 'name'>
);

export type PressReleaseBase_C___RoleDomain_Fragment = (
  { __typename?: 'C___RoleDomain' }
  & Pick<Types.C___RoleDomain, 'id' | 'name'>
);

export type PressReleaseBase_C___RoleName_Fragment = (
  { __typename?: 'C___RoleName' }
  & Pick<Types.C___RoleName, 'id' | 'name'>
);

export type PressReleaseBase_C___RoleType_Fragment = (
  { __typename?: 'C___RoleType' }
  & Pick<Types.C___RoleType, 'id' | 'name'>
);

export type PressReleaseBase_C___SalesforceCommonValidations_Fragment = (
  { __typename?: 'C___SalesforceCommonValidations' }
  & Pick<Types.C___SalesforceCommonValidations, 'id' | 'name'>
);

export type PressReleaseBase_C___SalesforceFieldId_Fragment = (
  { __typename?: 'C___SalesforceFieldId' }
  & Pick<Types.C___SalesforceFieldId, 'id' | 'name'>
);

export type PressReleaseBase_C___SalesforceFieldTitle_Fragment = (
  { __typename?: 'C___SalesforceFieldTitle' }
  & Pick<Types.C___SalesforceFieldTitle, 'id' | 'name'>
);

export type PressReleaseBase_C___SalesforceFieldValue_Fragment = (
  { __typename?: 'C___SalesforceFieldValue' }
  & Pick<Types.C___SalesforceFieldValue, 'id' | 'name'>
);

export type PressReleaseBase_C___Script_Fragment = (
  { __typename?: 'C___Script' }
  & Pick<Types.C___Script, 'id' | 'name'>
);

export type PressReleaseBase_C___SearchSignature_Fragment = (
  { __typename?: 'C___SearchSignature' }
  & Pick<Types.C___SearchSignature, 'id' | 'name'>
);

export type PressReleaseBase_C___Searchable_Fragment = (
  { __typename?: 'C___Searchable' }
  & Pick<Types.C___Searchable, 'id' | 'name'>
);

export type PressReleaseBase_C___SecurityItemPointer_Fragment = (
  { __typename?: 'C___SecurityItemPointer' }
  & Pick<Types.C___SecurityItemPointer, 'id' | 'name'>
);

export type PressReleaseBase_C___SharedArticles_Fragment = (
  { __typename?: 'C___SharedArticles' }
  & Pick<Types.C___SharedArticles, 'id' | 'name'>
);

export type PressReleaseBase_C___SharedContent_Fragment = (
  { __typename?: 'C___SharedContent' }
  & Pick<Types.C___SharedContent, 'id' | 'name'>
);

export type PressReleaseBase_C___SharedHelpArticles_Fragment = (
  { __typename?: 'C___SharedHelpArticles' }
  & Pick<Types.C___SharedHelpArticles, 'id' | 'name'>
);

export type PressReleaseBase_C___SharedPage_Fragment = (
  { __typename?: 'C___SharedPage' }
  & Pick<Types.C___SharedPage, 'id' | 'name'>
);

export type PressReleaseBase_C___SharedPressReleases_Fragment = (
  { __typename?: 'C___SharedPressReleases' }
  & Pick<Types.C___SharedPressReleases, 'id' | 'name'>
);

export type PressReleaseBase_C___SharedRoot_Fragment = (
  { __typename?: 'C___SharedRoot' }
  & Pick<Types.C___SharedRoot, 'id' | 'name'>
);

export type PressReleaseBase_C___SharedSettings_Fragment = (
  { __typename?: 'C___SharedSettings' }
  & Pick<Types.C___SharedSettings, 'id' | 'name'>
);

export type PressReleaseBase_C___SiteContent_Fragment = (
  { __typename?: 'C___SiteContent' }
  & Pick<Types.C___SiteContent, 'id' | 'name'>
);

export type PressReleaseBase_C___SiteFolder_Fragment = (
  { __typename?: 'C___SiteFolder' }
  & Pick<Types.C___SiteFolder, 'id' | 'name'>
);

export type PressReleaseBase_C___SiteMediaLibrary_Fragment = (
  { __typename?: 'C___SiteMediaLibrary' }
  & Pick<Types.C___SiteMediaLibrary, 'id' | 'name'>
);

export type PressReleaseBase_C___SiteSettings_Fragment = (
  { __typename?: 'C___SiteSettings' }
  & Pick<Types.C___SiteSettings, 'id' | 'name'>
);

export type PressReleaseBase_C___SiteTemplate_Fragment = (
  { __typename?: 'C___SiteTemplate' }
  & Pick<Types.C___SiteTemplate, 'id' | 'name'>
);

export type PressReleaseBase_C___SitecoreClientSiteManaging_Fragment = (
  { __typename?: 'C___SitecoreClientSiteManaging' }
  & Pick<Types.C___SitecoreClientSiteManaging, 'id' | 'name'>
);

export type PressReleaseBase_C___Sitemap_Fragment = (
  { __typename?: 'C___Sitemap' }
  & Pick<Types.C___Sitemap, 'id' | 'name'>
);

export type PressReleaseBase_C___SitemapMediaItems_Fragment = (
  { __typename?: 'C___SitemapMediaItems' }
  & Pick<Types.C___SitemapMediaItems, 'id' | 'name'>
);

export type PressReleaseBase_C___SlidersRangeSettings_Fragment = (
  { __typename?: 'C___SlidersRangeSettings' }
  & Pick<Types.C___SlidersRangeSettings, 'id' | 'name'>
);

export type PressReleaseBase_C___SolutionTemplateContent_Fragment = (
  { __typename?: 'C___SolutionTemplateContent' }
  & Pick<Types.C___SolutionTemplateContent, 'id' | 'name'>
);

export type PressReleaseBase_C___SolutionTemplateDescription_Fragment = (
  { __typename?: 'C___SolutionTemplateDescription' }
  & Pick<Types.C___SolutionTemplateDescription, 'id' | 'name'>
);

export type PressReleaseBase_C___SolutionTemplateName_Fragment = (
  { __typename?: 'C___SolutionTemplateName' }
  & Pick<Types.C___SolutionTemplateName, 'id' | 'name'>
);

export type PressReleaseBase_C___SortOrder_Fragment = (
  { __typename?: 'C___SortOrder' }
  & Pick<Types.C___SortOrder, 'id' | 'name'>
);

export type PressReleaseBase_C___StackBreakpoint_Fragment = (
  { __typename?: 'C___StackBreakpoint' }
  & Pick<Types.C___StackBreakpoint, 'id' | 'name'>
);

export type PressReleaseBase_C___Statistics_Fragment = (
  { __typename?: 'C___Statistics' }
  & Pick<Types.C___Statistics, 'id' | 'name'>
);

export type PressReleaseBase_C___SupportedLanguages_Fragment = (
  { __typename?: 'C___SupportedLanguages' }
  & Pick<Types.C___SupportedLanguages, 'id' | 'name'>
);

export type PressReleaseBase_C___Taggable_Fragment = (
  { __typename?: 'C___Taggable' }
  & Pick<Types.C___Taggable, 'id' | 'name'>
);

export type PressReleaseBase_C___TeamMembersParentPage_Fragment = (
  { __typename?: 'C___TeamMembersParentPage' }
  & Pick<Types.C___TeamMembersParentPage, 'id' | 'name'>
);

export type PressReleaseBase_C___TeamMembersWildcard_Fragment = (
  { __typename?: 'C___TeamMembersWildcard' }
  & Pick<Types.C___TeamMembersWildcard, 'id' | 'name'>
);

export type PressReleaseBase_C___TechzoneArticle_Fragment = (
  { __typename?: 'C___TechzoneArticle' }
  & Pick<Types.C___TechzoneArticle, 'id' | 'name'>
);

export type PressReleaseBase_C___Template_Fragment = (
  { __typename?: 'C___Template' }
  & Pick<Types.C___Template, 'id' | 'name'>
);

export type PressReleaseBase_C___Title_Fragment = (
  { __typename?: 'C___Title' }
  & Pick<Types.C___Title, 'id' | 'name'>
);

export type PressReleaseBase_C___Type_Fragment = (
  { __typename?: 'C___Type' }
  & Pick<Types.C___Type, 'id' | 'name'>
);

export type PressReleaseBase_C___Validation_Fragment = (
  { __typename?: 'C___Validation' }
  & Pick<Types.C___Validation, 'id' | 'name'>
);

export type PressReleaseBase_C___VariantPaging_Fragment = (
  { __typename?: 'C___VariantPaging' }
  & Pick<Types.C___VariantPaging, 'id' | 'name'>
);

export type PressReleaseBase_C___VectorTile_Fragment = (
  { __typename?: 'C___VectorTile' }
  & Pick<Types.C___VectorTile, 'id' | 'name'>
);

export type PressReleaseBase_C___VectorTileLink_Fragment = (
  { __typename?: 'C___VectorTileLink' }
  & Pick<Types.C___VectorTileLink, 'id' | 'name'>
);

export type PressReleaseBase_C___Video_Fragment = (
  { __typename?: 'C___Video' }
  & Pick<Types.C___Video, 'id' | 'name'>
);

export type PressReleaseBase_C___VideoPressRelease_Fragment = (
  { __typename?: 'C___VideoPressRelease' }
  & Pick<Types.C___VideoPressRelease, 'id' | 'name'>
);

export type PressReleaseBase_C___Width_Fragment = (
  { __typename?: 'C___Width' }
  & Pick<Types.C___Width, 'id' | 'name'>
);

export type PressReleaseBase_C___WildcardPage_Fragment = (
  { __typename?: 'C___WildcardPage' }
  & Pick<Types.C___WildcardPage, 'id' | 'name'>
);

export type PressReleaseBase_CacheSetting_Fragment = (
  { __typename?: 'CacheSetting' }
  & Pick<Types.CacheSetting, 'id' | 'name'>
);

export type PressReleaseBase_Caching_26fce9bf0256458d8281a713a5bf5520_Fragment = (
  { __typename?: 'Caching_26fce9bf0256458d8281a713a5bf5520' }
  & Pick<Types.Caching_26fce9bf0256458d8281a713a5bf5520, 'id' | 'name'>
);

export type PressReleaseBase_CalendarEvent_Fragment = (
  { __typename?: 'CalendarEvent' }
  & Pick<Types.CalendarEvent, 'id' | 'name'>
);

export type PressReleaseBase_CallOutSection_Fragment = (
  { __typename?: 'CallOutSection' }
  & Pick<Types.CallOutSection, 'id' | 'name'>
);

export type PressReleaseBase_CallOutSectionDropdownOption_Fragment = (
  { __typename?: 'CallOutSectionDropdownOption' }
  & Pick<Types.CallOutSectionDropdownOption, 'id' | 'name'>
);

export type PressReleaseBase_CallOutSectionFolder_Fragment = (
  { __typename?: 'CallOutSectionFolder' }
  & Pick<Types.CallOutSectionFolder, 'id' | 'name'>
);

export type PressReleaseBase_CallOutSectionParametersTemplate_Fragment = (
  { __typename?: 'CallOutSectionParametersTemplate' }
  & Pick<Types.CallOutSectionParametersTemplate, 'id' | 'name'>
);

export type PressReleaseBase_CallToAction_Fragment = (
  { __typename?: 'CallToAction' }
  & Pick<Types.CallToAction, 'id' | 'name'>
);

export type PressReleaseBase_CallToActionFolder_Fragment = (
  { __typename?: 'CallToActionFolder' }
  & Pick<Types.CallToActionFolder, 'id' | 'name'>
);

export type PressReleaseBase_CapabilitiesFolder_Fragment = (
  { __typename?: 'CapabilitiesFolder' }
  & Pick<Types.CapabilitiesFolder, 'id' | 'name'>
);

export type PressReleaseBase_Capability_Fragment = (
  { __typename?: 'Capability' }
  & Pick<Types.Capability, 'id' | 'name'>
);

export type PressReleaseBase_CapabilityMap_Fragment = (
  { __typename?: 'CapabilityMap' }
  & Pick<Types.CapabilityMap, 'id' | 'name'>
);

export type PressReleaseBase_CapabilityMappings_Fragment = (
  { __typename?: 'CapabilityMappings' }
  & Pick<Types.CapabilityMappings, 'id' | 'name'>
);

export type PressReleaseBase_Carousel_Fragment = (
  { __typename?: 'Carousel' }
  & Pick<Types.Carousel, 'id' | 'name'>
);

export type PressReleaseBase_CarouselFolder_Fragment = (
  { __typename?: 'CarouselFolder' }
  & Pick<Types.CarouselFolder, 'id' | 'name'>
);

export type PressReleaseBase_CarouselSlide_Fragment = (
  { __typename?: 'CarouselSlide' }
  & Pick<Types.CarouselSlide, 'id' | 'name'>
);

export type PressReleaseBase_Carousel_2b65f0d87ec54834b4aa1753c0f7036b_Fragment = (
  { __typename?: 'Carousel_2b65f0d87ec54834b4aa1753c0f7036b' }
  & Pick<Types.Carousel_2b65f0d87ec54834b4aa1753c0f7036b, 'id' | 'name'>
);

export type PressReleaseBase_Checkbox_Fragment = (
  { __typename?: 'Checkbox' }
  & Pick<Types.Checkbox, 'id' | 'name'>
);

export type PressReleaseBase_ChecklistFilter_Fragment = (
  { __typename?: 'ChecklistFilter' }
  & Pick<Types.ChecklistFilter, 'id' | 'name'>
);

export type PressReleaseBase_ChecklistFilterFolder_Fragment = (
  { __typename?: 'ChecklistFilterFolder' }
  & Pick<Types.ChecklistFilterFolder, 'id' | 'name'>
);

export type PressReleaseBase_ChecklistFilter_3cb40bd669c94976a9742120a5eba1ee_Fragment = (
  { __typename?: 'ChecklistFilter_3cb40bd669c94976a9742120a5eba1ee' }
  & Pick<Types.ChecklistFilter_3cb40bd669c94976a9742120a5eba1ee, 'id' | 'name'>
);

export type PressReleaseBase_ColumnSplitter_Fragment = (
  { __typename?: 'ColumnSplitter' }
  & Pick<Types.ColumnSplitter, 'id' | 'name'>
);

export type PressReleaseBase_ColumnSplitter_3e1016e56ecb4c19aa0117c18b42deb0_Fragment = (
  { __typename?: 'ColumnSplitter_3e1016e56ecb4c19aa0117c18b42deb0' }
  & Pick<Types.ColumnSplitter_3e1016e56ecb4c19aa0117c18b42deb0, 'id' | 'name'>
);

export type PressReleaseBase_CompatibilityMode_Fragment = (
  { __typename?: 'CompatibilityMode' }
  & Pick<Types.CompatibilityMode, 'id' | 'name'>
);

export type PressReleaseBase_ComponentConfiguration_Fragment = (
  { __typename?: 'ComponentConfiguration' }
  & Pick<Types.ComponentConfiguration, 'id' | 'name'>
);

export type PressReleaseBase_ComponentThemeConfiguration_Fragment = (
  { __typename?: 'ComponentThemeConfiguration' }
  & Pick<Types.ComponentThemeConfiguration, 'id' | 'name'>
);

export type PressReleaseBase_ComponentThemesConfiguration_Fragment = (
  { __typename?: 'ComponentThemesConfiguration' }
  & Pick<Types.ComponentThemesConfiguration, 'id' | 'name'>
);

export type PressReleaseBase_ComponentsConfigurations_Fragment = (
  { __typename?: 'ComponentsConfigurations' }
  & Pick<Types.ComponentsConfigurations, 'id' | 'name'>
);

export type PressReleaseBase_ConfigurationFolder_Fragment = (
  { __typename?: 'ConfigurationFolder' }
  & Pick<Types.ConfigurationFolder, 'id' | 'name'>
);

export type PressReleaseBase_Container_Fragment = (
  { __typename?: 'Container' }
  & Pick<Types.Container, 'id' | 'name'>
);

export type PressReleaseBase_ContainerOption_Fragment = (
  { __typename?: 'ContainerOption' }
  & Pick<Types.ContainerOption, 'id' | 'name'>
);

export type PressReleaseBase_ContainerOptionsFolder_Fragment = (
  { __typename?: 'ContainerOptionsFolder' }
  & Pick<Types.ContainerOptionsFolder, 'id' | 'name'>
);

export type PressReleaseBase_ContainerParametersTemplate_Fragment = (
  { __typename?: 'ContainerParametersTemplate' }
  & Pick<Types.ContainerParametersTemplate, 'id' | 'name'>
);

export type PressReleaseBase_Container_45130bdbbae34edcaea87b68b9d94c7f_Fragment = (
  { __typename?: 'Container_45130bdbbae34edcaea87b68b9d94c7f' }
  & Pick<Types.Container_45130bdbbae34edcaea87b68b9d94c7f, 'id' | 'name'>
);

export type PressReleaseBase_ContentBlock_Fragment = (
  { __typename?: 'ContentBlock' }
  & Pick<Types.ContentBlock, 'id' | 'name'>
);

export type PressReleaseBase_ContentBlockFolder_Fragment = (
  { __typename?: 'ContentBlockFolder' }
  & Pick<Types.ContentBlockFolder, 'id' | 'name'>
);

export type PressReleaseBase_ContentToken_Fragment = (
  { __typename?: 'ContentToken' }
  & Pick<Types.ContentToken, 'id' | 'name'>
);

export type PressReleaseBase_ContentTokenFolder_Fragment = (
  { __typename?: 'ContentTokenFolder' }
  & Pick<Types.ContentTokenFolder, 'id' | 'name'>
);

export type PressReleaseBase_ContentType_Fragment = (
  { __typename?: 'ContentType' }
  & Pick<Types.ContentType, 'id' | 'name'>
);

export type PressReleaseBase_CorporateTheme_Fragment = (
  { __typename?: 'CorporateTheme' }
  & Pick<Types.CorporateTheme, 'id' | 'name'>
);

export type PressReleaseBase_CorporateThemesFolder_Fragment = (
  { __typename?: 'CorporateThemesFolder' }
  & Pick<Types.CorporateThemesFolder, 'id' | 'name'>
);

export type PressReleaseBase_Country_Fragment = (
  { __typename?: 'Country' }
  & Pick<Types.Country, 'id' | 'name'>
);

export type PressReleaseBase_CountryIsoCode_Fragment = (
  { __typename?: 'CountryISOCode' }
  & Pick<Types.CountryIsoCode, 'id' | 'name'>
);

export type PressReleaseBase_CountryIsoCodesFolder_Fragment = (
  { __typename?: 'CountryISOCodesFolder' }
  & Pick<Types.CountryIsoCodesFolder, 'id' | 'name'>
);

export type PressReleaseBase_CustomerReviewFolder_Fragment = (
  { __typename?: 'CustomerReviewFolder' }
  & Pick<Types.CustomerReviewFolder, 'id' | 'name'>
);

export type PressReleaseBase_CustomerReviewTile_Fragment = (
  { __typename?: 'CustomerReviewTile' }
  & Pick<Types.CustomerReviewTile, 'id' | 'name'>
);

export type PressReleaseBase_CustomerReviewTileParametersTemplate_Fragment = (
  { __typename?: 'CustomerReviewTileParametersTemplate' }
  & Pick<Types.CustomerReviewTileParametersTemplate, 'id' | 'name'>
);

export type PressReleaseBase_DataBridgeDocumentCategoryMap_Fragment = (
  { __typename?: 'DataBridgeDocumentCategoryMap' }
  & Pick<Types.DataBridgeDocumentCategoryMap, 'id' | 'name'>
);

export type PressReleaseBase_DataBridgeFund_Fragment = (
  { __typename?: 'DataBridgeFund' }
  & Pick<Types.DataBridgeFund, 'id' | 'name'>
);

export type PressReleaseBase_DataBridgeFundRangeName_Fragment = (
  { __typename?: 'DataBridgeFundRangeName' }
  & Pick<Types.DataBridgeFundRangeName, 'id' | 'name'>
);

export type PressReleaseBase_DataBridgeSettingsFolder_Fragment = (
  { __typename?: 'DataBridgeSettingsFolder' }
  & Pick<Types.DataBridgeSettingsFolder, 'id' | 'name'>
);

export type PressReleaseBase_DataBridgeShareClass_Fragment = (
  { __typename?: 'DataBridgeShareClass' }
  & Pick<Types.DataBridgeShareClass, 'id' | 'name'>
);

export type PressReleaseBase_DataFolder_Fragment = (
  { __typename?: 'DataFolder' }
  & Pick<Types.DataFolder, 'id' | 'name'>
);

export type PressReleaseBase_DatasourceConfiguration_Fragment = (
  { __typename?: 'DatasourceConfiguration' }
  & Pick<Types.DatasourceConfiguration, 'id' | 'name'>
);

export type PressReleaseBase_DatasourceConfigurations_Fragment = (
  { __typename?: 'DatasourceConfigurations' }
  & Pick<Types.DatasourceConfigurations, 'id' | 'name'>
);

export type PressReleaseBase_DatasourceWorkflowAction_Fragment = (
  { __typename?: 'DatasourceWorkflowAction' }
  & Pick<Types.DatasourceWorkflowAction, 'id' | 'name'>
);

export type PressReleaseBase_DateFacet_Fragment = (
  { __typename?: 'DateFacet' }
  & Pick<Types.DateFacet, 'id' | 'name'>
);

export type PressReleaseBase_DateFilter_Fragment = (
  { __typename?: 'DateFilter' }
  & Pick<Types.DateFilter, 'id' | 'name'>
);

export type PressReleaseBase_DateFilterFolder_Fragment = (
  { __typename?: 'DateFilterFolder' }
  & Pick<Types.DateFilterFolder, 'id' | 'name'>
);

export type PressReleaseBase_DateFilter_Ad89c1f1e99148ef865938ab13aa28f1_Fragment = (
  { __typename?: 'DateFilter_ad89c1f1e99148ef865938ab13aa28f1' }
  & Pick<Types.DateFilter_Ad89c1f1e99148ef865938ab13aa28f1, 'id' | 'name'>
);

export type PressReleaseBase_DefaultColumnLayout_Fragment = (
  { __typename?: 'DefaultColumnLayout' }
  & Pick<Types.DefaultColumnLayout, 'id' | 'name'>
);

export type PressReleaseBase_DefaultShareclassMapping_Fragment = (
  { __typename?: 'DefaultShareclassMapping' }
  & Pick<Types.DefaultShareclassMapping, 'id' | 'name'>
);

export type PressReleaseBase_DefaultShareclassMappings_Fragment = (
  { __typename?: 'DefaultShareclassMappings' }
  & Pick<Types.DefaultShareclassMappings, 'id' | 'name'>
);

export type PressReleaseBase_DescriptiveHighlight_Fragment = (
  { __typename?: 'DescriptiveHighlight' }
  & Pick<Types.DescriptiveHighlight, 'id' | 'name'>
);

export type PressReleaseBase_DescriptiveHighlightFolder_Fragment = (
  { __typename?: 'DescriptiveHighlightFolder' }
  & Pick<Types.DescriptiveHighlightFolder, 'id' | 'name'>
);

export type PressReleaseBase_DescriptiveHighlightItem_Fragment = (
  { __typename?: 'DescriptiveHighlightItem' }
  & Pick<Types.DescriptiveHighlightItem, 'id' | 'name'>
);

export type PressReleaseBase_DescriptiveHighlightParametersTemplate_Fragment = (
  { __typename?: 'DescriptiveHighlightParametersTemplate' }
  & Pick<Types.DescriptiveHighlightParametersTemplate, 'id' | 'name'>
);

export type PressReleaseBase_Device_Fragment = (
  { __typename?: 'Device' }
  & Pick<Types.Device, 'id' | 'name'>
);

export type PressReleaseBase_Device_7c27ec70f42e40428a0fabaa2f8eda18_Fragment = (
  { __typename?: 'Device_7c27ec70f42e40428a0fabaa2f8eda18' }
  & Pick<Types.Device_7c27ec70f42e40428a0fabaa2f8eda18, 'id' | 'name'>
);

export type PressReleaseBase_Devices_Fragment = (
  { __typename?: 'Devices' }
  & Pick<Types.Devices, 'id' | 'name'>
);

export type PressReleaseBase_DictionaryFolder_Fragment = (
  { __typename?: 'DictionaryFolder' }
  & Pick<Types.DictionaryFolder, 'id' | 'name'>
);

export type PressReleaseBase_DisqusParameters_Fragment = (
  { __typename?: 'DisqusParameters' }
  & Pick<Types.DisqusParameters, 'id' | 'name'>
);

export type PressReleaseBase_DistanceFacet_Fragment = (
  { __typename?: 'DistanceFacet' }
  & Pick<Types.DistanceFacet, 'id' | 'name'>
);

export type PressReleaseBase_Divider_Fragment = (
  { __typename?: 'Divider' }
  & Pick<Types.Divider, 'id' | 'name'>
);

export type PressReleaseBase_DocumentItem_Fragment = (
  { __typename?: 'DocumentItem' }
  & Pick<Types.DocumentItem, 'id' | 'name'>
);

export type PressReleaseBase_DocumentListings_Fragment = (
  { __typename?: 'DocumentListings' }
  & Pick<Types.DocumentListings, 'id' | 'name'>
);

export type PressReleaseBase_DocumentListingsFolder_Fragment = (
  { __typename?: 'DocumentListingsFolder' }
  & Pick<Types.DocumentListingsFolder, 'id' | 'name'>
);

export type PressReleaseBase_DocumentTypeFolder_Fragment = (
  { __typename?: 'DocumentTypeFolder' }
  & Pick<Types.DocumentTypeFolder, 'id' | 'name'>
);

export type PressReleaseBase_DominantLanguageMapping_Fragment = (
  { __typename?: 'DominantLanguageMapping' }
  & Pick<Types.DominantLanguageMapping, 'id' | 'name'>
);

export type PressReleaseBase_Dropdown_Fragment = (
  { __typename?: 'Dropdown' }
  & Pick<Types.Dropdown, 'id' | 'name'>
);

export type PressReleaseBase_DropdownFilter_Fragment = (
  { __typename?: 'DropdownFilter' }
  & Pick<Types.DropdownFilter, 'id' | 'name'>
);

export type PressReleaseBase_DropdownFilterFolder_Fragment = (
  { __typename?: 'DropdownFilterFolder' }
  & Pick<Types.DropdownFilterFolder, 'id' | 'name'>
);

export type PressReleaseBase_DropdownFilter_790c0f2c16214604a6c672b9f8ae830d_Fragment = (
  { __typename?: 'DropdownFilter_790c0f2c16214604a6c672b9f8ae830d' }
  & Pick<Types.DropdownFilter_790c0f2c16214604a6c672b9f8ae830d, 'id' | 'name'>
);

export type PressReleaseBase_EditEditingTheme_Fragment = (
  { __typename?: 'EditEditingTheme' }
  & Pick<Types.EditEditingTheme, 'id' | 'name'>
);

export type PressReleaseBase_EditFrame_Fragment = (
  { __typename?: 'EditFrame' }
  & Pick<Types.EditFrame, 'id' | 'name'>
);

export type PressReleaseBase_EditModePanel_Fragment = (
  { __typename?: 'EditModePanel' }
  & Pick<Types.EditModePanel, 'id' | 'name'>
);

export type PressReleaseBase_EditSiteItem_Fragment = (
  { __typename?: 'EditSiteItem' }
  & Pick<Types.EditSiteItem, 'id' | 'name'>
);

export type PressReleaseBase_EditSiteItem_F040db0387fe4e10ae4053c63175e31b_Fragment = (
  { __typename?: 'EditSiteItem_f040db0387fe4e10ae4053c63175e31b' }
  & Pick<Types.EditSiteItem_F040db0387fe4e10ae4053c63175e31b, 'id' | 'name'>
);

export type PressReleaseBase_EditSiteTheme_Fragment = (
  { __typename?: 'EditSiteTheme' }
  & Pick<Types.EditSiteTheme, 'id' | 'name'>
);

export type PressReleaseBase_EditTenantTemplate_Fragment = (
  { __typename?: 'EditTenantTemplate' }
  & Pick<Types.EditTenantTemplate, 'id' | 'name'>
);

export type PressReleaseBase_EditTenantTemplate_A7d9fcbcc8944274935f9b9659c000d3_Fragment = (
  { __typename?: 'EditTenantTemplate_a7d9fcbcc8944274935f9b9659c000d3' }
  & Pick<Types.EditTenantTemplate_A7d9fcbcc8944274935f9b9659c000d3, 'id' | 'name'>
);

export type PressReleaseBase_EditType_Fragment = (
  { __typename?: 'EditType' }
  & Pick<Types.EditType, 'id' | 'name'>
);

export type PressReleaseBase_EloquaFormFolder_Fragment = (
  { __typename?: 'EloquaFormFolder' }
  & Pick<Types.EloquaFormFolder, 'id' | 'name'>
);

export type PressReleaseBase_EloquaFundForm_Fragment = (
  { __typename?: 'EloquaFundForm' }
  & Pick<Types.EloquaFundForm, 'id' | 'name'>
);

export type PressReleaseBase_Enum_Fragment = (
  { __typename?: 'Enum' }
  & Pick<Types.Enum, 'id' | 'name'>
);

export type PressReleaseBase_Enums_Fragment = (
  { __typename?: 'Enums' }
  & Pick<Types.Enums, 'id' | 'name'>
);

export type PressReleaseBase_ErrorPage_Fragment = (
  { __typename?: 'ErrorPage' }
  & Pick<Types.ErrorPage, 'id' | 'name'>
);

export type PressReleaseBase_ErrorPage_4b405ec4ef9f4c91a3ffb98c1ac81171_Fragment = (
  { __typename?: 'ErrorPage_4b405ec4ef9f4c91a3ffb98c1ac81171' }
  & Pick<Types.ErrorPage_4b405ec4ef9f4c91a3ffb98c1ac81171, 'id' | 'name'>
);

export type PressReleaseBase_ErrorPage_4dbccce416d1491f94198496e3f77c6d_Fragment = (
  { __typename?: 'ErrorPage_4dbccce416d1491f94198496e3f77c6d' }
  & Pick<Types.ErrorPage_4dbccce416d1491f94198496e3f77c6d, 'id' | 'name'>
);

export type PressReleaseBase_ErrorPage_45d797cc048740ffb693214883ff35c2_Fragment = (
  { __typename?: 'ErrorPage_45d797cc048740ffb693214883ff35c2' }
  & Pick<Types.ErrorPage_45d797cc048740ffb693214883ff35c2, 'id' | 'name'>
);

export type PressReleaseBase_ErrorPage_76eb47b3f3a248bdbbdbb5bf7d8f9bf9_Fragment = (
  { __typename?: 'ErrorPage_76eb47b3f3a248bdbbdbb5bf7d8f9bf9' }
  & Pick<Types.ErrorPage_76eb47b3f3a248bdbbdbb5bf7d8f9bf9, 'id' | 'name'>
);

export type PressReleaseBase_ErrorPage_A7dfa49761224679bf9949fffacd5fa1_Fragment = (
  { __typename?: 'ErrorPage_a7dfa49761224679bf9949fffacd5fa1' }
  & Pick<Types.ErrorPage_A7dfa49761224679bf9949fffacd5fa1, 'id' | 'name'>
);

export type PressReleaseBase_EventCalendarParameters_Fragment = (
  { __typename?: 'EventCalendarParameters' }
  & Pick<Types.EventCalendarParameters, 'id' | 'name'>
);

export type PressReleaseBase_EventList_Fragment = (
  { __typename?: 'EventList' }
  & Pick<Types.EventList, 'id' | 'name'>
);

export type PressReleaseBase_EventListParameters_Fragment = (
  { __typename?: 'EventListParameters' }
  & Pick<Types.EventListParameters, 'id' | 'name'>
);

export type PressReleaseBase_EventTypes_Fragment = (
  { __typename?: 'EventTypes' }
  & Pick<Types.EventTypes, 'id' | 'name'>
);

export type PressReleaseBase_EventsFolder_Fragment = (
  { __typename?: 'EventsFolder' }
  & Pick<Types.EventsFolder, 'id' | 'name'>
);

export type PressReleaseBase_ExecuteScript_Fragment = (
  { __typename?: 'ExecuteScript' }
  & Pick<Types.ExecuteScript, 'id' | 'name'>
);

export type PressReleaseBase_ExecuteScript_3d4e4577ab334ca6ae43b98d1ec6472f_Fragment = (
  { __typename?: 'ExecuteScript_3d4e4577ab334ca6ae43b98d1ec6472f' }
  & Pick<Types.ExecuteScript_3d4e4577ab334ca6ae43b98d1ec6472f, 'id' | 'name'>
);

export type PressReleaseBase_ExecuteScript_6545c81fc30f4b5897d9ef85b890f70a_Fragment = (
  { __typename?: 'ExecuteScript_6545c81fc30f4b5897d9ef85b890f70a' }
  & Pick<Types.ExecuteScript_6545c81fc30f4b5897d9ef85b890f70a, 'id' | 'name'>
);

export type PressReleaseBase_ExecuteScript_B06460c28b7b47a59e2cf966f689b6ca_Fragment = (
  { __typename?: 'ExecuteScript_b06460c28b7b47a59e2cf966f689b6ca' }
  & Pick<Types.ExecuteScript_B06460c28b7b47a59e2cf966f689b6ca, 'id' | 'name'>
);

export type PressReleaseBase_ExecuteScript_Bc9bb68436df4285888bd8b4d87b10de_Fragment = (
  { __typename?: 'ExecuteScript_bc9bb68436df4285888bd8b4d87b10de' }
  & Pick<Types.ExecuteScript_Bc9bb68436df4285888bd8b4d87b10de, 'id' | 'name'>
);

export type PressReleaseBase_ExecuteScript_E14c08721a97459eafef0acaaaf1ffbb_Fragment = (
  { __typename?: 'ExecuteScript_e14c08721a97459eafef0acaaaf1ffbb' }
  & Pick<Types.ExecuteScript_E14c08721a97459eafef0acaaaf1ffbb, 'id' | 'name'>
);

export type PressReleaseBase_ExtendSiteTheme_Fragment = (
  { __typename?: 'ExtendSiteTheme' }
  & Pick<Types.ExtendSiteTheme, 'id' | 'name'>
);

export type PressReleaseBase_ExternalLiterature_Fragment = (
  { __typename?: 'ExternalLiterature' }
  & Pick<Types.ExternalLiterature, 'id' | 'name'>
);

export type PressReleaseBase_FEaaSWrapperRenderingParameters_Fragment = (
  { __typename?: 'FEaaSWrapperRenderingParameters' }
  & Pick<Types.FEaaSWrapperRenderingParameters, 'id' | 'name'>
);

export type PressReleaseBase_FacebookCommentsParametersTemplate_Fragment = (
  { __typename?: 'FacebookCommentsParametersTemplate' }
  & Pick<Types.FacebookCommentsParametersTemplate, 'id' | 'name'>
);

export type PressReleaseBase_FacetSlider_Fragment = (
  { __typename?: 'FacetSlider' }
  & Pick<Types.FacetSlider, 'id' | 'name'>
);

export type PressReleaseBase_FacetSliderFolder_Fragment = (
  { __typename?: 'FacetSliderFolder' }
  & Pick<Types.FacetSliderFolder, 'id' | 'name'>
);

export type PressReleaseBase_FacetSlider_995ce2c7319f478b84fe22053ac85bb7_Fragment = (
  { __typename?: 'FacetSlider_995ce2c7319f478b84fe22053ac85bb7' }
  & Pick<Types.FacetSlider_995ce2c7319f478b84fe22053ac85bb7, 'id' | 'name'>
);

export type PressReleaseBase_FacetSummary_Fragment = (
  { __typename?: 'FacetSummary' }
  & Pick<Types.FacetSummary, 'id' | 'name'>
);

export type PressReleaseBase_FacetSummaryFolder_Fragment = (
  { __typename?: 'FacetSummaryFolder' }
  & Pick<Types.FacetSummaryFolder, 'id' | 'name'>
);

export type PressReleaseBase_FacetSummary_Cd5c935c1f604d899a6b88ce28305cf2_Fragment = (
  { __typename?: 'FacetSummary_cd5c935c1f604d899a6b88ce28305cf2' }
  & Pick<Types.FacetSummary_Cd5c935c1f604d899a6b88ce28305cf2, 'id' | 'name'>
);

export type PressReleaseBase_FacetsGrouping_Fragment = (
  { __typename?: 'FacetsGrouping' }
  & Pick<Types.FacetsGrouping, 'id' | 'name'>
);

export type PressReleaseBase_FakeNavigationItem_Fragment = (
  { __typename?: 'FakeNavigationItem' }
  & Pick<Types.FakeNavigationItem, 'id' | 'name'>
);

export type PressReleaseBase_FeatureBanner_Fragment = (
  { __typename?: 'FeatureBanner' }
  & Pick<Types.FeatureBanner, 'id' | 'name'>
);

export type PressReleaseBase_FeatureBannerParametersTemplate_Fragment = (
  { __typename?: 'FeatureBannerParametersTemplate' }
  & Pick<Types.FeatureBannerParametersTemplate, 'id' | 'name'>
);

export type PressReleaseBase_FeaturedArticles_Fragment = (
  { __typename?: 'FeaturedArticles' }
  & Pick<Types.FeaturedArticles, 'id' | 'name'>
);

export type PressReleaseBase_FeaturedArticlesFolder_Fragment = (
  { __typename?: 'FeaturedArticlesFolder' }
  & Pick<Types.FeaturedArticlesFolder, 'id' | 'name'>
);

export type PressReleaseBase_FeaturedTheme_Fragment = (
  { __typename?: 'FeaturedTheme' }
  & Pick<Types.FeaturedTheme, 'id' | 'name'>
);

export type PressReleaseBase_FeaturedThemesFolder_Fragment = (
  { __typename?: 'FeaturedThemesFolder' }
  & Pick<Types.FeaturedThemesFolder, 'id' | 'name'>
);

export type PressReleaseBase_Feed_Fragment = (
  { __typename?: 'Feed' }
  & Pick<Types.Feed, 'id' | 'name'>
);

export type PressReleaseBase_FeedFolder_Fragment = (
  { __typename?: 'FeedFolder' }
  & Pick<Types.FeedFolder, 'id' | 'name'>
);

export type PressReleaseBase_FeedParameters_Fragment = (
  { __typename?: 'FeedParameters' }
  & Pick<Types.FeedParameters, 'id' | 'name'>
);

export type PressReleaseBase_FieldEditor_Fragment = (
  { __typename?: 'FieldEditor' }
  & Pick<Types.FieldEditor, 'id' | 'name'>
);

export type PressReleaseBase_FieldRenderer_Fragment = (
  { __typename?: 'FieldRenderer' }
  & Pick<Types.FieldRenderer, 'id' | 'name'>
);

export type PressReleaseBase_FileList_Fragment = (
  { __typename?: 'FileList' }
  & Pick<Types.FileList, 'id' | 'name'>
);

export type PressReleaseBase_FileListFolder_Fragment = (
  { __typename?: 'FileListFolder' }
  & Pick<Types.FileListFolder, 'id' | 'name'>
);

export type PressReleaseBase_FileListParametersTemplate_Fragment = (
  { __typename?: 'FileListParametersTemplate' }
  & Pick<Types.FileListParametersTemplate, 'id' | 'name'>
);

export type PressReleaseBase_File_04129321770849c1801baee196e1c0a8_Fragment = (
  { __typename?: 'File_04129321770849c1801baee196e1c0a8' }
  & Pick<Types.File_04129321770849c1801baee196e1c0a8, 'id' | 'name'>
);

export type PressReleaseBase_FilterCriteria_Fragment = (
  { __typename?: 'FilterCriteria' }
  & Pick<Types.FilterCriteria, 'id' | 'name'>
);

export type PressReleaseBase_FilterCriteriaFolder_Fragment = (
  { __typename?: 'FilterCriteriaFolder' }
  & Pick<Types.FilterCriteriaFolder, 'id' | 'name'>
);

export type PressReleaseBase_FilterTaxonomyOption_Fragment = (
  { __typename?: 'FilterTaxonomyOption' }
  & Pick<Types.FilterTaxonomyOption, 'id' | 'name'>
);

export type PressReleaseBase_FilterTaxonomyOptions_Fragment = (
  { __typename?: 'FilterTaxonomyOptions' }
  & Pick<Types.FilterTaxonomyOptions, 'id' | 'name'>
);

export type PressReleaseBase_FilteredArticlesParentPage_Fragment = (
  { __typename?: 'FilteredArticlesParentPage' }
  & Pick<Types.FilteredArticlesParentPage, 'id' | 'name'>
);

export type PressReleaseBase_FilteredArticlesParentPage_6adc5be146ab4c7d97f64e5c3512177d_Fragment = (
  { __typename?: 'FilteredArticlesParentPage_6adc5be146ab4c7d97f64e5c3512177d' }
  & Pick<Types.FilteredArticlesParentPage_6adc5be146ab4c7d97f64e5c3512177d, 'id' | 'name'>
);

export type PressReleaseBase_FilteredArticlesParentPage_7f5d344247eb446a8f147890b998e941_Fragment = (
  { __typename?: 'FilteredArticlesParentPage_7f5d344247eb446a8f147890b998e941' }
  & Pick<Types.FilteredArticlesParentPage_7f5d344247eb446a8f147890b998e941, 'id' | 'name'>
);

export type PressReleaseBase_FilteredArticlesParentPage_A34845039cf1441f8c967a5bbbdd7616_Fragment = (
  { __typename?: 'FilteredArticlesParentPage_a34845039cf1441f8c967a5bbbdd7616' }
  & Pick<Types.FilteredArticlesParentPage_A34845039cf1441f8c967a5bbbdd7616, 'id' | 'name'>
);

export type PressReleaseBase_FilteredArticlesParentPage_E4f65f074322485787460a4058d378f9_Fragment = (
  { __typename?: 'FilteredArticlesParentPage_e4f65f074322485787460a4058d378f9' }
  & Pick<Types.FilteredArticlesParentPage_E4f65f074322485787460a4058d378f9, 'id' | 'name'>
);

export type PressReleaseBase_FilteredArticlesParentPage_F099104e87204d52a6ab75aa44d159ce_Fragment = (
  { __typename?: 'FilteredArticlesParentPage_f099104e87204d52a6ab75aa44d159ce' }
  & Pick<Types.FilteredArticlesParentPage_F099104e87204d52a6ab75aa44d159ce, 'id' | 'name'>
);

export type PressReleaseBase_FilteredArticlesWildcardPage_Fragment = (
  { __typename?: 'FilteredArticlesWildcardPage' }
  & Pick<Types.FilteredArticlesWildcardPage, 'id' | 'name'>
);

export type PressReleaseBase_FilteredArticlesWildcardPage_5d527e4033c048c6a474af1068db082e_Fragment = (
  { __typename?: 'FilteredArticlesWildcardPage_5d527e4033c048c6a474af1068db082e' }
  & Pick<Types.FilteredArticlesWildcardPage_5d527e4033c048c6a474af1068db082e, 'id' | 'name'>
);

export type PressReleaseBase_FilteredArticlesWildcardPage_98c82b05868444df9fe806b5fb955835_Fragment = (
  { __typename?: 'FilteredArticlesWildcardPage_98c82b05868444df9fe806b5fb955835' }
  & Pick<Types.FilteredArticlesWildcardPage_98c82b05868444df9fe806b5fb955835, 'id' | 'name'>
);

export type PressReleaseBase_FilteredArticlesWildcardPage_705b3bb7cecc447f910fa76bdc57ada2_Fragment = (
  { __typename?: 'FilteredArticlesWildcardPage_705b3bb7cecc447f910fa76bdc57ada2' }
  & Pick<Types.FilteredArticlesWildcardPage_705b3bb7cecc447f910fa76bdc57ada2, 'id' | 'name'>
);

export type PressReleaseBase_FilteredArticlesWildcardPage_Ceac9aa72d344797adf00f73f9a55f96_Fragment = (
  { __typename?: 'FilteredArticlesWildcardPage_ceac9aa72d344797adf00f73f9a55f96' }
  & Pick<Types.FilteredArticlesWildcardPage_Ceac9aa72d344797adf00f73f9a55f96, 'id' | 'name'>
);

export type PressReleaseBase_FilteredArticlesWildcardPage_Da761c9a4e8f4a91b99040d8f5baa260_Fragment = (
  { __typename?: 'FilteredArticlesWildcardPage_da761c9a4e8f4a91b99040d8f5baa260' }
  & Pick<Types.FilteredArticlesWildcardPage_Da761c9a4e8f4a91b99040d8f5baa260, 'id' | 'name'>
);

export type PressReleaseBase_Flip_Fragment = (
  { __typename?: 'Flip' }
  & Pick<Types.Flip, 'id' | 'name'>
);

export type PressReleaseBase_FlipFolder_Fragment = (
  { __typename?: 'FlipFolder' }
  & Pick<Types.FlipFolder, 'id' | 'name'>
);

export type PressReleaseBase_Flip_5ef078504c044b839dafefd752cfaba8_Fragment = (
  { __typename?: 'Flip_5ef078504c044b839dafefd752cfaba8' }
  & Pick<Types.Flip_5ef078504c044b839dafefd752cfaba8, 'id' | 'name'>
);

export type PressReleaseBase_Flipside_Fragment = (
  { __typename?: 'Flipside' }
  & Pick<Types.Flipside, 'id' | 'name'>
);

export type PressReleaseBase_FloatFacet_Fragment = (
  { __typename?: 'FloatFacet' }
  & Pick<Types.FloatFacet, 'id' | 'name'>
);

export type PressReleaseBase_Footer_Fragment = (
  { __typename?: 'Footer' }
  & Pick<Types.Footer, 'id' | 'name'>
);

export type PressReleaseBase_FooterFolder_Fragment = (
  { __typename?: 'FooterFolder' }
  & Pick<Types.FooterFolder, 'id' | 'name'>
);

export type PressReleaseBase_FooterLink_Fragment = (
  { __typename?: 'FooterLink' }
  & Pick<Types.FooterLink, 'id' | 'name'>
);

export type PressReleaseBase_FormRenderingParameters_Fragment = (
  { __typename?: 'FormRenderingParameters' }
  & Pick<Types.FormRenderingParameters, 'id' | 'name'>
);

export type PressReleaseBase_FundAssetClass_Fragment = (
  { __typename?: 'FundAssetClass' }
  & Pick<Types.FundAssetClass, 'id' | 'name'>
);

export type PressReleaseBase_FundAssetClassesFolder_Fragment = (
  { __typename?: 'FundAssetClassesFolder' }
  & Pick<Types.FundAssetClassesFolder, 'id' | 'name'>
);

export type PressReleaseBase_FundDetailsWildcardPage_Fragment = (
  { __typename?: 'FundDetailsWildcardPage' }
  & Pick<Types.FundDetailsWildcardPage, 'id' | 'name'>
);

export type PressReleaseBase_FundDetailsWildcardPage_97df45d1e5294f6dbc2279895ee83734_Fragment = (
  { __typename?: 'FundDetailsWildcardPage_97df45d1e5294f6dbc2279895ee83734' }
  & Pick<Types.FundDetailsWildcardPage_97df45d1e5294f6dbc2279895ee83734, 'id' | 'name'>
);

export type PressReleaseBase_FundDetailsWildcardPage_590b12426ab64f49990b2dd2c5fffd0f_Fragment = (
  { __typename?: 'FundDetailsWildcardPage_590b12426ab64f49990b2dd2c5fffd0f' }
  & Pick<Types.FundDetailsWildcardPage_590b12426ab64f49990b2dd2c5fffd0f, 'id' | 'name'>
);

export type PressReleaseBase_FundDetailsWildcardPage_60069dbb81dc496b888fe2e38073a74b_Fragment = (
  { __typename?: 'FundDetailsWildcardPage_60069dbb81dc496b888fe2e38073a74b' }
  & Pick<Types.FundDetailsWildcardPage_60069dbb81dc496b888fe2e38073a74b, 'id' | 'name'>
);

export type PressReleaseBase_FundFormsFolder_Fragment = (
  { __typename?: 'FundFormsFolder' }
  & Pick<Types.FundFormsFolder, 'id' | 'name'>
);

export type PressReleaseBase_FundInFocus_Fragment = (
  { __typename?: 'FundInFocus' }
  & Pick<Types.FundInFocus, 'id' | 'name'>
);

export type PressReleaseBase_FundInFocusShareClass_Fragment = (
  { __typename?: 'FundInFocusShareClass' }
  & Pick<Types.FundInFocusShareClass, 'id' | 'name'>
);

export type PressReleaseBase_FundSearchPage_Fragment = (
  { __typename?: 'FundSearchPage' }
  & Pick<Types.FundSearchPage, 'id' | 'name'>
);

export type PressReleaseBase_FundSearchPage_5505b84dba1f47c7b8054749d802d926_Fragment = (
  { __typename?: 'FundSearchPage_5505b84dba1f47c7b8054749d802d926' }
  & Pick<Types.FundSearchPage_5505b84dba1f47c7b8054749d802d926, 'id' | 'name'>
);

export type PressReleaseBase_FundSearchPage_5806f83c03bc443380678ff955f4310f_Fragment = (
  { __typename?: 'FundSearchPage_5806f83c03bc443380678ff955f4310f' }
  & Pick<Types.FundSearchPage_5806f83c03bc443380678ff955f4310f, 'id' | 'name'>
);

export type PressReleaseBase_FundSearchPage_7432205c04214a419ca064c4cb37501c_Fragment = (
  { __typename?: 'FundSearchPage_7432205c04214a419ca064c4cb37501c' }
  & Pick<Types.FundSearchPage_7432205c04214a419ca064c4cb37501c, 'id' | 'name'>
);

export type PressReleaseBase_FundSearchPage_Edc9df02132e4c0a8435dd60057cbb0a_Fragment = (
  { __typename?: 'FundSearchPage_edc9df02132e4c0a8435dd60057cbb0a' }
  & Pick<Types.FundSearchPage_Edc9df02132e4c0a8435dd60057cbb0a, 'id' | 'name'>
);

export type PressReleaseBase_FundSettings_Fragment = (
  { __typename?: 'FundSettings' }
  & Pick<Types.FundSettings, 'id' | 'name'>
);

export type PressReleaseBase_FundShareclassDetailsWildcardPage_Fragment = (
  { __typename?: 'FundShareclassDetailsWildcardPage' }
  & Pick<Types.FundShareclassDetailsWildcardPage, 'id' | 'name'>
);

export type PressReleaseBase_FundShareclassDetailsWildcardPage_543d5f778ad443269e2384804031cb3c_Fragment = (
  { __typename?: 'FundShareclassDetailsWildcardPage_543d5f778ad443269e2384804031cb3c' }
  & Pick<Types.FundShareclassDetailsWildcardPage_543d5f778ad443269e2384804031cb3c, 'id' | 'name'>
);

export type PressReleaseBase_FundShareclassDetailsWildcardPage_5827425c1b4246d19f1311387a5bd4b3_Fragment = (
  { __typename?: 'FundShareclassDetailsWildcardPage_5827425c1b4246d19f1311387a5bd4b3' }
  & Pick<Types.FundShareclassDetailsWildcardPage_5827425c1b4246d19f1311387a5bd4b3, 'id' | 'name'>
);

export type PressReleaseBase_FundShareclassDetailsWildcardPage_Cf3f2635270b49779bb3822ab90f1dcc_Fragment = (
  { __typename?: 'FundShareclassDetailsWildcardPage_cf3f2635270b49779bb3822ab90f1dcc' }
  & Pick<Types.FundShareclassDetailsWildcardPage_Cf3f2635270b49779bb3822ab90f1dcc, 'id' | 'name'>
);

export type PressReleaseBase_FundShareclassDetailsWildcardPage_D7e686d9c3bc4ef9974e201972b59eee_Fragment = (
  { __typename?: 'FundShareclassDetailsWildcardPage_d7e686d9c3bc4ef9974e201972b59eee' }
  & Pick<Types.FundShareclassDetailsWildcardPage_D7e686d9c3bc4ef9974e201972b59eee, 'id' | 'name'>
);

export type PressReleaseBase_FundSubAssetClass_Fragment = (
  { __typename?: 'FundSubAssetClass' }
  & Pick<Types.FundSubAssetClass, 'id' | 'name'>
);

export type PressReleaseBase_FundSubAssetClassesFolder_Fragment = (
  { __typename?: 'FundSubAssetClassesFolder' }
  & Pick<Types.FundSubAssetClassesFolder, 'id' | 'name'>
);

export type PressReleaseBase_FundsExternalLiteratureFolder_Fragment = (
  { __typename?: 'FundsExternalLiteratureFolder' }
  & Pick<Types.FundsExternalLiteratureFolder, 'id' | 'name'>
);

export type PressReleaseBase_FundsFolder_Fragment = (
  { __typename?: 'FundsFolder' }
  & Pick<Types.FundsFolder, 'id' | 'name'>
);

export type PressReleaseBase_FundsInFocusFolder_Fragment = (
  { __typename?: 'FundsInFocusFolder' }
  & Pick<Types.FundsInFocusFolder, 'id' | 'name'>
);

export type PressReleaseBase_FundsInFocusParametersTemplate_Fragment = (
  { __typename?: 'FundsInFocusParametersTemplate' }
  & Pick<Types.FundsInFocusParametersTemplate, 'id' | 'name'>
);

export type PressReleaseBase_FundsLiteratureFolder_Fragment = (
  { __typename?: 'FundsLiteratureFolder' }
  & Pick<Types.FundsLiteratureFolder, 'id' | 'name'>
);

export type PressReleaseBase_FundsLiteratureMappingsFolder_Fragment = (
  { __typename?: 'FundsLiteratureMappingsFolder' }
  & Pick<Types.FundsLiteratureMappingsFolder, 'id' | 'name'>
);

export type PressReleaseBase_Gallery_Fragment = (
  { __typename?: 'Gallery' }
  & Pick<Types.Gallery, 'id' | 'name'>
);

export type PressReleaseBase_GalleryFolder_Fragment = (
  { __typename?: 'GalleryFolder' }
  & Pick<Types.GalleryFolder, 'id' | 'name'>
);

export type PressReleaseBase_GalleryImage_Fragment = (
  { __typename?: 'GalleryImage' }
  & Pick<Types.GalleryImage, 'id' | 'name'>
);

export type PressReleaseBase_GalleryParametersTemplate_Fragment = (
  { __typename?: 'GalleryParametersTemplate' }
  & Pick<Types.GalleryParametersTemplate, 'id' | 'name'>
);

export type PressReleaseBase_GalleryVideo_Fragment = (
  { __typename?: 'GalleryVideo' }
  & Pick<Types.GalleryVideo, 'id' | 'name'>
);

export type PressReleaseBase_GatedAccordionContainer_Fragment = (
  { __typename?: 'GatedAccordionContainer' }
  & Pick<Types.GatedAccordionContainer, 'id' | 'name'>
);

export type PressReleaseBase_GlobalLanguageSelector_Fragment = (
  { __typename?: 'GlobalLanguageSelector' }
  & Pick<Types.GlobalLanguageSelector, 'id' | 'name'>
);

export type PressReleaseBase_GlobalNavigationBar_Fragment = (
  { __typename?: 'GlobalNavigationBar' }
  & Pick<Types.GlobalNavigationBar, 'id' | 'name'>
);

export type PressReleaseBase_GoogleAnalytics_Fragment = (
  { __typename?: 'GoogleAnalytics' }
  & Pick<Types.GoogleAnalytics, 'id' | 'name'>
);

export type PressReleaseBase_GoogleTagManager_Fragment = (
  { __typename?: 'GoogleTagManager' }
  & Pick<Types.GoogleTagManager, 'id' | 'name'>
);

export type PressReleaseBase_GoogleTagManagerFolder_Fragment = (
  { __typename?: 'GoogleTagManagerFolder' }
  & Pick<Types.GoogleTagManagerFolder, 'id' | 'name'>
);

export type PressReleaseBase_GridSetup_Fragment = (
  { __typename?: 'GridSetup' }
  & Pick<Types.GridSetup, 'id' | 'name'>
);

export type PressReleaseBase_GridTheme_Fragment = (
  { __typename?: 'GridTheme' }
  & Pick<Types.GridTheme, 'id' | 'name'>
);

export type PressReleaseBase_HtmlCode_Fragment = (
  { __typename?: 'HTMLCode' }
  & Pick<Types.HtmlCode, 'id' | 'name'>
);

export type PressReleaseBase_HtmlCodeFolder_Fragment = (
  { __typename?: 'HTMLCodeFolder' }
  & Pick<Types.HtmlCodeFolder, 'id' | 'name'>
);

export type PressReleaseBase_HtmlInclude_Fragment = (
  { __typename?: 'HTMLInclude' }
  & Pick<Types.HtmlInclude, 'id' | 'name'>
);

export type PressReleaseBase_HtmlIncludesFolder_Fragment = (
  { __typename?: 'HTMLIncludesFolder' }
  & Pick<Types.HtmlIncludesFolder, 'id' | 'name'>
);

export type PressReleaseBase_HtmlSnippet_Fragment = (
  { __typename?: 'HTMLSnippet' }
  & Pick<Types.HtmlSnippet, 'id' | 'name'>
);

export type PressReleaseBase_HtmlSnippetFolder_Fragment = (
  { __typename?: 'HTMLSnippetFolder' }
  & Pick<Types.HtmlSnippetFolder, 'id' | 'name'>
);

export type PressReleaseBase_HtmlTag_Fragment = (
  { __typename?: 'HTMLTag' }
  & Pick<Types.HtmlTag, 'id' | 'name'>
);

export type PressReleaseBase_Header_Fragment = (
  { __typename?: 'Header' }
  & Pick<Types.Header, 'id' | 'name'>
);

export type PressReleaseBase_HeaderFolder_Fragment = (
  { __typename?: 'HeaderFolder' }
  & Pick<Types.HeaderFolder, 'id' | 'name'>
);

export type PressReleaseBase_Heading_Fragment = (
  { __typename?: 'Heading' }
  & Pick<Types.Heading, 'id' | 'name'>
);

export type PressReleaseBase_HeadlessSiteSetupRoot_Fragment = (
  { __typename?: 'HeadlessSiteSetupRoot' }
  & Pick<Types.HeadlessSiteSetupRoot, 'id' | 'name'>
);

export type PressReleaseBase_HeadlessSite_00d050988bad49e5b65db1e08b03ca1b_Fragment = (
  { __typename?: 'HeadlessSite_00d050988bad49e5b65db1e08b03ca1b' }
  & Pick<Types.HeadlessSite_00d050988bad49e5b65db1e08b03ca1b, 'id' | 'name'>
);

export type PressReleaseBase_HeadlessSite_0bb67daed5d04933a5ce1c0baa6c4df1_Fragment = (
  { __typename?: 'HeadlessSite_0bb67daed5d04933a5ce1c0baa6c4df1' }
  & Pick<Types.HeadlessSite_0bb67daed5d04933a5ce1c0baa6c4df1, 'id' | 'name'>
);

export type PressReleaseBase_HeadlessSite_8ca001453c4b4715959d8a05292ecbc5_Fragment = (
  { __typename?: 'HeadlessSite_8ca001453c4b4715959d8a05292ecbc5' }
  & Pick<Types.HeadlessSite_8ca001453c4b4715959d8a05292ecbc5, 'id' | 'name'>
);

export type PressReleaseBase_HeadlessSite_68ffa40c5aab45548f774742b163f318_Fragment = (
  { __typename?: 'HeadlessSite_68ffa40c5aab45548f774742b163f318' }
  & Pick<Types.HeadlessSite_68ffa40c5aab45548f774742b163f318, 'id' | 'name'>
);

export type PressReleaseBase_HeadlessSite_89d464c8c03e4b0287e9a878d95d7149_Fragment = (
  { __typename?: 'HeadlessSite_89d464c8c03e4b0287e9a878d95d7149' }
  & Pick<Types.HeadlessSite_89d464c8c03e4b0287e9a878d95d7149, 'id' | 'name'>
);

export type PressReleaseBase_HeadlessSite_229484893ca144958b9937167dfb5064_Fragment = (
  { __typename?: 'HeadlessSite_229484893ca144958b9937167dfb5064' }
  & Pick<Types.HeadlessSite_229484893ca144958b9937167dfb5064, 'id' | 'name'>
);

export type PressReleaseBase_HeadlessSite_B28055626acc45a2913a9617398c9730_Fragment = (
  { __typename?: 'HeadlessSite_b28055626acc45a2913a9617398c9730' }
  & Pick<Types.HeadlessSite_B28055626acc45a2913a9617398c9730, 'id' | 'name'>
);

export type PressReleaseBase_HeadlessSite_F1cab1661abb450d84d55d938e7699cb_Fragment = (
  { __typename?: 'HeadlessSite_f1cab1661abb450d84d55d938e7699cb' }
  & Pick<Types.HeadlessSite_F1cab1661abb450d84d55d938e7699cb, 'id' | 'name'>
);

export type PressReleaseBase_HeadlessSite_F3884baa0e1548f59a6d7154a4559604_Fragment = (
  { __typename?: 'HeadlessSite_f3884baa0e1548f59a6d7154a4559604' }
  & Pick<Types.HeadlessSite_F3884baa0e1548f59a6d7154a4559604, 'id' | 'name'>
);

export type PressReleaseBase_HeadlessSolutionTemplateFolder_Fragment = (
  { __typename?: 'HeadlessSolutionTemplateFolder' }
  & Pick<Types.HeadlessSolutionTemplateFolder, 'id' | 'name'>
);

export type PressReleaseBase_HeadlessTenantSetupRoot_Fragment = (
  { __typename?: 'HeadlessTenantSetupRoot' }
  & Pick<Types.HeadlessTenantSetupRoot, 'id' | 'name'>
);

export type PressReleaseBase_HeadlessTenant_07248c4700af499eb2a9cb7789f72372_Fragment = (
  { __typename?: 'HeadlessTenant_07248c4700af499eb2a9cb7789f72372' }
  & Pick<Types.HeadlessTenant_07248c4700af499eb2a9cb7789f72372, 'id' | 'name'>
);

export type PressReleaseBase_HeadlessTenant_5b3d7ac5419343c697c722309a2ad4c8_Fragment = (
  { __typename?: 'HeadlessTenant_5b3d7ac5419343c697c722309a2ad4c8' }
  & Pick<Types.HeadlessTenant_5b3d7ac5419343c697c722309a2ad4c8, 'id' | 'name'>
);

export type PressReleaseBase_HeadlessTenant_5d72df6049c74324969205b55767ad7b_Fragment = (
  { __typename?: 'HeadlessTenant_5d72df6049c74324969205b55767ad7b' }
  & Pick<Types.HeadlessTenant_5d72df6049c74324969205b55767ad7b, 'id' | 'name'>
);

export type PressReleaseBase_HeadlessTenant_6abd3bf16bcb4f25ac5b2399ff7a92e3_Fragment = (
  { __typename?: 'HeadlessTenant_6abd3bf16bcb4f25ac5b2399ff7a92e3' }
  & Pick<Types.HeadlessTenant_6abd3bf16bcb4f25ac5b2399ff7a92e3, 'id' | 'name'>
);

export type PressReleaseBase_HeadlessTenant_77a403a2094e48afafa60943d349d23d_Fragment = (
  { __typename?: 'HeadlessTenant_77a403a2094e48afafa60943d349d23d' }
  & Pick<Types.HeadlessTenant_77a403a2094e48afafa60943d349d23d, 'id' | 'name'>
);

export type PressReleaseBase_HeadlessTenant_115c42029c0d4fbcb542a4a539c33ee2_Fragment = (
  { __typename?: 'HeadlessTenant_115c42029c0d4fbcb542a4a539c33ee2' }
  & Pick<Types.HeadlessTenant_115c42029c0d4fbcb542a4a539c33ee2, 'id' | 'name'>
);

export type PressReleaseBase_HeadlessTenant_94824ac390d748499e5af0275d10811f_Fragment = (
  { __typename?: 'HeadlessTenant_94824ac390d748499e5af0275d10811f' }
  & Pick<Types.HeadlessTenant_94824ac390d748499e5af0275d10811f, 'id' | 'name'>
);

export type PressReleaseBase_HeadlessTenant_4797571864fd40929cf2412c39757ec3_Fragment = (
  { __typename?: 'HeadlessTenant_4797571864fd40929cf2412c39757ec3' }
  & Pick<Types.HeadlessTenant_4797571864fd40929cf2412c39757ec3, 'id' | 'name'>
);

export type PressReleaseBase_HeadlessTenant_C102fb48f40f49fb9c21f8e3e1b0c107_Fragment = (
  { __typename?: 'HeadlessTenant_c102fb48f40f49fb9c21f8e3e1b0c107' }
  & Pick<Types.HeadlessTenant_C102fb48f40f49fb9c21f8e3e1b0c107, 'id' | 'name'>
);

export type PressReleaseBase_HeadlessTrustSite_Fragment = (
  { __typename?: 'HeadlessTrustSite' }
  & Pick<Types.HeadlessTrustSite, 'id' | 'name'>
);

export type PressReleaseBase_HeadlessVariants_Fragment = (
  { __typename?: 'HeadlessVariants' }
  & Pick<Types.HeadlessVariants, 'id' | 'name'>
);

export type PressReleaseBase_HeadlessVariantsGrouping_Fragment = (
  { __typename?: 'HeadlessVariantsGrouping' }
  & Pick<Types.HeadlessVariantsGrouping, 'id' | 'name'>
);

export type PressReleaseBase_HelpArticlePage_Fragment = (
  { __typename?: 'HelpArticlePage' }
  & Pick<Types.HelpArticlePage, 'id' | 'name'>
);

export type PressReleaseBase_HelpArticlePlatform_Fragment = (
  { __typename?: 'HelpArticlePlatform' }
  & Pick<Types.HelpArticlePlatform, 'id' | 'name'>
);

export type PressReleaseBase_HelpArticlePlatformMap_Fragment = (
  { __typename?: 'HelpArticlePlatformMap' }
  & Pick<Types.HelpArticlePlatformMap, 'id' | 'name'>
);

export type PressReleaseBase_HelpArticlePlatformMappings_Fragment = (
  { __typename?: 'HelpArticlePlatformMappings' }
  & Pick<Types.HelpArticlePlatformMappings, 'id' | 'name'>
);

export type PressReleaseBase_HelpArticlePlatformsFolder_Fragment = (
  { __typename?: 'HelpArticlePlatformsFolder' }
  & Pick<Types.HelpArticlePlatformsFolder, 'id' | 'name'>
);

export type PressReleaseBase_HelpArticleSearchPage_Fragment = (
  { __typename?: 'HelpArticleSearchPage' }
  & Pick<Types.HelpArticleSearchPage, 'id' | 'name'>
);

export type PressReleaseBase_HelpArticleSearchPage_486d4c7432c64f9a929b595943c6fe77_Fragment = (
  { __typename?: 'HelpArticleSearchPage_486d4c7432c64f9a929b595943c6fe77' }
  & Pick<Types.HelpArticleSearchPage_486d4c7432c64f9a929b595943c6fe77, 'id' | 'name'>
);

export type PressReleaseBase_HelpArticleTag_Fragment = (
  { __typename?: 'HelpArticleTag' }
  & Pick<Types.HelpArticleTag, 'id' | 'name'>
);

export type PressReleaseBase_HelpArticleTagsFolder_Fragment = (
  { __typename?: 'HelpArticleTagsFolder' }
  & Pick<Types.HelpArticleTagsFolder, 'id' | 'name'>
);

export type PressReleaseBase_HelpArticleWildcardPage_Fragment = (
  { __typename?: 'HelpArticleWildcardPage' }
  & Pick<Types.HelpArticleWildcardPage, 'id' | 'name'>
);

export type PressReleaseBase_HelpArticleWildcardPage_E4e2d58c853341deaa6b2a2a136421c4_Fragment = (
  { __typename?: 'HelpArticleWildcardPage_e4e2d58c853341deaa6b2a2a136421c4' }
  & Pick<Types.HelpArticleWildcardPage_E4e2d58c853341deaa6b2a2a136421c4, 'id' | 'name'>
);

export type PressReleaseBase_HelpArticlesGroupFolder_Fragment = (
  { __typename?: 'HelpArticlesGroupFolder' }
  & Pick<Types.HelpArticlesGroupFolder, 'id' | 'name'>
);

export type PressReleaseBase_HelpTagMap_Fragment = (
  { __typename?: 'HelpTagMap' }
  & Pick<Types.HelpTagMap, 'id' | 'name'>
);

export type PressReleaseBase_HelpTagMappings_Fragment = (
  { __typename?: 'HelpTagMappings' }
  & Pick<Types.HelpTagMappings, 'id' | 'name'>
);

export type PressReleaseBase_HeroBanner_Fragment = (
  { __typename?: 'HeroBanner' }
  & Pick<Types.HeroBanner, 'id' | 'name'>
);

export type PressReleaseBase_Highlight_Fragment = (
  { __typename?: 'Highlight' }
  & Pick<Types.Highlight, 'id' | 'name'>
);

export type PressReleaseBase_HighlightBlock_Fragment = (
  { __typename?: 'HighlightBlock' }
  & Pick<Types.HighlightBlock, 'id' | 'name'>
);

export type PressReleaseBase_HighlightBlockFolder_Fragment = (
  { __typename?: 'HighlightBlockFolder' }
  & Pick<Types.HighlightBlockFolder, 'id' | 'name'>
);

export type PressReleaseBase_HighlightBlockParametersTemplate_Fragment = (
  { __typename?: 'HighlightBlockParametersTemplate' }
  & Pick<Types.HighlightBlockParametersTemplate, 'id' | 'name'>
);

export type PressReleaseBase_HighlightFolder_Fragment = (
  { __typename?: 'HighlightFolder' }
  & Pick<Types.HighlightFolder, 'id' | 'name'>
);

export type PressReleaseBase_HighlightItem_Fragment = (
  { __typename?: 'HighlightItem' }
  & Pick<Types.HighlightItem, 'id' | 'name'>
);

export type PressReleaseBase_HighlightParametersTemplate_Fragment = (
  { __typename?: 'HighlightParametersTemplate' }
  & Pick<Types.HighlightParametersTemplate, 'id' | 'name'>
);

export type PressReleaseBase_Home_Fragment = (
  { __typename?: 'Home' }
  & Pick<Types.Home, 'id' | 'name'>
);

export type PressReleaseBase_HomePage_Fragment = (
  { __typename?: 'HomePage' }
  & Pick<Types.HomePage, 'id' | 'name'>
);

export type PressReleaseBase_HomePage_0d3963a8171d4080b5f808618578b631_Fragment = (
  { __typename?: 'HomePage_0d3963a8171d4080b5f808618578b631' }
  & Pick<Types.HomePage_0d3963a8171d4080b5f808618578b631, 'id' | 'name'>
);

export type PressReleaseBase_HomePage_6d95c7d946c74a70be07304cc73a2010_Fragment = (
  { __typename?: 'HomePage_6d95c7d946c74a70be07304cc73a2010' }
  & Pick<Types.HomePage_6d95c7d946c74a70be07304cc73a2010, 'id' | 'name'>
);

export type PressReleaseBase_HomePage_B407f259b4e34c7db9a06e8907a56b17_Fragment = (
  { __typename?: 'HomePage_b407f259b4e34c7db9a06e8907a56b17' }
  & Pick<Types.HomePage_B407f259b4e34c7db9a06e8907a56b17, 'id' | 'name'>
);

export type PressReleaseBase_HomePage_Cde13c51062d426b95569e8202edc963_Fragment = (
  { __typename?: 'HomePage_cde13c51062d426b95569e8202edc963' }
  & Pick<Types.HomePage_Cde13c51062d426b95569e8202edc963, 'id' | 'name'>
);

export type PressReleaseBase_HomePage_De9353283a3e41c495ba386aed0540c6_Fragment = (
  { __typename?: 'HomePage_de9353283a3e41c495ba386aed0540c6' }
  & Pick<Types.HomePage_De9353283a3e41c495ba386aed0540c6, 'id' | 'name'>
);

export type PressReleaseBase_IFrame_Fragment = (
  { __typename?: 'IFrame' }
  & Pick<Types.IFrame, 'id' | 'name'>
);

export type PressReleaseBase_IFrameFolder_Fragment = (
  { __typename?: 'IFrameFolder' }
  & Pick<Types.IFrameFolder, 'id' | 'name'>
);

export type PressReleaseBase_IFrameFolder_21366ebf5fda4ff4a4dac7b1f4d7ada2_Fragment = (
  { __typename?: 'IFrameFolder_21366ebf5fda4ff4a4dac7b1f4d7ada2' }
  & Pick<Types.IFrameFolder_21366ebf5fda4ff4a4dac7b1f4d7ada2, 'id' | 'name'>
);

export type PressReleaseBase_IFrameParametersTemplate_Fragment = (
  { __typename?: 'IFrameParametersTemplate' }
  & Pick<Types.IFrameParametersTemplate, 'id' | 'name'>
);

export type PressReleaseBase_IFrame_0da12d476de24dfeb4d0f513489bfea1_Fragment = (
  { __typename?: 'IFrame_0da12d476de24dfeb4d0f513489bfea1' }
  & Pick<Types.IFrame_0da12d476de24dfeb4d0f513489bfea1, 'id' | 'name'>
);

export type PressReleaseBase_IFrame_88a6f65f2b78491bb3770b06e48883e1_Fragment = (
  { __typename?: 'IFrame_88a6f65f2b78491bb3770b06e48883e1' }
  & Pick<Types.IFrame_88a6f65f2b78491bb3770b06e48883e1, 'id' | 'name'>
);

export type PressReleaseBase_Icon_Fragment = (
  { __typename?: 'Icon' }
  & Pick<Types.Icon, 'id' | 'name'>
);

export type PressReleaseBase_IconFolder_Fragment = (
  { __typename?: 'IconFolder' }
  & Pick<Types.IconFolder, 'id' | 'name'>
);

export type PressReleaseBase_Image_Fragment = (
  { __typename?: 'Image' }
  & Pick<Types.Image, 'id' | 'name'>
);

export type PressReleaseBase_ImageFolder_Fragment = (
  { __typename?: 'ImageFolder' }
  & Pick<Types.ImageFolder, 'id' | 'name'>
);

export type PressReleaseBase_ImageFolder_Edc00e86cef24d0cbfa264460becc323_Fragment = (
  { __typename?: 'ImageFolder_edc00e86cef24d0cbfa264460becc323' }
  & Pick<Types.ImageFolder_Edc00e86cef24d0cbfa264460becc323, 'id' | 'name'>
);

export type PressReleaseBase_ImageFolder_F7a4527687f14ea5bf25e3c7cb7aa993_Fragment = (
  { __typename?: 'ImageFolder_f7a4527687f14ea5bf25e3c7cb7aa993' }
  & Pick<Types.ImageFolder_F7a4527687f14ea5bf25e3c7cb7aa993, 'id' | 'name'>
);

export type PressReleaseBase_ImageParametersTemplate_Fragment = (
  { __typename?: 'ImageParametersTemplate' }
  & Pick<Types.ImageParametersTemplate, 'id' | 'name'>
);

export type PressReleaseBase_Image_83bc563c6320490092f8204bff81586a_Fragment = (
  { __typename?: 'Image_83bc563c6320490092f8204bff81586a' }
  & Pick<Types.Image_83bc563c6320490092f8204bff81586a, 'id' | 'name'>
);

export type PressReleaseBase_Image_15185b0e641844499f934ff03b7ee032_Fragment = (
  { __typename?: 'Image_15185b0e641844499f934ff03b7ee032' }
  & Pick<Types.Image_15185b0e641844499f934ff03b7ee032, 'id' | 'name'>
);

export type PressReleaseBase_Image_D885df8cb2d64007b34b2bbafb527304_Fragment = (
  { __typename?: 'Image_d885df8cb2d64007b34b2bbafb527304' }
  & Pick<Types.Image_D885df8cb2d64007b34b2bbafb527304, 'id' | 'name'>
);

export type PressReleaseBase_Infographics_Fragment = (
  { __typename?: 'Infographics' }
  & Pick<Types.Infographics, 'id' | 'name'>
);

export type PressReleaseBase_InfographicsFolder_Fragment = (
  { __typename?: 'InfographicsFolder' }
  & Pick<Types.InfographicsFolder, 'id' | 'name'>
);

export type PressReleaseBase_InputValidationStep_Fragment = (
  { __typename?: 'InputValidationStep' }
  & Pick<Types.InputValidationStep, 'id' | 'name'>
);

export type PressReleaseBase_InputValidationStep_088928cf558e40ec87f3342aa9e66757_Fragment = (
  { __typename?: 'InputValidationStep_088928cf558e40ec87f3342aa9e66757' }
  & Pick<Types.InputValidationStep_088928cf558e40ec87f3342aa9e66757, 'id' | 'name'>
);

export type PressReleaseBase_InputValidationStep_9eded2f7f84748938a0bf69e7fcf3593_Fragment = (
  { __typename?: 'InputValidationStep_9eded2f7f84748938a0bf69e7fcf3593' }
  & Pick<Types.InputValidationStep_9eded2f7f84748938a0bf69e7fcf3593, 'id' | 'name'>
);

export type PressReleaseBase_InputValidationStep_D028fef2babf4ad1bbe74d62a977992f_Fragment = (
  { __typename?: 'InputValidationStep_d028fef2babf4ad1bbe74d62a977992f' }
  & Pick<Types.InputValidationStep_D028fef2babf4ad1bbe74d62a977992f, 'id' | 'name'>
);

export type PressReleaseBase_IntegerFacet_Fragment = (
  { __typename?: 'IntegerFacet' }
  & Pick<Types.IntegerFacet, 'id' | 'name'>
);

export type PressReleaseBase_IntroCopy_Fragment = (
  { __typename?: 'IntroCopy' }
  & Pick<Types.IntroCopy, 'id' | 'name'>
);

export type PressReleaseBase_IntroCopyFolder_Fragment = (
  { __typename?: 'IntroCopyFolder' }
  & Pick<Types.IntroCopyFolder, 'id' | 'name'>
);

export type PressReleaseBase_InvestmentTrustAssetClass_Fragment = (
  { __typename?: 'InvestmentTrustAssetClass' }
  & Pick<Types.InvestmentTrustAssetClass, 'id' | 'name'>
);

export type PressReleaseBase_InvestmentTrustAssetClassFolder_Fragment = (
  { __typename?: 'InvestmentTrustAssetClassFolder' }
  & Pick<Types.InvestmentTrustAssetClassFolder, 'id' | 'name'>
);

export type PressReleaseBase_InvestmentTrustPage_8f108193367d41dcb4dc3a71722c2b73_Fragment = (
  { __typename?: 'InvestmentTrustPage_8f108193367d41dcb4dc3a71722c2b73' }
  & Pick<Types.InvestmentTrustPage_8f108193367d41dcb4dc3a71722c2b73, 'id' | 'name'>
);

export type PressReleaseBase_InvestmentTrustPage_79a99ec28fe841f0a929356fe3a6aaeb_Fragment = (
  { __typename?: 'InvestmentTrustPage_79a99ec28fe841f0a929356fe3a6aaeb' }
  & Pick<Types.InvestmentTrustPage_79a99ec28fe841f0a929356fe3a6aaeb, 'id' | 'name'>
);

export type PressReleaseBase_InvestmentTrustRegion_Fragment = (
  { __typename?: 'InvestmentTrustRegion' }
  & Pick<Types.InvestmentTrustRegion, 'id' | 'name'>
);

export type PressReleaseBase_InvestmentTrustRegionFolder_Fragment = (
  { __typename?: 'InvestmentTrustRegionFolder' }
  & Pick<Types.InvestmentTrustRegionFolder, 'id' | 'name'>
);

export type PressReleaseBase_InvestmentTrustStyle_Fragment = (
  { __typename?: 'InvestmentTrustStyle' }
  & Pick<Types.InvestmentTrustStyle, 'id' | 'name'>
);

export type PressReleaseBase_InvestmentTrustStyleFolder_Fragment = (
  { __typename?: 'InvestmentTrustStyleFolder' }
  & Pick<Types.InvestmentTrustStyleFolder, 'id' | 'name'>
);

export type PressReleaseBase_InvestorType_Fragment = (
  { __typename?: 'InvestorType' }
  & Pick<Types.InvestorType, 'id' | 'name'>
);

export type PressReleaseBase_InvestorTypesFolder_Fragment = (
  { __typename?: 'InvestorTypesFolder' }
  & Pick<Types.InvestorTypesFolder, 'id' | 'name'>
);

export type PressReleaseBase_ItemQueriesFolder_Fragment = (
  { __typename?: 'ItemQueriesFolder' }
  & Pick<Types.ItemQueriesFolder, 'id' | 'name'>
);

export type PressReleaseBase_ItemRights_Fragment = (
  { __typename?: 'ItemRights' }
  & Pick<Types.ItemRights, 'id' | 'name'>
);

export type PressReleaseBase_JsBeaconSettings_Fragment = (
  { __typename?: 'JSBeaconSettings' }
  & Pick<Types.JsBeaconSettings, 'id' | 'name'>
);

export type PressReleaseBase_JsonCheckbox_Fragment = (
  { __typename?: 'JSONCheckbox' }
  & Pick<Types.JsonCheckbox, 'id' | 'name'>
);

export type PressReleaseBase_JsonContent_Fragment = (
  { __typename?: 'JSONContent' }
  & Pick<Types.JsonContent, 'id' | 'name'>
);

export type PressReleaseBase_JsonDate_Fragment = (
  { __typename?: 'JSONDate' }
  & Pick<Types.JsonDate, 'id' | 'name'>
);

export type PressReleaseBase_JsonFile_Fragment = (
  { __typename?: 'JSONFile' }
  & Pick<Types.JsonFile, 'id' | 'name'>
);

export type PressReleaseBase_JsonImage_Fragment = (
  { __typename?: 'JSONImage' }
  & Pick<Types.JsonImage, 'id' | 'name'>
);

export type PressReleaseBase_JsonLayout_Fragment = (
  { __typename?: 'JSONLayout' }
  & Pick<Types.JsonLayout, 'id' | 'name'>
);

export type PressReleaseBase_JsonList_Fragment = (
  { __typename?: 'JSONList' }
  & Pick<Types.JsonList, 'id' | 'name'>
);

export type PressReleaseBase_JsonMultilistReference_Fragment = (
  { __typename?: 'JSONMultilistReference' }
  & Pick<Types.JsonMultilistReference, 'id' | 'name'>
);

export type PressReleaseBase_JsonPlaceholder_Fragment = (
  { __typename?: 'JSONPlaceholder' }
  & Pick<Types.JsonPlaceholder, 'id' | 'name'>
);

export type PressReleaseBase_JsonQuery_Fragment = (
  { __typename?: 'JSONQuery' }
  & Pick<Types.JsonQuery, 'id' | 'name'>
);

export type PressReleaseBase_JsonResults_Fragment = (
  { __typename?: 'JSONResults' }
  & Pick<Types.JsonResults, 'id' | 'name'>
);

export type PressReleaseBase_JsonRichText_Fragment = (
  { __typename?: 'JSONRichText' }
  & Pick<Types.JsonRichText, 'id' | 'name'>
);

export type PressReleaseBase_JsonScriban_Fragment = (
  { __typename?: 'JSONScriban' }
  & Pick<Types.JsonScriban, 'id' | 'name'>
);

export type PressReleaseBase_JsonSection_Fragment = (
  { __typename?: 'JSONSection' }
  & Pick<Types.JsonSection, 'id' | 'name'>
);

export type PressReleaseBase_JsonTemplate_Fragment = (
  { __typename?: 'JSONTemplate' }
  & Pick<Types.JsonTemplate, 'id' | 'name'>
);

export type PressReleaseBase_JsonText_Fragment = (
  { __typename?: 'JSONText' }
  & Pick<Types.JsonText, 'id' | 'name'>
);

export type PressReleaseBase_JsonToken_Fragment = (
  { __typename?: 'JSONToken' }
  & Pick<Types.JsonToken, 'id' | 'name'>
);

export type PressReleaseBase_JsonVariantDefinition_Fragment = (
  { __typename?: 'JSONVariantDefinition' }
  & Pick<Types.JsonVariantDefinition, 'id' | 'name'>
);

export type PressReleaseBase_JsonVariants_Fragment = (
  { __typename?: 'JSONVariants' }
  & Pick<Types.JsonVariants, 'id' | 'name'>
);

export type PressReleaseBase_JssLayout_Fragment = (
  { __typename?: 'JSSLayout' }
  & Pick<Types.JssLayout, 'id' | 'name'>
);

export type PressReleaseBase_JssSettings_1a6fb678eca242c09ae77a9e7f72a6d0_Fragment = (
  { __typename?: 'JSSSettings_1a6fb678eca242c09ae77a9e7f72a6d0' }
  & Pick<Types.JssSettings_1a6fb678eca242c09ae77a9e7f72a6d0, 'id' | 'name'>
);

export type PressReleaseBase_JssSettings_6b328292f8314ab79885d89a054ca10a_Fragment = (
  { __typename?: 'JSSSettings_6b328292f8314ab79885d89a054ca10a' }
  & Pick<Types.JssSettings_6b328292f8314ab79885d89a054ca10a, 'id' | 'name'>
);

export type PressReleaseBase_JssSettings_457c9d0b61b84adfaf7f82561ed275ff_Fragment = (
  { __typename?: 'JSSSettings_457c9d0b61b84adfaf7f82561ed275ff' }
  & Pick<Types.JssSettings_457c9d0b61b84adfaf7f82561ed275ff, 'id' | 'name'>
);

export type PressReleaseBase_JssSettings_5045bf85d2ea430b9f41c2e348436e5d_Fragment = (
  { __typename?: 'JSSSettings_5045bf85d2ea430b9f41c2e348436e5d' }
  & Pick<Types.JssSettings_5045bf85d2ea430b9f41c2e348436e5d, 'id' | 'name'>
);

export type PressReleaseBase_JssSettings_A767f80d5ad44bfbb8b750a8da144cb5_Fragment = (
  { __typename?: 'JSSSettings_a767f80d5ad44bfbb8b750a8da144cb5' }
  & Pick<Types.JssSettings_A767f80d5ad44bfbb8b750a8da144cb5, 'id' | 'name'>
);

export type PressReleaseBase_JssSettings_B001fd725bb1476496825a8cb9e995cd_Fragment = (
  { __typename?: 'JSSSettings_b001fd725bb1476496825a8cb9e995cd' }
  & Pick<Types.JssSettings_B001fd725bb1476496825a8cb9e995cd, 'id' | 'name'>
);

export type PressReleaseBase_JssSettings_C643bc8630d14d61a173c7870f5dbbad_Fragment = (
  { __typename?: 'JSSSettings_c643bc8630d14d61a173c7870f5dbbad' }
  & Pick<Types.JssSettings_C643bc8630d14d61a173c7870f5dbbad, 'id' | 'name'>
);

export type PressReleaseBase_JssSettings_Ce3dfd340df34b2d8715e54f85dfcce2_Fragment = (
  { __typename?: 'JSSSettings_ce3dfd340df34b2d8715e54f85dfcce2' }
  & Pick<Types.JssSettings_Ce3dfd340df34b2d8715e54f85dfcce2, 'id' | 'name'>
);

export type PressReleaseBase_JssSettings_Ef855d0ba8b04a8e87851d1298266d90_Fragment = (
  { __typename?: 'JSSSettings_ef855d0ba8b04a8e87851d1298266d90' }
  & Pick<Types.JssSettings_Ef855d0ba8b04a8e87851d1298266d90, 'id' | 'name'>
);

export type PressReleaseBase_JssSiteGrouping_Fragment = (
  { __typename?: 'JSSSiteGrouping' }
  & Pick<Types.JssSiteGrouping, 'id' | 'name'>
);

export type PressReleaseBase_JssTenantFolder_Fragment = (
  { __typename?: 'JSSTenantFolder' }
  & Pick<Types.JssTenantFolder, 'id' | 'name'>
);

export type PressReleaseBase_JavaScriptRendering_Fragment = (
  { __typename?: 'JavaScriptRendering' }
  & Pick<Types.JavaScriptRendering, 'id' | 'name'>
);

export type PressReleaseBase_JsonRendering_Fragment = (
  { __typename?: 'JsonRendering' }
  & Pick<Types.JsonRendering, 'id' | 'name'>
);

export type PressReleaseBase_JurisdictionStatus_Fragment = (
  { __typename?: 'JurisdictionStatus' }
  & Pick<Types.JurisdictionStatus, 'id' | 'name'>
);

export type PressReleaseBase_JurisdictionsFolder_Fragment = (
  { __typename?: 'JurisdictionsFolder' }
  & Pick<Types.JurisdictionsFolder, 'id' | 'name'>
);

export type PressReleaseBase_KeyHighlightItem_Fragment = (
  { __typename?: 'KeyHighlightItem' }
  & Pick<Types.KeyHighlightItem, 'id' | 'name'>
);

export type PressReleaseBase_KeyHighlights_Fragment = (
  { __typename?: 'KeyHighlights' }
  & Pick<Types.KeyHighlights, 'id' | 'name'>
);

export type PressReleaseBase_KeyHighlightsFolder_Fragment = (
  { __typename?: 'KeyHighlightsFolder' }
  & Pick<Types.KeyHighlightsFolder, 'id' | 'name'>
);

export type PressReleaseBase_KeyHighlightsParametersTemplate_Fragment = (
  { __typename?: 'KeyHighlightsParametersTemplate' }
  & Pick<Types.KeyHighlightsParametersTemplate, 'id' | 'name'>
);

export type PressReleaseBase_Language_Fragment = (
  { __typename?: 'Language' }
  & Pick<Types.Language, 'id' | 'name'>
);

export type PressReleaseBase_LanguageSelector_Fragment = (
  { __typename?: 'LanguageSelector' }
  & Pick<Types.LanguageSelector, 'id' | 'name'>
);

export type PressReleaseBase_LanguagesFolder_Fragment = (
  { __typename?: 'LanguagesFolder' }
  & Pick<Types.LanguagesFolder, 'id' | 'name'>
);

export type PressReleaseBase_LatestPressReleasesParametersTemplate_Fragment = (
  { __typename?: 'LatestPressReleasesParametersTemplate' }
  & Pick<Types.LatestPressReleasesParametersTemplate, 'id' | 'name'>
);

export type PressReleaseBase_LayoutServiceVariants_Fragment = (
  { __typename?: 'LayoutServiceVariants' }
  & Pick<Types.LayoutServiceVariants, 'id' | 'name'>
);

export type PressReleaseBase_LimitedDisplayFolder_Fragment = (
  { __typename?: 'LimitedDisplayFolder' }
  & Pick<Types.LimitedDisplayFolder, 'id' | 'name'>
);

export type PressReleaseBase_LimitedDisplayOption_Fragment = (
  { __typename?: 'LimitedDisplayOption' }
  & Pick<Types.LimitedDisplayOption, 'id' | 'name'>
);

export type PressReleaseBase_Link_Fragment = (
  { __typename?: 'Link' }
  & Pick<Types.Link, 'id' | 'name'>
);

export type PressReleaseBase_LinkList_Fragment = (
  { __typename?: 'LinkList' }
  & Pick<Types.LinkList, 'id' | 'name'>
);

export type PressReleaseBase_LinkListFolder_Fragment = (
  { __typename?: 'LinkListFolder' }
  & Pick<Types.LinkListFolder, 'id' | 'name'>
);

export type PressReleaseBase_LinkListFolder_C237d144647a4afeaa7b1570f3e3f139_Fragment = (
  { __typename?: 'LinkListFolder_c237d144647a4afeaa7b1570f3e3f139' }
  & Pick<Types.LinkListFolder_C237d144647a4afeaa7b1570f3e3f139, 'id' | 'name'>
);

export type PressReleaseBase_LinkList_33c9207e3b0446068ef54ca99a97c776_Fragment = (
  { __typename?: 'LinkList_33c9207e3b0446068ef54ca99a97c776' }
  & Pick<Types.LinkList_33c9207e3b0446068ef54ca99a97c776, 'id' | 'name'>
);

export type PressReleaseBase_LinkList_97a593ad273141dc80bfceb5ef6a33b7_Fragment = (
  { __typename?: 'LinkList_97a593ad273141dc80bfceb5ef6a33b7' }
  & Pick<Types.LinkList_97a593ad273141dc80bfceb5ef6a33b7, 'id' | 'name'>
);

export type PressReleaseBase_LinkList_F7561ffcc0d8477fb53d2703a4060be1_Fragment = (
  { __typename?: 'LinkList_f7561ffcc0d8477fb53d2703a4060be1' }
  & Pick<Types.LinkList_F7561ffcc0d8477fb53d2703a4060be1, 'id' | 'name'>
);

export type PressReleaseBase_Link_68bd1cb5a7624a969ac6cb16ab5882a3_Fragment = (
  { __typename?: 'Link_68bd1cb5a7624a969ac6cb16ab5882a3' }
  & Pick<Types.Link_68bd1cb5a7624a969ac6cb16ab5882a3, 'id' | 'name'>
);

export type PressReleaseBase_Link_930f134d56784b35bfd1b77f9d0115f1_Fragment = (
  { __typename?: 'Link_930f134d56784b35bfd1b77f9d0115f1' }
  & Pick<Types.Link_930f134d56784b35bfd1b77f9d0115f1, 'id' | 'name'>
);

export type PressReleaseBase_Link_E24e0789a05848bfabb6c69c0e60b6b7_Fragment = (
  { __typename?: 'Link_e24e0789a05848bfabb6c69c0e60b6b7' }
  & Pick<Types.Link_E24e0789a05848bfabb6c69c0e60b6b7, 'id' | 'name'>
);

export type PressReleaseBase_LinksFolder_Fragment = (
  { __typename?: 'LinksFolder' }
  & Pick<Types.LinksFolder, 'id' | 'name'>
);

export type PressReleaseBase_List_Fragment = (
  { __typename?: 'List' }
  & Pick<Types.List, 'id' | 'name'>
);

export type PressReleaseBase_ListFacet_Fragment = (
  { __typename?: 'ListFacet' }
  & Pick<Types.ListFacet, 'id' | 'name'>
);

export type PressReleaseBase_ListFolder_Fragment = (
  { __typename?: 'ListFolder' }
  & Pick<Types.ListFolder, 'id' | 'name'>
);

export type PressReleaseBase_ListItem_Fragment = (
  { __typename?: 'ListItem' }
  & Pick<Types.ListItem, 'id' | 'name'>
);

export type PressReleaseBase_ListParametersTemplate_Fragment = (
  { __typename?: 'ListParametersTemplate' }
  & Pick<Types.ListParametersTemplate, 'id' | 'name'>
);

export type PressReleaseBase_ListStyle_Fragment = (
  { __typename?: 'ListStyle' }
  & Pick<Types.ListStyle, 'id' | 'name'>
);

export type PressReleaseBase_ListStyleItem_Fragment = (
  { __typename?: 'ListStyleItem' }
  & Pick<Types.ListStyleItem, 'id' | 'name'>
);

export type PressReleaseBase_ListingHeroBanner_Fragment = (
  { __typename?: 'ListingHeroBanner' }
  & Pick<Types.ListingHeroBanner, 'id' | 'name'>
);

export type PressReleaseBase_ListingHeroParametersTemplate_Fragment = (
  { __typename?: 'ListingHeroParametersTemplate' }
  & Pick<Types.ListingHeroParametersTemplate, 'id' | 'name'>
);

export type PressReleaseBase_LiteratureAuthorization_Fragment = (
  { __typename?: 'LiteratureAuthorization' }
  & Pick<Types.LiteratureAuthorization, 'id' | 'name'>
);

export type PressReleaseBase_LiteratureAuthorizationsFolder_Fragment = (
  { __typename?: 'LiteratureAuthorizationsFolder' }
  & Pick<Types.LiteratureAuthorizationsFolder, 'id' | 'name'>
);

export type PressReleaseBase_LiteratureHubSearchPage_Fragment = (
  { __typename?: 'LiteratureHubSearchPage' }
  & Pick<Types.LiteratureHubSearchPage, 'id' | 'name'>
);

export type PressReleaseBase_LiteratureHubSearchPage_62f4748b81db49ee9be8b674a7f42d9d_Fragment = (
  { __typename?: 'LiteratureHubSearchPage_62f4748b81db49ee9be8b674a7f42d9d' }
  & Pick<Types.LiteratureHubSearchPage_62f4748b81db49ee9be8b674a7f42d9d, 'id' | 'name'>
);

export type PressReleaseBase_LiteratureHubSearchPage_94278fe5377a4665bccbd1d4cef5e30e_Fragment = (
  { __typename?: 'LiteratureHubSearchPage_94278fe5377a4665bccbd1d4cef5e30e' }
  & Pick<Types.LiteratureHubSearchPage_94278fe5377a4665bccbd1d4cef5e30e, 'id' | 'name'>
);

export type PressReleaseBase_LiteratureHubSearchPage_D2b2958263564ba8bba5922add46a0ea_Fragment = (
  { __typename?: 'LiteratureHubSearchPage_d2b2958263564ba8bba5922add46a0ea' }
  & Pick<Types.LiteratureHubSearchPage_D2b2958263564ba8bba5922add46a0ea, 'id' | 'name'>
);

export type PressReleaseBase_LoadMore_Fragment = (
  { __typename?: 'LoadMore' }
  & Pick<Types.LoadMore, 'id' | 'name'>
);

export type PressReleaseBase_LoadMoreFolder_Fragment = (
  { __typename?: 'LoadMoreFolder' }
  & Pick<Types.LoadMoreFolder, 'id' | 'name'>
);

export type PressReleaseBase_LoadMore_7a3a53e06a0144ff8ba52be46e201fe6_Fragment = (
  { __typename?: 'LoadMore_7a3a53e06a0144ff8ba52be46e201fe6' }
  & Pick<Types.LoadMore_7a3a53e06a0144ff8ba52be46e201fe6, 'id' | 'name'>
);

export type PressReleaseBase_LocationFilter_Fragment = (
  { __typename?: 'LocationFilter' }
  & Pick<Types.LocationFilter, 'id' | 'name'>
);

export type PressReleaseBase_LocationFilterFolder_Fragment = (
  { __typename?: 'LocationFilterFolder' }
  & Pick<Types.LocationFilterFolder, 'id' | 'name'>
);

export type PressReleaseBase_LocationFilter_Aaad4aad290744dc90b69e4e83a661ec_Fragment = (
  { __typename?: 'LocationFilter_aaad4aad290744dc90b69e4e83a661ec' }
  & Pick<Types.LocationFilter_Aaad4aad290744dc90b69e4e83a661ec, 'id' | 'name'>
);

export type PressReleaseBase_Log_Fragment = (
  { __typename?: 'Log' }
  & Pick<Types.Log, 'id' | 'name'>
);

export type PressReleaseBase_Login_Fragment = (
  { __typename?: 'Login' }
  & Pick<Types.Login, 'id' | 'name'>
);

export type PressReleaseBase_Login_Abed54dc4f7840ddac562289c9c849d8_Fragment = (
  { __typename?: 'Login_abed54dc4f7840ddac562289c9c849d8' }
  & Pick<Types.Login_Abed54dc4f7840ddac562289c9c849d8, 'id' | 'name'>
);

export type PressReleaseBase_LogoTextBlockItem_Fragment = (
  { __typename?: 'LogoTextBlockItem' }
  & Pick<Types.LogoTextBlockItem, 'id' | 'name'>
);

export type PressReleaseBase_LogoTextBlocks_Fragment = (
  { __typename?: 'LogoTextBlocks' }
  & Pick<Types.LogoTextBlocks, 'id' | 'name'>
);

export type PressReleaseBase_LogoTextBlocksFolder_Fragment = (
  { __typename?: 'LogoTextBlocksFolder' }
  & Pick<Types.LogoTextBlocksFolder, 'id' | 'name'>
);

export type PressReleaseBase_Logout_Fragment = (
  { __typename?: 'Logout' }
  & Pick<Types.Logout, 'id' | 'name'>
);

export type PressReleaseBase_Logout_C2294d8235a6452a94b15eb5e543b602_Fragment = (
  { __typename?: 'Logout_c2294d8235a6452a94b15eb5e543b602' }
  & Pick<Types.Logout_C2294d8235a6452a94b15eb5e543b602, 'id' | 'name'>
);

export type PressReleaseBase_ManagedRangeFilter_Fragment = (
  { __typename?: 'ManagedRangeFilter' }
  & Pick<Types.ManagedRangeFilter, 'id' | 'name'>
);

export type PressReleaseBase_ManagedRangeFilterFolder_Fragment = (
  { __typename?: 'ManagedRangeFilterFolder' }
  & Pick<Types.ManagedRangeFilterFolder, 'id' | 'name'>
);

export type PressReleaseBase_ManagedRangeFilter_14c6033e186b49088bb925aba0da4d91_Fragment = (
  { __typename?: 'ManagedRangeFilter_14c6033e186b49088bb925aba0da4d91' }
  & Pick<Types.ManagedRangeFilter_14c6033e186b49088bb925aba0da4d91, 'id' | 'name'>
);

export type PressReleaseBase_ManagedRangeItem_Fragment = (
  { __typename?: 'ManagedRangeItem' }
  & Pick<Types.ManagedRangeItem, 'id' | 'name'>
);

export type PressReleaseBase_Map_Fragment = (
  { __typename?: 'Map' }
  & Pick<Types.Map, 'id' | 'name'>
);

export type PressReleaseBase_MapParameters_Fragment = (
  { __typename?: 'MapParameters' }
  & Pick<Types.MapParameters, 'id' | 'name'>
);

export type PressReleaseBase_MapsFolder_Fragment = (
  { __typename?: 'MapsFolder' }
  & Pick<Types.MapsFolder, 'id' | 'name'>
);

export type PressReleaseBase_MapsProvider_Fragment = (
  { __typename?: 'MapsProvider' }
  & Pick<Types.MapsProvider, 'id' | 'name'>
);

export type PressReleaseBase_MediaBlock_Fragment = (
  { __typename?: 'MediaBlock' }
  & Pick<Types.MediaBlock, 'id' | 'name'>
);

export type PressReleaseBase_MediaBlockFolder_Fragment = (
  { __typename?: 'MediaBlockFolder' }
  & Pick<Types.MediaBlockFolder, 'id' | 'name'>
);

export type PressReleaseBase_MediaBlockParametersTemplate_Fragment = (
  { __typename?: 'MediaBlockParametersTemplate' }
  & Pick<Types.MediaBlockParametersTemplate, 'id' | 'name'>
);

export type PressReleaseBase_MediaFolder_81150e5837f5443fa3c075e14a9321e7_Fragment = (
  { __typename?: 'MediaFolder_81150e5837f5443fa3c075e14a9321e7' }
  & Pick<Types.MediaFolder_81150e5837f5443fa3c075e14a9321e7, 'id' | 'name'>
);

export type PressReleaseBase_MediaLinkParameters_Fragment = (
  { __typename?: 'MediaLinkParameters' }
  & Pick<Types.MediaLinkParameters, 'id' | 'name'>
);

export type PressReleaseBase_MediaVirtualFolder_Fragment = (
  { __typename?: 'MediaVirtualFolder' }
  & Pick<Types.MediaVirtualFolder, 'id' | 'name'>
);

export type PressReleaseBase_MegaNavigation_Fragment = (
  { __typename?: 'MegaNavigation' }
  & Pick<Types.MegaNavigation, 'id' | 'name'>
);

export type PressReleaseBase_MegaNavigationFolder_Fragment = (
  { __typename?: 'MegaNavigationFolder' }
  & Pick<Types.MegaNavigationFolder, 'id' | 'name'>
);

export type PressReleaseBase_MetaBranding_Fragment = (
  { __typename?: 'MetaBranding' }
  & Pick<Types.MetaBranding, 'id' | 'name'>
);

export type PressReleaseBase_MetaRenderingParameters_Fragment = (
  { __typename?: 'MetaRenderingParameters' }
  & Pick<Types.MetaRenderingParameters, 'id' | 'name'>
);

export type PressReleaseBase_MetadataPartialDesign_Fragment = (
  { __typename?: 'MetadataPartialDesign' }
  & Pick<Types.MetadataPartialDesign, 'id' | 'name'>
);

export type PressReleaseBase_Model_Fragment = (
  { __typename?: 'Model' }
  & Pick<Types.Model, 'id' | 'name'>
);

export type PressReleaseBase_ModelIterator_Fragment = (
  { __typename?: 'ModelIterator' }
  & Pick<Types.ModelIterator, 'id' | 'name'>
);

export type PressReleaseBase_MyLocationPoi_Fragment = (
  { __typename?: 'MyLocationPOI' }
  & Pick<Types.MyLocationPoi, 'id' | 'name'>
);

export type PressReleaseBase_Navigation_Fragment = (
  { __typename?: 'Navigation' }
  & Pick<Types.Navigation, 'id' | 'name'>
);

export type PressReleaseBase_NavigationCategory_Fragment = (
  { __typename?: 'NavigationCategory' }
  & Pick<Types.NavigationCategory, 'id' | 'name'>
);

export type PressReleaseBase_NavigationFilter_Fragment = (
  { __typename?: 'NavigationFilter' }
  & Pick<Types.NavigationFilter, 'id' | 'name'>
);

export type PressReleaseBase_NavigationFilterFolder_Fragment = (
  { __typename?: 'NavigationFilterFolder' }
  & Pick<Types.NavigationFilterFolder, 'id' | 'name'>
);

export type PressReleaseBase_NavigationLink_Fragment = (
  { __typename?: 'NavigationLink' }
  & Pick<Types.NavigationLink, 'id' | 'name'>
);

export type PressReleaseBase_NavigationSubcategory_Fragment = (
  { __typename?: 'NavigationSubcategory' }
  & Pick<Types.NavigationSubcategory, 'id' | 'name'>
);

export type PressReleaseBase_Navigation_9ce34bf95c934dff841d8f649c2bd6c8_Fragment = (
  { __typename?: 'Navigation_9ce34bf95c934dff841d8f649c2bd6c8' }
  & Pick<Types.Navigation_9ce34bf95c934dff841d8f649c2bd6c8, 'id' | 'name'>
);

export type PressReleaseBase_OneTrustSettings_Fragment = (
  { __typename?: 'OneTrustSettings' }
  & Pick<Types.OneTrustSettings, 'id' | 'name'>
);

export type PressReleaseBase_OptimiserConfiguration_Fragment = (
  { __typename?: 'OptimiserConfiguration' }
  & Pick<Types.OptimiserConfiguration, 'id' | 'name'>
);

export type PressReleaseBase_OptimiserConfigurationSection_Fragment = (
  { __typename?: 'OptimiserConfigurationSection' }
  & Pick<Types.OptimiserConfigurationSection, 'id' | 'name'>
);

export type PressReleaseBase_OptimizedFile_Fragment = (
  { __typename?: 'OptimizedFile' }
  & Pick<Types.OptimizedFile, 'id' | 'name'>
);

export type PressReleaseBase_OracleCdpSettings_Fragment = (
  { __typename?: 'OracleCDPSettings' }
  & Pick<Types.OracleCdpSettings, 'id' | 'name'>
);

export type PressReleaseBase_OverlayContent_Fragment = (
  { __typename?: 'OverlayContent' }
  & Pick<Types.OverlayContent, 'id' | 'name'>
);

export type PressReleaseBase_OverlayFolderTemplate_Fragment = (
  { __typename?: 'OverlayFolderTemplate' }
  & Pick<Types.OverlayFolderTemplate, 'id' | 'name'>
);

export type PressReleaseBase_Ownership_Fragment = (
  { __typename?: 'Ownership' }
  & Pick<Types.Ownership, 'id' | 'name'>
);

export type PressReleaseBase_OwnershipFolder_Fragment = (
  { __typename?: 'OwnershipFolder' }
  & Pick<Types.OwnershipFolder, 'id' | 'name'>
);

export type PressReleaseBase_Poi_Fragment = (
  { __typename?: 'POI' }
  & Pick<Types.Poi, 'id' | 'name'>
);

export type PressReleaseBase_PoiFolder_Fragment = (
  { __typename?: 'POIFolder' }
  & Pick<Types.PoiFolder, 'id' | 'name'>
);

export type PressReleaseBase_PoiType_Fragment = (
  { __typename?: 'POIType' }
  & Pick<Types.PoiType, 'id' | 'name'>
);

export type PressReleaseBase_PoIs_Fragment = (
  { __typename?: 'POIs' }
  & Pick<Types.PoIs, 'id' | 'name'>
);

export type PressReleaseBase_PageBranchesFolder_Fragment = (
  { __typename?: 'PageBranchesFolder' }
  & Pick<Types.PageBranchesFolder, 'id' | 'name'>
);

export type PressReleaseBase_PageContent_Fragment = (
  { __typename?: 'PageContent' }
  & Pick<Types.PageContent, 'id' | 'name'>
);

export type PressReleaseBase_PageContentFolder_Fragment = (
  { __typename?: 'PageContentFolder' }
  & Pick<Types.PageContentFolder, 'id' | 'name'>
);

export type PressReleaseBase_PageContent_Ef87e73bc7ff49a2ac599b0be83755c3_Fragment = (
  { __typename?: 'PageContent_ef87e73bc7ff49a2ac599b0be83755c3' }
  & Pick<Types.PageContent_Ef87e73bc7ff49a2ac599b0be83755c3, 'id' | 'name'>
);

export type PressReleaseBase_PageDesign_Fragment = (
  { __typename?: 'PageDesign' }
  & Pick<Types.PageDesign, 'id' | 'name'>
);

export type PressReleaseBase_PageDesignFolder_1aa9bc8250a94e4eb15003b55b4dfed0_Fragment = (
  { __typename?: 'PageDesignFolder_1aa9bc8250a94e4eb15003b55b4dfed0' }
  & Pick<Types.PageDesignFolder_1aa9bc8250a94e4eb15003b55b4dfed0, 'id' | 'name'>
);

export type PressReleaseBase_PageDesignFolder_27d4f8be63b045769a4ef3163c935b47_Fragment = (
  { __typename?: 'PageDesignFolder_27d4f8be63b045769a4ef3163c935b47' }
  & Pick<Types.PageDesignFolder_27d4f8be63b045769a4ef3163c935b47, 'id' | 'name'>
);

export type PressReleaseBase_PageDesignFolder_352ce40ee6e1457a8bf225d8771894e8_Fragment = (
  { __typename?: 'PageDesignFolder_352ce40ee6e1457a8bf225d8771894e8' }
  & Pick<Types.PageDesignFolder_352ce40ee6e1457a8bf225d8771894e8, 'id' | 'name'>
);

export type PressReleaseBase_PageDesignFolder_446a7eadeb894ed6b48c7f1862f29d7b_Fragment = (
  { __typename?: 'PageDesignFolder_446a7eadeb894ed6b48c7f1862f29d7b' }
  & Pick<Types.PageDesignFolder_446a7eadeb894ed6b48c7f1862f29d7b, 'id' | 'name'>
);

export type PressReleaseBase_PageDesignFolder_720d01f11e5046fa9c4a697f9321f662_Fragment = (
  { __typename?: 'PageDesignFolder_720d01f11e5046fa9c4a697f9321f662' }
  & Pick<Types.PageDesignFolder_720d01f11e5046fa9c4a697f9321f662, 'id' | 'name'>
);

export type PressReleaseBase_PageDesignFolder_771a0de7e83f44338c5d78727ead93bc_Fragment = (
  { __typename?: 'PageDesignFolder_771a0de7e83f44338c5d78727ead93bc' }
  & Pick<Types.PageDesignFolder_771a0de7e83f44338c5d78727ead93bc, 'id' | 'name'>
);

export type PressReleaseBase_PageDesignFolder_14161ec204984aa7a2a46decadf669f5_Fragment = (
  { __typename?: 'PageDesignFolder_14161ec204984aa7a2a46decadf669f5' }
  & Pick<Types.PageDesignFolder_14161ec204984aa7a2a46decadf669f5, 'id' | 'name'>
);

export type PressReleaseBase_PageDesignFolder_C691c2c4e0dd4fedb84a3c29de7002cb_Fragment = (
  { __typename?: 'PageDesignFolder_c691c2c4e0dd4fedb84a3c29de7002cb' }
  & Pick<Types.PageDesignFolder_C691c2c4e0dd4fedb84a3c29de7002cb, 'id' | 'name'>
);

export type PressReleaseBase_PageDesignFolder_D84605f786ea482da6ff683f6572821c_Fragment = (
  { __typename?: 'PageDesignFolder_d84605f786ea482da6ff683f6572821c' }
  & Pick<Types.PageDesignFolder_D84605f786ea482da6ff683f6572821c, 'id' | 'name'>
);

export type PressReleaseBase_PageDesign_1105b8f81e00426bbf1fc840742d827b_Fragment = (
  { __typename?: 'PageDesign_1105b8f81e00426bbf1fc840742d827b' }
  & Pick<Types.PageDesign_1105b8f81e00426bbf1fc840742d827b, 'id' | 'name'>
);

export type PressReleaseBase_PageDesigns_Fragment = (
  { __typename?: 'PageDesigns' }
  & Pick<Types.PageDesigns, 'id' | 'name'>
);

export type PressReleaseBase_PageDesigns_3af52e70e982424b9c85e355542500c9_Fragment = (
  { __typename?: 'PageDesigns_3af52e70e982424b9c85e355542500c9' }
  & Pick<Types.PageDesigns_3af52e70e982424b9c85e355542500c9, 'id' | 'name'>
);

export type PressReleaseBase_PageDesigns_9b34083e890b467d8e76b8c3dbbb712d_Fragment = (
  { __typename?: 'PageDesigns_9b34083e890b467d8e76b8c3dbbb712d' }
  & Pick<Types.PageDesigns_9b34083e890b467d8e76b8c3dbbb712d, 'id' | 'name'>
);

export type PressReleaseBase_PageDesigns_48d2d50a150c4f6283603a4fed5646e0_Fragment = (
  { __typename?: 'PageDesigns_48d2d50a150c4f6283603a4fed5646e0' }
  & Pick<Types.PageDesigns_48d2d50a150c4f6283603a4fed5646e0, 'id' | 'name'>
);

export type PressReleaseBase_PageDesigns_99a71bba507746729c3fb29b04abee23_Fragment = (
  { __typename?: 'PageDesigns_99a71bba507746729c3fb29b04abee23' }
  & Pick<Types.PageDesigns_99a71bba507746729c3fb29b04abee23, 'id' | 'name'>
);

export type PressReleaseBase_PageDesigns_A0f265b42d6241968b65d3ede7cb59c3_Fragment = (
  { __typename?: 'PageDesigns_a0f265b42d6241968b65d3ede7cb59c3' }
  & Pick<Types.PageDesigns_A0f265b42d6241968b65d3ede7cb59c3, 'id' | 'name'>
);

export type PressReleaseBase_PageDesigns_Abe5ce6a82ff4433b4973bc50f192e11_Fragment = (
  { __typename?: 'PageDesigns_abe5ce6a82ff4433b4973bc50f192e11' }
  & Pick<Types.PageDesigns_Abe5ce6a82ff4433b4973bc50f192e11, 'id' | 'name'>
);

export type PressReleaseBase_PageDesigns_B8d9b352c1694b31bd506848b47ca884_Fragment = (
  { __typename?: 'PageDesigns_b8d9b352c1694b31bd506848b47ca884' }
  & Pick<Types.PageDesigns_B8d9b352c1694b31bd506848b47ca884, 'id' | 'name'>
);

export type PressReleaseBase_PageDesigns_D3b2e1466f744df0900bec314f699ef3_Fragment = (
  { __typename?: 'PageDesigns_d3b2e1466f744df0900bec314f699ef3' }
  & Pick<Types.PageDesigns_D3b2e1466f744df0900bec314f699ef3, 'id' | 'name'>
);

export type PressReleaseBase_PageDesigns_Fd4b9b54f7474f01abdeba569d4b5bbe_Fragment = (
  { __typename?: 'PageDesigns_fd4b9b54f7474f01abdeba569d4b5bbe' }
  & Pick<Types.PageDesigns_Fd4b9b54f7474f01abdeba569d4b5bbe, 'id' | 'name'>
);

export type PressReleaseBase_PageLevelTabs_Fragment = (
  { __typename?: 'PageLevelTabs' }
  & Pick<Types.PageLevelTabs, 'id' | 'name'>
);

export type PressReleaseBase_PageLevelTabsFolder_Fragment = (
  { __typename?: 'PageLevelTabsFolder' }
  & Pick<Types.PageLevelTabsFolder, 'id' | 'name'>
);

export type PressReleaseBase_PageList_Fragment = (
  { __typename?: 'PageList' }
  & Pick<Types.PageList, 'id' | 'name'>
);

export type PressReleaseBase_PageSelector_Fragment = (
  { __typename?: 'PageSelector' }
  & Pick<Types.PageSelector, 'id' | 'name'>
);

export type PressReleaseBase_PageSelectorConfiguration_Fragment = (
  { __typename?: 'PageSelectorConfiguration' }
  & Pick<Types.PageSelectorConfiguration, 'id' | 'name'>
);

export type PressReleaseBase_PageSelectorFolder_Fragment = (
  { __typename?: 'PageSelectorFolder' }
  & Pick<Types.PageSelectorFolder, 'id' | 'name'>
);

export type PressReleaseBase_PageSelector_59a7bb775f8c435ab810291abde80e63_Fragment = (
  { __typename?: 'PageSelector_59a7bb775f8c435ab810291abde80e63' }
  & Pick<Types.PageSelector_59a7bb775f8c435ab810291abde80e63, 'id' | 'name'>
);

export type PressReleaseBase_PageSize_Fragment = (
  { __typename?: 'PageSize' }
  & Pick<Types.PageSize, 'id' | 'name'>
);

export type PressReleaseBase_PageSizeFolder_Fragment = (
  { __typename?: 'PageSizeFolder' }
  & Pick<Types.PageSizeFolder, 'id' | 'name'>
);

export type PressReleaseBase_PageSize_B682562e0af64b3e9e3b45273bbe152d_Fragment = (
  { __typename?: 'PageSize_b682562e0af64b3e9e3b45273bbe152d' }
  & Pick<Types.PageSize_B682562e0af64b3e9e3b45273bbe152d, 'id' | 'name'>
);

export type PressReleaseBase_PageTheme_Fragment = (
  { __typename?: 'PageTheme' }
  & Pick<Types.PageTheme, 'id' | 'name'>
);

export type PressReleaseBase_PageThemesFolder_Fragment = (
  { __typename?: 'PageThemesFolder' }
  & Pick<Types.PageThemesFolder, 'id' | 'name'>
);

export type PressReleaseBase_Page_4f49a81db3664f198b89cab92f377d7a_Fragment = (
  { __typename?: 'Page_4f49a81db3664f198b89cab92f377d7a' }
  & Pick<Types.Page_4f49a81db3664f198b89cab92f377d7a, 'id' | 'name'>
);

export type PressReleaseBase_Page_5e66d86353544fe6a27d3b894984d50f_Fragment = (
  { __typename?: 'Page_5e66d86353544fe6a27d3b894984d50f' }
  & Pick<Types.Page_5e66d86353544fe6a27d3b894984d50f, 'id' | 'name'>
);

export type PressReleaseBase_Page_84f342ad2d0646b9aa9a818201145ca2_Fragment = (
  { __typename?: 'Page_84f342ad2d0646b9aa9a818201145ca2' }
  & Pick<Types.Page_84f342ad2d0646b9aa9a818201145ca2, 'id' | 'name'>
);

export type PressReleaseBase_Page_718df200be51463d93edf4d77ab7a49e_Fragment = (
  { __typename?: 'Page_718df200be51463d93edf4d77ab7a49e' }
  & Pick<Types.Page_718df200be51463d93edf4d77ab7a49e, 'id' | 'name'>
);

export type PressReleaseBase_Page_B61d5babe46f4ef39f27b57c4ccefdf7_Fragment = (
  { __typename?: 'Page_b61d5babe46f4ef39f27b57c4ccefdf7' }
  & Pick<Types.Page_B61d5babe46f4ef39f27b57c4ccefdf7, 'id' | 'name'>
);

export type PressReleaseBase_Page_Cfd6e04697e24f3cb9eb41b79afc35dc_Fragment = (
  { __typename?: 'Page_cfd6e04697e24f3cb9eb41b79afc35dc' }
  & Pick<Types.Page_Cfd6e04697e24f3cb9eb41b79afc35dc, 'id' | 'name'>
);

export type PressReleaseBase_Page_Dae7821153e14dbabb0ddf0b53a90aaf_Fragment = (
  { __typename?: 'Page_dae7821153e14dbabb0ddf0b53a90aaf' }
  & Pick<Types.Page_Dae7821153e14dbabb0ddf0b53a90aaf, 'id' | 'name'>
);

export type PressReleaseBase_Page_Fa608b3e6aeb426388a059d89caabada_Fragment = (
  { __typename?: 'Page_fa608b3e6aeb426388a059d89caabada' }
  & Pick<Types.Page_Fa608b3e6aeb426388a059d89caabada, 'id' | 'name'>
);

export type PressReleaseBase_Pagging_Fragment = (
  { __typename?: 'Pagging' }
  & Pick<Types.Pagging, 'id' | 'name'>
);

export type PressReleaseBase_Pagination_Fragment = (
  { __typename?: 'Pagination' }
  & Pick<Types.Pagination, 'id' | 'name'>
);

export type PressReleaseBase_PaginationFolder_Fragment = (
  { __typename?: 'PaginationFolder' }
  & Pick<Types.PaginationFolder, 'id' | 'name'>
);

export type PressReleaseBase_Paragraph_Fragment = (
  { __typename?: 'Paragraph' }
  & Pick<Types.Paragraph, 'id' | 'name'>
);

export type PressReleaseBase_PartialDesignFolder_8cf20a4412b746ee801218122c955b2d_Fragment = (
  { __typename?: 'PartialDesignFolder_8cf20a4412b746ee801218122c955b2d' }
  & Pick<Types.PartialDesignFolder_8cf20a4412b746ee801218122c955b2d, 'id' | 'name'>
);

export type PressReleaseBase_PartialDesignFolder_42eb57ecaa474923b3ddbfb72818f00b_Fragment = (
  { __typename?: 'PartialDesignFolder_42eb57ecaa474923b3ddbfb72818f00b' }
  & Pick<Types.PartialDesignFolder_42eb57ecaa474923b3ddbfb72818f00b, 'id' | 'name'>
);

export type PressReleaseBase_PartialDesignFolder_766d4de859a0419292de1898fe0ac4e8_Fragment = (
  { __typename?: 'PartialDesignFolder_766d4de859a0419292de1898fe0ac4e8' }
  & Pick<Types.PartialDesignFolder_766d4de859a0419292de1898fe0ac4e8, 'id' | 'name'>
);

export type PressReleaseBase_PartialDesignFolder_827d4d2f2a84408e8f0ff1d6869a441b_Fragment = (
  { __typename?: 'PartialDesignFolder_827d4d2f2a84408e8f0ff1d6869a441b' }
  & Pick<Types.PartialDesignFolder_827d4d2f2a84408e8f0ff1d6869a441b, 'id' | 'name'>
);

export type PressReleaseBase_PartialDesignFolder_828b5ff144cd4150bcdfe54084165112_Fragment = (
  { __typename?: 'PartialDesignFolder_828b5ff144cd4150bcdfe54084165112' }
  & Pick<Types.PartialDesignFolder_828b5ff144cd4150bcdfe54084165112, 'id' | 'name'>
);

export type PressReleaseBase_PartialDesignFolder_89098e3089aa4062a77346d608caac90_Fragment = (
  { __typename?: 'PartialDesignFolder_89098e3089aa4062a77346d608caac90' }
  & Pick<Types.PartialDesignFolder_89098e3089aa4062a77346d608caac90, 'id' | 'name'>
);

export type PressReleaseBase_PartialDesignFolder_1695576fb93647d7842ed17730278c32_Fragment = (
  { __typename?: 'PartialDesignFolder_1695576fb93647d7842ed17730278c32' }
  & Pick<Types.PartialDesignFolder_1695576fb93647d7842ed17730278c32, 'id' | 'name'>
);

export type PressReleaseBase_PartialDesignFolder_F16ae56fb78845639407c88edaffcbcc_Fragment = (
  { __typename?: 'PartialDesignFolder_f16ae56fb78845639407c88edaffcbcc' }
  & Pick<Types.PartialDesignFolder_F16ae56fb78845639407c88edaffcbcc, 'id' | 'name'>
);

export type PressReleaseBase_PartialDesignFolder_Fb58558a3ec946d18524cd30805ab21a_Fragment = (
  { __typename?: 'PartialDesignFolder_fb58558a3ec946d18524cd30805ab21a' }
  & Pick<Types.PartialDesignFolder_Fb58558a3ec946d18524cd30805ab21a, 'id' | 'name'>
);

export type PressReleaseBase_PartialDesign_Fd2059fd60434dfe8c04e2437ce87634_Fragment = (
  { __typename?: 'PartialDesign_fd2059fd60434dfe8c04e2437ce87634' }
  & Pick<Types.PartialDesign_Fd2059fd60434dfe8c04e2437ce87634, 'id' | 'name'>
);

export type PressReleaseBase_PartialDesigns_Fragment = (
  { __typename?: 'PartialDesigns' }
  & Pick<Types.PartialDesigns, 'id' | 'name'>
);

export type PressReleaseBase_PartialDesigns_043d3ad0ac4445dba03afc3550d088ec_Fragment = (
  { __typename?: 'PartialDesigns_043d3ad0ac4445dba03afc3550d088ec' }
  & Pick<Types.PartialDesigns_043d3ad0ac4445dba03afc3550d088ec, 'id' | 'name'>
);

export type PressReleaseBase_PartialDesigns_0310a4bf20d1441c886a0418c53e30f4_Fragment = (
  { __typename?: 'PartialDesigns_0310a4bf20d1441c886a0418c53e30f4' }
  & Pick<Types.PartialDesigns_0310a4bf20d1441c886a0418c53e30f4, 'id' | 'name'>
);

export type PressReleaseBase_PartialDesigns_36c869ded22040929ce829f6ed643c66_Fragment = (
  { __typename?: 'PartialDesigns_36c869ded22040929ce829f6ed643c66' }
  & Pick<Types.PartialDesigns_36c869ded22040929ce829f6ed643c66, 'id' | 'name'>
);

export type PressReleaseBase_PartialDesigns_1943dc73710a430895515a342c84b037_Fragment = (
  { __typename?: 'PartialDesigns_1943dc73710a430895515a342c84b037' }
  & Pick<Types.PartialDesigns_1943dc73710a430895515a342c84b037, 'id' | 'name'>
);

export type PressReleaseBase_PartialDesigns_B1e2a6790a1442d8bafa66317b8be117_Fragment = (
  { __typename?: 'PartialDesigns_b1e2a6790a1442d8bafa66317b8be117' }
  & Pick<Types.PartialDesigns_B1e2a6790a1442d8bafa66317b8be117, 'id' | 'name'>
);

export type PressReleaseBase_PartialDesigns_Cc6d8635f3e2440ab8ebb93dc1030e9e_Fragment = (
  { __typename?: 'PartialDesigns_cc6d8635f3e2440ab8ebb93dc1030e9e' }
  & Pick<Types.PartialDesigns_Cc6d8635f3e2440ab8ebb93dc1030e9e, 'id' | 'name'>
);

export type PressReleaseBase_PartialDesigns_D52704ed3b704a53abb4292105f687ad_Fragment = (
  { __typename?: 'PartialDesigns_d52704ed3b704a53abb4292105f687ad' }
  & Pick<Types.PartialDesigns_D52704ed3b704a53abb4292105f687ad, 'id' | 'name'>
);

export type PressReleaseBase_PartialDesigns_D216303f58d8425688da8cd30d00afab_Fragment = (
  { __typename?: 'PartialDesigns_d216303f58d8425688da8cd30d00afab' }
  & Pick<Types.PartialDesigns_D216303f58d8425688da8cd30d00afab, 'id' | 'name'>
);

export type PressReleaseBase_PartialDesigns_Facda26791204fa9a0363344348f2c42_Fragment = (
  { __typename?: 'PartialDesigns_facda26791204fa9a0363344348f2c42' }
  & Pick<Types.PartialDesigns_Facda26791204fa9a0363344348f2c42, 'id' | 'name'>
);

export type PressReleaseBase_PerformanceChartSettings_Fragment = (
  { __typename?: 'PerformanceChartSettings' }
  & Pick<Types.PerformanceChartSettings, 'id' | 'name'>
);

export type PressReleaseBase_PerformanceChartTimePeriod_Fragment = (
  { __typename?: 'PerformanceChartTimePeriod' }
  & Pick<Types.PerformanceChartTimePeriod, 'id' | 'name'>
);

export type PressReleaseBase_PerformanceChartTimePeriodFolder_Fragment = (
  { __typename?: 'PerformanceChartTimePeriodFolder' }
  & Pick<Types.PerformanceChartTimePeriodFolder, 'id' | 'name'>
);

export type PressReleaseBase_PlaceholderSettingsFolder_0339bac078c143c1b930f8c26a5fdf80_Fragment = (
  { __typename?: 'PlaceholderSettingsFolder_0339bac078c143c1b930f8c26a5fdf80' }
  & Pick<Types.PlaceholderSettingsFolder_0339bac078c143c1b930f8c26a5fdf80, 'id' | 'name'>
);

export type PressReleaseBase_PlaceholderSettingsFolder_3d281bf8533646869dd6ab4ab5b3fd5d_Fragment = (
  { __typename?: 'PlaceholderSettingsFolder_3d281bf8533646869dd6ab4ab5b3fd5d' }
  & Pick<Types.PlaceholderSettingsFolder_3d281bf8533646869dd6ab4ab5b3fd5d, 'id' | 'name'>
);

export type PressReleaseBase_PlaceholderSettingsFolder_52288e3978304694b62d32a54c6ef7ba_Fragment = (
  { __typename?: 'PlaceholderSettingsFolder_52288e3978304694b62d32a54c6ef7ba' }
  & Pick<Types.PlaceholderSettingsFolder_52288e3978304694b62d32a54c6ef7ba, 'id' | 'name'>
);

export type PressReleaseBase_Placeholder_1ca0304be5b64810821154426f1752c2_Fragment = (
  { __typename?: 'Placeholder_1ca0304be5b64810821154426f1752c2' }
  & Pick<Types.Placeholder_1ca0304be5b64810821154426f1752c2, 'id' | 'name'>
);

export type PressReleaseBase_Placeholder_D2a6884c04d54089a64ed27ca9d68d4c_Fragment = (
  { __typename?: 'Placeholder_d2a6884c04d54089a64ed27ca9d68d4c' }
  & Pick<Types.Placeholder_D2a6884c04d54089a64ed27ca9d68d4c, 'id' | 'name'>
);

export type PressReleaseBase_PlainHtmlParametersTemplate_Fragment = (
  { __typename?: 'PlainHtmlParametersTemplate' }
  & Pick<Types.PlainHtmlParametersTemplate, 'id' | 'name'>
);

export type PressReleaseBase_Playlist_Fragment = (
  { __typename?: 'Playlist' }
  & Pick<Types.Playlist, 'id' | 'name'>
);

export type PressReleaseBase_PlaylistFolder_Fragment = (
  { __typename?: 'PlaylistFolder' }
  & Pick<Types.PlaylistFolder, 'id' | 'name'>
);

export type PressReleaseBase_PlaylistParametersTemplate_Fragment = (
  { __typename?: 'PlaylistParametersTemplate' }
  & Pick<Types.PlaylistParametersTemplate, 'id' | 'name'>
);

export type PressReleaseBase_Podcast_Fragment = (
  { __typename?: 'Podcast' }
  & Pick<Types.Podcast, 'id' | 'name'>
);

export type PressReleaseBase_PodcastFolder_Fragment = (
  { __typename?: 'PodcastFolder' }
  & Pick<Types.PodcastFolder, 'id' | 'name'>
);

export type PressReleaseBase_PodcastPage_Fragment = (
  { __typename?: 'PodcastPage' }
  & Pick<Types.PodcastPage, 'id' | 'name'>
);

export type PressReleaseBase_PodcastPressReleasePage_Fragment = (
  { __typename?: 'PodcastPressReleasePage' }
  & Pick<Types.PodcastPressReleasePage, 'id' | 'name'>
);

export type PressReleaseBase_PoiTypes_Fragment = (
  { __typename?: 'PoiTypes' }
  & Pick<Types.PoiTypes, 'id' | 'name'>
);

export type PressReleaseBase_PostDeleteStep_Fragment = (
  { __typename?: 'PostDeleteStep' }
  & Pick<Types.PostDeleteStep, 'id' | 'name'>
);

export type PressReleaseBase_PostDeleteStep_7a7e57b99c6d4a22b5fdf7b214dde574_Fragment = (
  { __typename?: 'PostDeleteStep_7a7e57b99c6d4a22b5fdf7b214dde574' }
  & Pick<Types.PostDeleteStep_7a7e57b99c6d4a22b5fdf7b214dde574, 'id' | 'name'>
);

export type PressReleaseBase_PostDeleteStep_78d6ec9b66e34763987003cf314ee37a_Fragment = (
  { __typename?: 'PostDeleteStep_78d6ec9b66e34763987003cf314ee37a' }
  & Pick<Types.PostDeleteStep_78d6ec9b66e34763987003cf314ee37a, 'id' | 'name'>
);

export type PressReleaseBase_PostDeleteStep_B20857895385413883f096f3767cb156_Fragment = (
  { __typename?: 'PostDeleteStep_b20857895385413883f096f3767cb156' }
  & Pick<Types.PostDeleteStep_B20857895385413883f096f3767cb156, 'id' | 'name'>
);

export type PressReleaseBase_PostSetupStep_Fragment = (
  { __typename?: 'PostSetupStep' }
  & Pick<Types.PostSetupStep, 'id' | 'name'>
);

export type PressReleaseBase_PostSetupStep_6fac654e22154a419a1d59197bebc0fe_Fragment = (
  { __typename?: 'PostSetupStep_6fac654e22154a419a1d59197bebc0fe' }
  & Pick<Types.PostSetupStep_6fac654e22154a419a1d59197bebc0fe, 'id' | 'name'>
);

export type PressReleaseBase_PostSetupStep_8ff2febff6d2461d9ed38b0cb5d9d86f_Fragment = (
  { __typename?: 'PostSetupStep_8ff2febff6d2461d9ed38b0cb5d9d86f' }
  & Pick<Types.PostSetupStep_8ff2febff6d2461d9ed38b0cb5d9d86f, 'id' | 'name'>
);

export type PressReleaseBase_PostSetupStep_341738aa44fe490e90ff7010a3c2463b_Fragment = (
  { __typename?: 'PostSetupStep_341738aa44fe490e90ff7010a3c2463b' }
  & Pick<Types.PostSetupStep_341738aa44fe490e90ff7010a3c2463b, 'id' | 'name'>
);

export type PressReleaseBase_PreDeleteStep_Fragment = (
  { __typename?: 'PreDeleteStep' }
  & Pick<Types.PreDeleteStep, 'id' | 'name'>
);

export type PressReleaseBase_PreDeleteStep_51437c06212c4c0fb3b2fa5b0486ab49_Fragment = (
  { __typename?: 'PreDeleteStep_51437c06212c4c0fb3b2fa5b0486ab49' }
  & Pick<Types.PreDeleteStep_51437c06212c4c0fb3b2fa5b0486ab49, 'id' | 'name'>
);

export type PressReleaseBase_PreDeleteStep_52510f549ec5464cb075ef44b5c2f96b_Fragment = (
  { __typename?: 'PreDeleteStep_52510f549ec5464cb075ef44b5c2f96b' }
  & Pick<Types.PreDeleteStep_52510f549ec5464cb075ef44b5c2f96b, 'id' | 'name'>
);

export type PressReleaseBase_PreDeleteStep_F0daf401190f45468bda8568d08e161d_Fragment = (
  { __typename?: 'PreDeleteStep_f0daf401190f45468bda8568d08e161d' }
  & Pick<Types.PreDeleteStep_F0daf401190f45468bda8568d08e161d, 'id' | 'name'>
);

export type PressReleaseBase_PreDeleteValidationStep_Fragment = (
  { __typename?: 'PreDeleteValidationStep' }
  & Pick<Types.PreDeleteValidationStep, 'id' | 'name'>
);

export type PressReleaseBase_PreDeleteValidationStep_408fd8ab1667440ba6051370ddf0a51f_Fragment = (
  { __typename?: 'PreDeleteValidationStep_408fd8ab1667440ba6051370ddf0a51f' }
  & Pick<Types.PreDeleteValidationStep_408fd8ab1667440ba6051370ddf0a51f, 'id' | 'name'>
);

export type PressReleaseBase_PreDeleteValidationStep_Edf1fa4206c44703ab1af23495bc6d8f_Fragment = (
  { __typename?: 'PreDeleteValidationStep_edf1fa4206c44703ab1af23495bc6d8f' }
  & Pick<Types.PreDeleteValidationStep_Edf1fa4206c44703ab1af23495bc6d8f, 'id' | 'name'>
);

export type PressReleaseBase_PreDeleteValidationStep_F8c52120d0ea4d009de3b49fe12a3f1e_Fragment = (
  { __typename?: 'PreDeleteValidationStep_f8c52120d0ea4d009de3b49fe12a3f1e' }
  & Pick<Types.PreDeleteValidationStep_F8c52120d0ea4d009de3b49fe12a3f1e, 'id' | 'name'>
);

export type PressReleaseBase_Presentation_Fragment = (
  { __typename?: 'Presentation' }
  & Pick<Types.Presentation, 'id' | 'name'>
);

export type PressReleaseBase_Presentation_0a70fa7389234a6eabf34134f25f3221_Fragment = (
  { __typename?: 'Presentation_0a70fa7389234a6eabf34134f25f3221' }
  & Pick<Types.Presentation_0a70fa7389234a6eabf34134f25f3221, 'id' | 'name'>
);

export type PressReleaseBase_PressReleaseContentType_Fragment = (
  { __typename?: 'PressReleaseContentType' }
  & Pick<Types.PressReleaseContentType, 'id' | 'name'>
);

export type PressReleaseBase_PressReleaseContentTypesFolder_Fragment = (
  { __typename?: 'PressReleaseContentTypesFolder' }
  & Pick<Types.PressReleaseContentTypesFolder, 'id' | 'name'>
);

export type PressReleaseBase_PressReleaseFilter_Fragment = (
  { __typename?: 'PressReleaseFilter' }
  & Pick<Types.PressReleaseFilter, 'id' | 'name'>
);

export type PressReleaseBase_PressReleasePage_Fragment = (
  { __typename?: 'PressReleasePage' }
  & Pick<Types.PressReleasePage, 'id' | 'name'>
);

export type PressReleaseBase_PressReleasePlatform_Fragment = (
  { __typename?: 'PressReleasePlatform' }
  & Pick<Types.PressReleasePlatform, 'id' | 'name'>
);

export type PressReleaseBase_PressReleasePlatformsFolder_Fragment = (
  { __typename?: 'PressReleasePlatformsFolder' }
  & Pick<Types.PressReleasePlatformsFolder, 'id' | 'name'>
);

export type PressReleaseBase_PressReleaseSearchPage_Fragment = (
  { __typename?: 'PressReleaseSearchPage' }
  & Pick<Types.PressReleaseSearchPage, 'id' | 'name'>
);

export type PressReleaseBase_PressReleaseSearchPage_1b2f7a53709a4c62b381dae5f1280b7f_Fragment = (
  { __typename?: 'PressReleaseSearchPage_1b2f7a53709a4c62b381dae5f1280b7f' }
  & Pick<Types.PressReleaseSearchPage_1b2f7a53709a4c62b381dae5f1280b7f, 'id' | 'name'>
);

export type PressReleaseBase_PressReleaseSearchPage_A6c344ca7c6946009de2ca92e27d7b72_Fragment = (
  { __typename?: 'PressReleaseSearchPage_a6c344ca7c6946009de2ca92e27d7b72' }
  & Pick<Types.PressReleaseSearchPage_A6c344ca7c6946009de2ca92e27d7b72, 'id' | 'name'>
);

export type PressReleaseBase_PressReleaseSearchPage_B9cd16f585ea4405a1ceda10cb20f64d_Fragment = (
  { __typename?: 'PressReleaseSearchPage_b9cd16f585ea4405a1ceda10cb20f64d' }
  & Pick<Types.PressReleaseSearchPage_B9cd16f585ea4405a1ceda10cb20f64d, 'id' | 'name'>
);

export type PressReleaseBase_PressReleaseSearchPage_C97027442df647cf9c36eedfc6787f58_Fragment = (
  { __typename?: 'PressReleaseSearchPage_c97027442df647cf9c36eedfc6787f58' }
  & Pick<Types.PressReleaseSearchPage_C97027442df647cf9c36eedfc6787f58, 'id' | 'name'>
);

export type PressReleaseBase_PressReleaseWildcardPage_Fragment = (
  { __typename?: 'PressReleaseWildcardPage' }
  & Pick<Types.PressReleaseWildcardPage, 'id' | 'name'>
);

export type PressReleaseBase_PressReleaseWildcardPage_2c028bdb02874051b629a7b7d422cc1e_Fragment = (
  { __typename?: 'PressReleaseWildcardPage_2c028bdb02874051b629a7b7d422cc1e' }
  & Pick<Types.PressReleaseWildcardPage_2c028bdb02874051b629a7b7d422cc1e, 'id' | 'name'>
);

export type PressReleaseBase_PressReleaseWildcardPage_5a72be834c654d70a591cef7e9ce9d79_Fragment = (
  { __typename?: 'PressReleaseWildcardPage_5a72be834c654d70a591cef7e9ce9d79' }
  & Pick<Types.PressReleaseWildcardPage_5a72be834c654d70a591cef7e9ce9d79, 'id' | 'name'>
);

export type PressReleaseBase_PressReleaseWildcardPage_B337d30403c642d2b9757e23d08223a1_Fragment = (
  { __typename?: 'PressReleaseWildcardPage_b337d30403c642d2b9757e23d08223a1' }
  & Pick<Types.PressReleaseWildcardPage_B337d30403c642d2b9757e23d08223a1, 'id' | 'name'>
);

export type PressReleaseBase_PressReleaseWildcardPage_E55e9d5bf9614e30b0a2a90327428258_Fragment = (
  { __typename?: 'PressReleaseWildcardPage_e55e9d5bf9614e30b0a2a90327428258' }
  & Pick<Types.PressReleaseWildcardPage_E55e9d5bf9614e30b0a2a90327428258, 'id' | 'name'>
);

export type PressReleaseBase_PressReleasesGroupFolder_Fragment = (
  { __typename?: 'PressReleasesGroupFolder' }
  & Pick<Types.PressReleasesGroupFolder, 'id' | 'name'>
);

export type PressReleaseBase_PrivacyWarning_Fragment = (
  { __typename?: 'PrivacyWarning' }
  & Pick<Types.PrivacyWarning, 'id' | 'name'>
);

export type PressReleaseBase_ProjectFolder_Fragment = (
  { __typename?: 'ProjectFolder' }
  & Pick<Types.ProjectFolder, 'id' | 'name'>
);

export type PressReleaseBase_Promo_Fragment = (
  { __typename?: 'Promo' }
  & Pick<Types.Promo, 'id' | 'name'>
);

export type PressReleaseBase_PromoFolder_Fragment = (
  { __typename?: 'PromoFolder' }
  & Pick<Types.PromoFolder, 'id' | 'name'>
);

export type PressReleaseBase_PromoFolder_F07cbe8973ae4de692172570260cac6e_Fragment = (
  { __typename?: 'PromoFolder_f07cbe8973ae4de692172570260cac6e' }
  & Pick<Types.PromoFolder_F07cbe8973ae4de692172570260cac6e, 'id' | 'name'>
);

export type PressReleaseBase_Promo_7f21f14d096b4f27bbccf115c6e6f6f1_Fragment = (
  { __typename?: 'Promo_7f21f14d096b4f27bbccf115c6e6f6f1' }
  & Pick<Types.Promo_7f21f14d096b4f27bbccf115c6e6f6f1, 'id' | 'name'>
);

export type PressReleaseBase_Promo_881869ca7f5845ea8b34ad1bfd3551a8_Fragment = (
  { __typename?: 'Promo_881869ca7f5845ea8b34ad1bfd3551a8' }
  & Pick<Types.Promo_881869ca7f5845ea8b34ad1bfd3551a8, 'id' | 'name'>
);

export type PressReleaseBase_Promo_Dfed4457d760457abec1c0dccdc44381_Fragment = (
  { __typename?: 'Promo_dfed4457d760457abec1c0dccdc44381' }
  & Pick<Types.Promo_Dfed4457d760457abec1c0dccdc44381, 'id' | 'name'>
);

export type PressReleaseBase_PromotedContent_Fragment = (
  { __typename?: 'PromotedContent' }
  & Pick<Types.PromotedContent, 'id' | 'name'>
);

export type PressReleaseBase_PromotedContentFolder_Fragment = (
  { __typename?: 'PromotedContentFolder' }
  & Pick<Types.PromotedContentFolder, 'id' | 'name'>
);

export type PressReleaseBase_PropertyListingCard_Fragment = (
  { __typename?: 'PropertyListingCard' }
  & Pick<Types.PropertyListingCard, 'id' | 'name'>
);

export type PressReleaseBase_PropertyListingCards_Fragment = (
  { __typename?: 'PropertyListingCards' }
  & Pick<Types.PropertyListingCards, 'id' | 'name'>
);

export type PressReleaseBase_PropertyListingCategory_Fragment = (
  { __typename?: 'PropertyListingCategory' }
  & Pick<Types.PropertyListingCategory, 'id' | 'name'>
);

export type PressReleaseBase_PropertyListingFolder_Fragment = (
  { __typename?: 'PropertyListingFolder' }
  & Pick<Types.PropertyListingFolder, 'id' | 'name'>
);

export type PressReleaseBase_Query_98b413525a4b4067b92418a4b50f0a53_Fragment = (
  { __typename?: 'Query_98b413525a4b4067b92418a4b50f0a53' }
  & Pick<Types.Query_98b413525a4b4067b92418a4b50f0a53, 'id' | 'name'>
);

export type PressReleaseBase_QuickLinks_Fragment = (
  { __typename?: 'QuickLinks' }
  & Pick<Types.QuickLinks, 'id' | 'name'>
);

export type PressReleaseBase_QuickLinksFolder_Fragment = (
  { __typename?: 'QuickLinksFolder' }
  & Pick<Types.QuickLinksFolder, 'id' | 'name'>
);

export type PressReleaseBase_QuickLinksParametersTemplate_Fragment = (
  { __typename?: 'QuickLinksParametersTemplate' }
  & Pick<Types.QuickLinksParametersTemplate, 'id' | 'name'>
);

export type PressReleaseBase_QuotationBlockItem_Fragment = (
  { __typename?: 'QuotationBlockItem' }
  & Pick<Types.QuotationBlockItem, 'id' | 'name'>
);

export type PressReleaseBase_QuotationBlocks_Fragment = (
  { __typename?: 'QuotationBlocks' }
  & Pick<Types.QuotationBlocks, 'id' | 'name'>
);

export type PressReleaseBase_QuotationBlocksFolder_Fragment = (
  { __typename?: 'QuotationBlocksFolder' }
  & Pick<Types.QuotationBlocksFolder, 'id' | 'name'>
);

export type PressReleaseBase_QuotationBlocksParametersTemplate_Fragment = (
  { __typename?: 'QuotationBlocksParametersTemplate' }
  & Pick<Types.QuotationBlocksParametersTemplate, 'id' | 'name'>
);

export type PressReleaseBase_Quote_Fragment = (
  { __typename?: 'Quote' }
  & Pick<Types.Quote, 'id' | 'name'>
);

export type PressReleaseBase_QuoteFolder_Fragment = (
  { __typename?: 'QuoteFolder' }
  & Pick<Types.QuoteFolder, 'id' | 'name'>
);

export type PressReleaseBase_QuoteParametersTemplate_Fragment = (
  { __typename?: 'QuoteParametersTemplate' }
  & Pick<Types.QuoteParametersTemplate, 'id' | 'name'>
);

export type PressReleaseBase_RadiusFilter_Fragment = (
  { __typename?: 'RadiusFilter' }
  & Pick<Types.RadiusFilter, 'id' | 'name'>
);

export type PressReleaseBase_RadiusFilterFolder_Fragment = (
  { __typename?: 'RadiusFilterFolder' }
  & Pick<Types.RadiusFilterFolder, 'id' | 'name'>
);

export type PressReleaseBase_RadiusFilter_De3fa58eef9d45449f77dcd1dbb05b64_Fragment = (
  { __typename?: 'RadiusFilter_de3fa58eef9d45449f77dcd1dbb05b64' }
  & Pick<Types.RadiusFilter_De3fa58eef9d45449f77dcd1dbb05b64, 'id' | 'name'>
);

export type PressReleaseBase_RadiusScheme_Fragment = (
  { __typename?: 'RadiusScheme' }
  & Pick<Types.RadiusScheme, 'id' | 'name'>
);

export type PressReleaseBase_RadiusSchemeValue_Fragment = (
  { __typename?: 'RadiusSchemeValue' }
  & Pick<Types.RadiusSchemeValue, 'id' | 'name'>
);

export type PressReleaseBase_RangeSliderFilter_Fragment = (
  { __typename?: 'RangeSliderFilter' }
  & Pick<Types.RangeSliderFilter, 'id' | 'name'>
);

export type PressReleaseBase_RangeSliderFilterFolder_Fragment = (
  { __typename?: 'RangeSliderFilterFolder' }
  & Pick<Types.RangeSliderFilterFolder, 'id' | 'name'>
);

export type PressReleaseBase_RangeSliderFilter_0a1787c296b54d40828522564a5d8e03_Fragment = (
  { __typename?: 'RangeSliderFilter_0a1787c296b54d40828522564a5d8e03' }
  & Pick<Types.RangeSliderFilter_0a1787c296b54d40828522564a5d8e03, 'id' | 'name'>
);

export type PressReleaseBase_RecentArticles_Fragment = (
  { __typename?: 'RecentArticles' }
  & Pick<Types.RecentArticles, 'id' | 'name'>
);

export type PressReleaseBase_Redirect_Fragment = (
  { __typename?: 'Redirect' }
  & Pick<Types.Redirect, 'id' | 'name'>
);

export type PressReleaseBase_RedirectMap_Fragment = (
  { __typename?: 'RedirectMap' }
  & Pick<Types.RedirectMap, 'id' | 'name'>
);

export type PressReleaseBase_RedirectMaps_Fragment = (
  { __typename?: 'RedirectMaps' }
  & Pick<Types.RedirectMaps, 'id' | 'name'>
);

export type PressReleaseBase_Region_Fragment = (
  { __typename?: 'Region' }
  & Pick<Types.Region, 'id' | 'name'>
);

export type PressReleaseBase_RegionLanguages_Fragment = (
  { __typename?: 'RegionLanguages' }
  & Pick<Types.RegionLanguages, 'id' | 'name'>
);

export type PressReleaseBase_RegionLanguagesFolder_Fragment = (
  { __typename?: 'RegionLanguagesFolder' }
  & Pick<Types.RegionLanguagesFolder, 'id' | 'name'>
);

export type PressReleaseBase_RelatedArticles_Fragment = (
  { __typename?: 'RelatedArticles' }
  & Pick<Types.RelatedArticles, 'id' | 'name'>
);

export type PressReleaseBase_RelatedArticlesParametersTemplate_Fragment = (
  { __typename?: 'RelatedArticlesParametersTemplate' }
  & Pick<Types.RelatedArticlesParametersTemplate, 'id' | 'name'>
);

export type PressReleaseBase_RenderEngineType_Fragment = (
  { __typename?: 'RenderEngineType' }
  & Pick<Types.RenderEngineType, 'id' | 'name'>
);

export type PressReleaseBase_RenderingFolder_840d4a46550349ecbf9dbd090946c63d_Fragment = (
  { __typename?: 'RenderingFolder_840d4a46550349ecbf9dbd090946c63d' }
  & Pick<Types.RenderingFolder_840d4a46550349ecbf9dbd090946c63d, 'id' | 'name'>
);

export type PressReleaseBase_RenderingHost_Fragment = (
  { __typename?: 'RenderingHost' }
  & Pick<Types.RenderingHost, 'id' | 'name'>
);

export type PressReleaseBase_ResizableIFramePage_Fragment = (
  { __typename?: 'ResizableIFramePage' }
  & Pick<Types.ResizableIFramePage, 'id' | 'name'>
);

export type PressReleaseBase_ResizableIFramePage_8ab2ae106350452ca0e7b06d6d859067_Fragment = (
  { __typename?: 'ResizableIFramePage_8ab2ae106350452ca0e7b06d6d859067' }
  & Pick<Types.ResizableIFramePage_8ab2ae106350452ca0e7b06d6d859067, 'id' | 'name'>
);

export type PressReleaseBase_ResizableIFramePage_92674815f3f74a879c0874bcb72c9b68_Fragment = (
  { __typename?: 'ResizableIFramePage_92674815f3f74a879c0874bcb72c9b68' }
  & Pick<Types.ResizableIFramePage_92674815f3f74a879c0874bcb72c9b68, 'id' | 'name'>
);

export type PressReleaseBase_ResizableIFramePage_B58eacfb27f5417bb536141f94b92521_Fragment = (
  { __typename?: 'ResizableIFramePage_b58eacfb27f5417bb536141f94b92521' }
  & Pick<Types.ResizableIFramePage_B58eacfb27f5417bb536141f94b92521, 'id' | 'name'>
);

export type PressReleaseBase_ResizableIFramePage_D8d76a2407084147bf3900cd5e12e401_Fragment = (
  { __typename?: 'ResizableIFramePage_d8d76a2407084147bf3900cd5e12e401' }
  & Pick<Types.ResizableIFramePage_D8d76a2407084147bf3900cd5e12e401, 'id' | 'name'>
);

export type PressReleaseBase_ResizableIFramePage_F460ab055585441892023750e7cef6b7_Fragment = (
  { __typename?: 'ResizableIFramePage_f460ab055585441892023750e7cef6b7' }
  & Pick<Types.ResizableIFramePage_F460ab055585441892023750e7cef6b7, 'id' | 'name'>
);

export type PressReleaseBase_ResponsiveImage_Fragment = (
  { __typename?: 'ResponsiveImage' }
  & Pick<Types.ResponsiveImage, 'id' | 'name'>
);

export type PressReleaseBase_ResultsCount_Fragment = (
  { __typename?: 'ResultsCount' }
  & Pick<Types.ResultsCount, 'id' | 'name'>
);

export type PressReleaseBase_ResultsCountFolder_Fragment = (
  { __typename?: 'ResultsCountFolder' }
  & Pick<Types.ResultsCountFolder, 'id' | 'name'>
);

export type PressReleaseBase_ResultsCount_F3c0661ef9a9444ca26d44bf2a68a186_Fragment = (
  { __typename?: 'ResultsCount_f3c0661ef9a9444ca26d44bf2a68a186' }
  & Pick<Types.ResultsCount_F3c0661ef9a9444ca26d44bf2a68a186, 'id' | 'name'>
);

export type PressReleaseBase_ResultsVariantSelector_Fragment = (
  { __typename?: 'ResultsVariantSelector' }
  & Pick<Types.ResultsVariantSelector, 'id' | 'name'>
);

export type PressReleaseBase_RichText_Fragment = (
  { __typename?: 'RichText' }
  & Pick<Types.RichText, 'id' | 'name'>
);

export type PressReleaseBase_RichTextFolder_Fragment = (
  { __typename?: 'RichTextFolder' }
  & Pick<Types.RichTextFolder, 'id' | 'name'>
);

export type PressReleaseBase_RichText_0f3b73366112418c8bbab0526f3887ce_Fragment = (
  { __typename?: 'RichText_0f3b73366112418c8bbab0526f3887ce' }
  & Pick<Types.RichText_0f3b73366112418c8bbab0526f3887ce, 'id' | 'name'>
);

export type PressReleaseBase_RichText_Efcfd8f6596745f48f85b5421928205d_Fragment = (
  { __typename?: 'RichText_efcfd8f6596745f48f85b5421928205d' }
  & Pick<Types.RichText_Efcfd8f6596745f48f85b5421928205d, 'id' | 'name'>
);

export type PressReleaseBase_RiskImageMapping_Fragment = (
  { __typename?: 'RiskImageMapping' }
  & Pick<Types.RiskImageMapping, 'id' | 'name'>
);

export type PressReleaseBase_RiskImageMappings_Fragment = (
  { __typename?: 'RiskImageMappings' }
  & Pick<Types.RiskImageMappings, 'id' | 'name'>
);

export type PressReleaseBase_RiskLevelOption_Fragment = (
  { __typename?: 'RiskLevelOption' }
  & Pick<Types.RiskLevelOption, 'id' | 'name'>
);

export type PressReleaseBase_RiskLevelOptionFolder_Fragment = (
  { __typename?: 'RiskLevelOptionFolder' }
  & Pick<Types.RiskLevelOptionFolder, 'id' | 'name'>
);

export type PressReleaseBase_RiskWarning_Fragment = (
  { __typename?: 'RiskWarning' }
  & Pick<Types.RiskWarning, 'id' | 'name'>
);

export type PressReleaseBase_RiskWarningFolder_Fragment = (
  { __typename?: 'RiskWarningFolder' }
  & Pick<Types.RiskWarningFolder, 'id' | 'name'>
);

export type PressReleaseBase_RiskWarningParametersTemplate_Fragment = (
  { __typename?: 'RiskWarningParametersTemplate' }
  & Pick<Types.RiskWarningParametersTemplate, 'id' | 'name'>
);

export type PressReleaseBase_RolePlaceholder_Fragment = (
  { __typename?: 'RolePlaceholder' }
  & Pick<Types.RolePlaceholder, 'id' | 'name'>
);

export type PressReleaseBase_RowSplitter_Fragment = (
  { __typename?: 'RowSplitter' }
  & Pick<Types.RowSplitter, 'id' | 'name'>
);

export type PressReleaseBase_RowSplitter_340c887da1d1415b9678c763af74ea97_Fragment = (
  { __typename?: 'RowSplitter_340c887da1d1415b9678c763af74ea97' }
  & Pick<Types.RowSplitter_340c887da1d1415b9678c763af74ea97, 'id' | 'name'>
);

export type PressReleaseBase_Rule_Fragment = (
  { __typename?: 'Rule' }
  & Pick<Types.Rule, 'id' | 'name'>
);

export type PressReleaseBase_SdrLogoMapping_Fragment = (
  { __typename?: 'SDRLogoMapping' }
  & Pick<Types.SdrLogoMapping, 'id' | 'name'>
);

export type PressReleaseBase_SdrLogoMappings_Fragment = (
  { __typename?: 'SDRLogoMappings' }
  & Pick<Types.SdrLogoMappings, 'id' | 'name'>
);

export type PressReleaseBase_SdrTypeOption_Fragment = (
  { __typename?: 'SDRTypeOption' }
  & Pick<Types.SdrTypeOption, 'id' | 'name'>
);

export type PressReleaseBase_SdrTypeOptionFolder_Fragment = (
  { __typename?: 'SDRTypeOptionFolder' }
  & Pick<Types.SdrTypeOptionFolder, 'id' | 'name'>
);

export type PressReleaseBase_SxajssLayout_Fragment = (
  { __typename?: 'SXAJSSLayout' }
  & Pick<Types.SxajssLayout, 'id' | 'name'>
);

export type PressReleaseBase_SxaRole_Fragment = (
  { __typename?: 'SXARole' }
  & Pick<Types.SxaRole, 'id' | 'name'>
);

export type PressReleaseBase_SxaStandardValuesFolder_Fragment = (
  { __typename?: 'SXAStandardValuesFolder' }
  & Pick<Types.SxaStandardValuesFolder, 'id' | 'name'>
);

export type PressReleaseBase_SalesforceAlertMessage_Fragment = (
  { __typename?: 'SalesforceAlertMessage' }
  & Pick<Types.SalesforceAlertMessage, 'id' | 'name'>
);

export type PressReleaseBase_SalesforceCheckBox_Fragment = (
  { __typename?: 'SalesforceCheckBox' }
  & Pick<Types.SalesforceCheckBox, 'id' | 'name'>
);

export type PressReleaseBase_SalesforceCheckBoxType_Fragment = (
  { __typename?: 'SalesforceCheckBoxType' }
  & Pick<Types.SalesforceCheckBoxType, 'id' | 'name'>
);

export type PressReleaseBase_SalesforceConditionalRadioButton_Fragment = (
  { __typename?: 'SalesforceConditionalRadioButton' }
  & Pick<Types.SalesforceConditionalRadioButton, 'id' | 'name'>
);

export type PressReleaseBase_SalesforceConditionalRadioButtons_Fragment = (
  { __typename?: 'SalesforceConditionalRadioButtons' }
  & Pick<Types.SalesforceConditionalRadioButtons, 'id' | 'name'>
);

export type PressReleaseBase_SalesforceDateInput_Fragment = (
  { __typename?: 'SalesforceDateInput' }
  & Pick<Types.SalesforceDateInput, 'id' | 'name'>
);

export type PressReleaseBase_SalesforceDropdown_Fragment = (
  { __typename?: 'SalesforceDropdown' }
  & Pick<Types.SalesforceDropdown, 'id' | 'name'>
);

export type PressReleaseBase_SalesforceDropdownOption_Fragment = (
  { __typename?: 'SalesforceDropdownOption' }
  & Pick<Types.SalesforceDropdownOption, 'id' | 'name'>
);

export type PressReleaseBase_SalesforceHiddenField_Fragment = (
  { __typename?: 'SalesforceHiddenField' }
  & Pick<Types.SalesforceHiddenField, 'id' | 'name'>
);

export type PressReleaseBase_SalesforceInput_Fragment = (
  { __typename?: 'SalesforceInput' }
  & Pick<Types.SalesforceInput, 'id' | 'name'>
);

export type PressReleaseBase_SalesforceInputType_Fragment = (
  { __typename?: 'SalesforceInputType' }
  & Pick<Types.SalesforceInputType, 'id' | 'name'>
);

export type PressReleaseBase_SalesforceIntegratedForm_Fragment = (
  { __typename?: 'SalesforceIntegratedForm' }
  & Pick<Types.SalesforceIntegratedForm, 'id' | 'name'>
);

export type PressReleaseBase_SalesforceIntegratedFormTypesFolder_Fragment = (
  { __typename?: 'SalesforceIntegratedFormTypesFolder' }
  & Pick<Types.SalesforceIntegratedFormTypesFolder, 'id' | 'name'>
);

export type PressReleaseBase_SalesforceRepeatableSubSection_Fragment = (
  { __typename?: 'SalesforceRepeatableSubSection' }
  & Pick<Types.SalesforceRepeatableSubSection, 'id' | 'name'>
);

export type PressReleaseBase_SalesforceRichTextArea_Fragment = (
  { __typename?: 'SalesforceRichTextArea' }
  & Pick<Types.SalesforceRichTextArea, 'id' | 'name'>
);

export type PressReleaseBase_SalesforceSection_Fragment = (
  { __typename?: 'SalesforceSection' }
  & Pick<Types.SalesforceSection, 'id' | 'name'>
);

export type PressReleaseBase_SalesforceSortCodeInput_Fragment = (
  { __typename?: 'SalesforceSortCodeInput' }
  & Pick<Types.SalesforceSortCodeInput, 'id' | 'name'>
);

export type PressReleaseBase_SalesforceSubmissionType_Fragment = (
  { __typename?: 'SalesforceSubmissionType' }
  & Pick<Types.SalesforceSubmissionType, 'id' | 'name'>
);

export type PressReleaseBase_Scope_Fragment = (
  { __typename?: 'Scope' }
  & Pick<Types.Scope, 'id' | 'name'>
);

export type PressReleaseBase_ScopesFolder_Fragment = (
  { __typename?: 'ScopesFolder' }
  & Pick<Types.ScopesFolder, 'id' | 'name'>
);

export type PressReleaseBase_Scriban_Fragment = (
  { __typename?: 'Scriban' }
  & Pick<Types.Scriban, 'id' | 'name'>
);

export type PressReleaseBase_Scripts_Fragment = (
  { __typename?: 'Scripts' }
  & Pick<Types.Scripts, 'id' | 'name'>
);

export type PressReleaseBase_SearchBox_Fragment = (
  { __typename?: 'SearchBox' }
  & Pick<Types.SearchBox, 'id' | 'name'>
);

export type PressReleaseBase_SearchBoxFolder_Fragment = (
  { __typename?: 'SearchBoxFolder' }
  & Pick<Types.SearchBoxFolder, 'id' | 'name'>
);

export type PressReleaseBase_SearchBox_1c04fd611d874590acfe9cc186865ab3_Fragment = (
  { __typename?: 'SearchBox_1c04fd611d874590acfe9cc186865ab3' }
  & Pick<Types.SearchBox_1c04fd611d874590acfe9cc186865ab3, 'id' | 'name'>
);

export type PressReleaseBase_SearchFolder_Fragment = (
  { __typename?: 'SearchFolder' }
  & Pick<Types.SearchFolder, 'id' | 'name'>
);

export type PressReleaseBase_SearchResults_Fragment = (
  { __typename?: 'SearchResults' }
  & Pick<Types.SearchResults, 'id' | 'name'>
);

export type PressReleaseBase_SearchResultsFolder_Fragment = (
  { __typename?: 'SearchResultsFolder' }
  & Pick<Types.SearchResultsFolder, 'id' | 'name'>
);

export type PressReleaseBase_SearchResults_A06f7130041d46bb8c2995a2dc00c26a_Fragment = (
  { __typename?: 'SearchResults_a06f7130041d46bb8c2995a2dc00c26a' }
  & Pick<Types.SearchResults_A06f7130041d46bb8c2995a2dc00c26a, 'id' | 'name'>
);

export type PressReleaseBase_SecondaryHeroBannerParametersTemplate_Fragment = (
  { __typename?: 'SecondaryHeroBannerParametersTemplate' }
  & Pick<Types.SecondaryHeroBannerParametersTemplate, 'id' | 'name'>
);

export type PressReleaseBase_SectionHeading_Fragment = (
  { __typename?: 'SectionHeading' }
  & Pick<Types.SectionHeading, 'id' | 'name'>
);

export type PressReleaseBase_SectionHeadingFolder_Fragment = (
  { __typename?: 'SectionHeadingFolder' }
  & Pick<Types.SectionHeadingFolder, 'id' | 'name'>
);

export type PressReleaseBase_SectionHeadingParametersTemplate_Fragment = (
  { __typename?: 'SectionHeadingParametersTemplate' }
  & Pick<Types.SectionHeadingParametersTemplate, 'id' | 'name'>
);

export type PressReleaseBase_SectionHeadingType_Fragment = (
  { __typename?: 'SectionHeadingType' }
  & Pick<Types.SectionHeadingType, 'id' | 'name'>
);

export type PressReleaseBase_SectionHeadingTypeFolder_Fragment = (
  { __typename?: 'SectionHeadingTypeFolder' }
  & Pick<Types.SectionHeadingTypeFolder, 'id' | 'name'>
);

export type PressReleaseBase_SectionSelector_Fragment = (
  { __typename?: 'SectionSelector' }
  & Pick<Types.SectionSelector, 'id' | 'name'>
);

export type PressReleaseBase_SectionSelectorFolder_Fragment = (
  { __typename?: 'SectionSelectorFolder' }
  & Pick<Types.SectionSelectorFolder, 'id' | 'name'>
);

export type PressReleaseBase_SectionSelectorTab_Fragment = (
  { __typename?: 'SectionSelectorTab' }
  & Pick<Types.SectionSelectorTab, 'id' | 'name'>
);

export type PressReleaseBase_Security_33077d51ebad4d1cb4a83b79f51dba13_Fragment = (
  { __typename?: 'Security_33077d51ebad4d1cb4a83b79f51dba13' }
  & Pick<Types.Security_33077d51ebad4d1cb4a83b79f51dba13, 'id' | 'name'>
);

export type PressReleaseBase_Series_Fragment = (
  { __typename?: 'Series' }
  & Pick<Types.Series, 'id' | 'name'>
);

export type PressReleaseBase_SeriesFolder_Fragment = (
  { __typename?: 'SeriesFolder' }
  & Pick<Types.SeriesFolder, 'id' | 'name'>
);

export type PressReleaseBase_Settings_Fragment = (
  { __typename?: 'Settings' }
  & Pick<Types.Settings, 'id' | 'name'>
);

export type PressReleaseBase_SettingsFolder_Fragment = (
  { __typename?: 'SettingsFolder' }
  & Pick<Types.SettingsFolder, 'id' | 'name'>
);

export type PressReleaseBase_Settings_6c82caca67dc464195698faad083230e_Fragment = (
  { __typename?: 'Settings_6c82caca67dc464195698faad083230e' }
  & Pick<Types.Settings_6c82caca67dc464195698faad083230e, 'id' | 'name'>
);

export type PressReleaseBase_SharePriceSettings_Fragment = (
  { __typename?: 'SharePriceSettings' }
  & Pick<Types.SharePriceSettings, 'id' | 'name'>
);

export type PressReleaseBase_SharedArticlesFolder_Fragment = (
  { __typename?: 'SharedArticlesFolder' }
  & Pick<Types.SharedArticlesFolder, 'id' | 'name'>
);

export type PressReleaseBase_SharedContentFolder_Fragment = (
  { __typename?: 'SharedContentFolder' }
  & Pick<Types.SharedContentFolder, 'id' | 'name'>
);

export type PressReleaseBase_SharedFolder_Fragment = (
  { __typename?: 'SharedFolder' }
  & Pick<Types.SharedFolder, 'id' | 'name'>
);

export type PressReleaseBase_SharedHelpArticlesFolder_Fragment = (
  { __typename?: 'SharedHelpArticlesFolder' }
  & Pick<Types.SharedHelpArticlesFolder, 'id' | 'name'>
);

export type PressReleaseBase_SharedPressReleasesFolder_Fragment = (
  { __typename?: 'SharedPressReleasesFolder' }
  & Pick<Types.SharedPressReleasesFolder, 'id' | 'name'>
);

export type PressReleaseBase_SharedSettingsFolder_Fragment = (
  { __typename?: 'SharedSettingsFolder' }
  & Pick<Types.SharedSettingsFolder, 'id' | 'name'>
);

export type PressReleaseBase_SharedSitesSettings_Fragment = (
  { __typename?: 'SharedSitesSettings' }
  & Pick<Types.SharedSitesSettings, 'id' | 'name'>
);

export type PressReleaseBase_SharedSitesSettings_C14bf746030f4e598594395f6d299e61_Fragment = (
  { __typename?: 'SharedSitesSettings_c14bf746030f4e598594395f6d299e61' }
  & Pick<Types.SharedSitesSettings_C14bf746030f4e598594395f6d299e61, 'id' | 'name'>
);

export type PressReleaseBase_Showcase_Fragment = (
  { __typename?: 'Showcase' }
  & Pick<Types.Showcase, 'id' | 'name'>
);

export type PressReleaseBase_ShowcaseFolder_Fragment = (
  { __typename?: 'ShowcaseFolder' }
  & Pick<Types.ShowcaseFolder, 'id' | 'name'>
);

export type PressReleaseBase_ShowcaseItem_Fragment = (
  { __typename?: 'ShowcaseItem' }
  & Pick<Types.ShowcaseItem, 'id' | 'name'>
);

export type PressReleaseBase_ShowcaseParametersTemplate_Fragment = (
  { __typename?: 'ShowcaseParametersTemplate' }
  & Pick<Types.ShowcaseParametersTemplate, 'id' | 'name'>
);

export type PressReleaseBase_Site_Fragment = (
  { __typename?: 'Site' }
  & Pick<Types.Site, 'id' | 'name'>
);

export type PressReleaseBase_SiteContentFolder_Fragment = (
  { __typename?: 'SiteContentFolder' }
  & Pick<Types.SiteContentFolder, 'id' | 'name'>
);

export type PressReleaseBase_SiteDefinition_Fragment = (
  { __typename?: 'SiteDefinition' }
  & Pick<Types.SiteDefinition, 'id' | 'name'>
);

export type PressReleaseBase_SiteEntryDisclaimer_Fragment = (
  { __typename?: 'SiteEntryDisclaimer' }
  & Pick<Types.SiteEntryDisclaimer, 'id' | 'name'>
);

export type PressReleaseBase_SiteFolder_Fragment = (
  { __typename?: 'SiteFolder' }
  & Pick<Types.SiteFolder, 'id' | 'name'>
);

export type PressReleaseBase_SiteGrouping_Fragment = (
  { __typename?: 'SiteGrouping' }
  & Pick<Types.SiteGrouping, 'id' | 'name'>
);

export type PressReleaseBase_SiteManagement_Fragment = (
  { __typename?: 'SiteManagement' }
  & Pick<Types.SiteManagement, 'id' | 'name'>
);

export type PressReleaseBase_SiteSecurityItemPointer_Fragment = (
  { __typename?: 'SiteSecurityItemPointer' }
  & Pick<Types.SiteSecurityItemPointer, 'id' | 'name'>
);

export type PressReleaseBase_SiteSelector_Fragment = (
  { __typename?: 'SiteSelector' }
  & Pick<Types.SiteSelector, 'id' | 'name'>
);

export type PressReleaseBase_SiteSelector_A44632f56dcd4d10b4892f4e35e193c3_Fragment = (
  { __typename?: 'SiteSelector_a44632f56dcd4d10b4892f4e35e193c3' }
  & Pick<Types.SiteSelector_A44632f56dcd4d10b4892f4e35e193c3, 'id' | 'name'>
);

export type PressReleaseBase_SiteSetupRoot_Fragment = (
  { __typename?: 'SiteSetupRoot' }
  & Pick<Types.SiteSetupRoot, 'id' | 'name'>
);

export type PressReleaseBase_SiteTheme_Fragment = (
  { __typename?: 'SiteTheme' }
  & Pick<Types.SiteTheme, 'id' | 'name'>
);

export type PressReleaseBase_Site_E46f3af239fa4866a1577017c4b2a40c_Fragment = (
  { __typename?: 'Site_e46f3af239fa4866a1577017c4b2a40c' }
  & Pick<Types.Site_E46f3af239fa4866a1577017c4b2a40c, 'id' | 'name'>
);

export type PressReleaseBase_SitecoreFormWrapperParametersTemplate_Fragment = (
  { __typename?: 'SitecoreFormWrapperParametersTemplate' }
  & Pick<Types.SitecoreFormWrapperParametersTemplate, 'id' | 'name'>
);

export type PressReleaseBase_SitecoreRole_Fragment = (
  { __typename?: 'SitecoreRole' }
  & Pick<Types.SitecoreRole, 'id' | 'name'>
);

export type PressReleaseBase_SitemapSettings_C71d856635c849b7a84d9d176e9cbd05_Fragment = (
  { __typename?: 'SitemapSettings_c71d856635c849b7a84d9d176e9cbd05' }
  & Pick<Types.SitemapSettings_C71d856635c849b7a84d9d176e9cbd05, 'id' | 'name'>
);

export type PressReleaseBase_SkipLink_Fragment = (
  { __typename?: 'SkipLink' }
  & Pick<Types.SkipLink, 'id' | 'name'>
);

export type PressReleaseBase_SkipLinkParameters_Fragment = (
  { __typename?: 'SkipLinkParameters' }
  & Pick<Types.SkipLinkParameters, 'id' | 'name'>
);

export type PressReleaseBase_SkipLinksFolder_Fragment = (
  { __typename?: 'SkipLinksFolder' }
  & Pick<Types.SkipLinksFolder, 'id' | 'name'>
);

export type PressReleaseBase_Snippet_Fragment = (
  { __typename?: 'Snippet' }
  & Pick<Types.Snippet, 'id' | 'name'>
);

export type PressReleaseBase_SnippetItem_Fragment = (
  { __typename?: 'SnippetItem' }
  & Pick<Types.SnippetItem, 'id' | 'name'>
);

export type PressReleaseBase_SnippetsFolder_Fragment = (
  { __typename?: 'SnippetsFolder' }
  & Pick<Types.SnippetsFolder, 'id' | 'name'>
);

export type PressReleaseBase_SocialLoginWrapper_Fragment = (
  { __typename?: 'SocialLoginWrapper' }
  & Pick<Types.SocialLoginWrapper, 'id' | 'name'>
);

export type PressReleaseBase_SocialMediaButtons_Fragment = (
  { __typename?: 'SocialMediaButtons' }
  & Pick<Types.SocialMediaButtons, 'id' | 'name'>
);

export type PressReleaseBase_SocialMediaFolder_Fragment = (
  { __typename?: 'SocialMediaFolder' }
  & Pick<Types.SocialMediaFolder, 'id' | 'name'>
);

export type PressReleaseBase_SocialMediaShare_Fragment = (
  { __typename?: 'SocialMediaShare' }
  & Pick<Types.SocialMediaShare, 'id' | 'name'>
);

export type PressReleaseBase_SocialMediaTemplate_Fragment = (
  { __typename?: 'SocialMediaTemplate' }
  & Pick<Types.SocialMediaTemplate, 'id' | 'name'>
);

export type PressReleaseBase_SocialNetwork_Fragment = (
  { __typename?: 'SocialNetwork' }
  & Pick<Types.SocialNetwork, 'id' | 'name'>
);

export type PressReleaseBase_SocialNetworkFolder_Fragment = (
  { __typename?: 'SocialNetworkFolder' }
  & Pick<Types.SocialNetworkFolder, 'id' | 'name'>
);

export type PressReleaseBase_SocialNetworkLink_Fragment = (
  { __typename?: 'SocialNetworkLink' }
  & Pick<Types.SocialNetworkLink, 'id' | 'name'>
);

export type PressReleaseBase_SolutionTemplate_Fragment = (
  { __typename?: 'SolutionTemplate' }
  & Pick<Types.SolutionTemplate, 'id' | 'name'>
);

export type PressReleaseBase_SortResults_Fragment = (
  { __typename?: 'SortResults' }
  & Pick<Types.SortResults, 'id' | 'name'>
);

export type PressReleaseBase_SortResultsFolder_Fragment = (
  { __typename?: 'SortResultsFolder' }
  & Pick<Types.SortResultsFolder, 'id' | 'name'>
);

export type PressReleaseBase_Sorting_Fragment = (
  { __typename?: 'Sorting' }
  & Pick<Types.Sorting, 'id' | 'name'>
);

export type PressReleaseBase_SortingGroups_Fragment = (
  { __typename?: 'SortingGroups' }
  & Pick<Types.SortingGroups, 'id' | 'name'>
);

export type PressReleaseBase_SpotifyPodcast_Fragment = (
  { __typename?: 'SpotifyPodcast' }
  & Pick<Types.SpotifyPodcast, 'id' | 'name'>
);

export type PressReleaseBase_SpotifyPodcastFolder_Fragment = (
  { __typename?: 'SpotifyPodcastFolder' }
  & Pick<Types.SpotifyPodcastFolder, 'id' | 'name'>
);

export type PressReleaseBase_StickyCta_Fragment = (
  { __typename?: 'StickyCTA' }
  & Pick<Types.StickyCta, 'id' | 'name'>
);

export type PressReleaseBase_StickyCtaFolder_Fragment = (
  { __typename?: 'StickyCTAFolder' }
  & Pick<Types.StickyCtaFolder, 'id' | 'name'>
);

export type PressReleaseBase_StickyCtaParametersTemplate_Fragment = (
  { __typename?: 'StickyCTAParametersTemplate' }
  & Pick<Types.StickyCtaParametersTemplate, 'id' | 'name'>
);

export type PressReleaseBase_StrategiesInFocusFolder_Fragment = (
  { __typename?: 'StrategiesInFocusFolder' }
  & Pick<Types.StrategiesInFocusFolder, 'id' | 'name'>
);

export type PressReleaseBase_StrategyInFocus_Fragment = (
  { __typename?: 'StrategyInFocus' }
  & Pick<Types.StrategyInFocus, 'id' | 'name'>
);

export type PressReleaseBase_Style_Fragment = (
  { __typename?: 'Style' }
  & Pick<Types.Style, 'id' | 'name'>
);

export type PressReleaseBase_Styles_Fragment = (
  { __typename?: 'Styles' }
  & Pick<Types.Styles, 'id' | 'name'>
);

export type PressReleaseBase_Styles_9c0dac2808aa4b44bc2153363206f6a5_Fragment = (
  { __typename?: 'Styles_9c0dac2808aa4b44bc2153363206f6a5' }
  & Pick<Types.Styles_9c0dac2808aa4b44bc2153363206f6a5, 'id' | 'name'>
);

export type PressReleaseBase_SubscriptionBannerParametersTemplate_Fragment = (
  { __typename?: 'SubscriptionBannerParametersTemplate' }
  & Pick<Types.SubscriptionBannerParametersTemplate, 'id' | 'name'>
);

export type PressReleaseBase_Tab_Fragment = (
  { __typename?: 'Tab' }
  & Pick<Types.Tab, 'id' | 'name'>
);

export type PressReleaseBase_TabItem_Fragment = (
  { __typename?: 'TabItem' }
  & Pick<Types.TabItem, 'id' | 'name'>
);

export type PressReleaseBase_TableOfContents_Fragment = (
  { __typename?: 'TableOfContents' }
  & Pick<Types.TableOfContents, 'id' | 'name'>
);

export type PressReleaseBase_TableOfContentsFolder_Fragment = (
  { __typename?: 'TableOfContentsFolder' }
  & Pick<Types.TableOfContentsFolder, 'id' | 'name'>
);

export type PressReleaseBase_TableOfContentsSection_Fragment = (
  { __typename?: 'TableOfContentsSection' }
  & Pick<Types.TableOfContentsSection, 'id' | 'name'>
);

export type PressReleaseBase_TableOfContentsSubsection_Fragment = (
  { __typename?: 'TableOfContentsSubsection' }
  & Pick<Types.TableOfContentsSubsection, 'id' | 'name'>
);

export type PressReleaseBase_Tabs_Fragment = (
  { __typename?: 'Tabs' }
  & Pick<Types.Tabs, 'id' | 'name'>
);

export type PressReleaseBase_TabsFolder_Fragment = (
  { __typename?: 'TabsFolder' }
  & Pick<Types.TabsFolder, 'id' | 'name'>
);

export type PressReleaseBase_Tabs_F26a9560ccf148c59542800e837caf7a_Fragment = (
  { __typename?: 'Tabs_f26a9560ccf148c59542800e837caf7a' }
  & Pick<Types.Tabs_F26a9560ccf148c59542800e837caf7a, 'id' | 'name'>
);

export type PressReleaseBase_Tag_Fragment = (
  { __typename?: 'Tag' }
  & Pick<Types.Tag, 'id' | 'name'>
);

export type PressReleaseBase_TagCloud_Fragment = (
  { __typename?: 'TagCloud' }
  & Pick<Types.TagCloud, 'id' | 'name'>
);

export type PressReleaseBase_TagFolder_Fragment = (
  { __typename?: 'TagFolder' }
  & Pick<Types.TagFolder, 'id' | 'name'>
);

export type PressReleaseBase_TagList_Fragment = (
  { __typename?: 'TagList' }
  & Pick<Types.TagList, 'id' | 'name'>
);

export type PressReleaseBase_TeamBiographySettings_Fragment = (
  { __typename?: 'TeamBiographySettings' }
  & Pick<Types.TeamBiographySettings, 'id' | 'name'>
);

export type PressReleaseBase_TeamListingCards_Fragment = (
  { __typename?: 'TeamListingCards' }
  & Pick<Types.TeamListingCards, 'id' | 'name'>
);

export type PressReleaseBase_TeamListingCardsFolder_Fragment = (
  { __typename?: 'TeamListingCardsFolder' }
  & Pick<Types.TeamListingCardsFolder, 'id' | 'name'>
);

export type PressReleaseBase_TeamMember_Fragment = (
  { __typename?: 'TeamMember' }
  & Pick<Types.TeamMember, 'id' | 'name'>
);

export type PressReleaseBase_TeamMemberCard_Fragment = (
  { __typename?: 'TeamMemberCard' }
  & Pick<Types.TeamMemberCard, 'id' | 'name'>
);

export type PressReleaseBase_TeamMembers_Fragment = (
  { __typename?: 'TeamMembers' }
  & Pick<Types.TeamMembers, 'id' | 'name'>
);

export type PressReleaseBase_TeamMembersParentPage_Fragment = (
  { __typename?: 'TeamMembersParentPage' }
  & Pick<Types.TeamMembersParentPage, 'id' | 'name'>
);

export type PressReleaseBase_TeamMembersParentPage_0dfb40140ba44abe8a480904ff1eff1e_Fragment = (
  { __typename?: 'TeamMembersParentPage_0dfb40140ba44abe8a480904ff1eff1e' }
  & Pick<Types.TeamMembersParentPage_0dfb40140ba44abe8a480904ff1eff1e, 'id' | 'name'>
);

export type PressReleaseBase_TeamMembersParentPage_2e9df92fe936461987fd0ea8ad08bd9e_Fragment = (
  { __typename?: 'TeamMembersParentPage_2e9df92fe936461987fd0ea8ad08bd9e' }
  & Pick<Types.TeamMembersParentPage_2e9df92fe936461987fd0ea8ad08bd9e, 'id' | 'name'>
);

export type PressReleaseBase_TeamMembersParentPage_47f304d629a84648a0e2b942513133ff_Fragment = (
  { __typename?: 'TeamMembersParentPage_47f304d629a84648a0e2b942513133ff' }
  & Pick<Types.TeamMembersParentPage_47f304d629a84648a0e2b942513133ff, 'id' | 'name'>
);

export type PressReleaseBase_TeamMembersParentPage_75c911bd18704434ad7adcca64dfb089_Fragment = (
  { __typename?: 'TeamMembersParentPage_75c911bd18704434ad7adcca64dfb089' }
  & Pick<Types.TeamMembersParentPage_75c911bd18704434ad7adcca64dfb089, 'id' | 'name'>
);

export type PressReleaseBase_TeamMembersParentPage_B4311697c06c4d58b88dca047c0a72b0_Fragment = (
  { __typename?: 'TeamMembersParentPage_b4311697c06c4d58b88dca047c0a72b0' }
  & Pick<Types.TeamMembersParentPage_B4311697c06c4d58b88dca047c0a72b0, 'id' | 'name'>
);

export type PressReleaseBase_TeamMembersWildcardPage_Fragment = (
  { __typename?: 'TeamMembersWildcardPage' }
  & Pick<Types.TeamMembersWildcardPage, 'id' | 'name'>
);

export type PressReleaseBase_TeamMembersWildcardPage_6c0a7b262ac64e1ba92ab20013a5a00e_Fragment = (
  { __typename?: 'TeamMembersWildcardPage_6c0a7b262ac64e1ba92ab20013a5a00e' }
  & Pick<Types.TeamMembersWildcardPage_6c0a7b262ac64e1ba92ab20013a5a00e, 'id' | 'name'>
);

export type PressReleaseBase_TeamMembersWildcardPage_9c436bbf177d481da8bdfdc12a53d450_Fragment = (
  { __typename?: 'TeamMembersWildcardPage_9c436bbf177d481da8bdfdc12a53d450' }
  & Pick<Types.TeamMembersWildcardPage_9c436bbf177d481da8bdfdc12a53d450, 'id' | 'name'>
);

export type PressReleaseBase_TeamMembersWildcardPage_52ba0118982f400fb80e1fee787f1d3a_Fragment = (
  { __typename?: 'TeamMembersWildcardPage_52ba0118982f400fb80e1fee787f1d3a' }
  & Pick<Types.TeamMembersWildcardPage_52ba0118982f400fb80e1fee787f1d3a, 'id' | 'name'>
);

export type PressReleaseBase_TeamMembersWildcardPage_54e4118770954f8abdfb908c88ce2f29_Fragment = (
  { __typename?: 'TeamMembersWildcardPage_54e4118770954f8abdfb908c88ce2f29' }
  & Pick<Types.TeamMembersWildcardPage_54e4118770954f8abdfb908c88ce2f29, 'id' | 'name'>
);

export type PressReleaseBase_TeamMembersWildcardPage_Ea27a3d835fd49a3a4c797d2a6d52745_Fragment = (
  { __typename?: 'TeamMembersWildcardPage_ea27a3d835fd49a3a4c797d2a6d52745' }
  & Pick<Types.TeamMembersWildcardPage_Ea27a3d835fd49a3a4c797d2a6d52745, 'id' | 'name'>
);

export type PressReleaseBase_TeamProfileCards_Fragment = (
  { __typename?: 'TeamProfileCards' }
  & Pick<Types.TeamProfileCards, 'id' | 'name'>
);

export type PressReleaseBase_TeamProfileCardsFolder_Fragment = (
  { __typename?: 'TeamProfileCardsFolder' }
  & Pick<Types.TeamProfileCardsFolder, 'id' | 'name'>
);

export type PressReleaseBase_TechzoneArticlePage_Fragment = (
  { __typename?: 'TechzoneArticlePage' }
  & Pick<Types.TechzoneArticlePage, 'id' | 'name'>
);

export type PressReleaseBase_Tenant_Fragment = (
  { __typename?: 'Tenant' }
  & Pick<Types.Tenant, 'id' | 'name'>
);

export type PressReleaseBase_TenantFolder_Fragment = (
  { __typename?: 'TenantFolder' }
  & Pick<Types.TenantFolder, 'id' | 'name'>
);

export type PressReleaseBase_TenantSecurityItemPointer_Fragment = (
  { __typename?: 'TenantSecurityItemPointer' }
  & Pick<Types.TenantSecurityItemPointer, 'id' | 'name'>
);

export type PressReleaseBase_TenantSetupRoot_Fragment = (
  { __typename?: 'TenantSetupRoot' }
  & Pick<Types.TenantSetupRoot, 'id' | 'name'>
);

export type PressReleaseBase_TertieryHeroBanner_Fragment = (
  { __typename?: 'TertieryHeroBanner' }
  & Pick<Types.TertieryHeroBanner, 'id' | 'name'>
);

export type PressReleaseBase_TertieryHeroBannerParametersTemplate_Fragment = (
  { __typename?: 'TertieryHeroBannerParametersTemplate' }
  & Pick<Types.TertieryHeroBannerParametersTemplate, 'id' | 'name'>
);

export type PressReleaseBase_Text_Fragment = (
  { __typename?: 'Text' }
  & Pick<Types.Text, 'id' | 'name'>
);

export type PressReleaseBase_TextBlock_Fragment = (
  { __typename?: 'TextBlock' }
  & Pick<Types.TextBlock, 'id' | 'name'>
);

export type PressReleaseBase_TextBlockHeadingParametersTemplate_Fragment = (
  { __typename?: 'TextBlockHeadingParametersTemplate' }
  & Pick<Types.TextBlockHeadingParametersTemplate, 'id' | 'name'>
);

export type PressReleaseBase_TextBlockHeadingType_Fragment = (
  { __typename?: 'TextBlockHeadingType' }
  & Pick<Types.TextBlockHeadingType, 'id' | 'name'>
);

export type PressReleaseBase_TextBlockHeadingTypeFolder_Fragment = (
  { __typename?: 'TextBlockHeadingTypeFolder' }
  & Pick<Types.TextBlockHeadingTypeFolder, 'id' | 'name'>
);

export type PressReleaseBase_TextBlockLinkType_Fragment = (
  { __typename?: 'TextBlockLinkType' }
  & Pick<Types.TextBlockLinkType, 'id' | 'name'>
);

export type PressReleaseBase_TextBlockLinkTypeFolder_Fragment = (
  { __typename?: 'TextBlockLinkTypeFolder' }
  & Pick<Types.TextBlockLinkTypeFolder, 'id' | 'name'>
);

export type PressReleaseBase_TextBlocks_Fragment = (
  { __typename?: 'TextBlocks' }
  & Pick<Types.TextBlocks, 'id' | 'name'>
);

export type PressReleaseBase_TextBlocksFolder_Fragment = (
  { __typename?: 'TextBlocksFolder' }
  & Pick<Types.TextBlocksFolder, 'id' | 'name'>
);

export type PressReleaseBase_TextBlocksParametersTemplate_Fragment = (
  { __typename?: 'TextBlocksParametersTemplate' }
  & Pick<Types.TextBlocksParametersTemplate, 'id' | 'name'>
);

export type PressReleaseBase_TextFolder_Fragment = (
  { __typename?: 'TextFolder' }
  & Pick<Types.TextFolder, 'id' | 'name'>
);

export type PressReleaseBase_TextFolder_B762d56787f5493cbb480c455d834457_Fragment = (
  { __typename?: 'TextFolder_b762d56787f5493cbb480c455d834457' }
  & Pick<Types.TextFolder_B762d56787f5493cbb480c455d834457, 'id' | 'name'>
);

export type PressReleaseBase_Text_B8f5894cb4934016bf784090b0a2fd16_Fragment = (
  { __typename?: 'Text_b8f5894cb4934016bf784090b0a2fd16' }
  & Pick<Types.Text_B8f5894cb4934016bf784090b0a2fd16, 'id' | 'name'>
);

export type PressReleaseBase_Theme_Fragment = (
  { __typename?: 'Theme' }
  & Pick<Types.Theme, 'id' | 'name'>
);

export type PressReleaseBase_ThemeTag_Fragment = (
  { __typename?: 'ThemeTag' }
  & Pick<Types.ThemeTag, 'id' | 'name'>
);

export type PressReleaseBase_ThemeTagsFolder_Fragment = (
  { __typename?: 'ThemeTagsFolder' }
  & Pick<Types.ThemeTagsFolder, 'id' | 'name'>
);

export type PressReleaseBase_ThemingMode_Fragment = (
  { __typename?: 'ThemingMode' }
  & Pick<Types.ThemingMode, 'id' | 'name'>
);

export type PressReleaseBase_ThemingModes_Fragment = (
  { __typename?: 'ThemingModes' }
  & Pick<Types.ThemingModes, 'id' | 'name'>
);

export type PressReleaseBase_Tile_Fragment = (
  { __typename?: 'Tile' }
  & Pick<Types.Tile, 'id' | 'name'>
);

export type PressReleaseBase_TileLink_Fragment = (
  { __typename?: 'TileLink' }
  & Pick<Types.TileLink, 'id' | 'name'>
);

export type PressReleaseBase_TileParametersTemplate_Fragment = (
  { __typename?: 'TileParametersTemplate' }
  & Pick<Types.TileParametersTemplate, 'id' | 'name'>
);

export type PressReleaseBase_TileSizeOption_Fragment = (
  { __typename?: 'TileSizeOption' }
  & Pick<Types.TileSizeOption, 'id' | 'name'>
);

export type PressReleaseBase_TileSizeOptionFolder_Fragment = (
  { __typename?: 'TileSizeOptionFolder' }
  & Pick<Types.TileSizeOptionFolder, 'id' | 'name'>
);

export type PressReleaseBase_TilesFolder_Fragment = (
  { __typename?: 'TilesFolder' }
  & Pick<Types.TilesFolder, 'id' | 'name'>
);

export type PressReleaseBase_TilesParametersTemplate_Fragment = (
  { __typename?: 'TilesParametersTemplate' }
  & Pick<Types.TilesParametersTemplate, 'id' | 'name'>
);

export type PressReleaseBase_Title_Fragment = (
  { __typename?: 'Title' }
  & Pick<Types.Title, 'id' | 'name'>
);

export type PressReleaseBase_Title_A82e893105754175917de904ef7e6dbe_Fragment = (
  { __typename?: 'Title_a82e893105754175917de904ef7e6dbe' }
  & Pick<Types.Title_A82e893105754175917de904ef7e6dbe, 'id' | 'name'>
);

export type PressReleaseBase_Toggle_Fragment = (
  { __typename?: 'Toggle' }
  & Pick<Types.Toggle, 'id' | 'name'>
);

export type PressReleaseBase_ToggleFolder_Fragment = (
  { __typename?: 'ToggleFolder' }
  & Pick<Types.ToggleFolder, 'id' | 'name'>
);

export type PressReleaseBase_Toggle_8e4c968e9fa543a89ac4c0baf273ccde_Fragment = (
  { __typename?: 'Toggle_8e4c968e9fa543a89ac4c0baf273ccde' }
  & Pick<Types.Toggle_8e4c968e9fa543a89ac4c0baf273ccde, 'id' | 'name'>
);

export type PressReleaseBase_Transformation_Fragment = (
  { __typename?: 'Transformation' }
  & Pick<Types.Transformation, 'id' | 'name'>
);

export type PressReleaseBase_TrustArticleHeroParametersTemplate_Fragment = (
  { __typename?: 'TrustArticleHeroParametersTemplate' }
  & Pick<Types.TrustArticleHeroParametersTemplate, 'id' | 'name'>
);

export type PressReleaseBase_TrustFinder_Fragment = (
  { __typename?: 'TrustFinder' }
  & Pick<Types.TrustFinder, 'id' | 'name'>
);

export type PressReleaseBase_TrustFinderFilterOption_Fragment = (
  { __typename?: 'TrustFinderFilterOption' }
  & Pick<Types.TrustFinderFilterOption, 'id' | 'name'>
);

export type PressReleaseBase_TrustRegion_Fragment = (
  { __typename?: 'TrustRegion' }
  & Pick<Types.TrustRegion, 'id' | 'name'>
);

export type PressReleaseBase_TrustType_Fragment = (
  { __typename?: 'TrustType' }
  & Pick<Types.TrustType, 'id' | 'name'>
);

export type PressReleaseBase_TrustTypesFolder_Fragment = (
  { __typename?: 'TrustTypesFolder' }
  & Pick<Types.TrustTypesFolder, 'id' | 'name'>
);

export type PressReleaseBase_Twitter_Fragment = (
  { __typename?: 'Twitter' }
  & Pick<Types.Twitter, 'id' | 'name'>
);

export type PressReleaseBase_TwitterApp_Fragment = (
  { __typename?: 'TwitterApp' }
  & Pick<Types.TwitterApp, 'id' | 'name'>
);

export type PressReleaseBase_TwitterApps_Fragment = (
  { __typename?: 'TwitterApps' }
  & Pick<Types.TwitterApps, 'id' | 'name'>
);

export type PressReleaseBase_TwitterFolder_Fragment = (
  { __typename?: 'TwitterFolder' }
  & Pick<Types.TwitterFolder, 'id' | 'name'>
);

export type PressReleaseBase_TwitterParametersTemplate_Fragment = (
  { __typename?: 'TwitterParametersTemplate' }
  & Pick<Types.TwitterParametersTemplate, 'id' | 'name'>
);

export type PressReleaseBase_TwitterSettings_Fragment = (
  { __typename?: 'TwitterSettings' }
  & Pick<Types.TwitterSettings, 'id' | 'name'>
);

export type PressReleaseBase_UnknownItem_Fragment = (
  { __typename?: 'UnknownItem' }
  & Pick<Types.UnknownItem, 'id' | 'name'>
);

export type PressReleaseBase_UnminifiedFile_Fragment = (
  { __typename?: 'UnminifiedFile' }
  & Pick<Types.UnminifiedFile, 'id' | 'name'>
);

export type PressReleaseBase_UpgradeScript_Fragment = (
  { __typename?: 'UpgradeScript' }
  & Pick<Types.UpgradeScript, 'id' | 'name'>
);

export type PressReleaseBase_UpgradeScriptLibrary_Fragment = (
  { __typename?: 'UpgradeScriptLibrary' }
  & Pick<Types.UpgradeScriptLibrary, 'id' | 'name'>
);

export type PressReleaseBase_VariantComponentField_Fragment = (
  { __typename?: 'VariantComponentField' }
  & Pick<Types.VariantComponentField, 'id' | 'name'>
);

export type PressReleaseBase_VariantDateField_Fragment = (
  { __typename?: 'VariantDateField' }
  & Pick<Types.VariantDateField, 'id' | 'name'>
);

export type PressReleaseBase_VariantDefinition_4d50cdaec2d94de8b0808f992bfb1b55_Fragment = (
  { __typename?: 'VariantDefinition_4d50cdaec2d94de8b0808f992bfb1b55' }
  & Pick<Types.VariantDefinition_4d50cdaec2d94de8b0808f992bfb1b55, 'id' | 'name'>
);

export type PressReleaseBase_VariantPlaceholder_Fragment = (
  { __typename?: 'VariantPlaceholder' }
  & Pick<Types.VariantPlaceholder, 'id' | 'name'>
);

export type PressReleaseBase_VariantReference_Fragment = (
  { __typename?: 'VariantReference' }
  & Pick<Types.VariantReference, 'id' | 'name'>
);

export type PressReleaseBase_VariantSection_Fragment = (
  { __typename?: 'VariantSection' }
  & Pick<Types.VariantSection, 'id' | 'name'>
);

export type PressReleaseBase_VariantTemplate_Fragment = (
  { __typename?: 'VariantTemplate' }
  & Pick<Types.VariantTemplate, 'id' | 'name'>
);

export type PressReleaseBase_VariantText_Fragment = (
  { __typename?: 'VariantText' }
  & Pick<Types.VariantText, 'id' | 'name'>
);

export type PressReleaseBase_VariantToken_Fragment = (
  { __typename?: 'VariantToken' }
  & Pick<Types.VariantToken, 'id' | 'name'>
);

export type PressReleaseBase_Variants_Fragment = (
  { __typename?: 'Variants' }
  & Pick<Types.Variants, 'id' | 'name'>
);

export type PressReleaseBase_VectorFolder_Fragment = (
  { __typename?: 'VectorFolder' }
  & Pick<Types.VectorFolder, 'id' | 'name'>
);

export type PressReleaseBase_VectorTile_Fragment = (
  { __typename?: 'VectorTile' }
  & Pick<Types.VectorTile, 'id' | 'name'>
);

export type PressReleaseBase_VectorTileLink_Fragment = (
  { __typename?: 'VectorTileLink' }
  & Pick<Types.VectorTileLink, 'id' | 'name'>
);

export type PressReleaseBase_VectorTilesFolder_Fragment = (
  { __typename?: 'VectorTilesFolder' }
  & Pick<Types.VectorTilesFolder, 'id' | 'name'>
);

export type PressReleaseBase_VectorTilesParametersTemplate_Fragment = (
  { __typename?: 'VectorTilesParametersTemplate' }
  & Pick<Types.VectorTilesParametersTemplate, 'id' | 'name'>
);

export type PressReleaseBase_Version_95ebc23204774dc38ad3465d5fe8da2f_Fragment = (
  { __typename?: 'Version_95ebc23204774dc38ad3465d5fe8da2f' }
  & Pick<Types.Version_95ebc23204774dc38ad3465d5fe8da2f, 'id' | 'name'>
);

export type PressReleaseBase_Video_Fragment = (
  { __typename?: 'Video' }
  & Pick<Types.Video, 'id' | 'name'>
);

export type PressReleaseBase_VideoCountOption_Fragment = (
  { __typename?: 'VideoCountOption' }
  & Pick<Types.VideoCountOption, 'id' | 'name'>
);

export type PressReleaseBase_VideoCountOptions_Fragment = (
  { __typename?: 'VideoCountOptions' }
  & Pick<Types.VideoCountOptions, 'id' | 'name'>
);

export type PressReleaseBase_VideoFolder_Fragment = (
  { __typename?: 'VideoFolder' }
  & Pick<Types.VideoFolder, 'id' | 'name'>
);

export type PressReleaseBase_VideoFolder_Bba49474673e468186ba8b1a20e067a9_Fragment = (
  { __typename?: 'VideoFolder_bba49474673e468186ba8b1a20e067a9' }
  & Pick<Types.VideoFolder_Bba49474673e468186ba8b1a20e067a9, 'id' | 'name'>
);

export type PressReleaseBase_VideoPage_Fragment = (
  { __typename?: 'VideoPage' }
  & Pick<Types.VideoPage, 'id' | 'name'>
);

export type PressReleaseBase_VideoParameters_Fragment = (
  { __typename?: 'VideoParameters' }
  & Pick<Types.VideoParameters, 'id' | 'name'>
);

export type PressReleaseBase_VideoParametersTemplate_Fragment = (
  { __typename?: 'VideoParametersTemplate' }
  & Pick<Types.VideoParametersTemplate, 'id' | 'name'>
);

export type PressReleaseBase_VideoPressReleasePage_Fragment = (
  { __typename?: 'VideoPressReleasePage' }
  & Pick<Types.VideoPressReleasePage, 'id' | 'name'>
);

export type PressReleaseBase_Video_4bc649610a894242be2dc5026090cf49_Fragment = (
  { __typename?: 'Video_4bc649610a894242be2dc5026090cf49' }
  & Pick<Types.Video_4bc649610a894242be2dc5026090cf49, 'id' | 'name'>
);

export type PressReleaseBase__AssetsOptimization_Fragment = (
  { __typename?: '_AssetsOptimization' }
  & Pick<Types._AssetsOptimization, 'id' | 'name'>
);

export type PressReleaseBase__BackgroundImage_Fragment = (
  { __typename?: '_BackgroundImage' }
  & Pick<Types._BackgroundImage, 'id' | 'name'>
);

export type PressReleaseBase__CompatibleThemes_Fragment = (
  { __typename?: '_CompatibleThemes' }
  & Pick<Types._CompatibleThemes, 'id' | 'name'>
);

export type PressReleaseBase__CompositeTheme_Fragment = (
  { __typename?: '_CompositeTheme' }
  & Pick<Types._CompositeTheme, 'id' | 'name'>
);

export type PressReleaseBase__CustomMetadata_Fragment = (
  { __typename?: '_CustomMetadata' }
  & Pick<Types._CustomMetadata, 'id' | 'name'>
);

export type PressReleaseBase__CustomRenderingViewPath_Fragment = (
  { __typename?: '_CustomRenderingViewPath' }
  & Pick<Types._CustomRenderingViewPath, 'id' | 'name'>
);

export type PressReleaseBase__DatasourceBehaviour_Fragment = (
  { __typename?: '_DatasourceBehaviour' }
  & Pick<Types._DatasourceBehaviour, 'id' | 'name'>
);

export type PressReleaseBase__Favicon_Fragment = (
  { __typename?: '_Favicon' }
  & Pick<Types._Favicon, 'id' | 'name'>
);

export type PressReleaseBase__FormsFolderLocation_Fragment = (
  { __typename?: '_FormsFolderLocation' }
  & Pick<Types._FormsFolderLocation, 'id' | 'name'>
);

export type PressReleaseBase__FundSettings_Fragment = (
  { __typename?: '_FundSettings' }
  & Pick<Types._FundSettings, 'id' | 'name'>
);

export type PressReleaseBase__HasValidUrlName_Fragment = (
  { __typename?: '_HasValidUrlName' }
  & Pick<Types._HasValidUrlName, 'id' | 'name'>
);

export type PressReleaseBase__LocalDataLink_Fragment = (
  { __typename?: '_LocalDataLink' }
  & Pick<Types._LocalDataLink, 'id' | 'name'>
);

export type PressReleaseBase__Login_Fragment = (
  { __typename?: '_Login' }
  & Pick<Types._Login, 'id' | 'name'>
);

export type PressReleaseBase__OpenGraphMetadata_Fragment = (
  { __typename?: '_OpenGraphMetadata' }
  & Pick<Types._OpenGraphMetadata, 'id' | 'name'>
);

export type PressReleaseBase__PageDesignTheme_Fragment = (
  { __typename?: '_PageDesignTheme' }
  & Pick<Types._PageDesignTheme, 'id' | 'name'>
);

export type PressReleaseBase__PageSearchScope_Fragment = (
  { __typename?: '_PageSearchScope' }
  & Pick<Types._PageSearchScope, 'id' | 'name'>
);

export type PressReleaseBase__SearchCriteria_Fragment = (
  { __typename?: '_SearchCriteria' }
  & Pick<Types._SearchCriteria, 'id' | 'name'>
);

export type PressReleaseBase__SearchableWithoutRelatedItems_Fragment = (
  { __typename?: '_SearchableWithoutRelatedItems' }
  & Pick<Types._SearchableWithoutRelatedItems, 'id' | 'name'>
);

export type PressReleaseBase__SeoMetadata_Fragment = (
  { __typename?: '_SeoMetadata' }
  & Pick<Types._SeoMetadata, 'id' | 'name'>
);

export type PressReleaseBase__SiteTheme_Fragment = (
  { __typename?: '_SiteTheme' }
  & Pick<Types._SiteTheme, 'id' | 'name'>
);

export type PressReleaseBase__SitemapSettings_Fragment = (
  { __typename?: '_SitemapSettings' }
  & Pick<Types._SitemapSettings, 'id' | 'name'>
);

export type PressReleaseBase__StickyNote_Fragment = (
  { __typename?: '_StickyNote' }
  & Pick<Types._StickyNote, 'id' | 'name'>
);

export type PressReleaseBase__Styleable_Fragment = (
  { __typename?: '_Styleable' }
  & Pick<Types._Styleable, 'id' | 'name'>
);

export type PressReleaseBase__TwitterMetadata_Fragment = (
  { __typename?: '_TwitterMetadata' }
  & Pick<Types._TwitterMetadata, 'id' | 'name'>
);

export type PressReleaseBase__Webinar_Fragment = (
  { __typename?: '_Webinar' }
  & Pick<Types._Webinar, 'id' | 'name'>
);

export type PressReleaseBase__WildcardSource_Fragment = (
  { __typename?: '_WildcardSource' }
  & Pick<Types._WildcardSource, 'id' | 'name'>
);

export type PressReleaseBaseFragment = PressReleaseBase_Accordion_Fragment | PressReleaseBase_AccordionFolder_Fragment | PressReleaseBase_AccordionFolder_03f88fb497884025b46f2cb249f4fcd6_Fragment | PressReleaseBase_AccordionItem_Fragment | PressReleaseBase_AccordionItem_8cf671721b2d489e809f4c23db5ab2da_Fragment | PressReleaseBase_AccordionParametersTemplate_Fragment | PressReleaseBase_AccordionPresentation_Fragment | PressReleaseBase_AccordionPresentationFolder_Fragment | PressReleaseBase_Accordion_02d060598cc14423a9ac9ff2365176b7_Fragment | PressReleaseBase_Accordion_705cc8b3bde54cb3bf1ce455a2a36ef1_Fragment | PressReleaseBase_AddItem_Fragment | PressReleaseBase_AddItem_1e1b739ec3784909941d171aca7362e5_Fragment | PressReleaseBase_AddItem_3aea335cd06d45b1841acbc8d2d1ce40_Fragment | PressReleaseBase_AddItem_De8c75222f3241288f20342f479894eb_Fragment | PressReleaseBase_AddItem_Ea8a3f269ccd443a95f571b868a94bd0_Fragment | PressReleaseBase_AddThisParameters_Fragment | PressReleaseBase_AggregatedFacetFilter_Fragment | PressReleaseBase_AlertMessage_Fragment | PressReleaseBase_AlertMessageFolder_Fragment | PressReleaseBase_AlertMessageParametersTemplate_Fragment | PressReleaseBase_AlertMessageType_Fragment | PressReleaseBase_AllertMessageTypeFolder_Fragment | PressReleaseBase_Archive_Fragment | PressReleaseBase_ArticleAuthor_Fragment | PressReleaseBase_ArticleAuthorsFolder_Fragment | PressReleaseBase_ArticleCategoriesFolder_Fragment | PressReleaseBase_ArticleCategory_Fragment | PressReleaseBase_ArticleChapter_Fragment | PressReleaseBase_ArticleChapters_Fragment | PressReleaseBase_ArticleContentType_Fragment | PressReleaseBase_ArticleContentTypesFolder_Fragment | PressReleaseBase_ArticleFilter_Fragment | PressReleaseBase_ArticleFilterOption_Fragment | PressReleaseBase_ArticleFootnote_Fragment | PressReleaseBase_ArticleFootnoteLink_Fragment | PressReleaseBase_ArticleFootnoteText_Fragment | PressReleaseBase_ArticleInfogramTile_Fragment | PressReleaseBase_ArticleInfogramTileParametersTemplate_Fragment | PressReleaseBase_ArticlePage_Fragment | PressReleaseBase_ArticleRegion_Fragment | PressReleaseBase_ArticleRegionsFolder_Fragment | PressReleaseBase_ArticleSearchPage_Fragment | PressReleaseBase_ArticleSearchPage_4d8bd0d1a07841dc96405ca1ed71d81c_Fragment | PressReleaseBase_ArticleSearchPage_22b7f7c7c37f4644a8eed9c32258b4a2_Fragment | PressReleaseBase_ArticleSearchPage_Be414ff574ac4203abb2694811443e25_Fragment | PressReleaseBase_ArticleSearchPage_C7ad44ac3cab45158b619465a552a82c_Fragment | PressReleaseBase_ArticleSearchPage_Cf31bd740a4b4363b03d1f7a88e39907_Fragment | PressReleaseBase_ArticleSeriesCollection_Fragment | PressReleaseBase_ArticleSeriesFolder_Fragment | PressReleaseBase_ArticleSettings_Fragment | PressReleaseBase_ArticleSubscriptionBanner_Fragment | PressReleaseBase_ArticleSubscriptionBannerFolder_Fragment | PressReleaseBase_ArticleTag_Fragment | PressReleaseBase_ArticleTagsFolder_Fragment | PressReleaseBase_ArticleTeamAuthor_Fragment | PressReleaseBase_ArticleTileParametersTemplate_Fragment | PressReleaseBase_ArticleTilesParametersTemplate_Fragment | PressReleaseBase_ArticleWildcardPage_4bf0be7a0c5c41d5973bb82f1ec73f8f_Fragment | PressReleaseBase_ArticleWildcardPage_8f17c5d3ea39491494916dbfe2410ad8_Fragment | PressReleaseBase_ArticleWildcardPage_84a63b4789ee4a3f82684b750a6a23ca_Fragment | PressReleaseBase_ArticleWildcardPage_95e7966e0da1412bafbf0e8a69392c8c_Fragment | PressReleaseBase_ArticleWildcardPage_405b20252077400383d3b47f09f88b47_Fragment | PressReleaseBase_ArticleWildcardPage_B037a577f5cb4ad3b79f07720a96985b_Fragment | PressReleaseBase_ArticlesGroupFolder_Fragment | PressReleaseBase_AttachThemeExtension_Fragment | PressReleaseBase_AutomaticDocumentListings_Fragment | PressReleaseBase_AutomaticDocumentListingsFolder_Fragment | PressReleaseBase_AvailableJsonRenderings_Fragment | PressReleaseBase_AvailableMetaRenderings_Fragment | PressReleaseBase_AvailableRenderings_Fragment | PressReleaseBase_AvailableRenderingsFolder_26ec1d1811b24dd98326f6115f4fd7eb_Fragment | PressReleaseBase_AwardsBanner_Fragment | PressReleaseBase_AwardsBannerFolder_Fragment | PressReleaseBase_AwardsBannerImage_Fragment | PressReleaseBase_AwardsBannerParametersTemplate_Fragment | PressReleaseBase_ByocWrapperRenderingParameters_Fragment | PressReleaseBase_BackgroundColorOption_Fragment | PressReleaseBase_BackgroundColorOptionFolder_Fragment | PressReleaseBase_BannerFolder_Fragment | PressReleaseBase_BannerType_Fragment | PressReleaseBase_BannerTypeFolder_Fragment | PressReleaseBase_BaseHeading_Fragment | PressReleaseBase_BaseHeadingFolder_Fragment | PressReleaseBase_BoolFacet_Fragment | PressReleaseBase_BranchesFolder_Fragment | PressReleaseBase_Breadcrumb_Fragment | PressReleaseBase_BrowserTitleDefinition_Fragment | PressReleaseBase_CorsEntry_Fragment | PressReleaseBase_CorsGrouping_Fragment | PressReleaseBase_CtaPresentationType_Fragment | PressReleaseBase_CtaPresentationTypeFolder_Fragment | PressReleaseBase_C__AbrdnPage_Fragment | PressReleaseBase_C__ActionBase_Fragment | PressReleaseBase_C__AdvancedParameter_Fragment | PressReleaseBase_C__App_Fragment | PressReleaseBase_C__ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180c_Fragment | PressReleaseBase_C__ArticleWildcardPage_Fragment | PressReleaseBase_C__AvailableRenderingsFolder_Fragment | PressReleaseBase_C__ByocRenderingParameters_Fragment | PressReleaseBase_C__BackgroundParametersTemplate_Fragment | PressReleaseBase_C__BaseCta_Fragment | PressReleaseBase_C__BasePage_Fragment | PressReleaseBase_C__BasePage_037da552a5524fe4aeee331f57ac1378_Fragment | PressReleaseBase_C__BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f_Fragment | PressReleaseBase_C__BasePage_315fd21bebf04c9d9f00bae191442f1d_Fragment | PressReleaseBase_C__BasePage_458c6cc442da4327b4d4d7d4ecd48cbd_Fragment | PressReleaseBase_C__BasePage_728c97b5c56146d9807e21018a972bb5_Fragment | PressReleaseBase_C__BasePage_6105875085f346729dfc8d133b481f26_Fragment | PressReleaseBase_C__BasePage_B08130ebd3314a3b9c0f2b5e9b66387b_Fragment | PressReleaseBase_C__BaseRenderingParameters_Fragment | PressReleaseBase_C__BaseTheme_Fragment | PressReleaseBase_C__BaseVariantField_Fragment | PressReleaseBase_C__Class_Fragment | PressReleaseBase_C__CompositeGroup_Fragment | PressReleaseBase_C__CompositeSection_Fragment | PressReleaseBase_C__EloquaForm_Fragment | PressReleaseBase_C__ErrorPage_D40dd5cadbf1461191b8f9e1071e557d_Fragment | PressReleaseBase_C__ExtendedOptions_Fragment | PressReleaseBase_C__ExtendedOptions_2964fb4257a6440fb192218443904c90_Fragment | PressReleaseBase_C__ExtendedOptions_F1850030f97848b4bdb5884b7e863160_Fragment | PressReleaseBase_C__FEaaSRenderingParameters_Fragment | PressReleaseBase_C__FacetSelectorConfigBase_Fragment | PressReleaseBase_C__FilteredArticlesParentPage_8196d9b5309f49f882f7918089b77845_Fragment | PressReleaseBase_C__FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2b_Fragment | PressReleaseBase_C__FundDetailsWildcardPage_Fb127f7aeeba46458c5fbe9f7c589303_Fragment | PressReleaseBase_C__FundSearchPage_D83da2a5ce9042b6bd557aa8820c62c5_Fragment | PressReleaseBase_C__FundShareclassDetailsWildcardPage_E3590ad764a84980a419c4f1f926f9fc_Fragment | PressReleaseBase_C__GlobalDatasourceBehavior_Fragment | PressReleaseBase_C__GridDefinition_Fragment | PressReleaseBase_C__GridItemBase_Fragment | PressReleaseBase_C__GridParameters_Fragment | PressReleaseBase_C__HeadlessSite_Fragment | PressReleaseBase_C__HeadlessTenant_Fragment | PressReleaseBase_C__HelpArticleSearchPage_D1c4d91365c8401389dcde7b5fb2f28b_Fragment | PressReleaseBase_C__HelpArticleWildcardPage_C0a939305f6e47a38739f2a8f300e65d_Fragment | PressReleaseBase_C__HomePage_2899b95da7f346b7a1da7ef14d7ef84d_Fragment | PressReleaseBase_C__IAllowEmpty_Fragment | PressReleaseBase_C__IBaseVariantDefinition_Fragment | PressReleaseBase_C__IBoosting_Fragment | PressReleaseBase_C__ICacheable_Fragment | PressReleaseBase_C__ICompatibleRenderings_Fragment | PressReleaseBase_C__IComponentVariant_Fragment | PressReleaseBase_C__IControlType_Fragment | PressReleaseBase_C__IDynamicPlaceholder_Fragment | PressReleaseBase_C__IfEaaSComponentsDataSourceTemplates_Fragment | PressReleaseBase_C__IfEaaSComponentsEditorScriptUrl_Fragment | PressReleaseBase_C__IIcon_Fragment | PressReleaseBase_C__ILocation_Fragment | PressReleaseBase_C__IPaginable_Fragment | PressReleaseBase_C__IPagination_Fragment | PressReleaseBase_C__IPoi_Fragment | PressReleaseBase_C__IRenderingId_Fragment | PressReleaseBase_C__ISplitter_Fragment | PressReleaseBase_C__IStyling_Fragment | PressReleaseBase_C__IVariantDefinition_Fragment | PressReleaseBase_C__InvestmentTrustPage_Fragment | PressReleaseBase_C__JsonField_Fragment | PressReleaseBase_C__JsonReference_Fragment | PressReleaseBase_C__JssData_Fragment | PressReleaseBase_C__JssSettings_Fragment | PressReleaseBase_C__JssSiteFolder_Fragment | PressReleaseBase_C__JssRootFolder_Fragment | PressReleaseBase_C__LiteratureHubSearchPage_5378ef42e2c4488497ac7cc017b10086_Fragment | PressReleaseBase_C__Navigation_E6d98f24d01c419e871a4617125a49ed_Fragment | PressReleaseBase_C__Page_Fragment | PressReleaseBase_C__PageData_Fragment | PressReleaseBase_C__PageDesignFolder_Fragment | PressReleaseBase_C__PageDesignFolder_023f5d48979d4381bc5e149e36abd3bd_Fragment | PressReleaseBase_C__PageDesigns_Daaf41fd96db4892be99f62f16d036c4_Fragment | PressReleaseBase_C__PartialDesign_Fragment | PressReleaseBase_C__PartialDesignFolder_Fragment | PressReleaseBase_C__PartialDesignFolder_25f01f50553444f9b1babcbb60b2d13d_Fragment | PressReleaseBase_C__PartialDesigns_79c9fa015f6a48b2b45905bbaa826a9d_Fragment | PressReleaseBase_C__PlaceholderWrapper_Fragment | PressReleaseBase_C__PressReleaseSearchPage_4197f4d95d5f4fb3be77e0be695df7ac_Fragment | PressReleaseBase_C__PressReleaseWildcardPage_6a8c237f261d4a9891ef3e27afee2b9b_Fragment | PressReleaseBase_C__RedirectMapGrouping_Fragment | PressReleaseBase_C__ResizableIFramePage_6ff27d6556ff453393bbb3f7f568d973_Fragment | PressReleaseBase_C__Route_Fragment | PressReleaseBase_C__SimpleVideo_Fragment | PressReleaseBase_C__SiteSettingsFolder_Fragment | PressReleaseBase_C__SitemapSettings_Fragment | PressReleaseBase_C__StandardTemplate_Fragment | PressReleaseBase_C__TeamMembersParentPage_11fbd080aa844abca056f5caac316e4c_Fragment | PressReleaseBase_C__TeamMembersWildcardPage_8b12628190064b2980f0a054ead02a65_Fragment | PressReleaseBase_C__TrustFolder_Fragment | PressReleaseBase_C__VariantDefinition_Fragment | PressReleaseBase_C__VariantField_Fragment | PressReleaseBase_C__VariantsGrouping_Fragment | PressReleaseBase_C___AdvancedItem_Fragment | PressReleaseBase_C___Arguments_Fragment | PressReleaseBase_C___Arguments_33fab87cd52f44319a1f589ba7c1e287_Fragment | PressReleaseBase_C___Article_Fragment | PressReleaseBase_C___ArticlePageWorkflow_Fragment | PressReleaseBase_C___ArticleSearchPage_Fragment | PressReleaseBase_C___ArticleWildcard_Fragment | PressReleaseBase_C___AssetServiceThemeMode_Fragment | PressReleaseBase_C___BaseArticle_Fragment | PressReleaseBase_C___BaseDataFolder_Fragment | PressReleaseBase_C___BaseHelpArticle_Fragment | PressReleaseBase_C___BaseInvestmentTrust_Fragment | PressReleaseBase_C___BaseJssTenant_Fragment | PressReleaseBase_C___BasePage_Fragment | PressReleaseBase_C___BasePageDesign_Fragment | PressReleaseBase_C___BasePageDesignFolder_Fragment | PressReleaseBase_C___BasePartialDesign_Fragment | PressReleaseBase_C___BasePartialDesignFolder_Fragment | PressReleaseBase_C___BasePlaceholder_Fragment | PressReleaseBase_C___BasePlaceholderSettingsFolder_Fragment | PressReleaseBase_C___BasePresentation_Fragment | PressReleaseBase_C___BasePressRelease_Fragment | PressReleaseBase_C___BaseRenderingParameters_Fragment | PressReleaseBase_C___BaseSxaStandardValuesFolder_Fragment | PressReleaseBase_C___BaseSettings_Fragment | PressReleaseBase_C___BaseSharedSitesSettings_Fragment | PressReleaseBase_C___BaseSiteDefinition_Fragment | PressReleaseBase_C___BaseSiteFolder_Fragment | PressReleaseBase_C___BaseSiteGrouping_Fragment | PressReleaseBase_C___BaseSiteRoot_Fragment | PressReleaseBase_C___BaseTenant_Fragment | PressReleaseBase_C___BaseTenantFolder_Fragment | PressReleaseBase_C___BucketRules_Fragment | PressReleaseBase_C___Cors_Fragment | PressReleaseBase_C___Content_Fragment | PressReleaseBase_C___ContentType_Fragment | PressReleaseBase_C___DataAttributes_Fragment | PressReleaseBase_C___DatasourceWorkflow_Fragment | PressReleaseBase_C___Dependencies_Fragment | PressReleaseBase_C___Description_Fragment | PressReleaseBase_C___DesignTemplateMapping_Fragment | PressReleaseBase_C___Designable_Fragment | PressReleaseBase_C___EditType_Fragment | PressReleaseBase_C___EditType_8a9f84baaa124c5d9096935714809da4_Fragment | PressReleaseBase_C___EditingTheme_Fragment | PressReleaseBase_C___Enabled_Fragment | PressReleaseBase_C___ErrorHandling_Fragment | PressReleaseBase_C___ExternalArticle_Fragment | PressReleaseBase_C___Fields_Fragment | PressReleaseBase_C___FilteredArticlesParent_Fragment | PressReleaseBase_C___FilteredArticlesWildcard_Fragment | PressReleaseBase_C___Footnotes_Fragment | PressReleaseBase_C___FundDetailsWildcard_Fragment | PressReleaseBase_C___FundFormAvailability_Fragment | PressReleaseBase_C___FundMetadataPage_Fragment | PressReleaseBase_C___FundSearchPage_Fragment | PressReleaseBase_C___FundsFolder_Fragment | PressReleaseBase_C___FundsFormsFolder_Fragment | PressReleaseBase_C___FundsLiteratureFolder_Fragment | PressReleaseBase_C___FundsShareclassesDetailsWildcard_Fragment | PressReleaseBase_C___GridMapping_Fragment | PressReleaseBase_C___HelpArticle_Fragment | PressReleaseBase_C___HelpArticleSearchPage_Fragment | PressReleaseBase_C___HelpArticleWildcard_Fragment | PressReleaseBase_C___HorizonDatasourceGrouping_Fragment | PressReleaseBase_C___Icon_Fragment | PressReleaseBase_C___IncludeByDefault_Fragment | PressReleaseBase_C___IncludeIfInstalled_Fragment | PressReleaseBase_C___InternalArticle_Fragment | PressReleaseBase_C___InternetExplorerCompatibilityMode_Fragment | PressReleaseBase_C___IsSystemModule_Fragment | PressReleaseBase_C___JsonVariantPaging_Fragment | PressReleaseBase_C___JsonVariantsBase_Fragment | PressReleaseBase_C___LimitedDisplay_Fragment | PressReleaseBase_C___LinkAttributes_Fragment | PressReleaseBase_C___LinkSettings_Fragment | PressReleaseBase_C___LiteratureHubSearchPage_Fragment | PressReleaseBase_C___ManualKeyInformation_Fragment | PressReleaseBase_C___MemberOf_Fragment | PressReleaseBase_C___MetadataPage_Fragment | PressReleaseBase_C___Modules_Fragment | PressReleaseBase_C___Name_Fragment | PressReleaseBase_C___Name_0345fd2f95094dc7b0f56c73a9b6cd8d_Fragment | PressReleaseBase_C___Name_299cdb154745448a807868d401248eaa_Fragment | PressReleaseBase_C___Name_B88cf88159a54a19991e71038751cb60_Fragment | PressReleaseBase_C___Navigable_Fragment | PressReleaseBase_C___NavigablePage_Fragment | PressReleaseBase_C___PageContent_Fragment | PressReleaseBase_C___PageWorkflow_Fragment | PressReleaseBase_C___PerSiteStandardValues_Fragment | PressReleaseBase_C___Podcast_Fragment | PressReleaseBase_C___PodcastPressRelease_Fragment | PressReleaseBase_C___PremiumContentPage_Fragment | PressReleaseBase_C___PressRelease_Fragment | PressReleaseBase_C___PressReleaseContentType_Fragment | PressReleaseBase_C___PressReleaseSearchPage_Fragment | PressReleaseBase_C___PressReleaseWildcard_Fragment | PressReleaseBase_C___ProtectedTheme_Fragment | PressReleaseBase_C___PublishingGroupingTemplate_Fragment | PressReleaseBase_C___RenderingRelatedParameters_Fragment | PressReleaseBase_C___RenderingVariantsBase_Fragment | PressReleaseBase_C___RenderingsList_Fragment | PressReleaseBase_C___RobotsContent_Fragment | PressReleaseBase_C___RoleDomain_Fragment | PressReleaseBase_C___RoleName_Fragment | PressReleaseBase_C___RoleType_Fragment | PressReleaseBase_C___SalesforceCommonValidations_Fragment | PressReleaseBase_C___SalesforceFieldId_Fragment | PressReleaseBase_C___SalesforceFieldTitle_Fragment | PressReleaseBase_C___SalesforceFieldValue_Fragment | PressReleaseBase_C___Script_Fragment | PressReleaseBase_C___SearchSignature_Fragment | PressReleaseBase_C___Searchable_Fragment | PressReleaseBase_C___SecurityItemPointer_Fragment | PressReleaseBase_C___SharedArticles_Fragment | PressReleaseBase_C___SharedContent_Fragment | PressReleaseBase_C___SharedHelpArticles_Fragment | PressReleaseBase_C___SharedPage_Fragment | PressReleaseBase_C___SharedPressReleases_Fragment | PressReleaseBase_C___SharedRoot_Fragment | PressReleaseBase_C___SharedSettings_Fragment | PressReleaseBase_C___SiteContent_Fragment | PressReleaseBase_C___SiteFolder_Fragment | PressReleaseBase_C___SiteMediaLibrary_Fragment | PressReleaseBase_C___SiteSettings_Fragment | PressReleaseBase_C___SiteTemplate_Fragment | PressReleaseBase_C___SitecoreClientSiteManaging_Fragment | PressReleaseBase_C___Sitemap_Fragment | PressReleaseBase_C___SitemapMediaItems_Fragment | PressReleaseBase_C___SlidersRangeSettings_Fragment | PressReleaseBase_C___SolutionTemplateContent_Fragment | PressReleaseBase_C___SolutionTemplateDescription_Fragment | PressReleaseBase_C___SolutionTemplateName_Fragment | PressReleaseBase_C___SortOrder_Fragment | PressReleaseBase_C___StackBreakpoint_Fragment | PressReleaseBase_C___Statistics_Fragment | PressReleaseBase_C___SupportedLanguages_Fragment | PressReleaseBase_C___Taggable_Fragment | PressReleaseBase_C___TeamMembersParentPage_Fragment | PressReleaseBase_C___TeamMembersWildcard_Fragment | PressReleaseBase_C___TechzoneArticle_Fragment | PressReleaseBase_C___Template_Fragment | PressReleaseBase_C___Title_Fragment | PressReleaseBase_C___Type_Fragment | PressReleaseBase_C___Validation_Fragment | PressReleaseBase_C___VariantPaging_Fragment | PressReleaseBase_C___VectorTile_Fragment | PressReleaseBase_C___VectorTileLink_Fragment | PressReleaseBase_C___Video_Fragment | PressReleaseBase_C___VideoPressRelease_Fragment | PressReleaseBase_C___Width_Fragment | PressReleaseBase_C___WildcardPage_Fragment | PressReleaseBase_CacheSetting_Fragment | PressReleaseBase_Caching_26fce9bf0256458d8281a713a5bf5520_Fragment | PressReleaseBase_CalendarEvent_Fragment | PressReleaseBase_CallOutSection_Fragment | PressReleaseBase_CallOutSectionDropdownOption_Fragment | PressReleaseBase_CallOutSectionFolder_Fragment | PressReleaseBase_CallOutSectionParametersTemplate_Fragment | PressReleaseBase_CallToAction_Fragment | PressReleaseBase_CallToActionFolder_Fragment | PressReleaseBase_CapabilitiesFolder_Fragment | PressReleaseBase_Capability_Fragment | PressReleaseBase_CapabilityMap_Fragment | PressReleaseBase_CapabilityMappings_Fragment | PressReleaseBase_Carousel_Fragment | PressReleaseBase_CarouselFolder_Fragment | PressReleaseBase_CarouselSlide_Fragment | PressReleaseBase_Carousel_2b65f0d87ec54834b4aa1753c0f7036b_Fragment | PressReleaseBase_Checkbox_Fragment | PressReleaseBase_ChecklistFilter_Fragment | PressReleaseBase_ChecklistFilterFolder_Fragment | PressReleaseBase_ChecklistFilter_3cb40bd669c94976a9742120a5eba1ee_Fragment | PressReleaseBase_ColumnSplitter_Fragment | PressReleaseBase_ColumnSplitter_3e1016e56ecb4c19aa0117c18b42deb0_Fragment | PressReleaseBase_CompatibilityMode_Fragment | PressReleaseBase_ComponentConfiguration_Fragment | PressReleaseBase_ComponentThemeConfiguration_Fragment | PressReleaseBase_ComponentThemesConfiguration_Fragment | PressReleaseBase_ComponentsConfigurations_Fragment | PressReleaseBase_ConfigurationFolder_Fragment | PressReleaseBase_Container_Fragment | PressReleaseBase_ContainerOption_Fragment | PressReleaseBase_ContainerOptionsFolder_Fragment | PressReleaseBase_ContainerParametersTemplate_Fragment | PressReleaseBase_Container_45130bdbbae34edcaea87b68b9d94c7f_Fragment | PressReleaseBase_ContentBlock_Fragment | PressReleaseBase_ContentBlockFolder_Fragment | PressReleaseBase_ContentToken_Fragment | PressReleaseBase_ContentTokenFolder_Fragment | PressReleaseBase_ContentType_Fragment | PressReleaseBase_CorporateTheme_Fragment | PressReleaseBase_CorporateThemesFolder_Fragment | PressReleaseBase_Country_Fragment | PressReleaseBase_CountryIsoCode_Fragment | PressReleaseBase_CountryIsoCodesFolder_Fragment | PressReleaseBase_CustomerReviewFolder_Fragment | PressReleaseBase_CustomerReviewTile_Fragment | PressReleaseBase_CustomerReviewTileParametersTemplate_Fragment | PressReleaseBase_DataBridgeDocumentCategoryMap_Fragment | PressReleaseBase_DataBridgeFund_Fragment | PressReleaseBase_DataBridgeFundRangeName_Fragment | PressReleaseBase_DataBridgeSettingsFolder_Fragment | PressReleaseBase_DataBridgeShareClass_Fragment | PressReleaseBase_DataFolder_Fragment | PressReleaseBase_DatasourceConfiguration_Fragment | PressReleaseBase_DatasourceConfigurations_Fragment | PressReleaseBase_DatasourceWorkflowAction_Fragment | PressReleaseBase_DateFacet_Fragment | PressReleaseBase_DateFilter_Fragment | PressReleaseBase_DateFilterFolder_Fragment | PressReleaseBase_DateFilter_Ad89c1f1e99148ef865938ab13aa28f1_Fragment | PressReleaseBase_DefaultColumnLayout_Fragment | PressReleaseBase_DefaultShareclassMapping_Fragment | PressReleaseBase_DefaultShareclassMappings_Fragment | PressReleaseBase_DescriptiveHighlight_Fragment | PressReleaseBase_DescriptiveHighlightFolder_Fragment | PressReleaseBase_DescriptiveHighlightItem_Fragment | PressReleaseBase_DescriptiveHighlightParametersTemplate_Fragment | PressReleaseBase_Device_Fragment | PressReleaseBase_Device_7c27ec70f42e40428a0fabaa2f8eda18_Fragment | PressReleaseBase_Devices_Fragment | PressReleaseBase_DictionaryFolder_Fragment | PressReleaseBase_DisqusParameters_Fragment | PressReleaseBase_DistanceFacet_Fragment | PressReleaseBase_Divider_Fragment | PressReleaseBase_DocumentItem_Fragment | PressReleaseBase_DocumentListings_Fragment | PressReleaseBase_DocumentListingsFolder_Fragment | PressReleaseBase_DocumentTypeFolder_Fragment | PressReleaseBase_DominantLanguageMapping_Fragment | PressReleaseBase_Dropdown_Fragment | PressReleaseBase_DropdownFilter_Fragment | PressReleaseBase_DropdownFilterFolder_Fragment | PressReleaseBase_DropdownFilter_790c0f2c16214604a6c672b9f8ae830d_Fragment | PressReleaseBase_EditEditingTheme_Fragment | PressReleaseBase_EditFrame_Fragment | PressReleaseBase_EditModePanel_Fragment | PressReleaseBase_EditSiteItem_Fragment | PressReleaseBase_EditSiteItem_F040db0387fe4e10ae4053c63175e31b_Fragment | PressReleaseBase_EditSiteTheme_Fragment | PressReleaseBase_EditTenantTemplate_Fragment | PressReleaseBase_EditTenantTemplate_A7d9fcbcc8944274935f9b9659c000d3_Fragment | PressReleaseBase_EditType_Fragment | PressReleaseBase_EloquaFormFolder_Fragment | PressReleaseBase_EloquaFundForm_Fragment | PressReleaseBase_Enum_Fragment | PressReleaseBase_Enums_Fragment | PressReleaseBase_ErrorPage_Fragment | PressReleaseBase_ErrorPage_4b405ec4ef9f4c91a3ffb98c1ac81171_Fragment | PressReleaseBase_ErrorPage_4dbccce416d1491f94198496e3f77c6d_Fragment | PressReleaseBase_ErrorPage_45d797cc048740ffb693214883ff35c2_Fragment | PressReleaseBase_ErrorPage_76eb47b3f3a248bdbbdbb5bf7d8f9bf9_Fragment | PressReleaseBase_ErrorPage_A7dfa49761224679bf9949fffacd5fa1_Fragment | PressReleaseBase_EventCalendarParameters_Fragment | PressReleaseBase_EventList_Fragment | PressReleaseBase_EventListParameters_Fragment | PressReleaseBase_EventTypes_Fragment | PressReleaseBase_EventsFolder_Fragment | PressReleaseBase_ExecuteScript_Fragment | PressReleaseBase_ExecuteScript_3d4e4577ab334ca6ae43b98d1ec6472f_Fragment | PressReleaseBase_ExecuteScript_6545c81fc30f4b5897d9ef85b890f70a_Fragment | PressReleaseBase_ExecuteScript_B06460c28b7b47a59e2cf966f689b6ca_Fragment | PressReleaseBase_ExecuteScript_Bc9bb68436df4285888bd8b4d87b10de_Fragment | PressReleaseBase_ExecuteScript_E14c08721a97459eafef0acaaaf1ffbb_Fragment | PressReleaseBase_ExtendSiteTheme_Fragment | PressReleaseBase_ExternalLiterature_Fragment | PressReleaseBase_FEaaSWrapperRenderingParameters_Fragment | PressReleaseBase_FacebookCommentsParametersTemplate_Fragment | PressReleaseBase_FacetSlider_Fragment | PressReleaseBase_FacetSliderFolder_Fragment | PressReleaseBase_FacetSlider_995ce2c7319f478b84fe22053ac85bb7_Fragment | PressReleaseBase_FacetSummary_Fragment | PressReleaseBase_FacetSummaryFolder_Fragment | PressReleaseBase_FacetSummary_Cd5c935c1f604d899a6b88ce28305cf2_Fragment | PressReleaseBase_FacetsGrouping_Fragment | PressReleaseBase_FakeNavigationItem_Fragment | PressReleaseBase_FeatureBanner_Fragment | PressReleaseBase_FeatureBannerParametersTemplate_Fragment | PressReleaseBase_FeaturedArticles_Fragment | PressReleaseBase_FeaturedArticlesFolder_Fragment | PressReleaseBase_FeaturedTheme_Fragment | PressReleaseBase_FeaturedThemesFolder_Fragment | PressReleaseBase_Feed_Fragment | PressReleaseBase_FeedFolder_Fragment | PressReleaseBase_FeedParameters_Fragment | PressReleaseBase_FieldEditor_Fragment | PressReleaseBase_FieldRenderer_Fragment | PressReleaseBase_FileList_Fragment | PressReleaseBase_FileListFolder_Fragment | PressReleaseBase_FileListParametersTemplate_Fragment | PressReleaseBase_File_04129321770849c1801baee196e1c0a8_Fragment | PressReleaseBase_FilterCriteria_Fragment | PressReleaseBase_FilterCriteriaFolder_Fragment | PressReleaseBase_FilterTaxonomyOption_Fragment | PressReleaseBase_FilterTaxonomyOptions_Fragment | PressReleaseBase_FilteredArticlesParentPage_Fragment | PressReleaseBase_FilteredArticlesParentPage_6adc5be146ab4c7d97f64e5c3512177d_Fragment | PressReleaseBase_FilteredArticlesParentPage_7f5d344247eb446a8f147890b998e941_Fragment | PressReleaseBase_FilteredArticlesParentPage_A34845039cf1441f8c967a5bbbdd7616_Fragment | PressReleaseBase_FilteredArticlesParentPage_E4f65f074322485787460a4058d378f9_Fragment | PressReleaseBase_FilteredArticlesParentPage_F099104e87204d52a6ab75aa44d159ce_Fragment | PressReleaseBase_FilteredArticlesWildcardPage_Fragment | PressReleaseBase_FilteredArticlesWildcardPage_5d527e4033c048c6a474af1068db082e_Fragment | PressReleaseBase_FilteredArticlesWildcardPage_98c82b05868444df9fe806b5fb955835_Fragment | PressReleaseBase_FilteredArticlesWildcardPage_705b3bb7cecc447f910fa76bdc57ada2_Fragment | PressReleaseBase_FilteredArticlesWildcardPage_Ceac9aa72d344797adf00f73f9a55f96_Fragment | PressReleaseBase_FilteredArticlesWildcardPage_Da761c9a4e8f4a91b99040d8f5baa260_Fragment | PressReleaseBase_Flip_Fragment | PressReleaseBase_FlipFolder_Fragment | PressReleaseBase_Flip_5ef078504c044b839dafefd752cfaba8_Fragment | PressReleaseBase_Flipside_Fragment | PressReleaseBase_FloatFacet_Fragment | PressReleaseBase_Footer_Fragment | PressReleaseBase_FooterFolder_Fragment | PressReleaseBase_FooterLink_Fragment | PressReleaseBase_FormRenderingParameters_Fragment | PressReleaseBase_FundAssetClass_Fragment | PressReleaseBase_FundAssetClassesFolder_Fragment | PressReleaseBase_FundDetailsWildcardPage_Fragment | PressReleaseBase_FundDetailsWildcardPage_97df45d1e5294f6dbc2279895ee83734_Fragment | PressReleaseBase_FundDetailsWildcardPage_590b12426ab64f49990b2dd2c5fffd0f_Fragment | PressReleaseBase_FundDetailsWildcardPage_60069dbb81dc496b888fe2e38073a74b_Fragment | PressReleaseBase_FundFormsFolder_Fragment | PressReleaseBase_FundInFocus_Fragment | PressReleaseBase_FundInFocusShareClass_Fragment | PressReleaseBase_FundSearchPage_Fragment | PressReleaseBase_FundSearchPage_5505b84dba1f47c7b8054749d802d926_Fragment | PressReleaseBase_FundSearchPage_5806f83c03bc443380678ff955f4310f_Fragment | PressReleaseBase_FundSearchPage_7432205c04214a419ca064c4cb37501c_Fragment | PressReleaseBase_FundSearchPage_Edc9df02132e4c0a8435dd60057cbb0a_Fragment | PressReleaseBase_FundSettings_Fragment | PressReleaseBase_FundShareclassDetailsWildcardPage_Fragment | PressReleaseBase_FundShareclassDetailsWildcardPage_543d5f778ad443269e2384804031cb3c_Fragment | PressReleaseBase_FundShareclassDetailsWildcardPage_5827425c1b4246d19f1311387a5bd4b3_Fragment | PressReleaseBase_FundShareclassDetailsWildcardPage_Cf3f2635270b49779bb3822ab90f1dcc_Fragment | PressReleaseBase_FundShareclassDetailsWildcardPage_D7e686d9c3bc4ef9974e201972b59eee_Fragment | PressReleaseBase_FundSubAssetClass_Fragment | PressReleaseBase_FundSubAssetClassesFolder_Fragment | PressReleaseBase_FundsExternalLiteratureFolder_Fragment | PressReleaseBase_FundsFolder_Fragment | PressReleaseBase_FundsInFocusFolder_Fragment | PressReleaseBase_FundsInFocusParametersTemplate_Fragment | PressReleaseBase_FundsLiteratureFolder_Fragment | PressReleaseBase_FundsLiteratureMappingsFolder_Fragment | PressReleaseBase_Gallery_Fragment | PressReleaseBase_GalleryFolder_Fragment | PressReleaseBase_GalleryImage_Fragment | PressReleaseBase_GalleryParametersTemplate_Fragment | PressReleaseBase_GalleryVideo_Fragment | PressReleaseBase_GatedAccordionContainer_Fragment | PressReleaseBase_GlobalLanguageSelector_Fragment | PressReleaseBase_GlobalNavigationBar_Fragment | PressReleaseBase_GoogleAnalytics_Fragment | PressReleaseBase_GoogleTagManager_Fragment | PressReleaseBase_GoogleTagManagerFolder_Fragment | PressReleaseBase_GridSetup_Fragment | PressReleaseBase_GridTheme_Fragment | PressReleaseBase_HtmlCode_Fragment | PressReleaseBase_HtmlCodeFolder_Fragment | PressReleaseBase_HtmlInclude_Fragment | PressReleaseBase_HtmlIncludesFolder_Fragment | PressReleaseBase_HtmlSnippet_Fragment | PressReleaseBase_HtmlSnippetFolder_Fragment | PressReleaseBase_HtmlTag_Fragment | PressReleaseBase_Header_Fragment | PressReleaseBase_HeaderFolder_Fragment | PressReleaseBase_Heading_Fragment | PressReleaseBase_HeadlessSiteSetupRoot_Fragment | PressReleaseBase_HeadlessSite_00d050988bad49e5b65db1e08b03ca1b_Fragment | PressReleaseBase_HeadlessSite_0bb67daed5d04933a5ce1c0baa6c4df1_Fragment | PressReleaseBase_HeadlessSite_8ca001453c4b4715959d8a05292ecbc5_Fragment | PressReleaseBase_HeadlessSite_68ffa40c5aab45548f774742b163f318_Fragment | PressReleaseBase_HeadlessSite_89d464c8c03e4b0287e9a878d95d7149_Fragment | PressReleaseBase_HeadlessSite_229484893ca144958b9937167dfb5064_Fragment | PressReleaseBase_HeadlessSite_B28055626acc45a2913a9617398c9730_Fragment | PressReleaseBase_HeadlessSite_F1cab1661abb450d84d55d938e7699cb_Fragment | PressReleaseBase_HeadlessSite_F3884baa0e1548f59a6d7154a4559604_Fragment | PressReleaseBase_HeadlessSolutionTemplateFolder_Fragment | PressReleaseBase_HeadlessTenantSetupRoot_Fragment | PressReleaseBase_HeadlessTenant_07248c4700af499eb2a9cb7789f72372_Fragment | PressReleaseBase_HeadlessTenant_5b3d7ac5419343c697c722309a2ad4c8_Fragment | PressReleaseBase_HeadlessTenant_5d72df6049c74324969205b55767ad7b_Fragment | PressReleaseBase_HeadlessTenant_6abd3bf16bcb4f25ac5b2399ff7a92e3_Fragment | PressReleaseBase_HeadlessTenant_77a403a2094e48afafa60943d349d23d_Fragment | PressReleaseBase_HeadlessTenant_115c42029c0d4fbcb542a4a539c33ee2_Fragment | PressReleaseBase_HeadlessTenant_94824ac390d748499e5af0275d10811f_Fragment | PressReleaseBase_HeadlessTenant_4797571864fd40929cf2412c39757ec3_Fragment | PressReleaseBase_HeadlessTenant_C102fb48f40f49fb9c21f8e3e1b0c107_Fragment | PressReleaseBase_HeadlessTrustSite_Fragment | PressReleaseBase_HeadlessVariants_Fragment | PressReleaseBase_HeadlessVariantsGrouping_Fragment | PressReleaseBase_HelpArticlePage_Fragment | PressReleaseBase_HelpArticlePlatform_Fragment | PressReleaseBase_HelpArticlePlatformMap_Fragment | PressReleaseBase_HelpArticlePlatformMappings_Fragment | PressReleaseBase_HelpArticlePlatformsFolder_Fragment | PressReleaseBase_HelpArticleSearchPage_Fragment | PressReleaseBase_HelpArticleSearchPage_486d4c7432c64f9a929b595943c6fe77_Fragment | PressReleaseBase_HelpArticleTag_Fragment | PressReleaseBase_HelpArticleTagsFolder_Fragment | PressReleaseBase_HelpArticleWildcardPage_Fragment | PressReleaseBase_HelpArticleWildcardPage_E4e2d58c853341deaa6b2a2a136421c4_Fragment | PressReleaseBase_HelpArticlesGroupFolder_Fragment | PressReleaseBase_HelpTagMap_Fragment | PressReleaseBase_HelpTagMappings_Fragment | PressReleaseBase_HeroBanner_Fragment | PressReleaseBase_Highlight_Fragment | PressReleaseBase_HighlightBlock_Fragment | PressReleaseBase_HighlightBlockFolder_Fragment | PressReleaseBase_HighlightBlockParametersTemplate_Fragment | PressReleaseBase_HighlightFolder_Fragment | PressReleaseBase_HighlightItem_Fragment | PressReleaseBase_HighlightParametersTemplate_Fragment | PressReleaseBase_Home_Fragment | PressReleaseBase_HomePage_Fragment | PressReleaseBase_HomePage_0d3963a8171d4080b5f808618578b631_Fragment | PressReleaseBase_HomePage_6d95c7d946c74a70be07304cc73a2010_Fragment | PressReleaseBase_HomePage_B407f259b4e34c7db9a06e8907a56b17_Fragment | PressReleaseBase_HomePage_Cde13c51062d426b95569e8202edc963_Fragment | PressReleaseBase_HomePage_De9353283a3e41c495ba386aed0540c6_Fragment | PressReleaseBase_IFrame_Fragment | PressReleaseBase_IFrameFolder_Fragment | PressReleaseBase_IFrameFolder_21366ebf5fda4ff4a4dac7b1f4d7ada2_Fragment | PressReleaseBase_IFrameParametersTemplate_Fragment | PressReleaseBase_IFrame_0da12d476de24dfeb4d0f513489bfea1_Fragment | PressReleaseBase_IFrame_88a6f65f2b78491bb3770b06e48883e1_Fragment | PressReleaseBase_Icon_Fragment | PressReleaseBase_IconFolder_Fragment | PressReleaseBase_Image_Fragment | PressReleaseBase_ImageFolder_Fragment | PressReleaseBase_ImageFolder_Edc00e86cef24d0cbfa264460becc323_Fragment | PressReleaseBase_ImageFolder_F7a4527687f14ea5bf25e3c7cb7aa993_Fragment | PressReleaseBase_ImageParametersTemplate_Fragment | PressReleaseBase_Image_83bc563c6320490092f8204bff81586a_Fragment | PressReleaseBase_Image_15185b0e641844499f934ff03b7ee032_Fragment | PressReleaseBase_Image_D885df8cb2d64007b34b2bbafb527304_Fragment | PressReleaseBase_Infographics_Fragment | PressReleaseBase_InfographicsFolder_Fragment | PressReleaseBase_InputValidationStep_Fragment | PressReleaseBase_InputValidationStep_088928cf558e40ec87f3342aa9e66757_Fragment | PressReleaseBase_InputValidationStep_9eded2f7f84748938a0bf69e7fcf3593_Fragment | PressReleaseBase_InputValidationStep_D028fef2babf4ad1bbe74d62a977992f_Fragment | PressReleaseBase_IntegerFacet_Fragment | PressReleaseBase_IntroCopy_Fragment | PressReleaseBase_IntroCopyFolder_Fragment | PressReleaseBase_InvestmentTrustAssetClass_Fragment | PressReleaseBase_InvestmentTrustAssetClassFolder_Fragment | PressReleaseBase_InvestmentTrustPage_8f108193367d41dcb4dc3a71722c2b73_Fragment | PressReleaseBase_InvestmentTrustPage_79a99ec28fe841f0a929356fe3a6aaeb_Fragment | PressReleaseBase_InvestmentTrustRegion_Fragment | PressReleaseBase_InvestmentTrustRegionFolder_Fragment | PressReleaseBase_InvestmentTrustStyle_Fragment | PressReleaseBase_InvestmentTrustStyleFolder_Fragment | PressReleaseBase_InvestorType_Fragment | PressReleaseBase_InvestorTypesFolder_Fragment | PressReleaseBase_ItemQueriesFolder_Fragment | PressReleaseBase_ItemRights_Fragment | PressReleaseBase_JsBeaconSettings_Fragment | PressReleaseBase_JsonCheckbox_Fragment | PressReleaseBase_JsonContent_Fragment | PressReleaseBase_JsonDate_Fragment | PressReleaseBase_JsonFile_Fragment | PressReleaseBase_JsonImage_Fragment | PressReleaseBase_JsonLayout_Fragment | PressReleaseBase_JsonList_Fragment | PressReleaseBase_JsonMultilistReference_Fragment | PressReleaseBase_JsonPlaceholder_Fragment | PressReleaseBase_JsonQuery_Fragment | PressReleaseBase_JsonResults_Fragment | PressReleaseBase_JsonRichText_Fragment | PressReleaseBase_JsonScriban_Fragment | PressReleaseBase_JsonSection_Fragment | PressReleaseBase_JsonTemplate_Fragment | PressReleaseBase_JsonText_Fragment | PressReleaseBase_JsonToken_Fragment | PressReleaseBase_JsonVariantDefinition_Fragment | PressReleaseBase_JsonVariants_Fragment | PressReleaseBase_JssLayout_Fragment | PressReleaseBase_JssSettings_1a6fb678eca242c09ae77a9e7f72a6d0_Fragment | PressReleaseBase_JssSettings_6b328292f8314ab79885d89a054ca10a_Fragment | PressReleaseBase_JssSettings_457c9d0b61b84adfaf7f82561ed275ff_Fragment | PressReleaseBase_JssSettings_5045bf85d2ea430b9f41c2e348436e5d_Fragment | PressReleaseBase_JssSettings_A767f80d5ad44bfbb8b750a8da144cb5_Fragment | PressReleaseBase_JssSettings_B001fd725bb1476496825a8cb9e995cd_Fragment | PressReleaseBase_JssSettings_C643bc8630d14d61a173c7870f5dbbad_Fragment | PressReleaseBase_JssSettings_Ce3dfd340df34b2d8715e54f85dfcce2_Fragment | PressReleaseBase_JssSettings_Ef855d0ba8b04a8e87851d1298266d90_Fragment | PressReleaseBase_JssSiteGrouping_Fragment | PressReleaseBase_JssTenantFolder_Fragment | PressReleaseBase_JavaScriptRendering_Fragment | PressReleaseBase_JsonRendering_Fragment | PressReleaseBase_JurisdictionStatus_Fragment | PressReleaseBase_JurisdictionsFolder_Fragment | PressReleaseBase_KeyHighlightItem_Fragment | PressReleaseBase_KeyHighlights_Fragment | PressReleaseBase_KeyHighlightsFolder_Fragment | PressReleaseBase_KeyHighlightsParametersTemplate_Fragment | PressReleaseBase_Language_Fragment | PressReleaseBase_LanguageSelector_Fragment | PressReleaseBase_LanguagesFolder_Fragment | PressReleaseBase_LatestPressReleasesParametersTemplate_Fragment | PressReleaseBase_LayoutServiceVariants_Fragment | PressReleaseBase_LimitedDisplayFolder_Fragment | PressReleaseBase_LimitedDisplayOption_Fragment | PressReleaseBase_Link_Fragment | PressReleaseBase_LinkList_Fragment | PressReleaseBase_LinkListFolder_Fragment | PressReleaseBase_LinkListFolder_C237d144647a4afeaa7b1570f3e3f139_Fragment | PressReleaseBase_LinkList_33c9207e3b0446068ef54ca99a97c776_Fragment | PressReleaseBase_LinkList_97a593ad273141dc80bfceb5ef6a33b7_Fragment | PressReleaseBase_LinkList_F7561ffcc0d8477fb53d2703a4060be1_Fragment | PressReleaseBase_Link_68bd1cb5a7624a969ac6cb16ab5882a3_Fragment | PressReleaseBase_Link_930f134d56784b35bfd1b77f9d0115f1_Fragment | PressReleaseBase_Link_E24e0789a05848bfabb6c69c0e60b6b7_Fragment | PressReleaseBase_LinksFolder_Fragment | PressReleaseBase_List_Fragment | PressReleaseBase_ListFacet_Fragment | PressReleaseBase_ListFolder_Fragment | PressReleaseBase_ListItem_Fragment | PressReleaseBase_ListParametersTemplate_Fragment | PressReleaseBase_ListStyle_Fragment | PressReleaseBase_ListStyleItem_Fragment | PressReleaseBase_ListingHeroBanner_Fragment | PressReleaseBase_ListingHeroParametersTemplate_Fragment | PressReleaseBase_LiteratureAuthorization_Fragment | PressReleaseBase_LiteratureAuthorizationsFolder_Fragment | PressReleaseBase_LiteratureHubSearchPage_Fragment | PressReleaseBase_LiteratureHubSearchPage_62f4748b81db49ee9be8b674a7f42d9d_Fragment | PressReleaseBase_LiteratureHubSearchPage_94278fe5377a4665bccbd1d4cef5e30e_Fragment | PressReleaseBase_LiteratureHubSearchPage_D2b2958263564ba8bba5922add46a0ea_Fragment | PressReleaseBase_LoadMore_Fragment | PressReleaseBase_LoadMoreFolder_Fragment | PressReleaseBase_LoadMore_7a3a53e06a0144ff8ba52be46e201fe6_Fragment | PressReleaseBase_LocationFilter_Fragment | PressReleaseBase_LocationFilterFolder_Fragment | PressReleaseBase_LocationFilter_Aaad4aad290744dc90b69e4e83a661ec_Fragment | PressReleaseBase_Log_Fragment | PressReleaseBase_Login_Fragment | PressReleaseBase_Login_Abed54dc4f7840ddac562289c9c849d8_Fragment | PressReleaseBase_LogoTextBlockItem_Fragment | PressReleaseBase_LogoTextBlocks_Fragment | PressReleaseBase_LogoTextBlocksFolder_Fragment | PressReleaseBase_Logout_Fragment | PressReleaseBase_Logout_C2294d8235a6452a94b15eb5e543b602_Fragment | PressReleaseBase_ManagedRangeFilter_Fragment | PressReleaseBase_ManagedRangeFilterFolder_Fragment | PressReleaseBase_ManagedRangeFilter_14c6033e186b49088bb925aba0da4d91_Fragment | PressReleaseBase_ManagedRangeItem_Fragment | PressReleaseBase_Map_Fragment | PressReleaseBase_MapParameters_Fragment | PressReleaseBase_MapsFolder_Fragment | PressReleaseBase_MapsProvider_Fragment | PressReleaseBase_MediaBlock_Fragment | PressReleaseBase_MediaBlockFolder_Fragment | PressReleaseBase_MediaBlockParametersTemplate_Fragment | PressReleaseBase_MediaFolder_81150e5837f5443fa3c075e14a9321e7_Fragment | PressReleaseBase_MediaLinkParameters_Fragment | PressReleaseBase_MediaVirtualFolder_Fragment | PressReleaseBase_MegaNavigation_Fragment | PressReleaseBase_MegaNavigationFolder_Fragment | PressReleaseBase_MetaBranding_Fragment | PressReleaseBase_MetaRenderingParameters_Fragment | PressReleaseBase_MetadataPartialDesign_Fragment | PressReleaseBase_Model_Fragment | PressReleaseBase_ModelIterator_Fragment | PressReleaseBase_MyLocationPoi_Fragment | PressReleaseBase_Navigation_Fragment | PressReleaseBase_NavigationCategory_Fragment | PressReleaseBase_NavigationFilter_Fragment | PressReleaseBase_NavigationFilterFolder_Fragment | PressReleaseBase_NavigationLink_Fragment | PressReleaseBase_NavigationSubcategory_Fragment | PressReleaseBase_Navigation_9ce34bf95c934dff841d8f649c2bd6c8_Fragment | PressReleaseBase_OneTrustSettings_Fragment | PressReleaseBase_OptimiserConfiguration_Fragment | PressReleaseBase_OptimiserConfigurationSection_Fragment | PressReleaseBase_OptimizedFile_Fragment | PressReleaseBase_OracleCdpSettings_Fragment | PressReleaseBase_OverlayContent_Fragment | PressReleaseBase_OverlayFolderTemplate_Fragment | PressReleaseBase_Ownership_Fragment | PressReleaseBase_OwnershipFolder_Fragment | PressReleaseBase_Poi_Fragment | PressReleaseBase_PoiFolder_Fragment | PressReleaseBase_PoiType_Fragment | PressReleaseBase_PoIs_Fragment | PressReleaseBase_PageBranchesFolder_Fragment | PressReleaseBase_PageContent_Fragment | PressReleaseBase_PageContentFolder_Fragment | PressReleaseBase_PageContent_Ef87e73bc7ff49a2ac599b0be83755c3_Fragment | PressReleaseBase_PageDesign_Fragment | PressReleaseBase_PageDesignFolder_1aa9bc8250a94e4eb15003b55b4dfed0_Fragment | PressReleaseBase_PageDesignFolder_27d4f8be63b045769a4ef3163c935b47_Fragment | PressReleaseBase_PageDesignFolder_352ce40ee6e1457a8bf225d8771894e8_Fragment | PressReleaseBase_PageDesignFolder_446a7eadeb894ed6b48c7f1862f29d7b_Fragment | PressReleaseBase_PageDesignFolder_720d01f11e5046fa9c4a697f9321f662_Fragment | PressReleaseBase_PageDesignFolder_771a0de7e83f44338c5d78727ead93bc_Fragment | PressReleaseBase_PageDesignFolder_14161ec204984aa7a2a46decadf669f5_Fragment | PressReleaseBase_PageDesignFolder_C691c2c4e0dd4fedb84a3c29de7002cb_Fragment | PressReleaseBase_PageDesignFolder_D84605f786ea482da6ff683f6572821c_Fragment | PressReleaseBase_PageDesign_1105b8f81e00426bbf1fc840742d827b_Fragment | PressReleaseBase_PageDesigns_Fragment | PressReleaseBase_PageDesigns_3af52e70e982424b9c85e355542500c9_Fragment | PressReleaseBase_PageDesigns_9b34083e890b467d8e76b8c3dbbb712d_Fragment | PressReleaseBase_PageDesigns_48d2d50a150c4f6283603a4fed5646e0_Fragment | PressReleaseBase_PageDesigns_99a71bba507746729c3fb29b04abee23_Fragment | PressReleaseBase_PageDesigns_A0f265b42d6241968b65d3ede7cb59c3_Fragment | PressReleaseBase_PageDesigns_Abe5ce6a82ff4433b4973bc50f192e11_Fragment | PressReleaseBase_PageDesigns_B8d9b352c1694b31bd506848b47ca884_Fragment | PressReleaseBase_PageDesigns_D3b2e1466f744df0900bec314f699ef3_Fragment | PressReleaseBase_PageDesigns_Fd4b9b54f7474f01abdeba569d4b5bbe_Fragment | PressReleaseBase_PageLevelTabs_Fragment | PressReleaseBase_PageLevelTabsFolder_Fragment | PressReleaseBase_PageList_Fragment | PressReleaseBase_PageSelector_Fragment | PressReleaseBase_PageSelectorConfiguration_Fragment | PressReleaseBase_PageSelectorFolder_Fragment | PressReleaseBase_PageSelector_59a7bb775f8c435ab810291abde80e63_Fragment | PressReleaseBase_PageSize_Fragment | PressReleaseBase_PageSizeFolder_Fragment | PressReleaseBase_PageSize_B682562e0af64b3e9e3b45273bbe152d_Fragment | PressReleaseBase_PageTheme_Fragment | PressReleaseBase_PageThemesFolder_Fragment | PressReleaseBase_Page_4f49a81db3664f198b89cab92f377d7a_Fragment | PressReleaseBase_Page_5e66d86353544fe6a27d3b894984d50f_Fragment | PressReleaseBase_Page_84f342ad2d0646b9aa9a818201145ca2_Fragment | PressReleaseBase_Page_718df200be51463d93edf4d77ab7a49e_Fragment | PressReleaseBase_Page_B61d5babe46f4ef39f27b57c4ccefdf7_Fragment | PressReleaseBase_Page_Cfd6e04697e24f3cb9eb41b79afc35dc_Fragment | PressReleaseBase_Page_Dae7821153e14dbabb0ddf0b53a90aaf_Fragment | PressReleaseBase_Page_Fa608b3e6aeb426388a059d89caabada_Fragment | PressReleaseBase_Pagging_Fragment | PressReleaseBase_Pagination_Fragment | PressReleaseBase_PaginationFolder_Fragment | PressReleaseBase_Paragraph_Fragment | PressReleaseBase_PartialDesignFolder_8cf20a4412b746ee801218122c955b2d_Fragment | PressReleaseBase_PartialDesignFolder_42eb57ecaa474923b3ddbfb72818f00b_Fragment | PressReleaseBase_PartialDesignFolder_766d4de859a0419292de1898fe0ac4e8_Fragment | PressReleaseBase_PartialDesignFolder_827d4d2f2a84408e8f0ff1d6869a441b_Fragment | PressReleaseBase_PartialDesignFolder_828b5ff144cd4150bcdfe54084165112_Fragment | PressReleaseBase_PartialDesignFolder_89098e3089aa4062a77346d608caac90_Fragment | PressReleaseBase_PartialDesignFolder_1695576fb93647d7842ed17730278c32_Fragment | PressReleaseBase_PartialDesignFolder_F16ae56fb78845639407c88edaffcbcc_Fragment | PressReleaseBase_PartialDesignFolder_Fb58558a3ec946d18524cd30805ab21a_Fragment | PressReleaseBase_PartialDesign_Fd2059fd60434dfe8c04e2437ce87634_Fragment | PressReleaseBase_PartialDesigns_Fragment | PressReleaseBase_PartialDesigns_043d3ad0ac4445dba03afc3550d088ec_Fragment | PressReleaseBase_PartialDesigns_0310a4bf20d1441c886a0418c53e30f4_Fragment | PressReleaseBase_PartialDesigns_36c869ded22040929ce829f6ed643c66_Fragment | PressReleaseBase_PartialDesigns_1943dc73710a430895515a342c84b037_Fragment | PressReleaseBase_PartialDesigns_B1e2a6790a1442d8bafa66317b8be117_Fragment | PressReleaseBase_PartialDesigns_Cc6d8635f3e2440ab8ebb93dc1030e9e_Fragment | PressReleaseBase_PartialDesigns_D52704ed3b704a53abb4292105f687ad_Fragment | PressReleaseBase_PartialDesigns_D216303f58d8425688da8cd30d00afab_Fragment | PressReleaseBase_PartialDesigns_Facda26791204fa9a0363344348f2c42_Fragment | PressReleaseBase_PerformanceChartSettings_Fragment | PressReleaseBase_PerformanceChartTimePeriod_Fragment | PressReleaseBase_PerformanceChartTimePeriodFolder_Fragment | PressReleaseBase_PlaceholderSettingsFolder_0339bac078c143c1b930f8c26a5fdf80_Fragment | PressReleaseBase_PlaceholderSettingsFolder_3d281bf8533646869dd6ab4ab5b3fd5d_Fragment | PressReleaseBase_PlaceholderSettingsFolder_52288e3978304694b62d32a54c6ef7ba_Fragment | PressReleaseBase_Placeholder_1ca0304be5b64810821154426f1752c2_Fragment | PressReleaseBase_Placeholder_D2a6884c04d54089a64ed27ca9d68d4c_Fragment | PressReleaseBase_PlainHtmlParametersTemplate_Fragment | PressReleaseBase_Playlist_Fragment | PressReleaseBase_PlaylistFolder_Fragment | PressReleaseBase_PlaylistParametersTemplate_Fragment | PressReleaseBase_Podcast_Fragment | PressReleaseBase_PodcastFolder_Fragment | PressReleaseBase_PodcastPage_Fragment | PressReleaseBase_PodcastPressReleasePage_Fragment | PressReleaseBase_PoiTypes_Fragment | PressReleaseBase_PostDeleteStep_Fragment | PressReleaseBase_PostDeleteStep_7a7e57b99c6d4a22b5fdf7b214dde574_Fragment | PressReleaseBase_PostDeleteStep_78d6ec9b66e34763987003cf314ee37a_Fragment | PressReleaseBase_PostDeleteStep_B20857895385413883f096f3767cb156_Fragment | PressReleaseBase_PostSetupStep_Fragment | PressReleaseBase_PostSetupStep_6fac654e22154a419a1d59197bebc0fe_Fragment | PressReleaseBase_PostSetupStep_8ff2febff6d2461d9ed38b0cb5d9d86f_Fragment | PressReleaseBase_PostSetupStep_341738aa44fe490e90ff7010a3c2463b_Fragment | PressReleaseBase_PreDeleteStep_Fragment | PressReleaseBase_PreDeleteStep_51437c06212c4c0fb3b2fa5b0486ab49_Fragment | PressReleaseBase_PreDeleteStep_52510f549ec5464cb075ef44b5c2f96b_Fragment | PressReleaseBase_PreDeleteStep_F0daf401190f45468bda8568d08e161d_Fragment | PressReleaseBase_PreDeleteValidationStep_Fragment | PressReleaseBase_PreDeleteValidationStep_408fd8ab1667440ba6051370ddf0a51f_Fragment | PressReleaseBase_PreDeleteValidationStep_Edf1fa4206c44703ab1af23495bc6d8f_Fragment | PressReleaseBase_PreDeleteValidationStep_F8c52120d0ea4d009de3b49fe12a3f1e_Fragment | PressReleaseBase_Presentation_Fragment | PressReleaseBase_Presentation_0a70fa7389234a6eabf34134f25f3221_Fragment | PressReleaseBase_PressReleaseContentType_Fragment | PressReleaseBase_PressReleaseContentTypesFolder_Fragment | PressReleaseBase_PressReleaseFilter_Fragment | PressReleaseBase_PressReleasePage_Fragment | PressReleaseBase_PressReleasePlatform_Fragment | PressReleaseBase_PressReleasePlatformsFolder_Fragment | PressReleaseBase_PressReleaseSearchPage_Fragment | PressReleaseBase_PressReleaseSearchPage_1b2f7a53709a4c62b381dae5f1280b7f_Fragment | PressReleaseBase_PressReleaseSearchPage_A6c344ca7c6946009de2ca92e27d7b72_Fragment | PressReleaseBase_PressReleaseSearchPage_B9cd16f585ea4405a1ceda10cb20f64d_Fragment | PressReleaseBase_PressReleaseSearchPage_C97027442df647cf9c36eedfc6787f58_Fragment | PressReleaseBase_PressReleaseWildcardPage_Fragment | PressReleaseBase_PressReleaseWildcardPage_2c028bdb02874051b629a7b7d422cc1e_Fragment | PressReleaseBase_PressReleaseWildcardPage_5a72be834c654d70a591cef7e9ce9d79_Fragment | PressReleaseBase_PressReleaseWildcardPage_B337d30403c642d2b9757e23d08223a1_Fragment | PressReleaseBase_PressReleaseWildcardPage_E55e9d5bf9614e30b0a2a90327428258_Fragment | PressReleaseBase_PressReleasesGroupFolder_Fragment | PressReleaseBase_PrivacyWarning_Fragment | PressReleaseBase_ProjectFolder_Fragment | PressReleaseBase_Promo_Fragment | PressReleaseBase_PromoFolder_Fragment | PressReleaseBase_PromoFolder_F07cbe8973ae4de692172570260cac6e_Fragment | PressReleaseBase_Promo_7f21f14d096b4f27bbccf115c6e6f6f1_Fragment | PressReleaseBase_Promo_881869ca7f5845ea8b34ad1bfd3551a8_Fragment | PressReleaseBase_Promo_Dfed4457d760457abec1c0dccdc44381_Fragment | PressReleaseBase_PromotedContent_Fragment | PressReleaseBase_PromotedContentFolder_Fragment | PressReleaseBase_PropertyListingCard_Fragment | PressReleaseBase_PropertyListingCards_Fragment | PressReleaseBase_PropertyListingCategory_Fragment | PressReleaseBase_PropertyListingFolder_Fragment | PressReleaseBase_Query_98b413525a4b4067b92418a4b50f0a53_Fragment | PressReleaseBase_QuickLinks_Fragment | PressReleaseBase_QuickLinksFolder_Fragment | PressReleaseBase_QuickLinksParametersTemplate_Fragment | PressReleaseBase_QuotationBlockItem_Fragment | PressReleaseBase_QuotationBlocks_Fragment | PressReleaseBase_QuotationBlocksFolder_Fragment | PressReleaseBase_QuotationBlocksParametersTemplate_Fragment | PressReleaseBase_Quote_Fragment | PressReleaseBase_QuoteFolder_Fragment | PressReleaseBase_QuoteParametersTemplate_Fragment | PressReleaseBase_RadiusFilter_Fragment | PressReleaseBase_RadiusFilterFolder_Fragment | PressReleaseBase_RadiusFilter_De3fa58eef9d45449f77dcd1dbb05b64_Fragment | PressReleaseBase_RadiusScheme_Fragment | PressReleaseBase_RadiusSchemeValue_Fragment | PressReleaseBase_RangeSliderFilter_Fragment | PressReleaseBase_RangeSliderFilterFolder_Fragment | PressReleaseBase_RangeSliderFilter_0a1787c296b54d40828522564a5d8e03_Fragment | PressReleaseBase_RecentArticles_Fragment | PressReleaseBase_Redirect_Fragment | PressReleaseBase_RedirectMap_Fragment | PressReleaseBase_RedirectMaps_Fragment | PressReleaseBase_Region_Fragment | PressReleaseBase_RegionLanguages_Fragment | PressReleaseBase_RegionLanguagesFolder_Fragment | PressReleaseBase_RelatedArticles_Fragment | PressReleaseBase_RelatedArticlesParametersTemplate_Fragment | PressReleaseBase_RenderEngineType_Fragment | PressReleaseBase_RenderingFolder_840d4a46550349ecbf9dbd090946c63d_Fragment | PressReleaseBase_RenderingHost_Fragment | PressReleaseBase_ResizableIFramePage_Fragment | PressReleaseBase_ResizableIFramePage_8ab2ae106350452ca0e7b06d6d859067_Fragment | PressReleaseBase_ResizableIFramePage_92674815f3f74a879c0874bcb72c9b68_Fragment | PressReleaseBase_ResizableIFramePage_B58eacfb27f5417bb536141f94b92521_Fragment | PressReleaseBase_ResizableIFramePage_D8d76a2407084147bf3900cd5e12e401_Fragment | PressReleaseBase_ResizableIFramePage_F460ab055585441892023750e7cef6b7_Fragment | PressReleaseBase_ResponsiveImage_Fragment | PressReleaseBase_ResultsCount_Fragment | PressReleaseBase_ResultsCountFolder_Fragment | PressReleaseBase_ResultsCount_F3c0661ef9a9444ca26d44bf2a68a186_Fragment | PressReleaseBase_ResultsVariantSelector_Fragment | PressReleaseBase_RichText_Fragment | PressReleaseBase_RichTextFolder_Fragment | PressReleaseBase_RichText_0f3b73366112418c8bbab0526f3887ce_Fragment | PressReleaseBase_RichText_Efcfd8f6596745f48f85b5421928205d_Fragment | PressReleaseBase_RiskImageMapping_Fragment | PressReleaseBase_RiskImageMappings_Fragment | PressReleaseBase_RiskLevelOption_Fragment | PressReleaseBase_RiskLevelOptionFolder_Fragment | PressReleaseBase_RiskWarning_Fragment | PressReleaseBase_RiskWarningFolder_Fragment | PressReleaseBase_RiskWarningParametersTemplate_Fragment | PressReleaseBase_RolePlaceholder_Fragment | PressReleaseBase_RowSplitter_Fragment | PressReleaseBase_RowSplitter_340c887da1d1415b9678c763af74ea97_Fragment | PressReleaseBase_Rule_Fragment | PressReleaseBase_SdrLogoMapping_Fragment | PressReleaseBase_SdrLogoMappings_Fragment | PressReleaseBase_SdrTypeOption_Fragment | PressReleaseBase_SdrTypeOptionFolder_Fragment | PressReleaseBase_SxajssLayout_Fragment | PressReleaseBase_SxaRole_Fragment | PressReleaseBase_SxaStandardValuesFolder_Fragment | PressReleaseBase_SalesforceAlertMessage_Fragment | PressReleaseBase_SalesforceCheckBox_Fragment | PressReleaseBase_SalesforceCheckBoxType_Fragment | PressReleaseBase_SalesforceConditionalRadioButton_Fragment | PressReleaseBase_SalesforceConditionalRadioButtons_Fragment | PressReleaseBase_SalesforceDateInput_Fragment | PressReleaseBase_SalesforceDropdown_Fragment | PressReleaseBase_SalesforceDropdownOption_Fragment | PressReleaseBase_SalesforceHiddenField_Fragment | PressReleaseBase_SalesforceInput_Fragment | PressReleaseBase_SalesforceInputType_Fragment | PressReleaseBase_SalesforceIntegratedForm_Fragment | PressReleaseBase_SalesforceIntegratedFormTypesFolder_Fragment | PressReleaseBase_SalesforceRepeatableSubSection_Fragment | PressReleaseBase_SalesforceRichTextArea_Fragment | PressReleaseBase_SalesforceSection_Fragment | PressReleaseBase_SalesforceSortCodeInput_Fragment | PressReleaseBase_SalesforceSubmissionType_Fragment | PressReleaseBase_Scope_Fragment | PressReleaseBase_ScopesFolder_Fragment | PressReleaseBase_Scriban_Fragment | PressReleaseBase_Scripts_Fragment | PressReleaseBase_SearchBox_Fragment | PressReleaseBase_SearchBoxFolder_Fragment | PressReleaseBase_SearchBox_1c04fd611d874590acfe9cc186865ab3_Fragment | PressReleaseBase_SearchFolder_Fragment | PressReleaseBase_SearchResults_Fragment | PressReleaseBase_SearchResultsFolder_Fragment | PressReleaseBase_SearchResults_A06f7130041d46bb8c2995a2dc00c26a_Fragment | PressReleaseBase_SecondaryHeroBannerParametersTemplate_Fragment | PressReleaseBase_SectionHeading_Fragment | PressReleaseBase_SectionHeadingFolder_Fragment | PressReleaseBase_SectionHeadingParametersTemplate_Fragment | PressReleaseBase_SectionHeadingType_Fragment | PressReleaseBase_SectionHeadingTypeFolder_Fragment | PressReleaseBase_SectionSelector_Fragment | PressReleaseBase_SectionSelectorFolder_Fragment | PressReleaseBase_SectionSelectorTab_Fragment | PressReleaseBase_Security_33077d51ebad4d1cb4a83b79f51dba13_Fragment | PressReleaseBase_Series_Fragment | PressReleaseBase_SeriesFolder_Fragment | PressReleaseBase_Settings_Fragment | PressReleaseBase_SettingsFolder_Fragment | PressReleaseBase_Settings_6c82caca67dc464195698faad083230e_Fragment | PressReleaseBase_SharePriceSettings_Fragment | PressReleaseBase_SharedArticlesFolder_Fragment | PressReleaseBase_SharedContentFolder_Fragment | PressReleaseBase_SharedFolder_Fragment | PressReleaseBase_SharedHelpArticlesFolder_Fragment | PressReleaseBase_SharedPressReleasesFolder_Fragment | PressReleaseBase_SharedSettingsFolder_Fragment | PressReleaseBase_SharedSitesSettings_Fragment | PressReleaseBase_SharedSitesSettings_C14bf746030f4e598594395f6d299e61_Fragment | PressReleaseBase_Showcase_Fragment | PressReleaseBase_ShowcaseFolder_Fragment | PressReleaseBase_ShowcaseItem_Fragment | PressReleaseBase_ShowcaseParametersTemplate_Fragment | PressReleaseBase_Site_Fragment | PressReleaseBase_SiteContentFolder_Fragment | PressReleaseBase_SiteDefinition_Fragment | PressReleaseBase_SiteEntryDisclaimer_Fragment | PressReleaseBase_SiteFolder_Fragment | PressReleaseBase_SiteGrouping_Fragment | PressReleaseBase_SiteManagement_Fragment | PressReleaseBase_SiteSecurityItemPointer_Fragment | PressReleaseBase_SiteSelector_Fragment | PressReleaseBase_SiteSelector_A44632f56dcd4d10b4892f4e35e193c3_Fragment | PressReleaseBase_SiteSetupRoot_Fragment | PressReleaseBase_SiteTheme_Fragment | PressReleaseBase_Site_E46f3af239fa4866a1577017c4b2a40c_Fragment | PressReleaseBase_SitecoreFormWrapperParametersTemplate_Fragment | PressReleaseBase_SitecoreRole_Fragment | PressReleaseBase_SitemapSettings_C71d856635c849b7a84d9d176e9cbd05_Fragment | PressReleaseBase_SkipLink_Fragment | PressReleaseBase_SkipLinkParameters_Fragment | PressReleaseBase_SkipLinksFolder_Fragment | PressReleaseBase_Snippet_Fragment | PressReleaseBase_SnippetItem_Fragment | PressReleaseBase_SnippetsFolder_Fragment | PressReleaseBase_SocialLoginWrapper_Fragment | PressReleaseBase_SocialMediaButtons_Fragment | PressReleaseBase_SocialMediaFolder_Fragment | PressReleaseBase_SocialMediaShare_Fragment | PressReleaseBase_SocialMediaTemplate_Fragment | PressReleaseBase_SocialNetwork_Fragment | PressReleaseBase_SocialNetworkFolder_Fragment | PressReleaseBase_SocialNetworkLink_Fragment | PressReleaseBase_SolutionTemplate_Fragment | PressReleaseBase_SortResults_Fragment | PressReleaseBase_SortResultsFolder_Fragment | PressReleaseBase_Sorting_Fragment | PressReleaseBase_SortingGroups_Fragment | PressReleaseBase_SpotifyPodcast_Fragment | PressReleaseBase_SpotifyPodcastFolder_Fragment | PressReleaseBase_StickyCta_Fragment | PressReleaseBase_StickyCtaFolder_Fragment | PressReleaseBase_StickyCtaParametersTemplate_Fragment | PressReleaseBase_StrategiesInFocusFolder_Fragment | PressReleaseBase_StrategyInFocus_Fragment | PressReleaseBase_Style_Fragment | PressReleaseBase_Styles_Fragment | PressReleaseBase_Styles_9c0dac2808aa4b44bc2153363206f6a5_Fragment | PressReleaseBase_SubscriptionBannerParametersTemplate_Fragment | PressReleaseBase_Tab_Fragment | PressReleaseBase_TabItem_Fragment | PressReleaseBase_TableOfContents_Fragment | PressReleaseBase_TableOfContentsFolder_Fragment | PressReleaseBase_TableOfContentsSection_Fragment | PressReleaseBase_TableOfContentsSubsection_Fragment | PressReleaseBase_Tabs_Fragment | PressReleaseBase_TabsFolder_Fragment | PressReleaseBase_Tabs_F26a9560ccf148c59542800e837caf7a_Fragment | PressReleaseBase_Tag_Fragment | PressReleaseBase_TagCloud_Fragment | PressReleaseBase_TagFolder_Fragment | PressReleaseBase_TagList_Fragment | PressReleaseBase_TeamBiographySettings_Fragment | PressReleaseBase_TeamListingCards_Fragment | PressReleaseBase_TeamListingCardsFolder_Fragment | PressReleaseBase_TeamMember_Fragment | PressReleaseBase_TeamMemberCard_Fragment | PressReleaseBase_TeamMembers_Fragment | PressReleaseBase_TeamMembersParentPage_Fragment | PressReleaseBase_TeamMembersParentPage_0dfb40140ba44abe8a480904ff1eff1e_Fragment | PressReleaseBase_TeamMembersParentPage_2e9df92fe936461987fd0ea8ad08bd9e_Fragment | PressReleaseBase_TeamMembersParentPage_47f304d629a84648a0e2b942513133ff_Fragment | PressReleaseBase_TeamMembersParentPage_75c911bd18704434ad7adcca64dfb089_Fragment | PressReleaseBase_TeamMembersParentPage_B4311697c06c4d58b88dca047c0a72b0_Fragment | PressReleaseBase_TeamMembersWildcardPage_Fragment | PressReleaseBase_TeamMembersWildcardPage_6c0a7b262ac64e1ba92ab20013a5a00e_Fragment | PressReleaseBase_TeamMembersWildcardPage_9c436bbf177d481da8bdfdc12a53d450_Fragment | PressReleaseBase_TeamMembersWildcardPage_52ba0118982f400fb80e1fee787f1d3a_Fragment | PressReleaseBase_TeamMembersWildcardPage_54e4118770954f8abdfb908c88ce2f29_Fragment | PressReleaseBase_TeamMembersWildcardPage_Ea27a3d835fd49a3a4c797d2a6d52745_Fragment | PressReleaseBase_TeamProfileCards_Fragment | PressReleaseBase_TeamProfileCardsFolder_Fragment | PressReleaseBase_TechzoneArticlePage_Fragment | PressReleaseBase_Tenant_Fragment | PressReleaseBase_TenantFolder_Fragment | PressReleaseBase_TenantSecurityItemPointer_Fragment | PressReleaseBase_TenantSetupRoot_Fragment | PressReleaseBase_TertieryHeroBanner_Fragment | PressReleaseBase_TertieryHeroBannerParametersTemplate_Fragment | PressReleaseBase_Text_Fragment | PressReleaseBase_TextBlock_Fragment | PressReleaseBase_TextBlockHeadingParametersTemplate_Fragment | PressReleaseBase_TextBlockHeadingType_Fragment | PressReleaseBase_TextBlockHeadingTypeFolder_Fragment | PressReleaseBase_TextBlockLinkType_Fragment | PressReleaseBase_TextBlockLinkTypeFolder_Fragment | PressReleaseBase_TextBlocks_Fragment | PressReleaseBase_TextBlocksFolder_Fragment | PressReleaseBase_TextBlocksParametersTemplate_Fragment | PressReleaseBase_TextFolder_Fragment | PressReleaseBase_TextFolder_B762d56787f5493cbb480c455d834457_Fragment | PressReleaseBase_Text_B8f5894cb4934016bf784090b0a2fd16_Fragment | PressReleaseBase_Theme_Fragment | PressReleaseBase_ThemeTag_Fragment | PressReleaseBase_ThemeTagsFolder_Fragment | PressReleaseBase_ThemingMode_Fragment | PressReleaseBase_ThemingModes_Fragment | PressReleaseBase_Tile_Fragment | PressReleaseBase_TileLink_Fragment | PressReleaseBase_TileParametersTemplate_Fragment | PressReleaseBase_TileSizeOption_Fragment | PressReleaseBase_TileSizeOptionFolder_Fragment | PressReleaseBase_TilesFolder_Fragment | PressReleaseBase_TilesParametersTemplate_Fragment | PressReleaseBase_Title_Fragment | PressReleaseBase_Title_A82e893105754175917de904ef7e6dbe_Fragment | PressReleaseBase_Toggle_Fragment | PressReleaseBase_ToggleFolder_Fragment | PressReleaseBase_Toggle_8e4c968e9fa543a89ac4c0baf273ccde_Fragment | PressReleaseBase_Transformation_Fragment | PressReleaseBase_TrustArticleHeroParametersTemplate_Fragment | PressReleaseBase_TrustFinder_Fragment | PressReleaseBase_TrustFinderFilterOption_Fragment | PressReleaseBase_TrustRegion_Fragment | PressReleaseBase_TrustType_Fragment | PressReleaseBase_TrustTypesFolder_Fragment | PressReleaseBase_Twitter_Fragment | PressReleaseBase_TwitterApp_Fragment | PressReleaseBase_TwitterApps_Fragment | PressReleaseBase_TwitterFolder_Fragment | PressReleaseBase_TwitterParametersTemplate_Fragment | PressReleaseBase_TwitterSettings_Fragment | PressReleaseBase_UnknownItem_Fragment | PressReleaseBase_UnminifiedFile_Fragment | PressReleaseBase_UpgradeScript_Fragment | PressReleaseBase_UpgradeScriptLibrary_Fragment | PressReleaseBase_VariantComponentField_Fragment | PressReleaseBase_VariantDateField_Fragment | PressReleaseBase_VariantDefinition_4d50cdaec2d94de8b0808f992bfb1b55_Fragment | PressReleaseBase_VariantPlaceholder_Fragment | PressReleaseBase_VariantReference_Fragment | PressReleaseBase_VariantSection_Fragment | PressReleaseBase_VariantTemplate_Fragment | PressReleaseBase_VariantText_Fragment | PressReleaseBase_VariantToken_Fragment | PressReleaseBase_Variants_Fragment | PressReleaseBase_VectorFolder_Fragment | PressReleaseBase_VectorTile_Fragment | PressReleaseBase_VectorTileLink_Fragment | PressReleaseBase_VectorTilesFolder_Fragment | PressReleaseBase_VectorTilesParametersTemplate_Fragment | PressReleaseBase_Version_95ebc23204774dc38ad3465d5fe8da2f_Fragment | PressReleaseBase_Video_Fragment | PressReleaseBase_VideoCountOption_Fragment | PressReleaseBase_VideoCountOptions_Fragment | PressReleaseBase_VideoFolder_Fragment | PressReleaseBase_VideoFolder_Bba49474673e468186ba8b1a20e067a9_Fragment | PressReleaseBase_VideoPage_Fragment | PressReleaseBase_VideoParameters_Fragment | PressReleaseBase_VideoParametersTemplate_Fragment | PressReleaseBase_VideoPressReleasePage_Fragment | PressReleaseBase_Video_4bc649610a894242be2dc5026090cf49_Fragment | PressReleaseBase__AssetsOptimization_Fragment | PressReleaseBase__BackgroundImage_Fragment | PressReleaseBase__CompatibleThemes_Fragment | PressReleaseBase__CompositeTheme_Fragment | PressReleaseBase__CustomMetadata_Fragment | PressReleaseBase__CustomRenderingViewPath_Fragment | PressReleaseBase__DatasourceBehaviour_Fragment | PressReleaseBase__Favicon_Fragment | PressReleaseBase__FormsFolderLocation_Fragment | PressReleaseBase__FundSettings_Fragment | PressReleaseBase__HasValidUrlName_Fragment | PressReleaseBase__LocalDataLink_Fragment | PressReleaseBase__Login_Fragment | PressReleaseBase__OpenGraphMetadata_Fragment | PressReleaseBase__PageDesignTheme_Fragment | PressReleaseBase__PageSearchScope_Fragment | PressReleaseBase__SearchCriteria_Fragment | PressReleaseBase__SearchableWithoutRelatedItems_Fragment | PressReleaseBase__SeoMetadata_Fragment | PressReleaseBase__SiteTheme_Fragment | PressReleaseBase__SitemapSettings_Fragment | PressReleaseBase__StickyNote_Fragment | PressReleaseBase__Styleable_Fragment | PressReleaseBase__TwitterMetadata_Fragment | PressReleaseBase__Webinar_Fragment | PressReleaseBase__WildcardSource_Fragment;

export type PressReleaseCardFragment = (
  { __typename?: 'C___BasePressRelease' | 'C___PodcastPressRelease' | 'C___PressRelease' | 'C___VideoPressRelease' | 'PodcastPressReleasePage' | 'PressReleasePage' | 'VideoPressReleasePage' }
  & { template: PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BasePressRelease_template_ItemTemplate, pressReleaseTitle: Types.Maybe<PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BasePressRelease_pressReleaseTitle_TextField>, pressReleaseDescription: Types.Maybe<PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BasePressRelease_pressReleaseDescription_TextField>, pressReleasePublicationDate: Types.Maybe<PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___BasePressRelease_pressReleasePublicationDate_DateField> }
);

export type PressReleaseVideoDurationFragment = (
  { __typename?: 'C___VideoPressRelease' | 'VideoPressReleasePage' }
  & { duration: Types.Maybe<PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___VideoPressRelease_duration_IntegerField> }
);

export type PressReleasePodcastDurationFragment = (
  { __typename?: 'C___PodcastPressRelease' | 'PodcastPressReleasePage' }
  & { duration: Types.Maybe<PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___PodcastPressRelease_duration_IntegerField> }
);

export type PressReleaseDurationFragment = (
  { __typename?: 'C___PressRelease' | 'PressReleasePage' }
  & { duration: Types.Maybe<PressReleaseSearchLatestQuery_search_ItemSearchResults_results_C___PressRelease_duration_IntegerField> }
);

export const PressReleaseBaseFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PressReleaseBase"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Item"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<PressReleaseBaseFragment, unknown>;
export const PressReleaseCardFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PressReleaseCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"_BasePressRelease"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pressReleaseTitle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pressReleaseDescription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pressReleasePublicationDate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"formattedDateValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"StringValue","value":"yyyy-MM-ddTHH:mm:ssZ","block":false}}]}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Item"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<PressReleaseCardFragment, unknown>;
export const PressReleaseVideoDurationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PressReleaseVideoDuration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"_VideoPressRelease"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<PressReleaseVideoDurationFragment, unknown>;
export const PressReleasePodcastDurationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PressReleasePodcastDuration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"_PodcastPressRelease"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<PressReleasePodcastDurationFragment, unknown>;
export const PressReleaseDurationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PressReleaseDuration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"_PressRelease"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<PressReleaseDurationFragment, unknown>;
export const PressReleaseSearchLatestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PressReleaseSearchLatest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"language"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"search"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"AND"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"StringValue","value":"_path","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"StringValue","value":"4E44BA879E0B4ABF8810F3C8B70117BD","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"operator"},"value":{"kind":"EnumValue","value":"CONTAINS"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"StringValue","value":"_templates","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"StringValue","value":"94E1D50186424DCF9CEAA0EE86451733","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"operator"},"value":{"kind":"EnumValue","value":"CONTAINS"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"StringValue","value":"_language","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"StringValue","value":"shareTo","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"operator"},"value":{"kind":"EnumValue","value":"CONTAINS"}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"StringValue","value":"pressReleasePublicationDate","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"direction"},"value":{"kind":"EnumValue","value":"DESC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNext"}}]}},{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PressReleaseBase"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PressReleaseCard"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PressReleaseVideoDuration"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PressReleasePodcastDuration"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PressReleaseDuration"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PressReleaseBase"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Item"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PressReleaseCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"_BasePressRelease"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pressReleaseTitle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pressReleaseDescription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pressReleasePublicationDate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"formattedDateValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"StringValue","value":"yyyy-MM-ddTHH:mm:ssZ","block":false}}]}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Item"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PressReleaseVideoDuration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"_VideoPressRelease"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PressReleasePodcastDuration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"_PodcastPressRelease"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PressReleaseDuration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"_PressRelease"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<PressReleaseSearchLatestQuery, PressReleaseSearchLatestQueryVariables>;